'use strict';

var React = require('react');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

var __defProp$7h = Object.defineProperty;
var __getOwnPropSymbols$7h = Object.getOwnPropertySymbols;
var __hasOwnProp$7h = Object.prototype.hasOwnProperty;
var __propIsEnum$7h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7h = (obj, key, value) => key in obj ? __defProp$7h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7h.call(b, prop))
      __defNormalProp$7h(a, prop, b[prop]);
  if (__getOwnPropSymbols$7h)
    for (var prop of __getOwnPropSymbols$7h(b)) {
      if (__propIsEnum$7h.call(b, prop))
        __defNormalProp$7h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7h)
    for (var prop of __getOwnPropSymbols$7h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAgencyDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17.115 15.358c-.27.306-.554.608-.851.905-4.296 4.296-9.678 5.88-12.021 3.536-1.607-1.606-1.368-4.641.325-7.775M6.89 8.725c.281-.32.578-.636.888-.947C12.074 3.482 17.456 1.9 19.8 4.243c1.608 1.607 1.367 4.645-.33 7.781",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.264 7.778c4.295 4.296 5.878 9.678 3.535 12.021s-7.725.76-12.02-3.535c-4.297-4.296-5.88-9.678-3.536-12.021 2.343-2.343 7.725-.76 12.02 3.535Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }
    )
  );
};

var __defProp$7g = Object.defineProperty;
var __getOwnPropSymbols$7g = Object.getOwnPropertySymbols;
var __hasOwnProp$7g = Object.prototype.hasOwnProperty;
var __propIsEnum$7g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7g = (obj, key, value) => key in obj ? __defProp$7g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7g.call(b, prop))
      __defNormalProp$7g(a, prop, b[prop]);
  if (__getOwnPropSymbols$7g)
    for (var prop of __getOwnPropSymbols$7g(b)) {
      if (__propIsEnum$7g.call(b, prop))
        __defNormalProp$7g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7g)
    for (var prop of __getOwnPropSymbols$7g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAgencySolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "currentColor", d: "M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.561 9.803c.214.726.51 1.47.882 2.218-.75 1.505-1.2 3.019-1.274 4.411-.08 1.54.305 3.013 1.367 4.074 1.551 1.552 3.944 1.657 6.267.974a13.62 13.62 0 0 0 2.218-.882c.747.373 1.492.669 2.218.882 2.323.683 4.715.578 6.267-.974 1.552-1.552 1.657-3.944.974-6.267a13.62 13.62 0 0 0-.882-2.218c.779-1.563 1.238-3.14 1.281-4.58.045-1.479-.35-2.883-1.373-3.906-1.552-1.551-3.944-1.657-6.267-.974-.726.214-1.47.51-2.218.882a13.61 13.61 0 0 0-2.218-.882c-2.324-.683-4.716-.577-6.268.974-1.551 1.552-1.657 3.944-.974 6.268ZM9.24 4.48c-2.028-.596-3.498-.322-4.29.47-.79.791-1.065 2.261-.469 4.289.584 1.986 1.952 4.264 4.005 6.317a17.902 17.902 0 0 0 3.536 2.767 17.901 17.901 0 0 0 3.535-2.767c.283-.282.553-.57.81-.86a1 1 0 0 1 1.498 1.325c-.284.32-.582.638-.893.95a20.504 20.504 0 0 1-2.832 2.37c.224.083.446.156.664.22 2.027.597 3.497.322 4.289-.47.791-.79 1.066-2.26.47-4.288-.585-1.986-1.953-4.265-4.006-6.318a17.904 17.904 0 0 0-3.535-2.767 17.904 17.904 0 0 0-3.536 2.767c-.295.296-.577.596-.845.9a1 1 0 0 1-1.501-1.32c.296-.337.606-.668.932-.994a20.512 20.512 0 0 1 2.832-2.37 10.328 10.328 0 0 0-.664-.22ZM7.07 16.97a20.509 20.509 0 0 0 2.832 2.37 9.738 9.738 0 0 1-.664.221c-2.028.597-3.498.322-4.29-.47-.544-.544-.843-1.393-.782-2.555.037-.722.215-1.533.534-2.397a20.519 20.519 0 0 0 2.37 2.832Zm12.81-9.59c-.023.751-.2 1.607-.54 2.523a20.509 20.509 0 0 0-2.37-2.832 20.519 20.519 0 0 0-2.831-2.37 9.54 9.54 0 0 1 .664-.22c2.027-.597 3.497-.323 4.289.469.526.525.821 1.332.788 2.43Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$7f = Object.defineProperty;
var __getOwnPropSymbols$7f = Object.getOwnPropertySymbols;
var __hasOwnProp$7f = Object.prototype.hasOwnProperty;
var __propIsEnum$7f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7f = (obj, key, value) => key in obj ? __defProp$7f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7f.call(b, prop))
      __defNormalProp$7f(a, prop, b[prop]);
  if (__getOwnPropSymbols$7f)
    for (var prop of __getOwnPropSymbols$7f(b)) {
      if (__propIsEnum$7f.call(b, prop))
        __defNormalProp$7f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7f)
    for (var prop of __getOwnPropSymbols$7f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlarmDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 21a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21v0Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 9v4l2 2"
      }
    )
  );
};

var __defProp$7e = Object.defineProperty;
var __getOwnPropSymbols$7e = Object.getOwnPropertySymbols;
var __hasOwnProp$7e = Object.prototype.hasOwnProperty;
var __propIsEnum$7e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7e = (obj, key, value) => key in obj ? __defProp$7e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7e.call(b, prop))
      __defNormalProp$7e(a, prop, b[prop]);
  if (__getOwnPropSymbols$7e)
    for (var prop of __getOwnPropSymbols$7e(b)) {
      if (__propIsEnum$7e.call(b, prop))
        __defNormalProp$7e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7e)
    for (var prop of __getOwnPropSymbols$7e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlarmSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414l3-3Zm14-1.414a1 1 0 1 0-1.414 1.414l3 3a1 1 0 1 0 1.414-1.414l-3-3Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 22a9 9 0 0 0 5.617-1.968l1.676 1.675a1 1 0 0 0 1.414-1.414l-1.675-1.675a9 9 0 1 0-14.064 0l-1.675 1.675a1 1 0 1 0 1.414 1.414l1.676-1.675A9 9 0 0 0 12 22Zm1-13a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2 2a1 1 0 0 0 1.414-1.414L13 12.586V9Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$7d = Object.defineProperty;
var __getOwnPropSymbols$7d = Object.getOwnPropertySymbols;
var __hasOwnProp$7d = Object.prototype.hasOwnProperty;
var __propIsEnum$7d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7d = (obj, key, value) => key in obj ? __defProp$7d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7d.call(b, prop))
      __defNormalProp$7d(a, prop, b[prop]);
  if (__getOwnPropSymbols$7d)
    for (var prop of __getOwnPropSymbols$7d(b)) {
      if (__propIsEnum$7d.call(b, prop))
        __defNormalProp$7d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7d)
    for (var prop of __getOwnPropSymbols$7d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlertCircleDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 8v4m0 4h.01"
      }
    )
  );
};

var __defProp$7c = Object.defineProperty;
var __getOwnPropSymbols$7c = Object.getOwnPropertySymbols;
var __hasOwnProp$7c = Object.prototype.hasOwnProperty;
var __propIsEnum$7c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7c = (obj, key, value) => key in obj ? __defProp$7c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7c.call(b, prop))
      __defNormalProp$7c(a, prop, b[prop]);
  if (__getOwnPropSymbols$7c)
    for (var prop of __getOwnPropSymbols$7c(b)) {
      if (__propIsEnum$7c.call(b, prop))
        __defNormalProp$7c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7c)
    for (var prop of __getOwnPropSymbols$7c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlertCircleSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm1 7a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$7b = Object.defineProperty;
var __getOwnPropSymbols$7b = Object.getOwnPropertySymbols;
var __hasOwnProp$7b = Object.prototype.hasOwnProperty;
var __propIsEnum$7b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7b = (obj, key, value) => key in obj ? __defProp$7b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7b.call(b, prop))
      __defNormalProp$7b(a, prop, b[prop]);
  if (__getOwnPropSymbols$7b)
    for (var prop of __getOwnPropSymbols$7b(b)) {
      if (__propIsEnum$7b.call(b, prop))
        __defNormalProp$7b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7b)
    for (var prop of __getOwnPropSymbols$7b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlertOctagonDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7.391 2.469c.173-.173.26-.26.36-.322a1 1 0 0 1 .29-.12C8.156 2 8.278 2 8.523 2h6.954c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.922 4.923c.173.173.26.26.322.36.054.09.095.188.12.29.027.115.027.237.027.482v6.954c0 .245 0 .367-.028.482a.998.998 0 0 1-.12.29c-.061.1-.148.187-.32.36l-4.923 4.922c-.173.173-.26.26-.36.322a.998.998 0 0 1-.29.12c-.115.027-.237.027-.482.027H8.523c-.245 0-.367 0-.482-.028a.998.998 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32L2.47 16.608c-.173-.173-.26-.26-.322-.36a1 1 0 0 1-.12-.29C2 15.844 2 15.722 2 15.477V8.523c0-.245 0-.367.028-.482a1 1 0 0 1 .12-.29c.061-.1.148-.187.32-.36L7.392 2.47Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 8v4m0 4h.01"
      }
    )
  );
};

var __defProp$7a = Object.defineProperty;
var __getOwnPropSymbols$7a = Object.getOwnPropertySymbols;
var __hasOwnProp$7a = Object.prototype.hasOwnProperty;
var __propIsEnum$7a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7a = (obj, key, value) => key in obj ? __defProp$7a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7a.call(b, prop))
      __defNormalProp$7a(a, prop, b[prop]);
  if (__getOwnPropSymbols$7a)
    for (var prop of __getOwnPropSymbols$7a(b)) {
      if (__propIsEnum$7a.call(b, prop))
        __defNormalProp$7a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7a)
    for (var prop of __getOwnPropSymbols$7a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlertOctagonSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.523 1h-.051c-.19 0-.43-.001-.665.055a2 2 0 0 0-.578.24c-.206.126-.375.296-.509.43l-.036.036-4.923 4.923-.036.036a2.794 2.794 0 0 0-.43.51 2 2 0 0 0-.24.577C1 8.043 1 8.282 1 8.472v7.056c0 .19-.001.43.055.665.05.204.13.399.24.578.126.206.296.375.43.509l.036.036 4.923 4.922.036.037c.134.134.303.304.51.43a2 2 0 0 0 .577.24c.236.056.475.055.665.055h7.056c.19 0 .43.001.665-.055.204-.05.399-.13.578-.24.206-.126.375-.296.509-.43l.036-.037 4.922-4.922.037-.036c.134-.134.304-.303.43-.51.11-.178.19-.373.24-.577.056-.236.055-.475.055-.665V8.472c0-.19.001-.43-.055-.665a2 2 0 0 0-.24-.578c-.126-.206-.296-.375-.43-.509l-.037-.036-4.922-4.923-.036-.036c-.134-.134-.303-.304-.51-.43a1.999 1.999 0 0 0-.577-.24C15.957 1 15.718 1 15.528 1H8.523ZM13 8a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$79 = Object.defineProperty;
var __getOwnPropSymbols$79 = Object.getOwnPropertySymbols;
var __hasOwnProp$79 = Object.prototype.hasOwnProperty;
var __propIsEnum$79 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$79 = (obj, key, value) => key in obj ? __defProp$79(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$79 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$79.call(b, prop))
      __defNormalProp$79(a, prop, b[prop]);
  if (__getOwnPropSymbols$79)
    for (var prop of __getOwnPropSymbols$79(b)) {
      if (__propIsEnum$79.call(b, prop))
        __defNormalProp$79(a, prop, b[prop]);
    }
  return a;
};
var __objRest$79 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$79.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$79)
    for (var prop of __getOwnPropSymbols$79(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$79.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlertTriangleDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$79(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$79({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m2.39 18.098 8.225-14.206c.455-.785.682-1.178.979-1.31a1 1 0 0 1 .812 0c.297.132.524.525.979 1.31l8.225 14.206c.456.788.684 1.182.65 1.506a1 1 0 0 1-.406.705c-.263.191-.719.191-1.63.191H3.776c-.91 0-1.366 0-1.629-.191a1 1 0 0 1-.406-.705c-.034-.324.194-.718.65-1.506Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 9v4m0 4h.01"
      }
    )
  );
};

var __defProp$78 = Object.defineProperty;
var __getOwnPropSymbols$78 = Object.getOwnPropertySymbols;
var __hasOwnProp$78 = Object.prototype.hasOwnProperty;
var __propIsEnum$78 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$78 = (obj, key, value) => key in obj ? __defProp$78(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$78 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$78.call(b, prop))
      __defNormalProp$78(a, prop, b[prop]);
  if (__getOwnPropSymbols$78)
    for (var prop of __getOwnPropSymbols$78(b)) {
      if (__propIsEnum$78.call(b, prop))
        __defNormalProp$78(a, prop, b[prop]);
    }
  return a;
};
var __objRest$78 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$78.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$78)
    for (var prop of __getOwnPropSymbols$78(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$78.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlertTriangleSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$78(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$78({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.813 1.668a2 2 0 0 0-1.626 0c-.4.178-.659.49-.84.746-.177.25-.367.579-.576.94l-8.267 14.28c-.21.362-.4.692-.53.971-.132.285-.274.666-.229 1.102a2 2 0 0 0 .813 1.41c.355.258.757.326 1.069.355.306.028.687.028 1.106.028h16.534c.419 0 .8 0 1.106-.028.312-.029.714-.097 1.069-.354a2 2 0 0 0 .813-1.41c.045-.437-.097-.818-.229-1.103-.13-.28-.32-.609-.53-.971L14.23 3.354c-.21-.361-.4-.69-.577-.94-.18-.255-.44-.568-.84-.746ZM13 9a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$77 = Object.defineProperty;
var __getOwnPropSymbols$77 = Object.getOwnPropertySymbols;
var __hasOwnProp$77 = Object.prototype.hasOwnProperty;
var __propIsEnum$77 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$77 = (obj, key, value) => key in obj ? __defProp$77(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$77 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$77.call(b, prop))
      __defNormalProp$77(a, prop, b[prop]);
  if (__getOwnPropSymbols$77)
    for (var prop of __getOwnPropSymbols$77(b)) {
      if (__propIsEnum$77.call(b, prop))
        __defNormalProp$77(a, prop, b[prop]);
    }
  return a;
};
var __objRest$77 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$77.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$77)
    for (var prop of __getOwnPropSymbols$77(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$77.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlphaOrderAzDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$77(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$77({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 4v16m0 0-4-4m4 4 4-4"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 14h6l-6 6h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15.2 8.28h3.6M14 11l2.563-6.392c.139-.346.208-.52.304-.573a.269.269 0 0 1 .266 0c.096.054.165.227.304.573L20 11"
      }
    )
  );
};

var __defProp$76 = Object.defineProperty;
var __getOwnPropSymbols$76 = Object.getOwnPropertySymbols;
var __hasOwnProp$76 = Object.prototype.hasOwnProperty;
var __propIsEnum$76 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$76 = (obj, key, value) => key in obj ? __defProp$76(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$76 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$76.call(b, prop))
      __defNormalProp$76(a, prop, b[prop]);
  if (__getOwnPropSymbols$76)
    for (var prop of __getOwnPropSymbols$76(b)) {
      if (__propIsEnum$76.call(b, prop))
        __defNormalProp$76(a, prop, b[prop]);
    }
  return a;
};
var __objRest$76 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$76.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$76)
    for (var prop of __getOwnPropSymbols$76(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$76.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlphaOrderAzSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$76(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$76({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 4v16m0 0-4-4m4 4 4-4m3-2h6l-6 6h6M15.2 8.28h3.6M14 11l2.563-6.392c.139-.346.208-.52.304-.573a.269.269 0 0 1 .266 0c.096.054.165.227.304.573L20 11"
      }
    )
  );
};

var __defProp$75 = Object.defineProperty;
var __getOwnPropSymbols$75 = Object.getOwnPropertySymbols;
var __hasOwnProp$75 = Object.prototype.hasOwnProperty;
var __propIsEnum$75 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$75 = (obj, key, value) => key in obj ? __defProp$75(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$75 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$75.call(b, prop))
      __defNormalProp$75(a, prop, b[prop]);
  if (__getOwnPropSymbols$75)
    for (var prop of __getOwnPropSymbols$75(b)) {
      if (__propIsEnum$75.call(b, prop))
        __defNormalProp$75(a, prop, b[prop]);
    }
  return a;
};
var __objRest$75 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$75.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$75)
    for (var prop of __getOwnPropSymbols$75(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$75.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlphaOrderZaDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$75(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$75({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 4v16m0 0-4-4m4 4 4-4m3-12h6l-6 6h6"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15.2 17.28h3.6M14 20l2.563-6.392c.139-.346.208-.52.304-.573a.269.269 0 0 1 .266 0c.096.054.165.227.304.573L20 20",
        opacity: 0.4
      }
    )
  );
};

var __defProp$74 = Object.defineProperty;
var __getOwnPropSymbols$74 = Object.getOwnPropertySymbols;
var __hasOwnProp$74 = Object.prototype.hasOwnProperty;
var __propIsEnum$74 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$74 = (obj, key, value) => key in obj ? __defProp$74(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$74 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$74.call(b, prop))
      __defNormalProp$74(a, prop, b[prop]);
  if (__getOwnPropSymbols$74)
    for (var prop of __getOwnPropSymbols$74(b)) {
      if (__propIsEnum$74.call(b, prop))
        __defNormalProp$74(a, prop, b[prop]);
    }
  return a;
};
var __objRest$74 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$74.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$74)
    for (var prop of __getOwnPropSymbols$74(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$74.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAlphaOrderZaSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$74(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$74({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 4v16m0 0-4-4m4 4 4-4m3-12h6l-6 6h6m-4.8 7.28h3.6M14 20l2.563-6.392c.139-.346.208-.52.304-.573a.269.269 0 0 1 .266 0c.096.054.165.227.304.573L20 20"
      }
    )
  );
};

var __defProp$73 = Object.defineProperty;
var __getOwnPropSymbols$73 = Object.getOwnPropertySymbols;
var __hasOwnProp$73 = Object.prototype.hasOwnProperty;
var __propIsEnum$73 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$73 = (obj, key, value) => key in obj ? __defProp$73(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$73 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$73.call(b, prop))
      __defNormalProp$73(a, prop, b[prop]);
  if (__getOwnPropSymbols$73)
    for (var prop of __getOwnPropSymbols$73(b)) {
      if (__propIsEnum$73.call(b, prop))
        __defNormalProp$73(a, prop, b[prop]);
    }
  return a;
};
var __objRest$73 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$73.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$73)
    for (var prop of __getOwnPropSymbols$73(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$73.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAnnotationQuestionDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$73(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$73({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.7c0 1.398 0 2.097-.228 2.648a3 3 0 0 1-1.624 1.624C18.597 18 17.898 18 16.5 18c-.489 0-.733 0-.96.053a2 2 0 0 0-.821.412c-.18.149-.326.344-.619.735l-1.46 1.947c-.217.29-.326.434-.459.486a.5.5 0 0 1-.362 0c-.133-.052-.242-.197-.459-.486L9.9 19.2c-.293-.39-.44-.586-.619-.735a2 2 0 0 0-.821-.412C8.233 18 7.989 18 7.5 18c-1.398 0-2.097 0-2.648-.228a3 3 0 0 1-1.624-1.624C3 15.597 3 14.898 3 13.5V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10 8.502a2.249 2.249 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01"
      }
    )
  );
};

var __defProp$72 = Object.defineProperty;
var __getOwnPropSymbols$72 = Object.getOwnPropertySymbols;
var __hasOwnProp$72 = Object.prototype.hasOwnProperty;
var __propIsEnum$72 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$72 = (obj, key, value) => key in obj ? __defProp$72(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$72 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$72.call(b, prop))
      __defNormalProp$72(a, prop, b[prop]);
  if (__getOwnPropSymbols$72)
    for (var prop of __getOwnPropSymbols$72(b)) {
      if (__propIsEnum$72.call(b, prop))
        __defNormalProp$72(a, prop, b[prop]);
    }
  return a;
};
var __objRest$72 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$72.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$72)
    for (var prop of __getOwnPropSymbols$72(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$72.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAnnotationQuestionSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$72(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$72({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.241 2H7.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v5.776c0 .67 0 1.223.03 1.675.033.47.101.904.274 1.322a4 4 0 0 0 2.165 2.165c.418.173.852.241 1.321.273C6.243 19 6.796 19 7.466 19H7.5c.537 0 .643.006.73.027a1 1 0 0 1 .41.205c.07.057.138.139.46.568l1.477 1.97c.093.124.199.265.3.378.112.124.299.308.58.417a1.5 1.5 0 0 0 1.087 0c.28-.11.467-.293.579-.417.101-.113.207-.254.3-.379L14.9 19.8c.322-.43.39-.51.46-.568a1 1 0 0 1 .41-.205c.087-.02.193-.027.73-.027h.034c.67 0 1.223 0 1.675-.03.47-.033.904-.101 1.322-.274a4 4 0 0 0 2.165-2.165c.173-.418.241-.852.273-1.321.031-.453.031-1.006.031-1.676V7.76c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C17.71 2 17.046 2 16.242 2Zm-4.753 6.172A1.248 1.248 0 0 1 13.37 9.25v.002c0 .218-.177.52-.679.854a4.287 4.287 0 0 1-.879.443l-.009.003h.002a1 1 0 0 0 .633 1.897h.001l.135-.05a6.281 6.281 0 0 0 1.226-.63c.623-.414 1.57-1.237 1.57-2.517A3.248 3.248 0 0 0 9.057 8.17a1 1 0 0 0 1.886.664c.098-.278.291-.513.545-.662Zm.662 5.328a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$71 = Object.defineProperty;
var __getOwnPropSymbols$71 = Object.getOwnPropertySymbols;
var __hasOwnProp$71 = Object.prototype.hasOwnProperty;
var __propIsEnum$71 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$71 = (obj, key, value) => key in obj ? __defProp$71(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$71 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$71.call(b, prop))
      __defNormalProp$71(a, prop, b[prop]);
  if (__getOwnPropSymbols$71)
    for (var prop of __getOwnPropSymbols$71(b)) {
      if (__propIsEnum$71.call(b, prop))
        __defNormalProp$71(a, prop, b[prop]);
    }
  return a;
};
var __objRest$71 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$71.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$71)
    for (var prop of __getOwnPropSymbols$71(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$71.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAnnouncement01Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$71(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$71({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 8v4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.25 5.5H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 7.78 2 8.62 2 10.3v1.2c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083c.367.152.833.152 1.765.152v4.25c0 .232 0 .348.01.446a2 2 0 0 0 1.794 1.794c.098.01.214.01.446.01s.348 0 .446-.01a2 2 0 0 0 1.794-1.794c.01-.098.01-.214.01-.446V14.5h.75c1.766 0 3.927.947 5.594 1.856.973.53 1.46.795 1.778.756a.946.946 0 0 0 .691-.41c.187-.262.187-.784.187-1.828V5.126c0-1.044 0-1.566-.187-1.827a.946.946 0 0 0-.691-.41c-.319-.04-.805.225-1.778.755-1.667.91-3.828 1.856-5.594 1.856Z"
      }
    )
  );
};

var __defProp$70 = Object.defineProperty;
var __getOwnPropSymbols$70 = Object.getOwnPropertySymbols;
var __hasOwnProp$70 = Object.prototype.hasOwnProperty;
var __propIsEnum$70 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$70 = (obj, key, value) => key in obj ? __defProp$70(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$70 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$70.call(b, prop))
      __defNormalProp$70(a, prop, b[prop]);
  if (__getOwnPropSymbols$70)
    for (var prop of __getOwnPropSymbols$70(b)) {
      if (__propIsEnum$70.call(b, prop))
        __defNormalProp$70(a, prop, b[prop]);
    }
  return a;
};
var __objRest$70 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$70.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$70)
    for (var prop of __getOwnPropSymbols$70(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$70.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAnnouncement01Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$70(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$70({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22 7a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-5.433-4.859c.292-.132.718-.302 1.176-.245.573.07 1.048.351 1.384.821.264.37.321.807.347 1.123.026.333.026.758.026 1.246v9.828c0 .488 0 .913-.026 1.246-.026.316-.083.754-.347 1.123-.336.47-.81.751-1.384.821-.458.056-.884-.113-1.176-.245-.318-.144-.71-.358-1.167-.607l-.034-.018c-1.569-.856-3.41-1.643-4.866-1.727v3.285c0 .19 0 .354-.014.502a3 3 0 0 1-2.692 2.691c-.159.016-.336.015-.544.015-.208 0-.385.001-.544-.015a3 3 0 0 1-2.692-2.691C4 19.146 4 18.982 4 18.792v-3.304a6.78 6.78 0 0 1-.162-.01 3.07 3.07 0 0 1-.986-.206 3 3 0 0 1-1.624-1.624 3.069 3.069 0 0 1-.207-.986C1 12.35 1 11.971 1 11.532v-1.273c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C5.29 4.5 5.954 4.5 6.758 4.5h3.492c1.491 0 3.456-.829 5.116-1.734l.034-.019c.457-.249.85-.462 1.167-.606Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6$ = Object.defineProperty;
var __getOwnPropSymbols$6$ = Object.getOwnPropertySymbols;
var __hasOwnProp$6$ = Object.prototype.hasOwnProperty;
var __propIsEnum$6$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6$ = (obj, key, value) => key in obj ? __defProp$6$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6$.call(b, prop))
      __defNormalProp$6$(a, prop, b[prop]);
  if (__getOwnPropSymbols$6$)
    for (var prop of __getOwnPropSymbols$6$(b)) {
      if (__propIsEnum$6$.call(b, prop))
        __defNormalProp$6$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6$)
    for (var prop of __getOwnPropSymbols$6$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArcheryTargetDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6$(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 12a5 5 0 1 1-5-5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 8V5l3-3 1 2 2 1-3 3h-3Zm0 0-4 4m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2"
      }
    )
  );
};

var __defProp$6_ = Object.defineProperty;
var __getOwnPropSymbols$6_ = Object.getOwnPropertySymbols;
var __hasOwnProp$6_ = Object.prototype.hasOwnProperty;
var __propIsEnum$6_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6_ = (obj, key, value) => key in obj ? __defProp$6_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6_.call(b, prop))
      __defNormalProp$6_(a, prop, b[prop]);
  if (__getOwnPropSymbols$6_)
    for (var prop of __getOwnPropSymbols$6_(b)) {
      if (__propIsEnum$6_.call(b, prop))
        __defNormalProp$6_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6_)
    for (var prop of __getOwnPropSymbols$6_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArcheryTargetSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6_(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.16 1.013a1 1 0 0 1 .734.54l.851 1.702 1.702.85a1 1 0 0 1 .26 1.602l-3 3A1 1 0 0 1 19 9h-2.586l-3.707 3.707a1 1 0 0 1-1.414-1.414L15 7.586V5a1 1 0 0 1 .293-.707l3-3a1 1 0 0 1 .867-.28Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3 12a9 9 0 0 1 9-9 1 1 0 1 0 0-2C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11a1 1 0 1 0-2 0 9 9 0 1 1-18 0Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8 12a4 4 0 0 1 4-4 1 1 0 1 0 0-2 6 6 0 1 0 6 6 1 1 0 1 0-2 0 4 4 0 0 1-8 0Z"
      }
    )
  );
};

var __defProp$6Z = Object.defineProperty;
var __getOwnPropSymbols$6Z = Object.getOwnPropertySymbols;
var __hasOwnProp$6Z = Object.prototype.hasOwnProperty;
var __propIsEnum$6Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6Z = (obj, key, value) => key in obj ? __defProp$6Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6Z.call(b, prop))
      __defNormalProp$6Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$6Z)
    for (var prop of __getOwnPropSymbols$6Z(b)) {
      if (__propIsEnum$6Z.call(b, prop))
        __defNormalProp$6Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6Z)
    for (var prop of __getOwnPropSymbols$6Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArchiveDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6Z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 8v8.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2V8",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10 13h4M4.5 3h15c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89s0 .697-.038.89a2 2 0 0 1-1.572 1.572C20.197 8 19.965 8 19.5 8h-15c-.465 0-.697 0-.89-.038A2 2 0 0 1 2.038 6.39C2 6.197 2 5.965 2 5.5s0-.697.038-.89A2 2 0 0 1 3.61 3.038C3.803 3 4.035 3 4.5 3Z"
      }
    )
  );
};

var __defProp$6Y = Object.defineProperty;
var __getOwnPropSymbols$6Y = Object.getOwnPropertySymbols;
var __hasOwnProp$6Y = Object.prototype.hasOwnProperty;
var __propIsEnum$6Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6Y = (obj, key, value) => key in obj ? __defProp$6Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6Y.call(b, prop))
      __defNormalProp$6Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$6Y)
    for (var prop of __getOwnPropSymbols$6Y(b)) {
      if (__propIsEnum$6Y.call(b, prop))
        __defNormalProp$6Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6Y)
    for (var prop of __getOwnPropSymbols$6Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArchiveSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6Y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 5a3 3 0 0 1 3-3h16a3 3 0 1 1 0 6H4a3 3 0 0 1-3-3Zm3 5a1 1 0 0 0-1 1v5.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 22 7.954 22 8.758 22h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V11a1 1 0 0 0-1-1H4Zm6 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6X = Object.defineProperty;
var __getOwnPropSymbols$6X = Object.getOwnPropertySymbols;
var __hasOwnProp$6X = Object.prototype.hasOwnProperty;
var __propIsEnum$6X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6X = (obj, key, value) => key in obj ? __defProp$6X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6X.call(b, prop))
      __defNormalProp$6X(a, prop, b[prop]);
  if (__getOwnPropSymbols$6X)
    for (var prop of __getOwnPropSymbols$6X(b)) {
      if (__propIsEnum$6X.call(b, prop))
        __defNormalProp$6X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6X)
    for (var prop of __getOwnPropSymbols$6X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowBottomLeftDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6X(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 6 6 18",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 18H6v-8"
      }
    )
  );
};

var __defProp$6W = Object.defineProperty;
var __getOwnPropSymbols$6W = Object.getOwnPropertySymbols;
var __hasOwnProp$6W = Object.prototype.hasOwnProperty;
var __propIsEnum$6W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6W = (obj, key, value) => key in obj ? __defProp$6W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6W.call(b, prop))
      __defNormalProp$6W(a, prop, b[prop]);
  if (__getOwnPropSymbols$6W)
    for (var prop of __getOwnPropSymbols$6W(b)) {
      if (__propIsEnum$6W.call(b, prop))
        __defNormalProp$6W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6W)
    for (var prop of __getOwnPropSymbols$6W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowBottomLeftSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6W(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L7 15.586V10a1 1 0 0 0-2 0v8a1 1 0 0 0 1 1h8a1 1 0 1 0 0-2H8.414L18.707 6.707Z"
      }
    )
  );
};

var __defProp$6V = Object.defineProperty;
var __getOwnPropSymbols$6V = Object.getOwnPropertySymbols;
var __hasOwnProp$6V = Object.prototype.hasOwnProperty;
var __propIsEnum$6V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6V = (obj, key, value) => key in obj ? __defProp$6V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6V.call(b, prop))
      __defNormalProp$6V(a, prop, b[prop]);
  if (__getOwnPropSymbols$6V)
    for (var prop of __getOwnPropSymbols$6V(b)) {
      if (__propIsEnum$6V.call(b, prop))
        __defNormalProp$6V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6V)
    for (var prop of __getOwnPropSymbols$6V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowBottomRightDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6V(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m6 6 12 12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 10v8h-8"
      }
    )
  );
};

var __defProp$6U = Object.defineProperty;
var __getOwnPropSymbols$6U = Object.getOwnPropertySymbols;
var __hasOwnProp$6U = Object.prototype.hasOwnProperty;
var __propIsEnum$6U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6U = (obj, key, value) => key in obj ? __defProp$6U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6U.call(b, prop))
      __defNormalProp$6U(a, prop, b[prop]);
  if (__getOwnPropSymbols$6U)
    for (var prop of __getOwnPropSymbols$6U(b)) {
      if (__propIsEnum$6U.call(b, prop))
        __defNormalProp$6U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6U)
    for (var prop of __getOwnPropSymbols$6U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowBottomRightSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6U(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M6.707 5.293a1 1 0 0 0-1.414 1.414L15.586 17H10a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1v-8a1 1 0 1 0-2 0v5.586L6.707 5.293Z"
      }
    )
  );
};

var __defProp$6T = Object.defineProperty;
var __getOwnPropSymbols$6T = Object.getOwnPropertySymbols;
var __hasOwnProp$6T = Object.prototype.hasOwnProperty;
var __propIsEnum$6T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6T = (obj, key, value) => key in obj ? __defProp$6T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6T.call(b, prop))
      __defNormalProp$6T(a, prop, b[prop]);
  if (__getOwnPropSymbols$6T)
    for (var prop of __getOwnPropSymbols$6T(b)) {
      if (__propIsEnum$6T.call(b, prop))
        __defNormalProp$6T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6T)
    for (var prop of __getOwnPropSymbols$6T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleDownDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6T(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m8 12 4 4m0 0 4-4m-4 4V8"
      }
    )
  );
};

var __defProp$6S = Object.defineProperty;
var __getOwnPropSymbols$6S = Object.getOwnPropertySymbols;
var __hasOwnProp$6S = Object.prototype.hasOwnProperty;
var __propIsEnum$6S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6S = (obj, key, value) => key in obj ? __defProp$6S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6S.call(b, prop))
      __defNormalProp$6S(a, prop, b[prop]);
  if (__getOwnPropSymbols$6S)
    for (var prop of __getOwnPropSymbols$6S(b)) {
      if (__propIsEnum$6S.call(b, prop))
        __defNormalProp$6S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6S)
    for (var prop of __getOwnPropSymbols$6S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleDownSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6S(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm0 6a1 1 0 0 1 1 1v5.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6R = Object.defineProperty;
var __getOwnPropSymbols$6R = Object.getOwnPropertySymbols;
var __hasOwnProp$6R = Object.prototype.hasOwnProperty;
var __propIsEnum$6R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6R = (obj, key, value) => key in obj ? __defProp$6R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6R.call(b, prop))
      __defNormalProp$6R(a, prop, b[prop]);
  if (__getOwnPropSymbols$6R)
    for (var prop of __getOwnPropSymbols$6R(b)) {
      if (__propIsEnum$6R.call(b, prop))
        __defNormalProp$6R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6R)
    for (var prop of __getOwnPropSymbols$6R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleLeftDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6R(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 8-4 4m0 0 4 4m-4-4h8"
      }
    )
  );
};

var __defProp$6Q = Object.defineProperty;
var __getOwnPropSymbols$6Q = Object.getOwnPropertySymbols;
var __hasOwnProp$6Q = Object.prototype.hasOwnProperty;
var __propIsEnum$6Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6Q = (obj, key, value) => key in obj ? __defProp$6Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6Q.call(b, prop))
      __defNormalProp$6Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$6Q)
    for (var prop of __getOwnPropSymbols$6Q(b)) {
      if (__propIsEnum$6Q.call(b, prop))
        __defNormalProp$6Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6Q)
    for (var prop of __getOwnPropSymbols$6Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleLeftSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6Q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11 11-4.925 11-11Zm-6 0a1 1 0 0 1-1 1h-5.586l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 1 1 1.414 1.414L10.414 11H16a1 1 0 0 1 1 1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6P = Object.defineProperty;
var __getOwnPropSymbols$6P = Object.getOwnPropertySymbols;
var __hasOwnProp$6P = Object.prototype.hasOwnProperty;
var __propIsEnum$6P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6P = (obj, key, value) => key in obj ? __defProp$6P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6P.call(b, prop))
      __defNormalProp$6P(a, prop, b[prop]);
  if (__getOwnPropSymbols$6P)
    for (var prop of __getOwnPropSymbols$6P(b)) {
      if (__propIsEnum$6P.call(b, prop))
        __defNormalProp$6P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6P)
    for (var prop of __getOwnPropSymbols$6P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleRightDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6P(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 16 4-4m0 0-4-4m4 4H8"
      }
    )
  );
};

var __defProp$6O = Object.defineProperty;
var __getOwnPropSymbols$6O = Object.getOwnPropertySymbols;
var __hasOwnProp$6O = Object.prototype.hasOwnProperty;
var __propIsEnum$6O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6O = (obj, key, value) => key in obj ? __defProp$6O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6O.call(b, prop))
      __defNormalProp$6O(a, prop, b[prop]);
  if (__getOwnPropSymbols$6O)
    for (var prop of __getOwnPropSymbols$6O(b)) {
      if (__propIsEnum$6O.call(b, prop))
        __defNormalProp$6O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6O)
    for (var prop of __getOwnPropSymbols$6O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleRightSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6O(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12Zm6 0a1 1 0 0 1 1-1h5.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.586 13H8a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6N = Object.defineProperty;
var __getOwnPropSymbols$6N = Object.getOwnPropertySymbols;
var __hasOwnProp$6N = Object.prototype.hasOwnProperty;
var __propIsEnum$6N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6N = (obj, key, value) => key in obj ? __defProp$6N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6N.call(b, prop))
      __defNormalProp$6N(a, prop, b[prop]);
  if (__getOwnPropSymbols$6N)
    for (var prop of __getOwnPropSymbols$6N(b)) {
      if (__propIsEnum$6N.call(b, prop))
        __defNormalProp$6N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6N)
    for (var prop of __getOwnPropSymbols$6N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleUpDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6N(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m16 12-4-4m0 0-4 4m4-4v8"
      }
    )
  );
};

var __defProp$6M = Object.defineProperty;
var __getOwnPropSymbols$6M = Object.getOwnPropertySymbols;
var __hasOwnProp$6M = Object.prototype.hasOwnProperty;
var __propIsEnum$6M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6M = (obj, key, value) => key in obj ? __defProp$6M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6M.call(b, prop))
      __defNormalProp$6M(a, prop, b[prop]);
  if (__getOwnPropSymbols$6M)
    for (var prop of __getOwnPropSymbols$6M(b)) {
      if (__propIsEnum$6M.call(b, prop))
        __defNormalProp$6M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6M)
    for (var prop of __getOwnPropSymbols$6M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowCircleUpSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6M(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm0-6a1 1 0 0 1-1-1v-5.586l-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 10.414V16a1 1 0 0 1-1 1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6L = Object.defineProperty;
var __getOwnPropSymbols$6L = Object.getOwnPropertySymbols;
var __hasOwnProp$6L = Object.prototype.hasOwnProperty;
var __propIsEnum$6L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6L = (obj, key, value) => key in obj ? __defProp$6L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6L.call(b, prop))
      __defNormalProp$6L(a, prop, b[prop]);
  if (__getOwnPropSymbols$6L)
    for (var prop of __getOwnPropSymbols$6L(b)) {
      if (__propIsEnum$6L.call(b, prop))
        __defNormalProp$6L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6L)
    for (var prop of __getOwnPropSymbols$6L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowDownDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6L(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 4v16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m18 14-6 6-6-6"
      }
    )
  );
};

var __defProp$6K = Object.defineProperty;
var __getOwnPropSymbols$6K = Object.getOwnPropertySymbols;
var __hasOwnProp$6K = Object.prototype.hasOwnProperty;
var __propIsEnum$6K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6K = (obj, key, value) => key in obj ? __defProp$6K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6K.call(b, prop))
      __defNormalProp$6K(a, prop, b[prop]);
  if (__getOwnPropSymbols$6K)
    for (var prop of __getOwnPropSymbols$6K(b)) {
      if (__propIsEnum$6K.call(b, prop))
        __defNormalProp$6K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6K)
    for (var prop of __getOwnPropSymbols$6K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowDownSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6K(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13 4a1 1 0 1 0-2 0v13.586l-4.293-4.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414L13 17.586V4Z"
      }
    )
  );
};

var __defProp$6J = Object.defineProperty;
var __getOwnPropSymbols$6J = Object.getOwnPropertySymbols;
var __hasOwnProp$6J = Object.prototype.hasOwnProperty;
var __propIsEnum$6J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6J = (obj, key, value) => key in obj ? __defProp$6J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6J.call(b, prop))
      __defNormalProp$6J(a, prop, b[prop]);
  if (__getOwnPropSymbols$6J)
    for (var prop of __getOwnPropSymbols$6J(b)) {
      if (__propIsEnum$6J.call(b, prop))
        __defNormalProp$6J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6J)
    for (var prop of __getOwnPropSymbols$6J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowLeftDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6J(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 12H4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m10 18-6-6 6-6"
      }
    )
  );
};

var __defProp$6I = Object.defineProperty;
var __getOwnPropSymbols$6I = Object.getOwnPropertySymbols;
var __hasOwnProp$6I = Object.prototype.hasOwnProperty;
var __propIsEnum$6I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6I = (obj, key, value) => key in obj ? __defProp$6I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6I.call(b, prop))
      __defNormalProp$6I(a, prop, b[prop]);
  if (__getOwnPropSymbols$6I)
    for (var prop of __getOwnPropSymbols$6I(b)) {
      if (__propIsEnum$6I.call(b, prop))
        __defNormalProp$6I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6I)
    for (var prop of __getOwnPropSymbols$6I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowLeftSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6I(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M10.707 6.707a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L6.414 13H20a1 1 0 1 0 0-2H6.414l4.293-4.293Z"
      }
    )
  );
};

var __defProp$6H = Object.defineProperty;
var __getOwnPropSymbols$6H = Object.getOwnPropertySymbols;
var __hasOwnProp$6H = Object.prototype.hasOwnProperty;
var __propIsEnum$6H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6H = (obj, key, value) => key in obj ? __defProp$6H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6H.call(b, prop))
      __defNormalProp$6H(a, prop, b[prop]);
  if (__getOwnPropSymbols$6H)
    for (var prop of __getOwnPropSymbols$6H(b)) {
      if (__propIsEnum$6H.call(b, prop))
        __defNormalProp$6H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6H)
    for (var prop of __getOwnPropSymbols$6H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowRightDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6H(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 12h16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m14 6 6 6-6 6"
      }
    )
  );
};

var __defProp$6G = Object.defineProperty;
var __getOwnPropSymbols$6G = Object.getOwnPropertySymbols;
var __hasOwnProp$6G = Object.prototype.hasOwnProperty;
var __propIsEnum$6G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6G = (obj, key, value) => key in obj ? __defProp$6G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6G.call(b, prop))
      __defNormalProp$6G(a, prop, b[prop]);
  if (__getOwnPropSymbols$6G)
    for (var prop of __getOwnPropSymbols$6G(b)) {
      if (__propIsEnum$6G.call(b, prop))
        __defNormalProp$6G(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6G)
    for (var prop of __getOwnPropSymbols$6G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowRightSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6G(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M14.707 5.293a1 1 0 1 0-1.414 1.414L17.586 11H4a1 1 0 1 0 0 2h13.586l-4.293 4.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6Z"
      }
    )
  );
};

var __defProp$6F = Object.defineProperty;
var __getOwnPropSymbols$6F = Object.getOwnPropertySymbols;
var __hasOwnProp$6F = Object.prototype.hasOwnProperty;
var __propIsEnum$6F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6F = (obj, key, value) => key in obj ? __defProp$6F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6F.call(b, prop))
      __defNormalProp$6F(a, prop, b[prop]);
  if (__getOwnPropSymbols$6F)
    for (var prop of __getOwnPropSymbols$6F(b)) {
      if (__propIsEnum$6F.call(b, prop))
        __defNormalProp$6F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6F)
    for (var prop of __getOwnPropSymbols$6F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowTopLeftDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6F(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 18 6 6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 14V6h8"
      }
    )
  );
};

var __defProp$6E = Object.defineProperty;
var __getOwnPropSymbols$6E = Object.getOwnPropertySymbols;
var __hasOwnProp$6E = Object.prototype.hasOwnProperty;
var __propIsEnum$6E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6E = (obj, key, value) => key in obj ? __defProp$6E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6E.call(b, prop))
      __defNormalProp$6E(a, prop, b[prop]);
  if (__getOwnPropSymbols$6E)
    for (var prop of __getOwnPropSymbols$6E(b)) {
      if (__propIsEnum$6E.call(b, prop))
        __defNormalProp$6E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6E)
    for (var prop of __getOwnPropSymbols$6E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowTopLeftSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6E(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M6 5a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0V8.414l10.293 10.293a1 1 0 0 0 1.414-1.414L8.414 7H14a1 1 0 1 0 0-2H6Z"
      }
    )
  );
};

var __defProp$6D = Object.defineProperty;
var __getOwnPropSymbols$6D = Object.getOwnPropertySymbols;
var __hasOwnProp$6D = Object.prototype.hasOwnProperty;
var __propIsEnum$6D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6D = (obj, key, value) => key in obj ? __defProp$6D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6D.call(b, prop))
      __defNormalProp$6D(a, prop, b[prop]);
  if (__getOwnPropSymbols$6D)
    for (var prop of __getOwnPropSymbols$6D(b)) {
      if (__propIsEnum$6D.call(b, prop))
        __defNormalProp$6D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6D)
    for (var prop of __getOwnPropSymbols$6D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowTopRightDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6D(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 18 18 6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10 6h8v8"
      }
    )
  );
};

var __defProp$6C = Object.defineProperty;
var __getOwnPropSymbols$6C = Object.getOwnPropertySymbols;
var __hasOwnProp$6C = Object.prototype.hasOwnProperty;
var __propIsEnum$6C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6C = (obj, key, value) => key in obj ? __defProp$6C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6C.call(b, prop))
      __defNormalProp$6C(a, prop, b[prop]);
  if (__getOwnPropSymbols$6C)
    for (var prop of __getOwnPropSymbols$6C(b)) {
      if (__propIsEnum$6C.call(b, prop))
        __defNormalProp$6C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6C)
    for (var prop of __getOwnPropSymbols$6C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowTopRightSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6C(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M10 5a1 1 0 0 0 0 2h5.586L5.293 17.293a1 1 0 1 0 1.414 1.414L17 8.414V14a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1h-8Z"
      }
    )
  );
};

var __defProp$6B = Object.defineProperty;
var __getOwnPropSymbols$6B = Object.getOwnPropertySymbols;
var __hasOwnProp$6B = Object.prototype.hasOwnProperty;
var __propIsEnum$6B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6B = (obj, key, value) => key in obj ? __defProp$6B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6B.call(b, prop))
      __defNormalProp$6B(a, prop, b[prop]);
  if (__getOwnPropSymbols$6B)
    for (var prop of __getOwnPropSymbols$6B(b)) {
      if (__propIsEnum$6B.call(b, prop))
        __defNormalProp$6B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6B)
    for (var prop of __getOwnPropSymbols$6B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowUpDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6B(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 20V4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m6 10 6-6 6 6"
      }
    )
  );
};

var __defProp$6A = Object.defineProperty;
var __getOwnPropSymbols$6A = Object.getOwnPropertySymbols;
var __hasOwnProp$6A = Object.prototype.hasOwnProperty;
var __propIsEnum$6A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6A = (obj, key, value) => key in obj ? __defProp$6A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6A.call(b, prop))
      __defNormalProp$6A(a, prop, b[prop]);
  if (__getOwnPropSymbols$6A)
    for (var prop of __getOwnPropSymbols$6A(b)) {
      if (__propIsEnum$6A.call(b, prop))
        __defNormalProp$6A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6A)
    for (var prop of __getOwnPropSymbols$6A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowUpSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6A(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.707 3.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L11 6.414V20a1 1 0 1 0 2 0V6.414l4.293 4.293a1 1 0 0 0 1.414-1.414l-6-6Z"
      }
    )
  );
};

var __defProp$6z = Object.defineProperty;
var __getOwnPropSymbols$6z = Object.getOwnPropertySymbols;
var __hasOwnProp$6z = Object.prototype.hasOwnProperty;
var __propIsEnum$6z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6z = (obj, key, value) => key in obj ? __defProp$6z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6z.call(b, prop))
      __defNormalProp$6z(a, prop, b[prop]);
  if (__getOwnPropSymbols$6z)
    for (var prop of __getOwnPropSymbols$6z(b)) {
      if (__propIsEnum$6z.call(b, prop))
        __defNormalProp$6z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6z)
    for (var prop of __getOwnPropSymbols$6z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowsDownDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 4v11m0 0-4-4m4 4 4-4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 4v16m0 0-4-4m4 4 4-4"
      }
    )
  );
};

var __defProp$6y = Object.defineProperty;
var __getOwnPropSymbols$6y = Object.getOwnPropertySymbols;
var __hasOwnProp$6y = Object.prototype.hasOwnProperty;
var __propIsEnum$6y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6y = (obj, key, value) => key in obj ? __defProp$6y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6y.call(b, prop))
      __defNormalProp$6y(a, prop, b[prop]);
  if (__getOwnPropSymbols$6y)
    for (var prop of __getOwnPropSymbols$6y(b)) {
      if (__propIsEnum$6y.call(b, prop))
        __defNormalProp$6y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6y)
    for (var prop of __getOwnPropSymbols$6y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgArrowsDownSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m6 17.586-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L8 17.586V4a1 1 0 1 0-2 0v13.586Zm12-5 2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 12.586V4a1 1 0 1 1 2 0v8.586Z"
      }
    )
  );
};

var __defProp$6x = Object.defineProperty;
var __getOwnPropSymbols$6x = Object.getOwnPropertySymbols;
var __hasOwnProp$6x = Object.prototype.hasOwnProperty;
var __propIsEnum$6x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6x = (obj, key, value) => key in obj ? __defProp$6x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6x.call(b, prop))
      __defNormalProp$6x(a, prop, b[prop]);
  if (__getOwnPropSymbols$6x)
    for (var prop of __getOwnPropSymbols$6x(b)) {
      if (__propIsEnum$6x.call(b, prop))
        __defNormalProp$6x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6x)
    for (var prop of __getOwnPropSymbols$6x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAttachmentDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6x(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21.152 10.9-9.015 9.015a5.25 5.25 0 1 1-7.425-7.424l9.016-9.016a3.5 3.5 0 1 1 4.95 4.95l-8.662 8.662a1.75 1.75 0 0 1-2.475-2.475l7.601-7.602"
      }
    )
  );
};

var __defProp$6w = Object.defineProperty;
var __getOwnPropSymbols$6w = Object.getOwnPropertySymbols;
var __hasOwnProp$6w = Object.prototype.hasOwnProperty;
var __propIsEnum$6w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6w = (obj, key, value) => key in obj ? __defProp$6w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6w.call(b, prop))
      __defNormalProp$6w(a, prop, b[prop]);
  if (__getOwnPropSymbols$6w)
    for (var prop of __getOwnPropSymbols$6w(b)) {
      if (__propIsEnum$6w.call(b, prop))
        __defNormalProp$6w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6w)
    for (var prop of __getOwnPropSymbols$6w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgAttachmentSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6w(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.97 4.182a2.5 2.5 0 0 0-3.535 0l-9.016 9.016a4.25 4.25 0 1 0 6.01 6.01l9.016-9.016a1 1 0 0 1 1.415 1.415l-9.016 9.015a6.25 6.25 0 1 1-8.839-8.839l9.016-9.015a4.5 4.5 0 1 1 6.364 6.364l-8.662 8.662a2.75 2.75 0 0 1-3.89-3.89l7.602-7.6a1 1 0 1 1 1.414 1.414l-7.601 7.6a.75.75 0 0 0 1.06 1.062l8.663-8.662a2.5 2.5 0 0 0 0-3.536Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6v = Object.defineProperty;
var __getOwnPropSymbols$6v = Object.getOwnPropertySymbols;
var __hasOwnProp$6v = Object.prototype.hasOwnProperty;
var __propIsEnum$6v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6v = (obj, key, value) => key in obj ? __defProp$6v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6v.call(b, prop))
      __defNormalProp$6v(a, prop, b[prop]);
  if (__getOwnPropSymbols$6v)
    for (var prop of __getOwnPropSymbols$6v(b)) {
      if (__propIsEnum$6v.call(b, prop))
        __defNormalProp$6v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6v)
    for (var prop of __getOwnPropSymbols$6v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBadgeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6v(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11.29 3.366c.23-.442.345-.663.499-.735a.5.5 0 0 1 .422 0c.154.072.27.293.499.735l1.513 2.913c.099.19.148.286.223.35a.5.5 0 0 0 .229.11c.096.018.201-.003.412-.044l3.22-.633c.49-.096.734-.144.886-.069a.5.5 0 0 1 .263.331c.04.165-.06.393-.263.848l-1.334 2.999c-.087.196-.13.294-.134.392a.5.5 0 0 0 .056.248c.046.086.128.156.292.295l2.502 2.123c.38.322.57.484.606.65a.5.5 0 0 1-.094.412c-.105.134-.346.197-.828.322l-3.176.827c-.208.055-.312.082-.39.14a.5.5 0 0 0-.159.199c-.039.089-.042.196-.049.411l-.1 3.28c-.015.498-.022.748-.13.879a.5.5 0 0 1-.38.183c-.17.003-.37-.147-.769-.445l-2.626-1.968c-.172-.129-.258-.193-.353-.218a.5.5 0 0 0-.254 0c-.095.025-.18.09-.353.218l-2.626 1.968c-.4.298-.598.448-.768.445a.5.5 0 0 1-.381-.183c-.108-.131-.115-.38-.13-.878l-.1-3.28c-.007-.216-.01-.323-.05-.412a.5.5 0 0 0-.158-.2c-.078-.058-.182-.085-.39-.139l-3.176-.827c-.482-.125-.723-.188-.828-.322a.5.5 0 0 1-.094-.412c.036-.166.226-.328.606-.65l2.503-2.123c.163-.14.245-.209.29-.295a.5.5 0 0 0 .057-.248c-.003-.098-.047-.196-.134-.392L4.807 7.172c-.202-.455-.303-.683-.263-.848a.5.5 0 0 1 .263-.33c.152-.076.397-.028.886.068l3.22.633c.21.041.316.062.412.043a.5.5 0 0 0 .23-.11c.073-.063.123-.159.222-.35l1.513-2.912Z"
      }
    )
  );
};

var __defProp$6u = Object.defineProperty;
var __getOwnPropSymbols$6u = Object.getOwnPropertySymbols;
var __hasOwnProp$6u = Object.prototype.hasOwnProperty;
var __propIsEnum$6u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6u = (obj, key, value) => key in obj ? __defProp$6u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6u.call(b, prop))
      __defNormalProp$6u(a, prop, b[prop]);
  if (__getOwnPropSymbols$6u)
    for (var prop of __getOwnPropSymbols$6u(b)) {
      if (__propIsEnum$6u.call(b, prop))
        __defNormalProp$6u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6u)
    for (var prop of __getOwnPropSymbols$6u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBadgeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6u(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.634 1.725a1.5 1.5 0 0 0-1.268 0c-.345.16-.54.438-.64.595-.102.159-.207.36-.307.555l-1.46 2.81-3.107-.61a7.415 7.415 0 0 0-.626-.106c-.185-.02-.523-.04-.864.129a1.5 1.5 0 0 0-.79.992c-.09.369.006.694.066.87.06.18.153.387.242.587l1.286 2.893-2.414 2.049c-.167.141-.34.288-.473.423-.13.133-.357.384-.437.756a1.5 1.5 0 0 0 .282 1.237c.233.3.547.428.722.49.178.065.398.122.61.177l3.064.798.096 3.165c.007.219.013.446.036.633.023.185.078.52.318.814.281.343.7.545 1.144.55.38.005.675-.16.834-.258.16-.099.343-.235.518-.366L12 19.009l2.534 1.898c.175.132.357.268.518.367.159.098.455.263.835.258a1.5 1.5 0 0 0 1.143-.55c.24-.294.295-.629.318-.814.023-.187.03-.414.036-.633l.096-3.165 3.064-.798c.212-.055.432-.112.61-.176.175-.063.489-.192.722-.491a1.5 1.5 0 0 0 .282-1.237c-.08-.371-.307-.623-.437-.756a7.372 7.372 0 0 0-.473-.423l-2.414-2.049 1.286-2.893c.09-.2.182-.408.242-.586.06-.177.156-.502.067-.871a1.5 1.5 0 0 0-.791-.992c-.34-.17-.679-.149-.864-.13-.188.02-.411.064-.626.106l-3.107.61-1.46-2.81a7.409 7.409 0 0 0-.307-.554c-.1-.157-.295-.434-.64-.595Z"
      }
    )
  );
};

var __defProp$6t = Object.defineProperty;
var __getOwnPropSymbols$6t = Object.getOwnPropertySymbols;
var __hasOwnProp$6t = Object.prototype.hasOwnProperty;
var __propIsEnum$6t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6t = (obj, key, value) => key in obj ? __defProp$6t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6t.call(b, prop))
      __defNormalProp$6t(a, prop, b[prop]);
  if (__getOwnPropSymbols$6t)
    for (var prop of __getOwnPropSymbols$6t(b)) {
      if (__propIsEnum$6t.call(b, prop))
        __defNormalProp$6t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6t)
    for (var prop of __getOwnPropSymbols$6t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBanDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6t(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m4.93 4.93 14.14 14.14",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
      }
    )
  );
};

var __defProp$6s = Object.defineProperty;
var __getOwnPropSymbols$6s = Object.getOwnPropertySymbols;
var __hasOwnProp$6s = Object.prototype.hasOwnProperty;
var __propIsEnum$6s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6s = (obj, key, value) => key in obj ? __defProp$6s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6s.call(b, prop))
      __defNormalProp$6s(a, prop, b[prop]);
  if (__getOwnPropSymbols$6s)
    for (var prop of __getOwnPropSymbols$6s(b)) {
      if (__propIsEnum$6s.call(b, prop))
        __defNormalProp$6s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6s)
    for (var prop of __getOwnPropSymbols$6s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBanSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6s(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM6.382 4.968a9 9 0 0 1 12.65 12.65L6.382 4.968ZM4.968 6.382a9 9 0 0 0 12.65 12.65L4.968 6.382Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6r = Object.defineProperty;
var __getOwnPropSymbols$6r = Object.getOwnPropertySymbols;
var __hasOwnProp$6r = Object.prototype.hasOwnProperty;
var __propIsEnum$6r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6r = (obj, key, value) => key in obj ? __defProp$6r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6r.call(b, prop))
      __defNormalProp$6r(a, prop, b[prop]);
  if (__getOwnPropSymbols$6r)
    for (var prop of __getOwnPropSymbols$6r(b)) {
      if (__propIsEnum$6r.call(b, prop))
        __defNormalProp$6r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6r)
    for (var prop of __getOwnPropSymbols$6r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBellDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6r(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9.354 21c.705.622 1.632 1 2.646 1s1.94-.378 2.646-1",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 8A6 6 0 1 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8Z"
      }
    )
  );
};

var __defProp$6q = Object.defineProperty;
var __getOwnPropSymbols$6q = Object.getOwnPropertySymbols;
var __hasOwnProp$6q = Object.prototype.hasOwnProperty;
var __propIsEnum$6q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6q = (obj, key, value) => key in obj ? __defProp$6q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6q.call(b, prop))
      __defNormalProp$6q(a, prop, b[prop]);
  if (__getOwnPropSymbols$6q)
    for (var prop of __getOwnPropSymbols$6q(b)) {
      if (__propIsEnum$6q.call(b, prop))
        __defNormalProp$6q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6q)
    for (var prop of __getOwnPropSymbols$6q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBellSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.604 20.338a1 1 0 0 1 1.412-.088c.53.468 1.223.75 1.984.75.761 0 1.455-.282 1.984-.75a1 1 0 1 1 1.323 1.5A4.984 4.984 0 0 1 12 23a4.984 4.984 0 0 1-3.308-1.25 1 1 0 0 1-.088-1.412ZM7.05 3.05A7 7 0 0 1 19 8c0 2.913.732 4.844 1.5 6.077l.011.02c.358.573.64 1.027.83 1.358.096.165.183.325.247.466.032.071.068.158.096.252.024.079.068.246.051.45-.01.136-.039.37-.173.611a1.482 1.482 0 0 1-.428.47c-.25.186-.538.229-.634.243h-.004a4.619 4.619 0 0 1-.483.04c-.336.013-.8.013-1.377.013H5.364c-.577 0-1.041 0-1.376-.013a4.618 4.618 0 0 1-.484-.04H3.5a1.405 1.405 0 0 1-.634-.242 1.48 1.48 0 0 1-.428-.47 1.482 1.482 0 0 1-.173-.613c-.017-.203.027-.37.05-.449.029-.094.065-.18.097-.251a5.66 5.66 0 0 1 .247-.467c.19-.33.472-.785.83-1.359l.012-.019C4.268 12.844 5 10.913 5 8a7 7 0 0 1 2.05-4.95Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6p = Object.defineProperty;
var __getOwnPropSymbols$6p = Object.getOwnPropertySymbols;
var __hasOwnProp$6p = Object.prototype.hasOwnProperty;
var __propIsEnum$6p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6p = (obj, key, value) => key in obj ? __defProp$6p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6p.call(b, prop))
      __defNormalProp$6p(a, prop, b[prop]);
  if (__getOwnPropSymbols$6p)
    for (var prop of __getOwnPropSymbols$6p(b)) {
      if (__propIsEnum$6p.call(b, prop))
        __defNormalProp$6p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6p)
    for (var prop of __getOwnPropSymbols$6p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBezierCurve03Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6p(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.857 7 5.143 17M6 19h12m.857-2L13.143 7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 18.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 17 3.04 17 3.6 17h.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C6 17.76 6 18.04 6 18.6v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C5.24 21 4.96 21 4.4 21h-.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C2 20.24 2 19.96 2 19.4v-.8Zm16 0c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C18.76 17 19.04 17 19.6 17h.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C22 17.76 22 18.04 22 18.6v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.24 21 20.96 21 20.4 21h-.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C18 20.24 18 19.96 18 19.4v-.8Zm-8-14c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C10.76 3 11.04 3 11.6 3h.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C14 3.76 14 4.04 14 4.6v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C13.24 7 12.96 7 12.4 7h-.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C10 6.24 10 5.96 10 5.4v-.8Z"
      }
    )
  );
};

var __defProp$6o = Object.defineProperty;
var __getOwnPropSymbols$6o = Object.getOwnPropertySymbols;
var __hasOwnProp$6o = Object.prototype.hasOwnProperty;
var __propIsEnum$6o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6o = (obj, key, value) => key in obj ? __defProp$6o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6o.call(b, prop))
      __defNormalProp$6o(a, prop, b[prop]);
  if (__getOwnPropSymbols$6o)
    for (var prop of __getOwnPropSymbols$6o(b)) {
      if (__propIsEnum$6o.call(b, prop))
        __defNormalProp$6o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6o)
    for (var prop of __getOwnPropSymbols$6o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBezierCurve03Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6o(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.568 2c-.252 0-.498 0-.706.017a2.022 2.022 0 0 0-.77.201 2 2 0 0 0-.874.874 2.022 2.022 0 0 0-.201.77C9 4.07 9 4.316 9 4.568v.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .295.43L4.563 16h-.995c-.252 0-.498 0-.706.017a2.02 2.02 0 0 0-.77.201 2 2 0 0 0-.874.874 2.022 2.022 0 0 0-.201.77C1 18.07 1 18.316 1 18.568v.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h.864c.252 0 .498 0 .706-.017a2.03 2.03 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2.03 2.03 0 0 0 .201-.77c.004-.044.007-.09.009-.138h10.016c.003.048.005.094.009.138.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h.864c.252 0 .498 0 .706-.017a2.03 2.03 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2.03 2.03 0 0 0 .201-.77c.017-.208.017-.454.017-.706v-.864c0-.252 0-.498-.017-.706a2.022 2.022 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2.02 2.02 0 0 0-.77-.201C20.93 16 20.684 16 20.432 16h-.995l-4.95-8.663c.116-.129.215-.273.295-.429a2.03 2.03 0 0 0 .201-.77C15 5.93 15 5.684 15 5.432v-.864c0-.252 0-.498-.017-.706a2.022 2.022 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2.022 2.022 0 0 0-.77-.201C12.93 2 12.684 2 12.432 2h-.864Zm-.13 6h1.124l4.95 8.663a2 2 0 0 0-.294.429 2.02 2.02 0 0 0-.201.77c-.004.044-.006.09-.009.138H6.992a4.034 4.034 0 0 0-.009-.138 2.022 2.022 0 0 0-.201-.77 2.05 2.05 0 0 0-.295-.43L11.437 8Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6n = Object.defineProperty;
var __getOwnPropSymbols$6n = Object.getOwnPropertySymbols;
var __hasOwnProp$6n = Object.prototype.hasOwnProperty;
var __propIsEnum$6n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6n = (obj, key, value) => key in obj ? __defProp$6n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6n.call(b, prop))
      __defNormalProp$6n(a, prop, b[prop]);
  if (__getOwnPropSymbols$6n)
    for (var prop of __getOwnPropSymbols$6n(b)) {
      if (__propIsEnum$6n.call(b, prop))
        __defNormalProp$6n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6n)
    for (var prop of __getOwnPropSymbols$6n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBillDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6n(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 3 7.12 3 8.8 3h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 5.28 20 6.12 20 7.8V21l-2.75-2-2.5 2L12 19l-2.75 2-2.5-2L4 21V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 10.5 2 2L15.5 8"
      }
    )
  );
};

var __defProp$6m = Object.defineProperty;
var __getOwnPropSymbols$6m = Object.getOwnPropertySymbols;
var __hasOwnProp$6m = Object.prototype.hasOwnProperty;
var __propIsEnum$6m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6m = (obj, key, value) => key in obj ? __defProp$6m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6m.call(b, prop))
      __defNormalProp$6m(a, prop, b[prop]);
  if (__getOwnPropSymbols$6m)
    for (var prop of __getOwnPropSymbols$6m(b)) {
      if (__propIsEnum$6m.call(b, prop))
        __defNormalProp$6m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6m)
    for (var prop of __getOwnPropSymbols$6m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBillSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6m(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.759 2h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 6.29 21 6.954 21 7.758V21a1 1 0 0 1-1.588.809l-2.133-1.552-1.904 1.524a1 1 0 0 1-1.213.028L12 20.236 9.838 21.81a1 1 0 0 1-1.213-.028l-1.904-1.523-2.133 1.55A1 1 0 0 1 3 21V7.759c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 2 7.954 2 8.758 2Zm7.448 6.707a1 1 0 0 0-1.414-1.414L11 11.086 9.707 9.793a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6l = Object.defineProperty;
var __getOwnPropSymbols$6l = Object.getOwnPropertySymbols;
var __hasOwnProp$6l = Object.prototype.hasOwnProperty;
var __propIsEnum$6l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6l = (obj, key, value) => key in obj ? __defProp$6l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6l.call(b, prop))
      __defNormalProp$6l(a, prop, b[prop]);
  if (__getOwnPropSymbols$6l)
    for (var prop of __getOwnPropSymbols$6l(b)) {
      if (__propIsEnum$6l.call(b, prop))
        __defNormalProp$6l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6l)
    for (var prop of __getOwnPropSymbols$6l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBlockqouteDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6l(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 9.25h-9M21 4h-9m9 10.75H3M21 20H3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 9.4c0 .515 0 .772.106.908a.5.5 0 0 0 .384.192c.172.004.378-.151.79-.46l3.867-2.9c.29-.217.434-.326.486-.459a.5.5 0 0 0 0-.362c-.052-.133-.197-.242-.486-.459L4.28 2.96c-.412-.309-.618-.463-.79-.46a.5.5 0 0 0-.384.192C3 2.828 3 3.085 3 3.6v5.8Z"
      }
    )
  );
};

var __defProp$6k = Object.defineProperty;
var __getOwnPropSymbols$6k = Object.getOwnPropertySymbols;
var __hasOwnProp$6k = Object.prototype.hasOwnProperty;
var __propIsEnum$6k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6k = (obj, key, value) => key in obj ? __defProp$6k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6k.call(b, prop))
      __defNormalProp$6k(a, prop, b[prop]);
  if (__getOwnPropSymbols$6k)
    for (var prop of __getOwnPropSymbols$6k(b)) {
      if (__propIsEnum$6k.call(b, prop))
        __defNormalProp$6k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6k)
    for (var prop of __getOwnPropSymbols$6k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBlockqouteSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6k(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M4.852 2.139a7.56 7.56 0 0 0-.532-.377c-.16-.099-.463-.27-.851-.262a1.5 1.5 0 0 0-1.15.575c-.24.306-.285.651-.302.838C2 3.105 2 3.338 2 3.565v5.87c0 .227 0 .46.017.652.017.187.063.532.302.838a1.5 1.5 0 0 0 1.15.575c.388.008.691-.163.85-.262a7.34 7.34 0 0 0 .533-.377L8.77 7.923c.125-.093.266-.199.379-.3.124-.112.307-.299.417-.58a1.5 1.5 0 0 0 0-1.087 1.522 1.522 0 0 0-.417-.579 5.679 5.679 0 0 0-.379-.3L4.852 2.139ZM12 3a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-9Zm0 5.25a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-9Zm-10 6.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"
      }
    )
  );
};

var __defProp$6j = Object.defineProperty;
var __getOwnPropSymbols$6j = Object.getOwnPropertySymbols;
var __hasOwnProp$6j = Object.prototype.hasOwnProperty;
var __propIsEnum$6j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6j = (obj, key, value) => key in obj ? __defProp$6j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6j.call(b, prop))
      __defNormalProp$6j(a, prop, b[prop]);
  if (__getOwnPropSymbols$6j)
    for (var prop of __getOwnPropSymbols$6j(b)) {
      if (__propIsEnum$6j.call(b, prop))
        __defNormalProp$6j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6j)
    for (var prop of __getOwnPropSymbols$6j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBookOpenDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6j(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 3 19.92 3 18.8 3h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C12 6.04 12 7.16 12 9.4V21l.1-.15c.695-1.042 1.042-1.563 1.5-1.94a3.999 3.999 0 0 1 1.378-.737C15.547 18 16.173 18 17.425 18H18.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V6.2Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 3 4.08 3 5.2 3h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 6.04 12 7.16 12 9.4V21l-.1-.15c-.695-1.042-1.042-1.563-1.5-1.94a4 4 0 0 0-1.378-.737C8.453 18 7.827 18 6.575 18H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V6.2Z"
      }
    )
  );
};

var __defProp$6i = Object.defineProperty;
var __getOwnPropSymbols$6i = Object.getOwnPropertySymbols;
var __hasOwnProp$6i = Object.prototype.hasOwnProperty;
var __propIsEnum$6i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6i = (obj, key, value) => key in obj ? __defProp$6i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6i.call(b, prop))
      __defNormalProp$6i(a, prop, b[prop]);
  if (__getOwnPropSymbols$6i)
    for (var prop of __getOwnPropSymbols$6i(b)) {
      if (__propIsEnum$6i.call(b, prop))
        __defNormalProp$6i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6i)
    for (var prop of __getOwnPropSymbols$6i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBookOpenSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6i(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m18.221 1.998.617.002c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.31c.193.38.264.772.296 1.168.031.374.031.83.031 1.356v8.677c0 .528 0 .982-.03 1.357-.033.395-.104.788-.297 1.167a3 3 0 0 1-1.311 1.31c-.378.194-.772.265-1.167.297-.669.055-1.346.046-2.02.037-.251-.003-.5-.006-.75-.006-1.314 0-1.763.01-2.156.13a3 3 0 0 0-1.033.552c-.46.378-.797.915-1.121 1.431-.094.15-.187.297-.28.438a.999.999 0 0 1-1.667.004c-.095-.143-.188-.291-.283-.442-.324-.516-.661-1.053-1.12-1.43a3 3 0 0 0-1.034-.554c-.393-.119-.842-.13-2.156-.13-.25 0-.499.004-.75.007-.674.01-1.351.018-2.02-.037-.395-.032-.789-.103-1.167-.296a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 15.82 1 15.365 1 14.838V6.161c0-.527 0-.982.03-1.356.033-.396.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.297C4.18 2 4.635 2 5.161 2l.618-.002c.844-.005 1.69-.009 2.53.06.728.06 1.369.185 1.961.487A5 5 0 0 1 12 4a5 5 0 0 1 1.73-1.455c.592-.302 1.232-.428 1.961-.487.84-.069 1.686-.065 2.53-.06Z"
      }
    )
  );
};

var __defProp$6h = Object.defineProperty;
var __getOwnPropSymbols$6h = Object.getOwnPropertySymbols;
var __hasOwnProp$6h = Object.prototype.hasOwnProperty;
var __propIsEnum$6h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6h = (obj, key, value) => key in obj ? __defProp$6h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6h.call(b, prop))
      __defNormalProp$6h(a, prop, b[prop]);
  if (__getOwnPropSymbols$6h)
    for (var prop of __getOwnPropSymbols$6h(b)) {
      if (__propIsEnum$6h.call(b, prop))
        __defNormalProp$6h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6h)
    for (var prop of __getOwnPropSymbols$6h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBotDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#1B1C1E",
        d: "M8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z",
        opacity: 0.12
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#1B1C1E",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m22 2-2 2m2 18-2-2M2 22l2-2M2 2l2 2m4-2v1.5M22 8h-1.5M16 22v-1.5M2 16h1.5M8 18v3.5M22 16h-4M16 2v4M2 8h4m6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
      }
    )
  );
};

var __defProp$6g = Object.defineProperty;
var __getOwnPropSymbols$6g = Object.getOwnPropertySymbols;
var __hasOwnProp$6g = Object.prototype.hasOwnProperty;
var __propIsEnum$6g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6g = (obj, key, value) => key in obj ? __defProp$6g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6g.call(b, prop))
      __defNormalProp$6g(a, prop, b[prop]);
  if (__getOwnPropSymbols$6g)
    for (var prop of __getOwnPropSymbols$6g(b)) {
      if (__propIsEnum$6g.call(b, prop))
        __defNormalProp$6g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6g)
    for (var prop of __getOwnPropSymbols$6g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBotSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#1B1C1E",
        fillRule: "evenodd",
        d: "M22.707 1.293a1 1 0 0 1 0 1.414l-2 2a1 1 0 1 1-1.414-1.414l2-2a1 1 0 0 1 1.414 0ZM23 8a1 1 0 0 1-1 1h-1.5a1 1 0 1 1 0-2H22a1 1 0 0 1 1 1Zm-.293 13.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 1.414-1.414l2 2ZM23 16a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1ZM16 1a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Zm-4 6a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm4 12.5a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-1.5a1 1 0 0 1 1-1Zm-9-16V2a1 1 0 1 1 2 0v1.5a1 1 0 1 1-2 0ZM8 17a1 1 0 0 1 1 1v3.5a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1ZM7 8a1 1 0 0 1-1 1H2a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1ZM4.707 4.707a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l2 2a1 1 0 0 1 0 1.414Zm0 14.586a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414l2-2a1 1 0 0 1 1.414 0ZM4.5 16a1 1 0 0 1-1 1H2a1 1 0 1 1 0-2h1.5a1 1 0 0 1 1 1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$6f = Object.defineProperty;
var __getOwnPropSymbols$6f = Object.getOwnPropertySymbols;
var __hasOwnProp$6f = Object.prototype.hasOwnProperty;
var __propIsEnum$6f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6f = (obj, key, value) => key in obj ? __defProp$6f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6f.call(b, prop))
      __defNormalProp$6f(a, prop, b[prop]);
  if (__getOwnPropSymbols$6f)
    for (var prop of __getOwnPropSymbols$6f(b)) {
      if (__propIsEnum$6f.call(b, prop))
        __defNormalProp$6f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6f)
    for (var prop of __getOwnPropSymbols$6f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBrandDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 2 2.012 5.231c.282.733.423 1.1.642 1.408.195.274.433.512.707.707.308.219.675.36 1.408.642L22 12l-5.231 2.012c-.733.282-1.1.423-1.408.642a3.003 3.003 0 0 0-.707.707c-.219.308-.36.675-.642 1.408L12 22l-2.012-5.231c-.282-.733-.423-1.1-.642-1.408a3.002 3.002 0 0 0-.707-.707c-.308-.219-.675-.36-1.408-.642L2 12l5.231-2.012c.733-.282 1.1-.423 1.408-.642a3 3 0 0 0 .707-.707c.219-.308.36-.675.642-1.408L12 2Z"
      }
    )
  );
};

var __defProp$6e = Object.defineProperty;
var __getOwnPropSymbols$6e = Object.getOwnPropertySymbols;
var __hasOwnProp$6e = Object.prototype.hasOwnProperty;
var __propIsEnum$6e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6e = (obj, key, value) => key in obj ? __defProp$6e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6e.call(b, prop))
      __defNormalProp$6e(a, prop, b[prop]);
  if (__getOwnPropSymbols$6e)
    for (var prop of __getOwnPropSymbols$6e(b)) {
      if (__propIsEnum$6e.call(b, prop))
        __defNormalProp$6e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6e)
    for (var prop of __getOwnPropSymbols$6e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBrandSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.933 1.641a1 1 0 0 0-1.866 0L9.055 6.872c-.3.781-.395 1.006-.524 1.188a2 2 0 0 1-.471.47c-.182.13-.407.224-1.188.525l-5.231 2.012a1 1 0 0 0 0 1.866l5.231 2.012c.781.3 1.006.395 1.188.524.182.13.341.289.47.471.13.182.224.407.525 1.188l2.012 5.231a1 1 0 0 0 1.866 0l2.012-5.231c.3-.781.395-1.006.524-1.188.13-.182.289-.341.471-.47.182-.13.407-.224 1.188-.525l5.231-2.012a1 1 0 0 0 0-1.866l-5.231-2.012c-.781-.3-1.006-.395-1.188-.524a2.001 2.001 0 0 1-.47-.471c-.13-.182-.224-.407-.525-1.188l-2.012-5.231Z"
      }
    )
  );
};

var __defProp$6d = Object.defineProperty;
var __getOwnPropSymbols$6d = Object.getOwnPropertySymbols;
var __hasOwnProp$6d = Object.prototype.hasOwnProperty;
var __propIsEnum$6d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6d = (obj, key, value) => key in obj ? __defProp$6d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6d.call(b, prop))
      __defNormalProp$6d(a, prop, b[prop]);
  if (__getOwnPropSymbols$6d)
    for (var prop of __getOwnPropSymbols$6d(b)) {
      if (__propIsEnum$6d.call(b, prop))
        __defNormalProp$6d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6d)
    for (var prop of __getOwnPropSymbols$6d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBrightnessDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m6.5 13 .784 1.569c.266.53.399.796.576 1.026a3 3 0 0 0 .545.545c.23.177.495.31 1.026.575L11 17.5l-1.569.785c-.53.265-.796.398-1.026.575a3 3 0 0 0-.545.545c-.177.23-.31.495-.576 1.026L6.5 22l-.784-1.569c-.266-.53-.399-.796-.576-1.026a3 3 0 0 0-.545-.545c-.23-.177-.495-.31-1.026-.575L2 17.5l1.569-.785c.53-.265.796-.398 1.026-.575a3 3 0 0 0 .545-.545c.177-.23.31-.495.576-1.026L6.5 13Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m15 2 1.179 3.064c.282.734.423 1.1.642 1.409a3 3 0 0 0 .706.706c.309.22.675.36 1.409.642L22 9l-3.064 1.179c-.734.282-1.1.423-1.409.642a3 3 0 0 0-.706.706c-.22.309-.36.675-.642 1.409L15 16l-1.179-3.064c-.282-.734-.423-1.1-.642-1.409a3 3 0 0 0-.706-.706c-.309-.22-.675-.36-1.409-.642L8 9l3.064-1.179c.734-.282 1.1-.423 1.409-.642a3 3 0 0 0 .706-.706c.22-.309.36-.675.642-1.409L15 2Z"
      }
    )
  );
};

var __defProp$6c = Object.defineProperty;
var __getOwnPropSymbols$6c = Object.getOwnPropertySymbols;
var __hasOwnProp$6c = Object.prototype.hasOwnProperty;
var __propIsEnum$6c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6c = (obj, key, value) => key in obj ? __defProp$6c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6c.call(b, prop))
      __defNormalProp$6c(a, prop, b[prop]);
  if (__getOwnPropSymbols$6c)
    for (var prop of __getOwnPropSymbols$6c(b)) {
      if (__propIsEnum$6c.call(b, prop))
        __defNormalProp$6c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6c)
    for (var prop of __getOwnPropSymbols$6c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBrightnessSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.933 1.641a1 1 0 0 0-1.866 0l-1.179 3.064c-.3.781-.395 1.007-.524 1.188a2 2 0 0 1-.47.471c-.182.13-.408.224-1.189.524L7.641 8.067a1 1 0 0 0 0 1.866l3.064 1.179c.781.3 1.007.395 1.188.524.182.13.341.289.471.47.13.182.224.408.524 1.189l1.179 3.064a1 1 0 0 0 1.866 0l1.179-3.064c.3-.781.395-1.007.524-1.188a2.04 2.04 0 0 1 .47-.471c.182-.13.407-.224 1.189-.524l3.064-1.179a1 1 0 0 0 0-1.866l-3.064-1.179c-.782-.3-1.007-.395-1.188-.524a1.997 1.997 0 0 1-.471-.47c-.13-.182-.224-.408-.524-1.189l-1.179-3.064ZM7.394 12.553a1 1 0 0 0-1.788 0l-.785 1.569c-.282.565-.368.727-.473.863a2.003 2.003 0 0 1-.363.363c-.136.104-.298.19-.863.473l-1.57.785a1 1 0 0 0 0 1.788l1.57.785c.565.282.727.369.863.473.136.105.258.227.363.363.105.136.19.298.473.863l.785 1.57a1 1 0 0 0 1.788 0l.785-1.57c.282-.565.368-.727.473-.863.105-.136.227-.258.363-.363.136-.105.298-.19.863-.473l1.57-.785a1 1 0 0 0 0-1.788l-1.57-.785c-.565-.282-.727-.368-.863-.473a2.003 2.003 0 0 1-.363-.363c-.105-.136-.19-.298-.473-.863l-.785-1.57Z"
      }
    )
  );
};

var __defProp$6b = Object.defineProperty;
var __getOwnPropSymbols$6b = Object.getOwnPropertySymbols;
var __hasOwnProp$6b = Object.prototype.hasOwnProperty;
var __propIsEnum$6b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6b = (obj, key, value) => key in obj ? __defProp$6b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6b.call(b, prop))
      __defNormalProp$6b(a, prop, b[prop]);
  if (__getOwnPropSymbols$6b)
    for (var prop of __getOwnPropSymbols$6b(b)) {
      if (__propIsEnum$6b.call(b, prop))
        __defNormalProp$6b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6b)
    for (var prop of __getOwnPropSymbols$6b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBrowserDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 9H2",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21h10.4Z"
      }
    )
  );
};

var __defProp$6a = Object.defineProperty;
var __getOwnPropSymbols$6a = Object.getOwnPropertySymbols;
var __hasOwnProp$6a = Object.prototype.hasOwnProperty;
var __propIsEnum$6a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6a = (obj, key, value) => key in obj ? __defProp$6a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6a.call(b, prop))
      __defNormalProp$6a(a, prop, b[prop]);
  if (__getOwnPropSymbols$6a)
    for (var prop of __getOwnPropSymbols$6a(b)) {
      if (__propIsEnum$6a.call(b, prop))
        __defNormalProp$6a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6a)
    for (var prop of __getOwnPropSymbols$6a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBrowserSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.241 2H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564-.018.217-.029.434-.036.652-.017.542-.025.813.081 1.034.092.19.251.355.438.453C1.745 8 2.03 8 2.6 8h18.8c.57 0 .855 0 1.073-.113.187-.098.346-.263.438-.453.106-.22.098-.492.08-1.034a13.131 13.131 0 0 0-.035-.652c-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 2 18.046 2 17.242 2ZM23 11.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 10 21.96 10 21.4 10H2.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 10.76 1 11.04 1 11.6v4.641c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V11.6Z"
      }
    )
  );
};

var __defProp$69 = Object.defineProperty;
var __getOwnPropSymbols$69 = Object.getOwnPropertySymbols;
var __hasOwnProp$69 = Object.prototype.hasOwnProperty;
var __propIsEnum$69 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$69 = (obj, key, value) => key in obj ? __defProp$69(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$69 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$69.call(b, prop))
      __defNormalProp$69(a, prop, b[prop]);
  if (__getOwnPropSymbols$69)
    for (var prop of __getOwnPropSymbols$69(b)) {
      if (__propIsEnum$69.call(b, prop))
        __defNormalProp$69(a, prop, b[prop]);
    }
  return a;
};
var __objRest$69 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$69.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$69)
    for (var prop of __getOwnPropSymbols$69(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$69.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBuilding05Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$69(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$69({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 11h4.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 12.52 21 13.08 21 14.2V21",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 21V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C11.48 3 10.92 3 9.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2V21m19 0H2M6.5 7h3m-3 4h3m-3 4h3"
      }
    )
  );
};

var __defProp$68 = Object.defineProperty;
var __getOwnPropSymbols$68 = Object.getOwnPropertySymbols;
var __hasOwnProp$68 = Object.prototype.hasOwnProperty;
var __propIsEnum$68 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$68 = (obj, key, value) => key in obj ? __defProp$68(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$68 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$68.call(b, prop))
      __defNormalProp$68(a, prop, b[prop]);
  if (__getOwnPropSymbols$68)
    for (var prop of __getOwnPropSymbols$68(b)) {
      if (__propIsEnum$68.call(b, prop))
        __defNormalProp$68(a, prop, b[prop]);
    }
  return a;
};
var __objRest$68 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$68.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$68)
    for (var prop of __getOwnPropSymbols$68(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$68.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBuilding05Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$68(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$68({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V20a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2v-5.838c0-.528 0-.982-.03-1.357-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C18.82 10 18.365 10 17.838 10H14V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 9.839 2ZM5 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$67 = Object.defineProperty;
var __getOwnPropSymbols$67 = Object.getOwnPropertySymbols;
var __hasOwnProp$67 = Object.prototype.hasOwnProperty;
var __propIsEnum$67 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$67 = (obj, key, value) => key in obj ? __defProp$67(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$67 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$67.call(b, prop))
      __defNormalProp$67(a, prop, b[prop]);
  if (__getOwnPropSymbols$67)
    for (var prop of __getOwnPropSymbols$67(b)) {
      if (__propIsEnum$67.call(b, prop))
        __defNormalProp$67(a, prop, b[prop]);
    }
  return a;
};
var __objRest$67 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$67.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$67)
    for (var prop of __getOwnPropSymbols$67(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$67.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBusinessContactDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$67(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$67({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18.684 19.438A4.001 4.001 0 0 0 15 17H9a4.001 4.001 0 0 0-3.684 2.438",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 13.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
      }
    )
  );
};

var __defProp$66 = Object.defineProperty;
var __getOwnPropSymbols$66 = Object.getOwnPropertySymbols;
var __hasOwnProp$66 = Object.prototype.hasOwnProperty;
var __propIsEnum$66 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$66 = (obj, key, value) => key in obj ? __defProp$66(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$66 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$66.call(b, prop))
      __defNormalProp$66(a, prop, b[prop]);
  if (__getOwnPropSymbols$66)
    for (var prop of __getOwnPropSymbols$66(b)) {
      if (__propIsEnum$66.call(b, prop))
        __defNormalProp$66(a, prop, b[prop]);
    }
  return a;
};
var __objRest$66 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$66.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$66)
    for (var prop of __getOwnPropSymbols$66(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$66.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgBusinessContactSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$66(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$66({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 9.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3 12a9 9 0 1 1 15.862 5.824A4.99 4.99 0 0 0 15 16H9a4.99 4.99 0 0 0-3.862 1.824A8.965 8.965 0 0 1 3 12Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$65 = Object.defineProperty;
var __getOwnPropSymbols$65 = Object.getOwnPropertySymbols;
var __hasOwnProp$65 = Object.prototype.hasOwnProperty;
var __propIsEnum$65 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$65 = (obj, key, value) => key in obj ? __defProp$65(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$65 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$65.call(b, prop))
      __defNormalProp$65(a, prop, b[prop]);
  if (__getOwnPropSymbols$65)
    for (var prop of __getOwnPropSymbols$65(b)) {
      if (__propIsEnum$65.call(b, prop))
        __defNormalProp$65(a, prop, b[prop]);
    }
  return a;
};
var __objRest$65 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$65.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$65)
    for (var prop of __getOwnPropSymbols$65(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$65.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCDeleteDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$65(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$65({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 12h8"
      }
    )
  );
};

var __defProp$64 = Object.defineProperty;
var __getOwnPropSymbols$64 = Object.getOwnPropertySymbols;
var __hasOwnProp$64 = Object.prototype.hasOwnProperty;
var __propIsEnum$64 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$64 = (obj, key, value) => key in obj ? __defProp$64(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$64 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$64.call(b, prop))
      __defNormalProp$64(a, prop, b[prop]);
  if (__getOwnPropSymbols$64)
    for (var prop of __getOwnPropSymbols$64(b)) {
      if (__propIsEnum$64.call(b, prop))
        __defNormalProp$64(a, prop, b[prop]);
    }
  return a;
};
var __objRest$64 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$64.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$64)
    for (var prop of __getOwnPropSymbols$64(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$64.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCDeleteSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$64(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$64({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$63 = Object.defineProperty;
var __getOwnPropSymbols$63 = Object.getOwnPropertySymbols;
var __hasOwnProp$63 = Object.prototype.hasOwnProperty;
var __propIsEnum$63 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$63 = (obj, key, value) => key in obj ? __defProp$63(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$63 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$63.call(b, prop))
      __defNormalProp$63(a, prop, b[prop]);
  if (__getOwnPropSymbols$63)
    for (var prop of __getOwnPropSymbols$63(b)) {
      if (__propIsEnum$63.call(b, prop))
        __defNormalProp$63(a, prop, b[prop]);
    }
  return a;
};
var __objRest$63 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$63.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$63)
    for (var prop of __getOwnPropSymbols$63(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$63.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCRemoveDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$63(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$63({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m15 9-6 6m0-6 6 6"
      }
    )
  );
};

var __defProp$62 = Object.defineProperty;
var __getOwnPropSymbols$62 = Object.getOwnPropertySymbols;
var __hasOwnProp$62 = Object.prototype.hasOwnProperty;
var __propIsEnum$62 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$62 = (obj, key, value) => key in obj ? __defProp$62(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$62 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$62.call(b, prop))
      __defNormalProp$62(a, prop, b[prop]);
  if (__getOwnPropSymbols$62)
    for (var prop of __getOwnPropSymbols$62(b)) {
      if (__propIsEnum$62.call(b, prop))
        __defNormalProp$62(a, prop, b[prop]);
    }
  return a;
};
var __objRest$62 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$62.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$62)
    for (var prop of __getOwnPropSymbols$62(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$62.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCRemoveSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$62(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$62({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm3.707 7.293a1 1 0 0 1 0 1.414L13.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 0 1 1.414-1.414L12 10.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$61 = Object.defineProperty;
var __getOwnPropSymbols$61 = Object.getOwnPropertySymbols;
var __hasOwnProp$61 = Object.prototype.hasOwnProperty;
var __propIsEnum$61 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$61 = (obj, key, value) => key in obj ? __defProp$61(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$61 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$61.call(b, prop))
      __defNormalProp$61(a, prop, b[prop]);
  if (__getOwnPropSymbols$61)
    for (var prop of __getOwnPropSymbols$61(b)) {
      if (__propIsEnum$61.call(b, prop))
        __defNormalProp$61(a, prop, b[prop]);
    }
  return a;
};
var __objRest$61 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$61.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$61)
    for (var prop of __getOwnPropSymbols$61(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$61.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalculationDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$61(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$61({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 12h16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      }
    )
  );
};

var __defProp$60 = Object.defineProperty;
var __getOwnPropSymbols$60 = Object.getOwnPropertySymbols;
var __hasOwnProp$60 = Object.prototype.hasOwnProperty;
var __propIsEnum$60 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$60 = (obj, key, value) => key in obj ? __defProp$60(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$60 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$60.call(b, prop))
      __defNormalProp$60(a, prop, b[prop]);
  if (__getOwnPropSymbols$60)
    for (var prop of __getOwnPropSymbols$60(b)) {
      if (__propIsEnum$60.call(b, prop))
        __defNormalProp$60(a, prop, b[prop]);
    }
  return a;
};
var __objRest$60 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$60.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$60)
    for (var prop of __getOwnPropSymbols$60(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$60.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalculationSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$60(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$60({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-7-6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5$ = Object.defineProperty;
var __getOwnPropSymbols$5$ = Object.getOwnPropertySymbols;
var __hasOwnProp$5$ = Object.prototype.hasOwnProperty;
var __propIsEnum$5$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5$ = (obj, key, value) => key in obj ? __defProp$5$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5$.call(b, prop))
      __defNormalProp$5$(a, prop, b[prop]);
  if (__getOwnPropSymbols$5$)
    for (var prop of __getOwnPropSymbols$5$(b)) {
      if (__propIsEnum$5$.call(b, prop))
        __defNormalProp$5$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5$)
    for (var prop of __getOwnPropSymbols$5$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalculatorDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5$(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m17.5 6.5-11 11m2-7v-4m-2 2h4m3 7h4"
      }
    )
  );
};

var __defProp$5_ = Object.defineProperty;
var __getOwnPropSymbols$5_ = Object.getOwnPropertySymbols;
var __hasOwnProp$5_ = Object.prototype.hasOwnProperty;
var __propIsEnum$5_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5_ = (obj, key, value) => key in obj ? __defProp$5_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5_.call(b, prop))
      __defNormalProp$5_(a, prop, b[prop]);
  if (__getOwnPropSymbols$5_)
    for (var prop of __getOwnPropSymbols$5_(b)) {
      if (__propIsEnum$5_.call(b, prop))
        __defNormalProp$5_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5_)
    for (var prop of __getOwnPropSymbols$5_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalculatorSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5_(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2Zm-.552 16.207 11-11a1 1 0 0 0-1.414-1.414l-11 11a1 1 0 1 0 1.414 1.414ZM9.5 6.5a1 1 0 1 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1Zm3 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5Z = Object.defineProperty;
var __getOwnPropSymbols$5Z = Object.getOwnPropertySymbols;
var __hasOwnProp$5Z = Object.prototype.hasOwnProperty;
var __propIsEnum$5Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5Z = (obj, key, value) => key in obj ? __defProp$5Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5Z.call(b, prop))
      __defNormalProp$5Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$5Z)
    for (var prop of __getOwnPropSymbols$5Z(b)) {
      if (__propIsEnum$5Z.call(b, prop))
        __defNormalProp$5Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5Z)
    for (var prop of __getOwnPropSymbols$5Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarAdd1Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5Z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 21v-6m-3 3h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 11.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22h4.7M21 10H3m13-8v4M8 2v4"
      }
    )
  );
};

var __defProp$5Y = Object.defineProperty;
var __getOwnPropSymbols$5Y = Object.getOwnPropertySymbols;
var __hasOwnProp$5Y = Object.prototype.hasOwnProperty;
var __propIsEnum$5Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5Y = (obj, key, value) => key in obj ? __defProp$5Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5Y.call(b, prop))
      __defNormalProp$5Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$5Y)
    for (var prop of __getOwnPropSymbols$5Y(b)) {
      if (__propIsEnum$5Y.call(b, prop))
        __defNormalProp$5Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5Y)
    for (var prop of __getOwnPropSymbols$5Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarAdd1Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5Y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042V2ZM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15.16 15.16 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0Zm5 6a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5X = Object.defineProperty;
var __getOwnPropSymbols$5X = Object.getOwnPropertySymbols;
var __hasOwnProp$5X = Object.prototype.hasOwnProperty;
var __propIsEnum$5X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5X = (obj, key, value) => key in obj ? __defProp$5X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5X.call(b, prop))
      __defNormalProp$5X(a, prop, b[prop]);
  if (__getOwnPropSymbols$5X)
    for (var prop of __getOwnPropSymbols$5X(b)) {
      if (__propIsEnum$5X.call(b, prop))
        __defNormalProp$5X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5X)
    for (var prop of __getOwnPropSymbols$5X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarAddDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5X(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 18v-6m-3 3h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 8H3m13-6v3M8 2v3m-.2 17h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
      }
    )
  );
};

var __defProp$5W = Object.defineProperty;
var __getOwnPropSymbols$5W = Object.getOwnPropertySymbols;
var __hasOwnProp$5W = Object.prototype.hasOwnProperty;
var __propIsEnum$5W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5W = (obj, key, value) => key in obj ? __defProp$5W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5W.call(b, prop))
      __defNormalProp$5W(a, prop, b[prop]);
  if (__getOwnPropSymbols$5W)
    for (var prop of __getOwnPropSymbols$5W(b)) {
      if (__propIsEnum$5W.call(b, prop))
        __defNormalProp$5W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5W)
    for (var prop of __getOwnPropSymbols$5W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarAddSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5W(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20 15a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 1a1 1 0 0 1 1 1v1.002c.476.003.891.013 1.252.042.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 7.29 22 7.954 22 8.758v4.488c0 .14-.114.254-.255.254a.268.268 0 0 1-.223-.125A3 3 0 1 0 16 21c0 .138.01.273.027.406.105.772.157 1.159.109 1.28-.058.145-.084.176-.22.252-.114.064-.387.064-.934.065-2.408.003-4.816-.003-7.223-.003-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.71 2 18.046 2 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392.361-.03.777-.04 1.252-.042V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1ZM7 5.002V6a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0v-.998c.445.003.795.012 1.089.036.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 7.361 20 7.943 20 8.8V9H4v-.2c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18.294-.024.643-.033 1.089-.036Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5V = Object.defineProperty;
var __getOwnPropSymbols$5V = Object.getOwnPropertySymbols;
var __hasOwnProp$5V = Object.prototype.hasOwnProperty;
var __propIsEnum$5V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5V = (obj, key, value) => key in obj ? __defProp$5V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5V.call(b, prop))
      __defNormalProp$5V(a, prop, b[prop]);
  if (__getOwnPropSymbols$5V)
    for (var prop of __getOwnPropSymbols$5V(b)) {
      if (__propIsEnum$5V.call(b, prop))
        __defNormalProp$5V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5V)
    for (var prop of __getOwnPropSymbols$5V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarCheck1Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5V(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 16 2 2 4.5-4.5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 10H3m13-8v4M8 2v4m-.2 16h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
      }
    )
  );
};

var __defProp$5U = Object.defineProperty;
var __getOwnPropSymbols$5U = Object.getOwnPropertySymbols;
var __hasOwnProp$5U = Object.prototype.hasOwnProperty;
var __propIsEnum$5U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5U = (obj, key, value) => key in obj ? __defProp$5U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5U.call(b, prop))
      __defNormalProp$5U(a, prop, b[prop]);
  if (__getOwnPropSymbols$5U)
    for (var prop of __getOwnPropSymbols$5U(b)) {
      if (__propIsEnum$5U.call(b, prop))
        __defNormalProp$5U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5U)
    for (var prop of __getOwnPropSymbols$5U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarCheck1Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5U(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22.707 15.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.793-3.793a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h5.568c.606 0 .909 0 1.049-.12a.5.5 0 0 0 .174-.42c-.015-.183-.229-.397-.657-.826l-.513-.513a3 3 0 0 1 4.118-4.36l2.382-2.382a3 3 0 0 1 1.33-.774c.345-.093.518-.14.596-.2a.418.418 0 0 0 .157-.206c.038-.092.038-.227.038-.499V8.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042V2ZM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15.16 15.16 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5T = Object.defineProperty;
var __getOwnPropSymbols$5T = Object.getOwnPropertySymbols;
var __hasOwnProp$5T = Object.prototype.hasOwnProperty;
var __propIsEnum$5T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5T = (obj, key, value) => key in obj ? __defProp$5T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5T.call(b, prop))
      __defNormalProp$5T(a, prop, b[prop]);
  if (__getOwnPropSymbols$5T)
    for (var prop of __getOwnPropSymbols$5T(b)) {
      if (__propIsEnum$5T.call(b, prop))
        __defNormalProp$5T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5T)
    for (var prop of __getOwnPropSymbols$5T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarCheckDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5T(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m14.5 19 2 2 4.5-4.5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 10H3m18 2.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22H12m4-20v4M8 2v4"
      }
    )
  );
};

var __defProp$5S = Object.defineProperty;
var __getOwnPropSymbols$5S = Object.getOwnPropertySymbols;
var __hasOwnProp$5S = Object.prototype.hasOwnProperty;
var __propIsEnum$5S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5S = (obj, key, value) => key in obj ? __defProp$5S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5S.call(b, prop))
      __defNormalProp$5S(a, prop, b[prop]);
  if (__getOwnPropSymbols$5S)
    for (var prop of __getOwnPropSymbols$5S(b)) {
      if (__propIsEnum$5S.call(b, prop))
        __defNormalProp$5S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5S)
    for (var prop of __getOwnPropSymbols$5S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarCheckSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5S(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042V2ZM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15.16 15.16 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0Zm9.207 8.207a1 1 0 0 0-1.414-1.414L11 16.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5R = Object.defineProperty;
var __getOwnPropSymbols$5R = Object.getOwnPropertySymbols;
var __hasOwnProp$5R = Object.prototype.hasOwnProperty;
var __propIsEnum$5R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5R = (obj, key, value) => key in obj ? __defProp$5R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5R.call(b, prop))
      __defNormalProp$5R(a, prop, b[prop]);
  if (__getOwnPropSymbols$5R)
    for (var prop of __getOwnPropSymbols$5R(b)) {
      if (__propIsEnum$5R.call(b, prop))
        __defNormalProp$5R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5R)
    for (var prop of __getOwnPropSymbols$5R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarDateDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5R(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m10.5 14 1.5-1v5m-1.25 0h2.5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 10H3m13-8v4M8 2v4m-.2 16h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
      }
    )
  );
};

var __defProp$5Q = Object.defineProperty;
var __getOwnPropSymbols$5Q = Object.getOwnPropertySymbols;
var __hasOwnProp$5Q = Object.prototype.hasOwnProperty;
var __propIsEnum$5Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5Q = (obj, key, value) => key in obj ? __defProp$5Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5Q.call(b, prop))
      __defNormalProp$5Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$5Q)
    for (var prop of __getOwnPropSymbols$5Q(b)) {
      if (__propIsEnum$5Q.call(b, prop))
        __defNormalProp$5Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5Q)
    for (var prop of __getOwnPropSymbols$5Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarDateSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5Q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042V2ZM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15.16 15.16 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0Zm5.472 6.118A1 1 0 0 1 13 13v4h.25a1 1 0 1 1 0 2h-2.5a1 1 0 1 1 0-2H11v-2.134a1 1 0 0 1-1.055-1.698l1.5-1a1 1 0 0 1 1.027-.05Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5P = Object.defineProperty;
var __getOwnPropSymbols$5P = Object.getOwnPropertySymbols;
var __hasOwnProp$5P = Object.prototype.hasOwnProperty;
var __propIsEnum$5P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5P = (obj, key, value) => key in obj ? __defProp$5P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5P.call(b, prop))
      __defNormalProp$5P(a, prop, b[prop]);
  if (__getOwnPropSymbols$5P)
    for (var prop of __getOwnPropSymbols$5P(b)) {
      if (__propIsEnum$5P.call(b, prop))
        __defNormalProp$5P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5P)
    for (var prop of __getOwnPropSymbols$5P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5P(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 10H3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 2v4M8 2v4m-.2 16h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
      }
    )
  );
};

var __defProp$5O = Object.defineProperty;
var __getOwnPropSymbols$5O = Object.getOwnPropertySymbols;
var __hasOwnProp$5O = Object.prototype.hasOwnProperty;
var __propIsEnum$5O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5O = (obj, key, value) => key in obj ? __defProp$5O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5O.call(b, prop))
      __defNormalProp$5O(a, prop, b[prop]);
  if (__getOwnPropSymbols$5O)
    for (var prop of __getOwnPropSymbols$5O(b)) {
      if (__propIsEnum$5O.call(b, prop))
        __defNormalProp$5O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5O)
    for (var prop of __getOwnPropSymbols$5O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarMinusDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5O(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 15h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 8H3m13-6v3M8 2v3m-.2 17h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
      }
    )
  );
};

var __defProp$5N = Object.defineProperty;
var __getOwnPropSymbols$5N = Object.getOwnPropertySymbols;
var __hasOwnProp$5N = Object.prototype.hasOwnProperty;
var __propIsEnum$5N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5N = (obj, key, value) => key in obj ? __defProp$5N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5N.call(b, prop))
      __defNormalProp$5N(a, prop, b[prop]);
  if (__getOwnPropSymbols$5N)
    for (var prop of __getOwnPropSymbols$5N(b)) {
      if (__propIsEnum$5N.call(b, prop))
        __defNormalProp$5N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5N)
    for (var prop of __getOwnPropSymbols$5N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarMinusSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5N(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042V2ZM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15.16 15.16 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0Zm2 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5M = Object.defineProperty;
var __getOwnPropSymbols$5M = Object.getOwnPropertySymbols;
var __hasOwnProp$5M = Object.prototype.hasOwnProperty;
var __propIsEnum$5M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5M = (obj, key, value) => key in obj ? __defProp$5M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5M.call(b, prop))
      __defNormalProp$5M(a, prop, b[prop]);
  if (__getOwnPropSymbols$5M)
    for (var prop of __getOwnPropSymbols$5M(b)) {
      if (__propIsEnum$5M.call(b, prop))
        __defNormalProp$5M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5M)
    for (var prop of __getOwnPropSymbols$5M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCalendarSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5M(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 1a1 1 0 0 1 1 1v1.002c.476.003.891.013 1.252.042.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 7.29 22 7.954 22 8.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.71 2 18.046 2 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392.361-.03.777-.04 1.252-.042V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1ZM7 5.002V6a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0v-.998c.445.003.795.012 1.089.036.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 7.361 20 7.943 20 8.8V9H4v-.2c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18.294-.024.643-.033 1.089-.036Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5L = Object.defineProperty;
var __getOwnPropSymbols$5L = Object.getOwnPropertySymbols;
var __hasOwnProp$5L = Object.prototype.hasOwnProperty;
var __propIsEnum$5L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5L = (obj, key, value) => key in obj ? __defProp$5L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5L.call(b, prop))
      __defNormalProp$5L(a, prop, b[prop]);
  if (__getOwnPropSymbols$5L)
    for (var prop of __getOwnPropSymbols$5L(b)) {
      if (__propIsEnum$5L.call(b, prop))
        __defNormalProp$5L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5L)
    for (var prop of __getOwnPropSymbols$5L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCampaignDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5L(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 22V6M9 2v16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 6v16l7-4 7 4 6-4V2l-6 4-7-4-7 4Z"
      }
    )
  );
};

var __defProp$5K = Object.defineProperty;
var __getOwnPropSymbols$5K = Object.getOwnPropertySymbols;
var __hasOwnProp$5K = Object.prototype.hasOwnProperty;
var __propIsEnum$5K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5K = (obj, key, value) => key in obj ? __defProp$5K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5K.call(b, prop))
      __defNormalProp$5K(a, prop, b[prop]);
  if (__getOwnPropSymbols$5K)
    for (var prop of __getOwnPropSymbols$5K(b)) {
      if (__propIsEnum$5K.call(b, prop))
        __defNormalProp$5K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5K)
    for (var prop of __getOwnPropSymbols$5K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCampaignSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5K(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8 2.798c0-.452 0-.679-.095-.81a.5.5 0 0 0-.351-.204c-.161-.017-.358.095-.75.32l-5.3 3.028A1 1 0 0 0 1 6v16a1 1 0 0 0 1.496.868l4.698-2.684c.293-.168.44-.252.547-.37a1 1 0 0 0 .21-.36c.049-.152.049-.321.049-.66V2.799Zm2 15.997c0 .338 0 .507.05.658a.999.999 0 0 0 .209.361c.107.118.254.202.547.37l2.997 1.712c.393.225.59.337.75.32a.5.5 0 0 0 .352-.204c.095-.131.095-.358.095-.81V5.205c0-.338 0-.507-.05-.658a.999.999 0 0 0-.209-.361c-.107-.118-.254-.202-.547-.37l-2.997-1.712c-.393-.225-.59-.337-.75-.32a.5.5 0 0 0-.352.204c-.095.131-.095.358-.095.81v15.997ZM23 2a1 1 0 0 0-1.555-.832l-3.733 2.489c-.26.173-.39.26-.485.375a1.001 1.001 0 0 0-.184.344C17 4.518 17 4.675 17 4.988V21.04c0 .486 0 .729.101.863a.5.5 0 0 0 .37.197c.167.01.369-.125.773-.394l4.31-2.874A1 1 0 0 0 23 18V2Z"
      }
    )
  );
};

var __defProp$5J = Object.defineProperty;
var __getOwnPropSymbols$5J = Object.getOwnPropertySymbols;
var __hasOwnProp$5J = Object.prototype.hasOwnProperty;
var __propIsEnum$5J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5J = (obj, key, value) => key in obj ? __defProp$5J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5J.call(b, prop))
      __defNormalProp$5J(a, prop, b[prop]);
  if (__getOwnPropSymbols$5J)
    for (var prop of __getOwnPropSymbols$5J(b)) {
      if (__propIsEnum$5J.call(b, prop))
        __defNormalProp$5J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5J)
    for (var prop of __getOwnPropSymbols$5J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCartDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5J(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 2h1.306c.246 0 .37 0 .468.045a.5.5 0 0 1 .213.185c.059.092.076.213.111.457L4.571 6m0 0 1.052 7.731c.134.982.2 1.472.435 1.841a2 2 0 0 0 .853.745c.398.183.893.183 1.883.183h8.558c.942 0 1.414 0 1.799-.17a2 2 0 0 0 .841-.696c.239-.346.327-.81.503-1.735l1.324-6.95c.062-.325.093-.488.048-.615a.5.5 0 0 0-.22-.266C21.532 6 21.366 6 21.034 6H4.571Z"
      }
    )
  );
};

var __defProp$5I = Object.defineProperty;
var __getOwnPropSymbols$5I = Object.getOwnPropertySymbols;
var __hasOwnProp$5I = Object.prototype.hasOwnProperty;
var __propIsEnum$5I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5I = (obj, key, value) => key in obj ? __defProp$5I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5I.call(b, prop))
      __defNormalProp$5I(a, prop, b[prop]);
  if (__getOwnPropSymbols$5I)
    for (var prop of __getOwnPropSymbols$5I(b)) {
      if (__propIsEnum$5I.call(b, prop))
        __defNormalProp$5I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5I)
    for (var prop of __getOwnPropSymbols$5I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCartSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5I(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M2 3h1.133l.448 3.138 1.056 7.763c.063.46.117.861.188 1.19.075.35.183.693.389 1.018a3 3 0 0 0 1.28 1.117c.349.16.703.22 1.06.248.336.026.74.026 1.205.026h8.627c.442 0 .828 0 1.149-.024a3.026 3.026 0 0 0 1.019-.23 3 3 0 0 0 1.262-1.045c.209-.303.328-.626.417-.958.084-.31.156-.69.238-1.123l1.335-7.01c.027-.139.058-.3.072-.442a1.51 1.51 0 0 0-.068-.667 1.5 1.5 0 0 0-.659-.797 1.516 1.516 0 0 0-.643-.192A5.392 5.392 0 0 0 21.06 5H5.439l-.354-2.475c-.015-.103-.032-.23-.057-.34a1.516 1.516 0 0 0-.2-.495 1.5 1.5 0 0 0-.638-.554 1.503 1.503 0 0 0-.518-.127A4.672 4.672 0 0 0 3.327 1H2a1 1 0 0 0 0 2Zm5 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm8 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
      }
    )
  );
};

var __defProp$5H = Object.defineProperty;
var __getOwnPropSymbols$5H = Object.getOwnPropertySymbols;
var __hasOwnProp$5H = Object.prototype.hasOwnProperty;
var __propIsEnum$5H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5H = (obj, key, value) => key in obj ? __defProp$5H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5H.call(b, prop))
      __defNormalProp$5H(a, prop, b[prop]);
  if (__getOwnPropSymbols$5H)
    for (var prop of __getOwnPropSymbols$5H(b)) {
      if (__propIsEnum$5H.call(b, prop))
        __defNormalProp$5H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5H)
    for (var prop of __getOwnPropSymbols$5H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCentralizeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5H(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m14 10 7-7M3 21l7-7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 14h6v6m10-10h-6V4"
      }
    )
  );
};

var __defProp$5G = Object.defineProperty;
var __getOwnPropSymbols$5G = Object.getOwnPropertySymbols;
var __hasOwnProp$5G = Object.prototype.hasOwnProperty;
var __propIsEnum$5G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5G = (obj, key, value) => key in obj ? __defProp$5G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5G.call(b, prop))
      __defNormalProp$5G(a, prop, b[prop]);
  if (__getOwnPropSymbols$5G)
    for (var prop of __getOwnPropSymbols$5G(b)) {
      if (__propIsEnum$5G.call(b, prop))
        __defNormalProp$5G(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5G)
    for (var prop of __getOwnPropSymbols$5G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCentralizeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5G(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m16.414 9 5.293-5.293a1 1 0 0 0-1.414-1.414L15 7.586V4a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2h-3.586ZM9 20v-3.586l-5.293 5.293a1 1 0 0 1-1.414-1.414L7.586 15H4a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0Z"
      }
    )
  );
};

var __defProp$5F = Object.defineProperty;
var __getOwnPropSymbols$5F = Object.getOwnPropertySymbols;
var __hasOwnProp$5F = Object.prototype.hasOwnProperty;
var __propIsEnum$5F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5F = (obj, key, value) => key in obj ? __defProp$5F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5F.call(b, prop))
      __defNormalProp$5F(a, prop, b[prop]);
  if (__getOwnPropSymbols$5F)
    for (var prop of __getOwnPropSymbols$5F(b)) {
      if (__propIsEnum$5F.call(b, prop))
        __defNormalProp$5F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5F)
    for (var prop of __getOwnPropSymbols$5F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChartBarDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5F(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 7H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 7.76 3 8.04 3 8.6v10.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H9m6-10h4.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 11.76 21 12.04 21 12.6v6.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 21 19.96 21 19.4 21H15",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 3.76 9 4.04 9 4.6V21h6V4.6Z"
      }
    )
  );
};

var __defProp$5E = Object.defineProperty;
var __getOwnPropSymbols$5E = Object.getOwnPropertySymbols;
var __hasOwnProp$5E = Object.prototype.hasOwnProperty;
var __propIsEnum$5E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5E = (obj, key, value) => key in obj ? __defProp$5E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5E.call(b, prop))
      __defNormalProp$5E(a, prop, b[prop]);
  if (__getOwnPropSymbols$5E)
    for (var prop of __getOwnPropSymbols$5E(b)) {
      if (__propIsEnum$5E.call(b, prop))
        __defNormalProp$5E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5E)
    for (var prop of __getOwnPropSymbols$5E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChartBarSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5E(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.568 6h.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77C7 8.07 7 8.316 7 8.568v10.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201C4.93 22 4.684 22 4.432 22h-.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C1 19.93 1 19.684 1 19.432V8.568c0-.252 0-.498.017-.706a2.03 2.03 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.03 2.03 0 0 1 .77-.201C3.07 6 3.316 6 3.568 6Zm8-4h.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v14.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C9 19.93 9 19.684 9 19.432V4.568c0-.252 0-.498.017-.706a2.03 2.03 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.03 2.03 0 0 1 .77-.201C11.07 2 11.316 2 11.568 2Zm8 8h.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v6.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C17 19.93 17 19.684 17 19.432v-6.864c0-.252 0-.498.017-.706a2.02 2.02 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.02 2.02 0 0 1 .77-.201c.208-.017.454-.017.706-.017Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5D = Object.defineProperty;
var __getOwnPropSymbols$5D = Object.getOwnPropertySymbols;
var __hasOwnProp$5D = Object.prototype.hasOwnProperty;
var __propIsEnum$5D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5D = (obj, key, value) => key in obj ? __defProp$5D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5D.call(b, prop))
      __defNormalProp$5D(a, prop, b[prop]);
  if (__getOwnPropSymbols$5D)
    for (var prop of __getOwnPropSymbols$5D(b)) {
      if (__propIsEnum$5D.call(b, prop))
        __defNormalProp$5D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5D)
    for (var prop of __getOwnPropSymbols$5D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChartPieDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5D(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21.21 15.89A10 10 0 1 1 8 2.83",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21.2 12c.278 0 .417 0 .528-.06a.525.525 0 0 0 .22-.238c.05-.116.04-.244.02-.501a10 10 0 0 0-9.169-9.169c-.257-.02-.385-.03-.5.02a.525.525 0 0 0-.239.22c-.06.111-.06.25-.06.528v8.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h8.4Z"
      }
    )
  );
};

var __defProp$5C = Object.defineProperty;
var __getOwnPropSymbols$5C = Object.getOwnPropertySymbols;
var __hasOwnProp$5C = Object.prototype.hasOwnProperty;
var __propIsEnum$5C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5C = (obj, key, value) => key in obj ? __defProp$5C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5C.call(b, prop))
      __defNormalProp$5C(a, prop, b[prop]);
  if (__getOwnPropSymbols$5C)
    for (var prop of __getOwnPropSymbols$5C(b)) {
      if (__propIsEnum$5C.call(b, prop))
        __defNormalProp$5C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5C)
    for (var prop of __getOwnPropSymbols$5C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChartPieSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5C(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13.595 1.115a11.007 11.007 0 0 1 9.29 9.29c.07.474.104.712.008.957a1.089 1.089 0 0 1-.44.508c-.229.13-.503.13-1.053.13h-7.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C12 11.24 12 10.96 12 10.4V2.6c0-.55 0-.824.13-1.053.103-.184.311-.364.508-.44.245-.096.483-.061.957.008Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M10 3.102c0-.638 0-.957-.163-1.206a1.096 1.096 0 0 0-.618-.43c-.29-.064-.55.032-1.068.226C3.974 3.252 1 7.28 1 12c0 6.075 4.925 11 11 11 4.721 0 8.747-2.974 10.308-7.15.194-.52.29-.779.225-1.07a1.096 1.096 0 0 0-.429-.617C21.855 14 21.536 14 20.898 14h-7.344c-.239 0-.523 0-.774-.02a3.014 3.014 0 0 1-1.142-.307 3 3 0 0 1-1.311-1.311 3.015 3.015 0 0 1-.307-1.142c-.02-.251-.02-.536-.02-.774V3.102Z"
      }
    )
  );
};

var __defProp$5B = Object.defineProperty;
var __getOwnPropSymbols$5B = Object.getOwnPropertySymbols;
var __hasOwnProp$5B = Object.prototype.hasOwnProperty;
var __propIsEnum$5B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5B = (obj, key, value) => key in obj ? __defProp$5B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5B.call(b, prop))
      __defNormalProp$5B(a, prop, b[prop]);
  if (__getOwnPropSymbols$5B)
    for (var prop of __getOwnPropSymbols$5B(b)) {
      if (__propIsEnum$5B.call(b, prop))
        __defNormalProp$5B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5B)
    for (var prop of __getOwnPropSymbols$5B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCheckCircleDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5B(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m7.5 12 3 3 6-6"
      }
    )
  );
};

var __defProp$5A = Object.defineProperty;
var __getOwnPropSymbols$5A = Object.getOwnPropertySymbols;
var __hasOwnProp$5A = Object.prototype.hasOwnProperty;
var __propIsEnum$5A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5A = (obj, key, value) => key in obj ? __defProp$5A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5A.call(b, prop))
      __defNormalProp$5A(a, prop, b[prop]);
  if (__getOwnPropSymbols$5A)
    for (var prop of __getOwnPropSymbols$5A(b)) {
      if (__propIsEnum$5A.call(b, prop))
        __defNormalProp$5A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5A)
    for (var prop of __getOwnPropSymbols$5A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCheckCircleSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5A(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm5.207 8.707a1 1 0 0 0-1.414-1.414L10.5 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5z = Object.defineProperty;
var __getOwnPropSymbols$5z = Object.getOwnPropertySymbols;
var __hasOwnProp$5z = Object.prototype.hasOwnProperty;
var __propIsEnum$5z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5z = (obj, key, value) => key in obj ? __defProp$5z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5z.call(b, prop))
      __defNormalProp$5z(a, prop, b[prop]);
  if (__getOwnPropSymbols$5z)
    for (var prop of __getOwnPropSymbols$5z(b)) {
      if (__propIsEnum$5z.call(b, prop))
        __defNormalProp$5z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5z)
    for (var prop of __getOwnPropSymbols$5z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCheckDone02Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 16 4.08 16 5.2 16H8",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 15 2 2 4.5-4.5M11.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 8 19.92 8 18.8 8h-7.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 9.52 8 10.08 8 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C9.52 22 10.08 22 11.2 22Z"
      }
    )
  );
};

var __defProp$5y = Object.defineProperty;
var __getOwnPropSymbols$5y = Object.getOwnPropertySymbols;
var __hasOwnProp$5y = Object.prototype.hasOwnProperty;
var __propIsEnum$5y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5y = (obj, key, value) => key in obj ? __defProp$5y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5y.call(b, prop))
      __defNormalProp$5y(a, prop, b[prop]);
  if (__getOwnPropSymbols$5y)
    for (var prop of __getOwnPropSymbols$5y(b)) {
      if (__propIsEnum$5y.call(b, prop))
        __defNormalProp$5y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5y)
    for (var prop of __getOwnPropSymbols$5y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCheckDone02Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.838 7h-7.677c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C7 10.18 7 10.635 7 11.161v7.678c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h7.678c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.357v-7.677c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 18.838 7Zm.37 6.207a1 1 0 0 0-1.415-1.414L14 15.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5.161 1h7.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.028.336.03.736.031 1.195h-5.88c-.49 0-1.02 0-1.478.037-.519.043-1.205.148-1.912.508A5 5 0 0 0 5.545 7.73c-.36.707-.465 1.393-.508 1.912C5 10.101 5 10.631 5 11.12V17c-.459 0-.86-.003-1.195-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 13.82 1 13.365 1 12.839V5.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 1 4.635 1 5.161 1Z"
      }
    )
  );
};

var __defProp$5x = Object.defineProperty;
var __getOwnPropSymbols$5x = Object.getOwnPropertySymbols;
var __hasOwnProp$5x = Object.prototype.hasOwnProperty;
var __propIsEnum$5x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5x = (obj, key, value) => key in obj ? __defProp$5x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5x.call(b, prop))
      __defNormalProp$5x(a, prop, b[prop]);
  if (__getOwnPropSymbols$5x)
    for (var prop of __getOwnPropSymbols$5x(b)) {
      if (__propIsEnum$5x.call(b, prop))
        __defNormalProp$5x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5x)
    for (var prop of __getOwnPropSymbols$5x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCheckDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5x(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 6 9 17l-5-5"
      }
    )
  );
};

var __defProp$5w = Object.defineProperty;
var __getOwnPropSymbols$5w = Object.getOwnPropertySymbols;
var __hasOwnProp$5w = Object.prototype.hasOwnProperty;
var __propIsEnum$5w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5w = (obj, key, value) => key in obj ? __defProp$5w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5w.call(b, prop))
      __defNormalProp$5w(a, prop, b[prop]);
  if (__getOwnPropSymbols$5w)
    for (var prop of __getOwnPropSymbols$5w(b)) {
      if (__propIsEnum$5w.call(b, prop))
        __defNormalProp$5w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5w)
    for (var prop of __getOwnPropSymbols$5w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCheckSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5w(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.707 5.293a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 15.586 19.293 5.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5v = Object.defineProperty;
var __getOwnPropSymbols$5v = Object.getOwnPropertySymbols;
var __hasOwnProp$5v = Object.prototype.hasOwnProperty;
var __propIsEnum$5v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5v = (obj, key, value) => key in obj ? __defProp$5v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5v.call(b, prop))
      __defNormalProp$5v(a, prop, b[prop]);
  if (__getOwnPropSymbols$5v)
    for (var prop of __getOwnPropSymbols$5v(b)) {
      if (__propIsEnum$5v.call(b, prop))
        __defNormalProp$5v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5v)
    for (var prop of __getOwnPropSymbols$5v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronDownDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5v(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m6 9 6 6 6-6"
      }
    )
  );
};

var __defProp$5u = Object.defineProperty;
var __getOwnPropSymbols$5u = Object.getOwnPropertySymbols;
var __hasOwnProp$5u = Object.prototype.hasOwnProperty;
var __propIsEnum$5u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5u = (obj, key, value) => key in obj ? __defProp$5u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5u.call(b, prop))
      __defNormalProp$5u(a, prop, b[prop]);
  if (__getOwnPropSymbols$5u)
    for (var prop of __getOwnPropSymbols$5u(b)) {
      if (__propIsEnum$5u.call(b, prop))
        __defNormalProp$5u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5u)
    for (var prop of __getOwnPropSymbols$5u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronDownSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5u(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 8.293a1 1 0 0 1 1.414 0L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5t = Object.defineProperty;
var __getOwnPropSymbols$5t = Object.getOwnPropertySymbols;
var __hasOwnProp$5t = Object.prototype.hasOwnProperty;
var __propIsEnum$5t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5t = (obj, key, value) => key in obj ? __defProp$5t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5t.call(b, prop))
      __defNormalProp$5t(a, prop, b[prop]);
  if (__getOwnPropSymbols$5t)
    for (var prop of __getOwnPropSymbols$5t(b)) {
      if (__propIsEnum$5t.call(b, prop))
        __defNormalProp$5t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5t)
    for (var prop of __getOwnPropSymbols$5t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronLeftDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5t(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m15 18-6-6 6-6"
      }
    )
  );
};

var __defProp$5s = Object.defineProperty;
var __getOwnPropSymbols$5s = Object.getOwnPropertySymbols;
var __hasOwnProp$5s = Object.prototype.hasOwnProperty;
var __propIsEnum$5s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5s = (obj, key, value) => key in obj ? __defProp$5s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5s.call(b, prop))
      __defNormalProp$5s(a, prop, b[prop]);
  if (__getOwnPropSymbols$5s)
    for (var prop of __getOwnPropSymbols$5s(b)) {
      if (__propIsEnum$5s.call(b, prop))
        __defNormalProp$5s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5s)
    for (var prop of __getOwnPropSymbols$5s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronLeftSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5s(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 5.293a1 1 0 0 1 0 1.414L10.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5r = Object.defineProperty;
var __getOwnPropSymbols$5r = Object.getOwnPropertySymbols;
var __hasOwnProp$5r = Object.prototype.hasOwnProperty;
var __propIsEnum$5r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5r = (obj, key, value) => key in obj ? __defProp$5r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5r.call(b, prop))
      __defNormalProp$5r(a, prop, b[prop]);
  if (__getOwnPropSymbols$5r)
    for (var prop of __getOwnPropSymbols$5r(b)) {
      if (__propIsEnum$5r.call(b, prop))
        __defNormalProp$5r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5r)
    for (var prop of __getOwnPropSymbols$5r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronRightDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5r(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 18 6-6-6-6"
      }
    )
  );
};

var __defProp$5q = Object.defineProperty;
var __getOwnPropSymbols$5q = Object.getOwnPropertySymbols;
var __hasOwnProp$5q = Object.prototype.hasOwnProperty;
var __propIsEnum$5q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5q = (obj, key, value) => key in obj ? __defProp$5q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5q.call(b, prop))
      __defNormalProp$5q(a, prop, b[prop]);
  if (__getOwnPropSymbols$5q)
    for (var prop of __getOwnPropSymbols$5q(b)) {
      if (__propIsEnum$5q.call(b, prop))
        __defNormalProp$5q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5q)
    for (var prop of __getOwnPropSymbols$5q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronRightSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5p = Object.defineProperty;
var __getOwnPropSymbols$5p = Object.getOwnPropertySymbols;
var __hasOwnProp$5p = Object.prototype.hasOwnProperty;
var __propIsEnum$5p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5p = (obj, key, value) => key in obj ? __defProp$5p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5p.call(b, prop))
      __defNormalProp$5p(a, prop, b[prop]);
  if (__getOwnPropSymbols$5p)
    for (var prop of __getOwnPropSymbols$5p(b)) {
      if (__propIsEnum$5p.call(b, prop))
        __defNormalProp$5p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5p)
    for (var prop of __getOwnPropSymbols$5p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronSelectorVerticalDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5p(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m7 15 5 5 5-5M7 9l5-5 5 5"
      }
    )
  );
};

var __defProp$5o = Object.defineProperty;
var __getOwnPropSymbols$5o = Object.getOwnPropertySymbols;
var __hasOwnProp$5o = Object.prototype.hasOwnProperty;
var __propIsEnum$5o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5o = (obj, key, value) => key in obj ? __defProp$5o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5o.call(b, prop))
      __defNormalProp$5o(a, prop, b[prop]);
  if (__getOwnPropSymbols$5o)
    for (var prop of __getOwnPropSymbols$5o(b)) {
      if (__propIsEnum$5o.call(b, prop))
        __defNormalProp$5o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5o)
    for (var prop of __getOwnPropSymbols$5o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronSelectorVerticalSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5o(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m7 15 5 5 5-5M7 9l5-5 5 5"
      }
    )
  );
};

var __defProp$5n = Object.defineProperty;
var __getOwnPropSymbols$5n = Object.getOwnPropertySymbols;
var __hasOwnProp$5n = Object.prototype.hasOwnProperty;
var __propIsEnum$5n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5n = (obj, key, value) => key in obj ? __defProp$5n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5n.call(b, prop))
      __defNormalProp$5n(a, prop, b[prop]);
  if (__getOwnPropSymbols$5n)
    for (var prop of __getOwnPropSymbols$5n(b)) {
      if (__propIsEnum$5n.call(b, prop))
        __defNormalProp$5n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5n)
    for (var prop of __getOwnPropSymbols$5n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronUpDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5n(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m18 15-6-6-6 6"
      }
    )
  );
};

var __defProp$5m = Object.defineProperty;
var __getOwnPropSymbols$5m = Object.getOwnPropertySymbols;
var __hasOwnProp$5m = Object.prototype.hasOwnProperty;
var __propIsEnum$5m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5m = (obj, key, value) => key in obj ? __defProp$5m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5m.call(b, prop))
      __defNormalProp$5m(a, prop, b[prop]);
  if (__getOwnPropSymbols$5m)
    for (var prop of __getOwnPropSymbols$5m(b)) {
      if (__propIsEnum$5m.call(b, prop))
        __defNormalProp$5m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5m)
    for (var prop of __getOwnPropSymbols$5m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgChevronUpSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5m(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 8.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 10.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5l = Object.defineProperty;
var __getOwnPropSymbols$5l = Object.getOwnPropertySymbols;
var __hasOwnProp$5l = Object.prototype.hasOwnProperty;
var __propIsEnum$5l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5l = (obj, key, value) => key in obj ? __defProp$5l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5l.call(b, prop))
      __defNormalProp$5l(a, prop, b[prop]);
  if (__getOwnPropSymbols$5l)
    for (var prop of __getOwnPropSymbols$5l(b)) {
      if (__propIsEnum$5l.call(b, prop))
        __defNormalProp$5l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5l)
    for (var prop of __getOwnPropSymbols$5l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCircleDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5l(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
      }
    )
  );
};

var __defProp$5k = Object.defineProperty;
var __getOwnPropSymbols$5k = Object.getOwnPropertySymbols;
var __hasOwnProp$5k = Object.prototype.hasOwnProperty;
var __propIsEnum$5k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5k = (obj, key, value) => key in obj ? __defProp$5k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5k.call(b, prop))
      __defNormalProp$5k(a, prop, b[prop]);
  if (__getOwnPropSymbols$5k)
    for (var prop of __getOwnPropSymbols$5k(b)) {
      if (__propIsEnum$5k.call(b, prop))
        __defNormalProp$5k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5k)
    for (var prop of __getOwnPropSymbols$5k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCircleSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5k(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Z"
      }
    )
  );
};

var __defProp$5j = Object.defineProperty;
var __getOwnPropSymbols$5j = Object.getOwnPropertySymbols;
var __hasOwnProp$5j = Object.prototype.hasOwnProperty;
var __propIsEnum$5j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5j = (obj, key, value) => key in obj ? __defProp$5j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5j.call(b, prop))
      __defNormalProp$5j(a, prop, b[prop]);
  if (__getOwnPropSymbols$5j)
    for (var prop of __getOwnPropSymbols$5j(b)) {
      if (__propIsEnum$5j.call(b, prop))
        __defNormalProp$5j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5j)
    for (var prop of __getOwnPropSymbols$5j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClientsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5j(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m16 18 2 2 4-4M15.5 3.29a4.001 4.001 0 0 1 0 7.42",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      }
    )
  );
};

var __defProp$5i = Object.defineProperty;
var __getOwnPropSymbols$5i = Object.getOwnPropertySymbols;
var __hasOwnProp$5i = Object.prototype.hasOwnProperty;
var __propIsEnum$5i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5i = (obj, key, value) => key in obj ? __defProp$5i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5i.call(b, prop))
      __defNormalProp$5i(a, prop, b[prop]);
  if (__getOwnPropSymbols$5i)
    for (var prop of __getOwnPropSymbols$5i(b)) {
      if (__propIsEnum$5i.call(b, prop))
        __defNormalProp$5i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5i)
    for (var prop of __getOwnPropSymbols$5i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClientsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5i(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.181 14.164a1.5 1.5 0 0 1 .655.655c.154.3.164.629.164.958v4.446c0 .12 0 .262-.01.387a1.508 1.508 0 0 1-.154.571 1.5 1.5 0 0 1-.655.655 1.508 1.508 0 0 1-.571.154c-.125.01-.268.01-.387.01H2.777c-.12 0-.262 0-.388-.01a1.508 1.508 0 0 1-.572-.154 1.501 1.501 0 0 1-.656-.66 1.507 1.507 0 0 1-.151-.571 4.877 4.877 0 0 1-.01-.387c.005-1.039-.026-2.153.38-3.131a5 5 0 0 1 2.706-2.706c.51-.212 1.048-.3 1.656-.34C6.335 14 7.063 14 7.964 14h3.26c.328 0 .657.01.957.164Zm10.526 1.129a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L18 18.586l3.293-3.293a1 1 0 0 1 1.414 0ZM14.573 2.916a1 1 0 0 1 1.302-.552 5.001 5.001 0 0 1 0 9.272 1 1 0 0 1-.75-1.854 3.001 3.001 0 0 0 0-5.564 1 1 0 0 1-.552-1.302Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5h = Object.defineProperty;
var __getOwnPropSymbols$5h = Object.getOwnPropertySymbols;
var __hasOwnProp$5h = Object.prototype.hasOwnProperty;
var __propIsEnum$5h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5h = (obj, key, value) => key in obj ? __defProp$5h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5h.call(b, prop))
      __defNormalProp$5h(a, prop, b[prop]);
  if (__getOwnPropSymbols$5h)
    for (var prop of __getOwnPropSymbols$5h(b)) {
      if (__propIsEnum$5h.call(b, prop))
        __defNormalProp$5h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5h)
    for (var prop of __getOwnPropSymbols$5h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClipboardCheckDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 15 2 2 4.5-4.5M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
      }
    )
  );
};

var __defProp$5g = Object.defineProperty;
var __getOwnPropSymbols$5g = Object.getOwnPropertySymbols;
var __hasOwnProp$5g = Object.prototype.hasOwnProperty;
var __propIsEnum$5g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5g = (obj, key, value) => key in obj ? __defProp$5g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5g.call(b, prop))
      __defNormalProp$5g(a, prop, b[prop]);
  if (__getOwnPropSymbols$5g)
    for (var prop of __getOwnPropSymbols$5g(b)) {
      if (__propIsEnum$5g.call(b, prop))
        __defNormalProp$5g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5g)
    for (var prop of __getOwnPropSymbols$5g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClipboardCheckSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.862 1.017C9.07 1 9.316 1 9.568 1h4.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77l.01.146c.394.013.733.045 1.042.128a4 4 0 0 1 2.829 2.829C21 6.476 21 7.067 21 7.863v9.378c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-9.38c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829c.31-.083.648-.115 1.043-.128.002-.05.005-.1.009-.146a2.03 2.03 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.03 2.03 0 0 1 .77-.201Zm.247 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437Zm7.098 9.661a1 1 0 0 0-1.414-1.414L11 15.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5f = Object.defineProperty;
var __getOwnPropSymbols$5f = Object.getOwnPropertySymbols;
var __hasOwnProp$5f = Object.prototype.hasOwnProperty;
var __propIsEnum$5f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5f = (obj, key, value) => key in obj ? __defProp$5f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5f.call(b, prop))
      __defNormalProp$5f(a, prop, b[prop]);
  if (__getOwnPropSymbols$5f)
    for (var prop of __getOwnPropSymbols$5f(b)) {
      if (__propIsEnum$5f.call(b, prop))
        __defNormalProp$5f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5f)
    for (var prop of __getOwnPropSymbols$5f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClockDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 6v6l4 2"
      }
    )
  );
};

var __defProp$5e = Object.defineProperty;
var __getOwnPropSymbols$5e = Object.getOwnPropertySymbols;
var __hasOwnProp$5e = Object.prototype.hasOwnProperty;
var __propIsEnum$5e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5e = (obj, key, value) => key in obj ? __defProp$5e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5e.call(b, prop))
      __defNormalProp$5e(a, prop, b[prop]);
  if (__getOwnPropSymbols$5e)
    for (var prop of __getOwnPropSymbols$5e(b)) {
      if (__propIsEnum$5e.call(b, prop))
        __defNormalProp$5e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5e)
    for (var prop of __getOwnPropSymbols$5e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClockRewindDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m22.7 13.5-2-2-2 2M21 12a9 9 0 1 1-1.245-4.57",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 7v5l3 2"
      }
    )
  );
};

var __defProp$5d = Object.defineProperty;
var __getOwnPropSymbols$5d = Object.getOwnPropertySymbols;
var __hasOwnProp$5d = Object.prototype.hasOwnProperty;
var __propIsEnum$5d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5d = (obj, key, value) => key in obj ? __defProp$5d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5d.call(b, prop))
      __defNormalProp$5d(a, prop, b[prop]);
  if (__getOwnPropSymbols$5d)
    for (var prop of __getOwnPropSymbols$5d(b)) {
      if (__propIsEnum$5d.call(b, prop))
        __defNormalProp$5d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5d)
    for (var prop of __getOwnPropSymbols$5d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClockRewindSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 4a8 8 0 1 0 7.791 9.823l-.384.384a1 1 0 0 1-1.414-1.414l2-2a1 1 0 0 1 1.415 0l2 2a1 1 0 0 1-1.415 1.414l-.195-.195C20.867 18.57 16.834 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2a9.996 9.996 0 0 1 8.616 4.92 1 1 0 0 1-1.723 1.018A7.996 7.996 0 0 0 12 4Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .445.832l3 2a1 1 0 0 0 1.11-1.664L13 11.465V7Z"
      }
    )
  );
};

var __defProp$5c = Object.defineProperty;
var __getOwnPropSymbols$5c = Object.getOwnPropertySymbols;
var __hasOwnProp$5c = Object.prototype.hasOwnProperty;
var __propIsEnum$5c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5c = (obj, key, value) => key in obj ? __defProp$5c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5c.call(b, prop))
      __defNormalProp$5c(a, prop, b[prop]);
  if (__getOwnPropSymbols$5c)
    for (var prop of __getOwnPropSymbols$5c(b)) {
      if (__propIsEnum$5c.call(b, prop))
        __defNormalProp$5c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5c)
    for (var prop of __getOwnPropSymbols$5c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgClockSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm12-6a1 1 0 1 0-2 0v6a1 1 0 0 0 .553.894l4 2a1 1 0 1 0 .894-1.788L13 11.382V6Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$5b = Object.defineProperty;
var __getOwnPropSymbols$5b = Object.getOwnPropertySymbols;
var __hasOwnProp$5b = Object.prototype.hasOwnProperty;
var __propIsEnum$5b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5b = (obj, key, value) => key in obj ? __defProp$5b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5b.call(b, prop))
      __defNormalProp$5b(a, prop, b[prop]);
  if (__getOwnPropSymbols$5b)
    for (var prop of __getOwnPropSymbols$5b(b)) {
      if (__propIsEnum$5b.call(b, prop))
        __defNormalProp$5b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5b)
    for (var prop of __getOwnPropSymbols$5b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgColorsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 20.472a6 6 0 1 0 5.58-10.262",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6.42 10.21a6 6 0 1 0 7.16 3.58M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Z"
      }
    )
  );
};

var __defProp$5a = Object.defineProperty;
var __getOwnPropSymbols$5a = Object.getOwnPropertySymbols;
var __hasOwnProp$5a = Object.prototype.hasOwnProperty;
var __propIsEnum$5a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5a = (obj, key, value) => key in obj ? __defProp$5a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5a.call(b, prop))
      __defNormalProp$5a(a, prop, b[prop]);
  if (__getOwnPropSymbols$5a)
    for (var prop of __getOwnPropSymbols$5a(b)) {
      if (__propIsEnum$5a.call(b, prop))
        __defNormalProp$5a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5a)
    for (var prop of __getOwnPropSymbols$5a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgColorsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13.45 13.23a6.217 6.217 0 0 1-5.85-1.662 6.2 6.2 0 1 1 5.85 1.662Zm1.698 1.544a8.23 8.23 0 0 0 3.698-3.06c.154-.232.231-.349.33-.407a.51.51 0 0 1 .289-.07c.114.009.212.065.408.176a6.2 6.2 0 0 1-5.567 11.065c-.251-.11-.377-.165-.456-.273a.51.51 0 0 1-.096-.327c.008-.134.103-.276.291-.561a8.156 8.156 0 0 0 1.355-4.494V16.8a8.222 8.222 0 0 0-.252-2.026ZM4.127 11.413c.196-.111.293-.167.408-.175a.51.51 0 0 1 .289.069c.099.058.176.175.33.408a8.193 8.193 0 0 0 8.066 3.595l.006.026c.114.469.174.959.174 1.464v.021a6.2 6.2 0 1 1-9.273-5.408Z"
      }
    )
  );
};

var __defProp$59 = Object.defineProperty;
var __getOwnPropSymbols$59 = Object.getOwnPropertySymbols;
var __hasOwnProp$59 = Object.prototype.hasOwnProperty;
var __propIsEnum$59 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$59 = (obj, key, value) => key in obj ? __defProp$59(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$59 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$59.call(b, prop))
      __defNormalProp$59(a, prop, b[prop]);
  if (__getOwnPropSymbols$59)
    for (var prop of __getOwnPropSymbols$59(b)) {
      if (__propIsEnum$59.call(b, prop))
        __defNormalProp$59(a, prop, b[prop]);
    }
  return a;
};
var __objRest$59 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$59.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$59)
    for (var prop of __getOwnPropSymbols$59(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$59.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCompohfeatured = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$59(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$59({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#D9D9D9",
        strokeWidth: 0.2,
        d: "M15.234 9.8V7.143h-2.657V9.8h2.657Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#2A8BFB",
        fillRule: "evenodd",
        stroke: "#2A8BFB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.1,
        d: "M14.549 8.017a.07.07 0 0 1 0 .103l-.873.806a.084.084 0 0 1-.112 0l-.397-.366a.07.07 0 0 1 0-.104.084.084 0 0 1 .112 0l.232.215c.039.035.058.053.08.06a.1.1 0 0 0 .058 0c.022-.007.041-.025.08-.06l.708-.654a.084.084 0 0 1 .112 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#2A8BFB",
        strokeWidth: 0.2,
        d: "M21.9 5.686V3.029h-9.324v2.657H21.9Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#E72B78", d: "M18.19 3.881h.952v.952h-.952z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#C5C5C5",
        d: "M21.025 4.698a.08.08 0 0 1-.112.112l-.341-.34-.34.34a.08.08 0 0 1-.113-.112l.34-.34-.34-.342a.08.08 0 0 1 .112-.112l.34.34.342-.34a.08.08 0 1 1 .112.112l-.34.341.34.34Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#2A8BFB",
        d: "M2.2 3a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h9.124a.2.2 0 0 0 .2-.2V3.2a.2.2 0 0 0-.2-.2H2.2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#EAEAEA",
        d: "M2.2 5.5a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h9.124a.2.2 0 0 0 .2-.2V5.7a.2.2 0 0 0-.2-.2H2.2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#FCECA7",
        d: "M2.2 8a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h9.124a.2.2 0 0 0 .2-.2V8.2a.2.2 0 0 0-.2-.2H2.2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "rect",
      {
        width: 4,
        height: 1,
        fill: "#EAEAEA",
        rx: 0.5,
        transform: "matrix(1 0 0 -1 17 9)"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#2A8BFB", d: "M19 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" })
  );
};

var __defProp$58 = Object.defineProperty;
var __getOwnPropSymbols$58 = Object.getOwnPropertySymbols;
var __hasOwnProp$58 = Object.prototype.hasOwnProperty;
var __propIsEnum$58 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$58 = (obj, key, value) => key in obj ? __defProp$58(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$58 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$58.call(b, prop))
      __defNormalProp$58(a, prop, b[prop]);
  if (__getOwnPropSymbols$58)
    for (var prop of __getOwnPropSymbols$58(b)) {
      if (__propIsEnum$58.call(b, prop))
        __defNormalProp$58(a, prop, b[prop]);
    }
  return a;
};
var __objRest$58 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$58.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$58)
    for (var prop of __getOwnPropSymbols$58(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$58.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgContractDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$58(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$58({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 3H3m18 18H3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 18V6m0 12-3-2m3 2 3-2M12 6 9 8m3-2 3 2"
      }
    )
  );
};

var __defProp$57 = Object.defineProperty;
var __getOwnPropSymbols$57 = Object.getOwnPropertySymbols;
var __hasOwnProp$57 = Object.prototype.hasOwnProperty;
var __propIsEnum$57 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$57 = (obj, key, value) => key in obj ? __defProp$57(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$57 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$57.call(b, prop))
      __defNormalProp$57(a, prop, b[prop]);
  if (__getOwnPropSymbols$57)
    for (var prop of __getOwnPropSymbols$57(b)) {
      if (__propIsEnum$57.call(b, prop))
        __defNormalProp$57(a, prop, b[prop]);
    }
  return a;
};
var __objRest$57 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$57.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$57)
    for (var prop of __getOwnPropSymbols$57(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$57.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgContractSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$57(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$57({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M2 3a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 18a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM14.445 8.832 13 7.87v8.263l1.445-.964a1 1 0 1 1 1.11 1.664l-3 2a1 1 0 0 1-1.11 0l-3-2a1 1 0 0 1 1.11-1.664l1.445.964V7.869l-1.445.963a1 1 0 0 1-1.11-1.664l3-2a1 1 0 0 1 1.11 0l3 2a1 1 0 0 1-1.11 1.664Z"
      }
    )
  );
};

var __defProp$56 = Object.defineProperty;
var __getOwnPropSymbols$56 = Object.getOwnPropertySymbols;
var __hasOwnProp$56 = Object.prototype.hasOwnProperty;
var __propIsEnum$56 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$56 = (obj, key, value) => key in obj ? __defProp$56(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$56 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$56.call(b, prop))
      __defNormalProp$56(a, prop, b[prop]);
  if (__getOwnPropSymbols$56)
    for (var prop of __getOwnPropSymbols$56(b)) {
      if (__propIsEnum$56.call(b, prop))
        __defNormalProp$56(a, prop, b[prop]);
    }
  return a;
};
var __objRest$56 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$56.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$56)
    for (var prop of __getOwnPropSymbols$56(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$56.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgConversationDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$56(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$56({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m10 15-3.075 3.114c-.43.434-.644.651-.828.666a.5.5 0 0 1-.421-.172c-.12-.14-.12-.446-.12-1.056v-1.56c0-.548-.449-.944-.99-1.024v0a3 3 0 0 1-2.534-2.533C2 12.219 2 11.96 2 11.445V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h7.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 4.28 19 5.12 19 6.8V11",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 14.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 11 19.92 11 18.8 11h-5.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C10 12.52 10 13.08 10 14.2v2.514c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h1.797c.373 0 .559 0 .739.033.16.03.314.079.462.145.167.076.32.182.626.395L19 22v-2.086c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.082c.152-.368.152-.834.152-1.766V14.2Z"
      }
    )
  );
};

var __defProp$55 = Object.defineProperty;
var __getOwnPropSymbols$55 = Object.getOwnPropertySymbols;
var __hasOwnProp$55 = Object.prototype.hasOwnProperty;
var __propIsEnum$55 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$55 = (obj, key, value) => key in obj ? __defProp$55(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$55 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$55.call(b, prop))
      __defNormalProp$55(a, prop, b[prop]);
  if (__getOwnPropSymbols$55)
    for (var prop of __getOwnPropSymbols$55(b)) {
      if (__propIsEnum$55.call(b, prop))
        __defNormalProp$55(a, prop, b[prop]);
    }
  return a;
};
var __objRest$55 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$55.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$55)
    for (var prop of __getOwnPropSymbols$55(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$55.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgConversationSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$55(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$55({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.162 10h5.676c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.357v2.784c0 .439 0 .817-.021 1.13-.023.33-.072.66-.207.986a3 3 0 0 1-1.624 1.624 3.07 3.07 0 0 1-.986.207 6.784 6.784 0 0 1-.162.009V22a1 1 0 0 1-1.57.821l-2.177-1.513c-.335-.233-.403-.276-.467-.305a.996.996 0 0 0-.232-.072c-.069-.013-.149-.017-.557-.017h-1.835c-.528 0-.982 0-1.357-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.31c-.193-.38-.264-.772-.296-1.168C9 17.735 9 17.28 9 16.753v-2.591c0-.528 0-.982.03-1.357.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296.375-.031.83-.031 1.357-.031Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M14.241 1H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 5.29 1 5.954 1 6.758v4.763c0 .441 0 .769.042 1.059a4 4 0 0 0 3.378 3.378c.072.01.116.037.136.053v1.578c0 .273 0 .54.019.755.016.19.06.587.342.915a1.5 1.5 0 0 0 1.263.518c.43-.036.74-.286.886-.41l.13-.115a5.813 5.813 0 0 1-.159-.98C7 17.814 7 17.284 7 16.795V14.12c0-.489 0-1.018.037-1.477.043-.519.148-1.205.508-1.912A5 5 0 0 1 9.73 8.545c.707-.36 1.393-.465 1.912-.508C12.101 8 12.631 8 13.12 8h5.762c.366 0 .754 0 1.119.015V6.76c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C15.71 1 15.046 1 14.242 1Z"
      }
    )
  );
};

var __defProp$54 = Object.defineProperty;
var __getOwnPropSymbols$54 = Object.getOwnPropertySymbols;
var __hasOwnProp$54 = Object.prototype.hasOwnProperty;
var __propIsEnum$54 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$54 = (obj, key, value) => key in obj ? __defProp$54(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$54 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$54.call(b, prop))
      __defNormalProp$54(a, prop, b[prop]);
  if (__getOwnPropSymbols$54)
    for (var prop of __getOwnPropSymbols$54(b)) {
      if (__propIsEnum$54.call(b, prop))
        __defNormalProp$54(a, prop, b[prop]);
    }
  return a;
};
var __objRest$54 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$54.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$54)
    for (var prop of __getOwnPropSymbols$54(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$54.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCopyDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$54(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$54({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.5 2.003c-.675.009-1.08.048-1.408.215a2 2 0 0 0-.874.874c-.167.328-.206.733-.215 1.408M19.5 2.003c.675.009 1.08.048 1.408.215a2 2 0 0 1 .874.874c.167.328.206.733.215 1.408m0 9c-.009.675-.048 1.08-.215 1.408a2 2 0 0 1-.874.874c-.328.167-.733.206-1.408.215M22 8v2m-8-8h2",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 11.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 8 4.08 8 5.2 8h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 9.52 16 10.08 16 11.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 22 13.92 22 12.8 22H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.48 2 19.92 2 18.8v-7.6Z"
      }
    )
  );
};

var __defProp$53 = Object.defineProperty;
var __getOwnPropSymbols$53 = Object.getOwnPropertySymbols;
var __hasOwnProp$53 = Object.prototype.hasOwnProperty;
var __propIsEnum$53 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$53 = (obj, key, value) => key in obj ? __defProp$53(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$53 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$53.call(b, prop))
      __defNormalProp$53(a, prop, b[prop]);
  if (__getOwnPropSymbols$53)
    for (var prop of __getOwnPropSymbols$53(b)) {
      if (__propIsEnum$53.call(b, prop))
        __defNormalProp$53(a, prop, b[prop]);
    }
  return a;
};
var __objRest$53 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$53.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$53)
    for (var prop of __getOwnPropSymbols$53(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$53.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCopySolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$53(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$53({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.161 7h7.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v7.678c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 19.82 1 19.365 1 18.838v-7.677c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 7 4.635 7 5.161 7ZM13 2a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1Zm-1.5-.01a1 1 0 0 1-.986 1.013c-.694.01-.875.058-.968.106a1 1 0 0 0-.437.437c-.048.093-.097.274-.106.968a1 1 0 0 1-2-.028c.009-.656.038-1.286.324-1.848a3 3 0 0 1 1.311-1.311c.562-.286 1.192-.315 1.848-.324a1 1 0 0 1 1.014.986Zm7 0a1 1 0 0 1 1.014-.987c.656.009 1.286.038 1.848.324a3 3 0 0 1 1.311 1.311c.286.562.315 1.192.324 1.848a1 1 0 1 1-2 .028c-.01-.694-.058-.875-.106-.968a1 1 0 0 0-.437-.437c-.093-.048-.274-.097-.968-.106a1 1 0 0 1-.986-1.014ZM22 7a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm.01 5.5a1 1 0 0 1 .987 1.014c-.009.656-.038 1.286-.324 1.848a3 3 0 0 1-1.311 1.311c-.562.286-1.192.315-1.848.324a1 1 0 1 1-.027-2c.693-.01.874-.058.967-.106a1 1 0 0 0 .437-.437c.048-.093.097-.274.106-.968a1 1 0 0 1 1.014-.986Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$52 = Object.defineProperty;
var __getOwnPropSymbols$52 = Object.getOwnPropertySymbols;
var __hasOwnProp$52 = Object.prototype.hasOwnProperty;
var __propIsEnum$52 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$52 = (obj, key, value) => key in obj ? __defProp$52(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$52 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$52.call(b, prop))
      __defNormalProp$52(a, prop, b[prop]);
  if (__getOwnPropSymbols$52)
    for (var prop of __getOwnPropSymbols$52(b)) {
      if (__propIsEnum$52.call(b, prop))
        __defNormalProp$52(a, prop, b[prop]);
    }
  return a;
};
var __objRest$52 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$52.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$52)
    for (var prop of __getOwnPropSymbols$52(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$52.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCreditCardDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$52(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$52({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 10H2m9 4H6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18.8 19c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6Z"
      }
    )
  );
};

var __defProp$51 = Object.defineProperty;
var __getOwnPropSymbols$51 = Object.getOwnPropertySymbols;
var __hasOwnProp$51 = Object.prototype.hasOwnProperty;
var __propIsEnum$51 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$51 = (obj, key, value) => key in obj ? __defProp$51(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$51 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$51.call(b, prop))
      __defNormalProp$51(a, prop, b[prop]);
  if (__getOwnPropSymbols$51)
    for (var prop of __getOwnPropSymbols$51(b)) {
      if (__propIsEnum$51.call(b, prop))
        __defNormalProp$51(a, prop, b[prop]);
    }
  return a;
};
var __objRest$51 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$51.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$51)
    for (var prop of __getOwnPropSymbols$51(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$51.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCreditCardSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$51(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$51({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.838 4H5.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 7.18 1 7.635 1 8.161c0 .464.375.839.839.839H22.16a.839.839 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 4 19.365 4 18.838 4Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.546 11.109C1.76 11 2.04 11 2.6 11h18.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C23 11.76 23 12.04 23 12.6v3.239c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 16.82 1 16.365 1 15.839V12.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437ZM6 14a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$50 = Object.defineProperty;
var __getOwnPropSymbols$50 = Object.getOwnPropertySymbols;
var __hasOwnProp$50 = Object.prototype.hasOwnProperty;
var __propIsEnum$50 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$50 = (obj, key, value) => key in obj ? __defProp$50(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$50 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$50.call(b, prop))
      __defNormalProp$50(a, prop, b[prop]);
  if (__getOwnPropSymbols$50)
    for (var prop of __getOwnPropSymbols$50(b)) {
      if (__propIsEnum$50.call(b, prop))
        __defNormalProp$50(a, prop, b[prop]);
    }
  return a;
};
var __objRest$50 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$50.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$50)
    for (var prop of __getOwnPropSymbols$50(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$50.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCurrencyExchangeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$50(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$50({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.101 4A7 7 0 0 1 20 13.899",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 22A7 7 0 1 0 9 8a7 7 0 0 0 0 14Z"
      }
    )
  );
};

var __defProp$4$ = Object.defineProperty;
var __getOwnPropSymbols$4$ = Object.getOwnPropertySymbols;
var __hasOwnProp$4$ = Object.prototype.hasOwnProperty;
var __propIsEnum$4$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4$ = (obj, key, value) => key in obj ? __defProp$4$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4$.call(b, prop))
      __defNormalProp$4$(a, prop, b[prop]);
  if (__getOwnPropSymbols$4$)
    for (var prop of __getOwnPropSymbols$4$(b)) {
      if (__propIsEnum$4$.call(b, prop))
        __defNormalProp$4$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4$)
    for (var prop of __getOwnPropSymbols$4$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgCurrencyExchangeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4$(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M7.203 7.203a8 8 0 1 0 3.595 15.595A8 8 0 0 0 7.202 7.202Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8.044 5.045A10.1 10.1 0 0 1 9 5c5.523 0 10 4.477 10 10 0 .322-.015.641-.045.956a8 8 0 1 0-10.91-10.91Z"
      }
    )
  );
};

var __defProp$4_ = Object.defineProperty;
var __getOwnPropSymbols$4_ = Object.getOwnPropertySymbols;
var __hasOwnProp$4_ = Object.prototype.hasOwnProperty;
var __propIsEnum$4_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4_ = (obj, key, value) => key in obj ? __defProp$4_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4_.call(b, prop))
      __defNormalProp$4_(a, prop, b[prop]);
  if (__getOwnPropSymbols$4_)
    for (var prop of __getOwnPropSymbols$4_(b)) {
      if (__propIsEnum$4_.call(b, prop))
        __defNormalProp$4_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4_)
    for (var prop of __getOwnPropSymbols$4_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataLineDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4_(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 20v-7m-8 7V10M4 20v-4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m13.407 5.027 5.168 1.939M10.8 5.4 5.2 9.6m15.86-3.16a1.5 1.5 0 1 1-2.121 2.12 1.5 1.5 0 0 1 2.122-2.12Zm-16 3a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12Zm8-6a1.5 1.5 0 1 1-2.121 2.12 1.5 1.5 0 0 1 2.122-2.12Z"
      }
    )
  );
};

var __defProp$4Z = Object.defineProperty;
var __getOwnPropSymbols$4Z = Object.getOwnPropertySymbols;
var __hasOwnProp$4Z = Object.prototype.hasOwnProperty;
var __propIsEnum$4Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4Z = (obj, key, value) => key in obj ? __defProp$4Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4Z.call(b, prop))
      __defNormalProp$4Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$4Z)
    for (var prop of __getOwnPropSymbols$4Z(b)) {
      if (__propIsEnum$4Z.call(b, prop))
        __defNormalProp$4Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4Z)
    for (var prop of __getOwnPropSymbols$4Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataLineSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4Z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.232 2.732a2.5 2.5 0 0 1 4.264 1.636l3.71 1.391.026-.027a2.5 2.5 0 1 1-.729 1.9L13.794 6.24a2.501 2.501 0 0 1-3.028.434l-4.333 3.25a2.5 2.5 0 1 1-1.2-1.6l4.334-3.25a2.498 2.498 0 0 1 .665-2.343Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20 12a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1Zm-7-2a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V10Zm-9 5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z"
      }
    )
  );
};

var __defProp$4Y = Object.defineProperty;
var __getOwnPropSymbols$4Y = Object.getOwnPropertySymbols;
var __hasOwnProp$4Y = Object.prototype.hasOwnProperty;
var __propIsEnum$4Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4Y = (obj, key, value) => key in obj ? __defProp$4Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4Y.call(b, prop))
      __defNormalProp$4Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$4Y)
    for (var prop of __getOwnPropSymbols$4Y(b)) {
      if (__propIsEnum$4Y.call(b, prop))
        __defNormalProp$4Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4Y)
    for (var prop of __getOwnPropSymbols$4Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataTableDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4Y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 10H3m18 8H3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 6H3m18 8H3"
      }
    )
  );
};

var __defProp$4X = Object.defineProperty;
var __getOwnPropSymbols$4X = Object.getOwnPropertySymbols;
var __hasOwnProp$4X = Object.prototype.hasOwnProperty;
var __propIsEnum$4X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4X = (obj, key, value) => key in obj ? __defProp$4X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4X.call(b, prop))
      __defNormalProp$4X(a, prop, b[prop]);
  if (__getOwnPropSymbols$4X)
    for (var prop of __getOwnPropSymbols$4X(b)) {
      if (__propIsEnum$4X.call(b, prop))
        __defNormalProp$4X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4X)
    for (var prop of __getOwnPropSymbols$4X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataTableSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4X(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 10a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4W = Object.defineProperty;
var __getOwnPropSymbols$4W = Object.getOwnPropertySymbols;
var __hasOwnProp$4W = Object.prototype.hasOwnProperty;
var __propIsEnum$4W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4W = (obj, key, value) => key in obj ? __defProp$4W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4W.call(b, prop))
      __defNormalProp$4W(a, prop, b[prop]);
  if (__getOwnPropSymbols$4W)
    for (var prop of __getOwnPropSymbols$4W(b)) {
      if (__propIsEnum$4W.call(b, prop))
        __defNormalProp$4W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4W)
    for (var prop of __getOwnPropSymbols$4W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataUploadDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4W(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V15",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m17 8-5-5m0 0L7 8m5-5v12"
      }
    )
  );
};

var __defProp$4V = Object.defineProperty;
var __getOwnPropSymbols$4V = Object.getOwnPropertySymbols;
var __hasOwnProp$4V = Object.prototype.hasOwnProperty;
var __propIsEnum$4V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4V = (obj, key, value) => key in obj ? __defProp$4V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4V.call(b, prop))
      __defNormalProp$4V(a, prop, b[prop]);
  if (__getOwnPropSymbols$4V)
    for (var prop of __getOwnPropSymbols$4V(b)) {
      if (__propIsEnum$4V.call(b, prop))
        __defNormalProp$4V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4V)
    for (var prop of __getOwnPropSymbols$4V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataUploadSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4V(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L13 5.414V15a1 1 0 1 1-2 0V5.414L7.707 8.707a1 1 0 0 1-1.414-1.414l5-5Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3 14a1 1 0 0 1 1 1v1.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V15a1 1 0 1 1 2 0v1.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V15a1 1 0 0 1 1-1Z"
      }
    )
  );
};

var __defProp$4U = Object.defineProperty;
var __getOwnPropSymbols$4U = Object.getOwnPropertySymbols;
var __hasOwnProp$4U = Object.prototype.hasOwnProperty;
var __propIsEnum$4U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4U = (obj, key, value) => key in obj ? __defProp$4U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4U.call(b, prop))
      __defNormalProp$4U(a, prop, b[prop]);
  if (__getOwnPropSymbols$4U)
    for (var prop of __getOwnPropSymbols$4U(b)) {
      if (__propIsEnum$4U.call(b, prop))
        __defNormalProp$4U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4U)
    for (var prop of __getOwnPropSymbols$4U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDatabaseDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4U(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5"
      }
    )
  );
};

var __defProp$4T = Object.defineProperty;
var __getOwnPropSymbols$4T = Object.getOwnPropertySymbols;
var __hasOwnProp$4T = Object.prototype.hasOwnProperty;
var __propIsEnum$4T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4T = (obj, key, value) => key in obj ? __defProp$4T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4T.call(b, prop))
      __defNormalProp$4T(a, prop, b[prop]);
  if (__getOwnPropSymbols$4T)
    for (var prop of __getOwnPropSymbols$4T(b)) {
      if (__propIsEnum$4T.call(b, prop))
        __defNormalProp$4T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4T)
    for (var prop of __getOwnPropSymbols$4T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDatabaseSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4T(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M2.415 13.5c.12 0 .233.053.317.139a3.8 3.8 0 0 0 .35.314c.579.459 1.355.827 2.226 1.118C7.061 15.656 9.423 16 12 16s4.939-.344 6.692-.929c.87-.29 1.647-.66 2.226-1.118a3.8 3.8 0 0 0 .35-.314.447.447 0 0 1 .317-.139c.23 0 .415.186.415.415V19c0 .85-.513 1.502-1.082 1.953-.579.459-1.355.827-2.226 1.118-1.753.585-4.115.929-6.692.929s-4.939-.344-6.692-.929c-.87-.29-1.647-.66-2.226-1.118C2.513 20.502 2 19.849 2 19v-5.085c0-.23.186-.415.415-.415Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.912 3.047C21.482 3.496 22 4.148 22 5v5c0 .85-.513 1.502-1.082 1.953-.579.459-1.355.827-2.226 1.118-1.753.585-4.115.929-6.692.929s-4.939-.344-6.692-.929c-.87-.29-1.647-.66-2.226-1.118C2.513 11.502 2 10.849 2 10V5c0-.852.519-1.504 1.088-1.953.581-.458 1.36-.826 2.232-1.117C7.075 1.345 9.437 1 12 1c2.563 0 4.925.345 6.68.93.873.29 1.651.66 2.232 1.117ZM4 5l.003-.015a.296.296 0 0 1 .032-.066c.043-.07.13-.174.291-.301.33-.26.87-.539 1.626-.79C7.454 3.326 9.592 3 12 3s4.546.327 6.048.827c.756.252 1.296.53 1.626.79.162.128.248.232.29.302.021.033.03.055.033.066A.06.06 0 0 1 20 5s0 .006-.003.015a.293.293 0 0 1-.032.066c-.043.07-.13.174-.291.301-.33.26-.87.539-1.626.79C16.546 6.674 14.408 7 12 7s-4.546-.327-6.048-.827c-.756-.252-1.296-.53-1.626-.79a1.236 1.236 0 0 1-.29-.302.296.296 0 0 1-.033-.066A.066.066 0 0 1 4 5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4S = Object.defineProperty;
var __getOwnPropSymbols$4S = Object.getOwnPropertySymbols;
var __hasOwnProp$4S = Object.prototype.hasOwnProperty;
var __propIsEnum$4S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4S = (obj, key, value) => key in obj ? __defProp$4S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4S.call(b, prop))
      __defNormalProp$4S(a, prop, b[prop]);
  if (__getOwnPropSymbols$4S)
    for (var prop of __getOwnPropSymbols$4S(b)) {
      if (__propIsEnum$4S.call(b, prop))
        __defNormalProp$4S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4S)
    for (var prop of __getOwnPropSymbols$4S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataflow01Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4S(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 20h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C12 17.72 12 16.88 12 15.2V8.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C14.28 4 15.12 4 16.8 4h.2M7 12h10",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M19 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm14-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      }
    )
  );
};

var __defProp$4R = Object.defineProperty;
var __getOwnPropSymbols$4R = Object.getOwnPropertySymbols;
var __hasOwnProp$4R = Object.prototype.hasOwnProperty;
var __propIsEnum$4R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4R = (obj, key, value) => key in obj ? __defProp$4R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4R.call(b, prop))
      __defNormalProp$4R(a, prop, b[prop]);
  if (__getOwnPropSymbols$4R)
    for (var prop of __getOwnPropSymbols$4R(b)) {
      if (__propIsEnum$4R.call(b, prop))
        __defNormalProp$4R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4R)
    for (var prop of __getOwnPropSymbols$4R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataflow01Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4R(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.911 5.038c.33-.027.732-.035 1.26-.037A3.001 3.001 0 0 0 22 4a3 3 0 0 0-5.83-1 19.07 19.07 0 0 0-1.422.044c-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C11 7.29 11 7.954 11 8.758V11H7.83a3.001 3.001 0 1 0 0 2H11v2.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.404.033.875.041 1.423.043a3.001 3.001 0 1 0 0-2c-.528-.002-.93-.01-1.26-.037-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C13 16.639 13 16.057 13 15.2V13h3.17a3.001 3.001 0 1 0 0-2H13V8.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4Q = Object.defineProperty;
var __getOwnPropSymbols$4Q = Object.getOwnPropertySymbols;
var __hasOwnProp$4Q = Object.prototype.hasOwnProperty;
var __propIsEnum$4Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4Q = (obj, key, value) => key in obj ? __defProp$4Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4Q.call(b, prop))
      __defNormalProp$4Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$4Q)
    for (var prop of __getOwnPropSymbols$4Q(b)) {
      if (__propIsEnum$4Q.call(b, prop))
        __defNormalProp$4Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4Q)
    for (var prop of __getOwnPropSymbols$4Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataflow02Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4Q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 4v11.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C14.28 20 15.12 20 16.8 20h.2M7 4h10m-5 8h5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M19 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM5 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm14 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      }
    )
  );
};

var __defProp$4P = Object.defineProperty;
var __getOwnPropSymbols$4P = Object.getOwnPropertySymbols;
var __hasOwnProp$4P = Object.prototype.hasOwnProperty;
var __propIsEnum$4P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4P = (obj, key, value) => key in obj ? __defProp$4P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4P.call(b, prop))
      __defNormalProp$4P(a, prop, b[prop]);
  if (__getOwnPropSymbols$4P)
    for (var prop of __getOwnPropSymbols$4P(b)) {
      if (__propIsEnum$4P.call(b, prop))
        __defNormalProp$4P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4P)
    for (var prop of __getOwnPropSymbols$4P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataflow02Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4P(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.83 3a3.001 3.001 0 1 0 0 2H11v10.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.404.033.875.041 1.423.043a3.001 3.001 0 1 0 0-2c-.528-.002-.93-.01-1.26-.037-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C13 16.639 13 16.057 13 15.2V13h3.17a3.001 3.001 0 1 0 0-2H13V5h3.17a3.001 3.001 0 1 0 0-2H7.83Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4O = Object.defineProperty;
var __getOwnPropSymbols$4O = Object.getOwnPropertySymbols;
var __hasOwnProp$4O = Object.prototype.hasOwnProperty;
var __propIsEnum$4O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4O = (obj, key, value) => key in obj ? __defProp$4O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4O.call(b, prop))
      __defNormalProp$4O(a, prop, b[prop]);
  if (__getOwnPropSymbols$4O)
    for (var prop of __getOwnPropSymbols$4O(b)) {
      if (__propIsEnum$4O.call(b, prop))
        __defNormalProp$4O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4O)
    for (var prop of __getOwnPropSymbols$4O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataflow04Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4O(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 18v-.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 13 7.12 13 8.8 13h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 15.28 20 16.12 20 17.8v.2m-8 0V8",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm16 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-8 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM3 5c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C4.602 2 5.068 2 6 2h12c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C21 3.602 21 4.068 21 5c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C19.398 8 18.932 8 18 8H6c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C3 6.398 3 5.932 3 5Z"
      }
    )
  );
};

var __defProp$4N = Object.defineProperty;
var __getOwnPropSymbols$4N = Object.getOwnPropertySymbols;
var __hasOwnProp$4N = Object.prototype.hasOwnProperty;
var __propIsEnum$4N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4N = (obj, key, value) => key in obj ? __defProp$4N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4N.call(b, prop))
      __defNormalProp$4N(a, prop, b[prop]);
  if (__getOwnPropSymbols$4N)
    for (var prop of __getOwnPropSymbols$4N(b)) {
      if (__propIsEnum$4N.call(b, prop))
        __defNormalProp$4N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4N)
    for (var prop of __getOwnPropSymbols$4N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDataflow04Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4N(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.032 1H5.968c-.439 0-.817 0-1.13.021a3.07 3.07 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3.07 3.07 0 0 0-.207.986C2 4.15 2 4.529 2 4.968v.064c0 .439 0 .817.021 1.13.023.33.072.66.207.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207C5.15 9 5.529 9 5.968 9H11v3H8.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564a19.07 19.07 0 0 0-.043 1.423 3.001 3.001 0 1 0 2 0c.002-.529.01-.93.037-1.26.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C7.361 14 7.943 14 8.8 14H11v3.17a3.001 3.001 0 1 0 2 0V14h2.2c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819.027.33.035.731.037 1.26A3.001 3.001 0 0 0 20 23a3 3 0 0 0 1-5.83 19.079 19.079 0 0 0-.044-1.422c-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 12 16.046 12 15.242 12H13V9h5.032c.439 0 .817 0 1.13-.021.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624c.135-.326.184-.656.207-.986C22 5.85 22 5.471 22 5.032v-.064c0-.439 0-.817-.021-1.13a3.072 3.072 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3.07 3.07 0 0 0-.986-.207C18.85 1 18.471 1 18.032 1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4M = Object.defineProperty;
var __getOwnPropSymbols$4M = Object.getOwnPropertySymbols;
var __hasOwnProp$4M = Object.prototype.hasOwnProperty;
var __propIsEnum$4M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4M = (obj, key, value) => key in obj ? __defProp$4M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4M.call(b, prop))
      __defNormalProp$4M(a, prop, b[prop]);
  if (__getOwnPropSymbols$4M)
    for (var prop of __getOwnPropSymbols$4M(b)) {
      if (__propIsEnum$4M.call(b, prop))
        __defNormalProp$4M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4M)
    for (var prop of __getOwnPropSymbols$4M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDecisionProcessDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4M(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 6h3a2 2 0 0 1 2 2v7M6 9v12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$4L = Object.defineProperty;
var __getOwnPropSymbols$4L = Object.getOwnPropertySymbols;
var __hasOwnProp$4L = Object.prototype.hasOwnProperty;
var __propIsEnum$4L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4L = (obj, key, value) => key in obj ? __defProp$4L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4L.call(b, prop))
      __defNormalProp$4L(a, prop, b[prop]);
  if (__getOwnPropSymbols$4L)
    for (var prop of __getOwnPropSymbols$4L(b)) {
      if (__propIsEnum$4L.call(b, prop))
        __defNormalProp$4L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4L)
    for (var prop of __getOwnPropSymbols$4L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDecisionProcessSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4L(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 9.874A4.002 4.002 0 0 0 6 2a4 4 0 0 0-1 7.874V21a1 1 0 1 0 2 0V9.874ZM14 18a4.002 4.002 0 0 1 3-3.874V8a1 1 0 0 0-1-1h-3a1 1 0 1 1 0-2h3a3 3 0 0 1 3 3v6.126A4.002 4.002 0 0 1 18 22a4 4 0 0 1-4-4Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4K = Object.defineProperty;
var __getOwnPropSymbols$4K = Object.getOwnPropertySymbols;
var __hasOwnProp$4K = Object.prototype.hasOwnProperty;
var __propIsEnum$4K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4K = (obj, key, value) => key in obj ? __defProp$4K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4K.call(b, prop))
      __defNormalProp$4K(a, prop, b[prop]);
  if (__getOwnPropSymbols$4K)
    for (var prop of __getOwnPropSymbols$4K(b)) {
      if (__propIsEnum$4K.call(b, prop))
        __defNormalProp$4K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4K)
    for (var prop of __getOwnPropSymbols$4K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDiamondDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4K(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10 3 8 9l4 11.5L16 9l-2-6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2.5 9h19m-8.885 11.262 8.958-10.75c.152-.182.228-.273.257-.375a.501.501 0 0 0 0-.274c-.029-.102-.105-.193-.257-.375l-4.333-5.2a1.083 1.083 0 0 0-.186-.197.5.5 0 0 0-.158-.074C16.832 3 16.763 3 16.626 3H7.374c-.138 0-.207 0-.27.017a.5.5 0 0 0-.159.074 1.08 1.08 0 0 0-.186.197l-4.333 5.2c-.152.182-.228.273-.257.375a.5.5 0 0 0 0 .274c.03.102.105.193.257.375l8.958 10.75c.212.254.317.38.443.427a.5.5 0 0 0 .344 0c.126-.047.231-.173.443-.427Z"
      }
    )
  );
};

var __defProp$4J = Object.defineProperty;
var __getOwnPropSymbols$4J = Object.getOwnPropertySymbols;
var __hasOwnProp$4J = Object.prototype.hasOwnProperty;
var __propIsEnum$4J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4J = (obj, key, value) => key in obj ? __defProp$4J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4J.call(b, prop))
      __defNormalProp$4J(a, prop, b[prop]);
  if (__getOwnPropSymbols$4J)
    for (var prop of __getOwnPropSymbols$4J(b)) {
      if (__propIsEnum$4J.call(b, prop))
        __defNormalProp$4J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4J)
    for (var prop of __getOwnPropSymbols$4J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDiamondSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4J(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.613 2h-1.226l-2 6h5.226l-2-6Zm2 8H9.387L12 17.837 14.613 10ZM7.28 8l2-6H7.233a1.5 1.5 0 0 0-1.152.54L2.215 7.18a.5.5 0 0 0 .384.82h4.68Zm-5.065 2.82a.5.5 0 0 1 .384-.82h4.68l3.512 10.535c.077.23-.175.385-.325.194a8.29 8.29 0 0 0-.155-.194L2.215 10.82ZM16.72 10h4.68a.5.5 0 0 1 .385.82l-8.096 9.715a8.29 8.29 0 0 0-.155.194c-.15.19-.402.036-.325-.194L16.721 10Zm5.065-2.82a.5.5 0 0 1-.384.82h-4.68l-2-6h2.045a1.5 1.5 0 0 1 1.152.54l3.867 4.64Z"
      }
    )
  );
};

var __defProp$4I = Object.defineProperty;
var __getOwnPropSymbols$4I = Object.getOwnPropertySymbols;
var __hasOwnProp$4I = Object.prototype.hasOwnProperty;
var __propIsEnum$4I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4I = (obj, key, value) => key in obj ? __defProp$4I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4I.call(b, prop))
      __defNormalProp$4I(a, prop, b[prop]);
  if (__getOwnPropSymbols$4I)
    for (var prop of __getOwnPropSymbols$4I(b)) {
      if (__propIsEnum$4I.call(b, prop))
        __defNormalProp$4I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4I)
    for (var prop of __getOwnPropSymbols$4I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDocumentsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4I(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m2 14.5 9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 14.5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12.358 4.679a1.028 1.028 0 0 0-.266-.111.5.5 0 0 0-.184 0 1.093 1.093 0 0 0-.266.11L2 9.5l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.013.135-.045.266-.11L22 9.5l-9.642-4.821Z"
      }
    )
  );
};

var __defProp$4H = Object.defineProperty;
var __getOwnPropSymbols$4H = Object.getOwnPropertySymbols;
var __hasOwnProp$4H = Object.prototype.hasOwnProperty;
var __propIsEnum$4H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4H = (obj, key, value) => key in obj ? __defProp$4H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4H.call(b, prop))
      __defNormalProp$4H(a, prop, b[prop]);
  if (__getOwnPropSymbols$4H)
    for (var prop of __getOwnPropSymbols$4H(b)) {
      if (__propIsEnum$4H.call(b, prop))
        __defNormalProp$4H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4H)
    for (var prop of __getOwnPropSymbols$4H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDocumentsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4H(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.723 3.576a1.5 1.5 0 0 1 .554 0 1.902 1.902 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014a1.902 1.902 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 1.846 1.846 0 0 1-.502-.187l-.026-.012-9.642-4.822a1 1 0 0 1 0-1.788l9.642-4.822.026-.013c.093-.047.286-.146.502-.186Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m2.528 13.109-.975.487a1 1 0 0 0 0 1.79l9.642 4.82.026.013c.093.048.286.146.502.187a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.187l.026-.013 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.886-.011.006a5.936 5.936 0 0 1-.29.137 3.489 3.489 0 0 1-2.043.234 3.489 3.489 0 0 1-.754-.234 6.056 6.056 0 0 1-.289-.137l-.011-.006-7.773-3.886Z"
      }
    )
  );
};

var __defProp$4G = Object.defineProperty;
var __getOwnPropSymbols$4G = Object.getOwnPropertySymbols;
var __hasOwnProp$4G = Object.prototype.hasOwnProperty;
var __propIsEnum$4G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4G = (obj, key, value) => key in obj ? __defProp$4G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4G.call(b, prop))
      __defNormalProp$4G(a, prop, b[prop]);
  if (__getOwnPropSymbols$4G)
    for (var prop of __getOwnPropSymbols$4G(b)) {
      if (__propIsEnum$4G.call(b, prop))
        __defNormalProp$4G(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4G)
    for (var prop of __getOwnPropSymbols$4G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDotsHorizontalDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4G(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }
    )
  );
};

var __defProp$4F = Object.defineProperty;
var __getOwnPropSymbols$4F = Object.getOwnPropertySymbols;
var __hasOwnProp$4F = Object.prototype.hasOwnProperty;
var __propIsEnum$4F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4F = (obj, key, value) => key in obj ? __defProp$4F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4F.call(b, prop))
      __defNormalProp$4F(a, prop, b[prop]);
  if (__getOwnPropSymbols$4F)
    for (var prop of __getOwnPropSymbols$4F(b)) {
      if (__propIsEnum$4F.call(b, prop))
        __defNormalProp$4F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4F)
    for (var prop of __getOwnPropSymbols$4F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDotsHorizontalSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4F(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4E = Object.defineProperty;
var __getOwnPropSymbols$4E = Object.getOwnPropertySymbols;
var __hasOwnProp$4E = Object.prototype.hasOwnProperty;
var __propIsEnum$4E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4E = (obj, key, value) => key in obj ? __defProp$4E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4E.call(b, prop))
      __defNormalProp$4E(a, prop, b[prop]);
  if (__getOwnPropSymbols$4E)
    for (var prop of __getOwnPropSymbols$4E(b)) {
      if (__propIsEnum$4E.call(b, prop))
        __defNormalProp$4E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4E)
    for (var prop of __getOwnPropSymbols$4E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDotsMatrixDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4E(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }
    )
  );
};

var __defProp$4D = Object.defineProperty;
var __getOwnPropSymbols$4D = Object.getOwnPropertySymbols;
var __hasOwnProp$4D = Object.prototype.hasOwnProperty;
var __propIsEnum$4D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4D = (obj, key, value) => key in obj ? __defProp$4D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4D.call(b, prop))
      __defNormalProp$4D(a, prop, b[prop]);
  if (__getOwnPropSymbols$4D)
    for (var prop of __getOwnPropSymbols$4D(b)) {
      if (__propIsEnum$4D.call(b, prop))
        __defNormalProp$4D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4D)
    for (var prop of __getOwnPropSymbols$4D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDotsMatrixSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4D(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7-14a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4C = Object.defineProperty;
var __getOwnPropSymbols$4C = Object.getOwnPropertySymbols;
var __hasOwnProp$4C = Object.prototype.hasOwnProperty;
var __propIsEnum$4C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4C = (obj, key, value) => key in obj ? __defProp$4C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4C.call(b, prop))
      __defNormalProp$4C(a, prop, b[prop]);
  if (__getOwnPropSymbols$4C)
    for (var prop of __getOwnPropSymbols$4C(b)) {
      if (__propIsEnum$4C.call(b, prop))
        __defNormalProp$4C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4C)
    for (var prop of __getOwnPropSymbols$4C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDotsVerticalDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4C(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm0-7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm0 14a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
      }
    )
  );
};

var __defProp$4B = Object.defineProperty;
var __getOwnPropSymbols$4B = Object.getOwnPropertySymbols;
var __hasOwnProp$4B = Object.prototype.hasOwnProperty;
var __propIsEnum$4B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4B = (obj, key, value) => key in obj ? __defProp$4B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4B.call(b, prop))
      __defNormalProp$4B(a, prop, b[prop]);
  if (__getOwnPropSymbols$4B)
    for (var prop of __getOwnPropSymbols$4B(b)) {
      if (__propIsEnum$4B.call(b, prop))
        __defNormalProp$4B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4B)
    for (var prop of __getOwnPropSymbols$4B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDotsVerticalSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4B(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0-7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4A = Object.defineProperty;
var __getOwnPropSymbols$4A = Object.getOwnPropertySymbols;
var __hasOwnProp$4A = Object.prototype.hasOwnProperty;
var __propIsEnum$4A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4A = (obj, key, value) => key in obj ? __defProp$4A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4A.call(b, prop))
      __defNormalProp$4A(a, prop, b[prop]);
  if (__getOwnPropSymbols$4A)
    for (var prop of __getOwnPropSymbols$4A(b)) {
      if (__propIsEnum$4A.call(b, prop))
        __defNormalProp$4A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4A)
    for (var prop of __getOwnPropSymbols$4A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDownloadDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4A(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V15",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m17 10-5 5m0 0-5-5m5 5V3"
      }
    )
  );
};

var __defProp$4z = Object.defineProperty;
var __getOwnPropSymbols$4z = Object.getOwnPropertySymbols;
var __hasOwnProp$4z = Object.prototype.hasOwnProperty;
var __propIsEnum$4z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4z = (obj, key, value) => key in obj ? __defProp$4z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4z.call(b, prop))
      __defNormalProp$4z(a, prop, b[prop]);
  if (__getOwnPropSymbols$4z)
    for (var prop of __getOwnPropSymbols$4z(b)) {
      if (__propIsEnum$4z.call(b, prop))
        __defNormalProp$4z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4z)
    for (var prop of __getOwnPropSymbols$4z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDownloadSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13 3a1 1 0 1 0-2 0v9.586L7.707 9.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L13 12.586V3Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3 14a1 1 0 0 1 1 1v1.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V15a1 1 0 1 1 2 0v1.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V15a1 1 0 0 1 1-1Z"
      }
    )
  );
};

var __defProp$4y = Object.defineProperty;
var __getOwnPropSymbols$4y = Object.getOwnPropertySymbols;
var __hasOwnProp$4y = Object.prototype.hasOwnProperty;
var __propIsEnum$4y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4y = (obj, key, value) => key in obj ? __defProp$4y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4y.call(b, prop))
      __defNormalProp$4y(a, prop, b[prop]);
  if (__getOwnPropSymbols$4y)
    for (var prop of __getOwnPropSymbols$4y(b)) {
      if (__propIsEnum$4y.call(b, prop))
        __defNormalProp$4y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4y)
    for (var prop of __getOwnPropSymbols$4y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDragDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 8.5h18m-18 7h18"
      }
    )
  );
};

var __defProp$4x = Object.defineProperty;
var __getOwnPropSymbols$4x = Object.getOwnPropertySymbols;
var __hasOwnProp$4x = Object.prototype.hasOwnProperty;
var __propIsEnum$4x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4x = (obj, key, value) => key in obj ? __defProp$4x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4x.call(b, prop))
      __defNormalProp$4x(a, prop, b[prop]);
  if (__getOwnPropSymbols$4x)
    for (var prop of __getOwnPropSymbols$4x(b)) {
      if (__propIsEnum$4x.call(b, prop))
        __defNormalProp$4x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4x)
    for (var prop of __getOwnPropSymbols$4x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDragSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4x(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 7a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4w = Object.defineProperty;
var __getOwnPropSymbols$4w = Object.getOwnPropertySymbols;
var __hasOwnProp$4w = Object.prototype.hasOwnProperty;
var __propIsEnum$4w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4w = (obj, key, value) => key in obj ? __defProp$4w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4w.call(b, prop))
      __defNormalProp$4w(a, prop, b[prop]);
  if (__getOwnPropSymbols$4w)
    for (var prop of __getOwnPropSymbols$4w(b)) {
      if (__propIsEnum$4w.call(b, prop))
        __defNormalProp$4w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4w)
    for (var prop of __getOwnPropSymbols$4w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDropperDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4w(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m16 12-7 7c-2.5 2.5-7 3-7 3s.5-4.5 3-7l7-7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m16 12 5-5a2.828 2.828 0 1 0-4-4l-5 5m-1.5-1.5 7 7"
      }
    )
  );
};

var __defProp$4v = Object.defineProperty;
var __getOwnPropSymbols$4v = Object.getOwnPropertySymbols;
var __hasOwnProp$4v = Object.prototype.hasOwnProperty;
var __propIsEnum$4v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4v = (obj, key, value) => key in obj ? __defProp$4v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4v.call(b, prop))
      __defNormalProp$4v(a, prop, b[prop]);
  if (__getOwnPropSymbols$4v)
    for (var prop of __getOwnPropSymbols$4v(b)) {
      if (__propIsEnum$4v.call(b, prop))
        __defNormalProp$4v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4v)
    for (var prop of __getOwnPropSymbols$4v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgDropperSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4v(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M1.89 22.994a.99.99 0 0 1-.594-.29.99.99 0 0 1-.29-.594c-.03-.267.031-.561.088-.835l.04-.2c.091-.49.24-1.167.472-1.929.456-1.498 1.266-3.433 2.687-4.853L10.586 8l-.793-.793a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1-1.414 1.414L16 13.414l-6.293 6.293c-1.42 1.42-3.355 2.23-4.853 2.687-.762.232-1.44.38-1.928.472a9.894 9.894 0 0 0-.201.04c-.274.056-.568.117-.835.088ZM14.546 4.04c-.396.396-.594.594-.669.823a1 1 0 0 0 0 .618c.075.228.273.426.669.822l3.151 3.151c.396.396.594.595.822.669a1 1 0 0 0 .619 0c.228-.074.426-.273.822-.669l1.747-1.747a3.828 3.828 0 0 0 0-5.414l-.002-.003a3.828 3.828 0 0 0-5.412.003L14.546 4.04Z"
      }
    )
  );
};

var __defProp$4u = Object.defineProperty;
var __getOwnPropSymbols$4u = Object.getOwnPropertySymbols;
var __hasOwnProp$4u = Object.prototype.hasOwnProperty;
var __propIsEnum$4u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4u = (obj, key, value) => key in obj ? __defProp$4u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4u.call(b, prop))
      __defNormalProp$4u(a, prop, b[prop]);
  if (__getOwnPropSymbols$4u)
    for (var prop of __getOwnPropSymbols$4u(b)) {
      if (__propIsEnum$4u.call(b, prop))
        __defNormalProp$4u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4u)
    for (var prop of __getOwnPropSymbols$4u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEditBoxDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4u(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V13",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 14.325c0-.489 0-.733.055-.963a2 2 0 0 1 .24-.579c.123-.201.296-.374.642-.72L18.5 2.5a2.121 2.121 0 0 1 3 3l-9.563 9.563c-.346.346-.519.519-.72.642-.18.11-.375.19-.579.24-.23.055-.474.055-.963.055H8v-1.675Z"
      }
    )
  );
};

var __defProp$4t = Object.defineProperty;
var __getOwnPropSymbols$4t = Object.getOwnPropertySymbols;
var __hasOwnProp$4t = Object.prototype.hasOwnProperty;
var __propIsEnum$4t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4t = (obj, key, value) => key in obj ? __defProp$4t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4t.call(b, prop))
      __defNormalProp$4t(a, prop, b[prop]);
  if (__getOwnPropSymbols$4t)
    for (var prop of __getOwnPropSymbols$4t(b)) {
      if (__propIsEnum$4t.call(b, prop))
        __defNormalProp$4t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4t)
    for (var prop of __getOwnPropSymbols$4t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEditBoxSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4t(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.759 3H11a1 1 0 1 1 0 2H6.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C3 7.361 3 7.943 3 8.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C5.361 21 5.943 21 6.8 21h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.82.037-.45.038-1.031.038-1.888V13a1 1 0 1 1 2 0v4.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 18.71 1 18.046 1 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C5.29 3 5.954 3 6.758 3Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.793 1.793a3.121 3.121 0 1 1 4.414 4.414l-9.563 9.563-.059.059c-.287.288-.54.542-.846.729a3 3 0 0 1-.867.36c-.348.083-.707.082-1.114.082H8a1 1 0 0 1-1-1v-1.758c0-.407 0-.766.083-1.114a3 3 0 0 1 .36-.867c.186-.306.44-.56.728-.846l.06-.06 9.562-9.562Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4s = Object.defineProperty;
var __getOwnPropSymbols$4s = Object.getOwnPropertySymbols;
var __hasOwnProp$4s = Object.prototype.hasOwnProperty;
var __propIsEnum$4s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4s = (obj, key, value) => key in obj ? __defProp$4s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4s.call(b, prop))
      __defNormalProp$4s(a, prop, b[prop]);
  if (__getOwnPropSymbols$4s)
    for (var prop of __getOwnPropSymbols$4s(b)) {
      if (__propIsEnum$4s.call(b, prop))
        __defNormalProp$4s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4s)
    for (var prop of __getOwnPropSymbols$4s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEditDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4s(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 21h-8",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m2.5 21.5 5.55-2.134c.354-.137.532-.205.698-.294.147-.08.288-.17.42-.273.149-.116.283-.25.552-.52L21 7a2.828 2.828 0 1 0-4-4L5.72 14.28c-.269.269-.403.403-.519.552a2.996 2.996 0 0 0-.273.42c-.089.166-.157.344-.294.699L2.5 21.5Zm0 0 2.058-5.351c.147-.383.221-.574.347-.662a.5.5 0 0 1 .38-.08c.15.028.295.173.585.463l2.26 2.26c.29.29.435.435.464.586a.5.5 0 0 1-.08.379c-.089.126-.28.2-.663.347L2.5 21.5Z"
      }
    )
  );
};

var __defProp$4r = Object.defineProperty;
var __getOwnPropSymbols$4r = Object.getOwnPropertySymbols;
var __hasOwnProp$4r = Object.prototype.hasOwnProperty;
var __propIsEnum$4r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4r = (obj, key, value) => key in obj ? __defProp$4r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4r.call(b, prop))
      __defNormalProp$4r(a, prop, b[prop]);
  if (__getOwnPropSymbols$4r)
    for (var prop of __getOwnPropSymbols$4r(b)) {
      if (__propIsEnum$4r.call(b, prop))
        __defNormalProp$4r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4r)
    for (var prop of __getOwnPropSymbols$4r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEditSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4r(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.293 2.293a3.829 3.829 0 0 1 5.414 5.414L10.391 19.023c-.234.234-.41.41-.61.566a4.006 4.006 0 0 1-.56.364c-.223.12-.456.209-.764.327l-.125.048-.093.036-5.38 2.07a1 1 0 0 1-1.292-1.293l2.153-5.598c.118-.308.208-.541.327-.764a4 4 0 0 1 .364-.56c.155-.2.332-.376.565-.61L16.293 2.293ZM5.38 16.795l-1.14 2.964 2.964-1.14-1.824-1.824Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "currentColor", d: "M13 20h8a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2Z" })
  );
};

var __defProp$4q = Object.defineProperty;
var __getOwnPropSymbols$4q = Object.getOwnPropertySymbols;
var __hasOwnProp$4q = Object.prototype.hasOwnProperty;
var __propIsEnum$4q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4q = (obj, key, value) => key in obj ? __defProp$4q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4q.call(b, prop))
      __defNormalProp$4q(a, prop, b[prop]);
  if (__getOwnPropSymbols$4q)
    for (var prop of __getOwnPropSymbols$4q(b)) {
      if (__propIsEnum$4q.call(b, prop))
        __defNormalProp$4q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4q)
    for (var prop of __getOwnPropSymbols$4q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEmptyAreaDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7.5 12h.01m8.99 0h.01M12 12h.01M12 16.5h.01m-.01-9h.01",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4Z"
      }
    )
  );
};

var __defProp$4p = Object.defineProperty;
var __getOwnPropSymbols$4p = Object.getOwnPropertySymbols;
var __hasOwnProp$4p = Object.prototype.hasOwnProperty;
var __propIsEnum$4p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4p = (obj, key, value) => key in obj ? __defProp$4p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4p.call(b, prop))
      __defNormalProp$4p(a, prop, b[prop]);
  if (__getOwnPropSymbols$4p)
    for (var prop of __getOwnPropSymbols$4p(b)) {
      if (__propIsEnum$4p.call(b, prop))
        __defNormalProp$4p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4p)
    for (var prop of __getOwnPropSymbols$4p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEmptyAreaSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4p(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1Zm9 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM11 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm0 4.5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm0-9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2ZM5.91 4.038c-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V7.8c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C17.639 4 17.057 4 16.2 4H7.8c-.857 0-1.439 0-1.889.038Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4o = Object.defineProperty;
var __getOwnPropSymbols$4o = Object.getOwnPropertySymbols;
var __hasOwnProp$4o = Object.prototype.hasOwnProperty;
var __propIsEnum$4o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4o = (obj, key, value) => key in obj ? __defProp$4o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4o.call(b, prop))
      __defNormalProp$4o(a, prop, b[prop]);
  if (__getOwnPropSymbols$4o)
    for (var prop of __getOwnPropSymbols$4o(b)) {
      if (__propIsEnum$4o.call(b, prop))
        __defNormalProp$4o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4o)
    for (var prop of __getOwnPropSymbols$4o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEmptyDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4o(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2V8m5 13H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V16m18-8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H16m5 13v1.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      }
    )
  );
};

var __defProp$4n = Object.defineProperty;
var __getOwnPropSymbols$4n = Object.getOwnPropertySymbols;
var __hasOwnProp$4n = Object.prototype.hasOwnProperty;
var __propIsEnum$4n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4n = (obj, key, value) => key in obj ? __defProp$4n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4n.call(b, prop))
      __defNormalProp$4n(a, prop, b[prop]);
  if (__getOwnPropSymbols$4n)
    for (var prop of __getOwnPropSymbols$4n(b)) {
      if (__propIsEnum$4n.call(b, prop))
        __defNormalProp$4n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4n)
    for (var prop of __getOwnPropSymbols$4n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEmptySolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4n(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.8 4c.577 0 .949 0 1.232.024.272.022.372.06.422.085a1 1 0 0 1 .437.437c.025.05.063.15.085.422C20 5.25 20 5.623 20 6.2V8a1 1 0 1 0 2 0V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.839 2H16a1 1 0 1 0 0 2h1.8ZM6.161 2H8a1 1 0 1 1 0 2H6.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C4 5.25 4 5.623 4 6.2V8a1 1 0 1 1-2 0V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C5.18 2 5.635 2 6.161 2ZM3 15a1 1 0 0 1 1 1v1.8c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C5.25 20 5.623 20 6.2 20H8a1 1 0 1 1 0 2H6.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A17.9 17.9 0 0 1 2 17.839V16a1 1 0 0 1 1-1Zm18 0a1 1 0 0 1 1 1v1.838c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031H16a1 1 0 1 1 0-2h1.8c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C20 18.75 20 18.377 20 17.8V16a1 1 0 0 1 1-1Zm-5-3a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      }
    )
  );
};

var __defProp$4m = Object.defineProperty;
var __getOwnPropSymbols$4m = Object.getOwnPropertySymbols;
var __hasOwnProp$4m = Object.prototype.hasOwnProperty;
var __propIsEnum$4m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4m = (obj, key, value) => key in obj ? __defProp$4m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4m.call(b, prop))
      __defNormalProp$4m(a, prop, b[prop]);
  if (__getOwnPropSymbols$4m)
    for (var prop of __getOwnPropSymbols$4m(b)) {
      if (__propIsEnum$4m.call(b, prop))
        __defNormalProp$4m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4m)
    for (var prop of __getOwnPropSymbols$4m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgExampleDataDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4m(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 4V2m0 14v-2M8 9h2m10 0h2m-4.2 2.8L19 13m-1.2-6.8L19 5m-6.8 1.2L11 5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m3 21 9-9"
      }
    )
  );
};

var __defProp$4l = Object.defineProperty;
var __getOwnPropSymbols$4l = Object.getOwnPropertySymbols;
var __hasOwnProp$4l = Object.prototype.hasOwnProperty;
var __propIsEnum$4l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4l = (obj, key, value) => key in obj ? __defProp$4l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4l.call(b, prop))
      __defNormalProp$4l(a, prop, b[prop]);
  if (__getOwnPropSymbols$4l)
    for (var prop of __getOwnPropSymbols$4l(b)) {
      if (__propIsEnum$4l.call(b, prop))
        __defNormalProp$4l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4l)
    for (var prop of __getOwnPropSymbols$4l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgExampleDataSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4l(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M16 2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V2Zm0 12a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2ZM7 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm13-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-2.907 3.093a1 1 0 0 1 1.414 0l1.2 1.2a1 1 0 0 1-1.414 1.414l-1.2-1.2a1 1 0 0 1 0-1.414Zm2.614-5.386a1 1 0 0 0-1.414-1.414l-1.2 1.2a1 1 0 0 0 1.414 1.414l1.2-1.2Zm-9.414-1.414a1 1 0 0 1 1.414 0l1.2 1.2a1 1 0 0 1-1.414 1.414l-1.2-1.2a1 1 0 0 1 0-1.414Zm2.414 8.414a1 1 0 0 0-1.414-1.414l-9 9a1 1 0 1 0 1.414 1.414l9-9Z"
      }
    )
  );
};

var __defProp$4k = Object.defineProperty;
var __getOwnPropSymbols$4k = Object.getOwnPropertySymbols;
var __hasOwnProp$4k = Object.prototype.hasOwnProperty;
var __propIsEnum$4k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4k = (obj, key, value) => key in obj ? __defProp$4k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4k.call(b, prop))
      __defNormalProp$4k(a, prop, b[prop]);
  if (__getOwnPropSymbols$4k)
    for (var prop of __getOwnPropSymbols$4k(b)) {
      if (__propIsEnum$4k.call(b, prop))
        __defNormalProp$4k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4k)
    for (var prop of __getOwnPropSymbols$4k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgExploreDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4k(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14.722 8.266c.489-.163.733-.244.895-.186a.5.5 0 0 1 .303.303c.058.162-.023.406-.186.895l-1.488 4.463c-.046.139-.07.208-.109.266a.5.5 0 0 1-.13.13c-.058.04-.127.063-.266.11l-4.463 1.487c-.489.163-.733.244-.895.186a.5.5 0 0 1-.303-.303c-.058-.162.023-.406.186-.895l1.488-4.463c.046-.139.07-.208.109-.266a.5.5 0 0 1 .13-.13c.058-.04.127-.063.266-.11l4.463-1.487Z"
      }
    )
  );
};

var __defProp$4j = Object.defineProperty;
var __getOwnPropSymbols$4j = Object.getOwnPropertySymbols;
var __hasOwnProp$4j = Object.prototype.hasOwnProperty;
var __propIsEnum$4j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4j = (obj, key, value) => key in obj ? __defProp$4j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4j.call(b, prop))
      __defNormalProp$4j(a, prop, b[prop]);
  if (__getOwnPropSymbols$4j)
    for (var prop of __getOwnPropSymbols$4j(b)) {
      if (__propIsEnum$4j.call(b, prop))
        __defNormalProp$4j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4j)
    for (var prop of __getOwnPropSymbols$4j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgExploreSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4j(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm3.617 7.08c-.162-.059-.406.023-.895.186L10.26 9.753c-.139.047-.208.07-.266.11a.5.5 0 0 0-.13.13c-.04.057-.063.127-.11.266l-1.487 4.463c-.163.488-.244.733-.186.895a.5.5 0 0 0 .303.303c.162.058.406-.023.895-.186l4.463-1.488c.139-.046.208-.07.266-.109a.5.5 0 0 0 .13-.13c.04-.058.063-.128.11-.267l1.487-4.462c.163-.489.244-.733.186-.896a.5.5 0 0 0-.303-.303Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4i = Object.defineProperty;
var __getOwnPropSymbols$4i = Object.getOwnPropertySymbols;
var __hasOwnProp$4i = Object.prototype.hasOwnProperty;
var __propIsEnum$4i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4i = (obj, key, value) => key in obj ? __defProp$4i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4i.call(b, prop))
      __defNormalProp$4i(a, prop, b[prop]);
  if (__getOwnPropSymbols$4i)
    for (var prop of __getOwnPropSymbols$4i(b)) {
      if (__propIsEnum$4i.call(b, prop))
        __defNormalProp$4i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4i)
    for (var prop of __getOwnPropSymbols$4i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgExternalUsersDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4i(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m19 21 3-3m0 0-3-3m3 3h-6m-.5-14.71a4.001 4.001 0 0 1 0 7.42",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      }
    )
  );
};

var __defProp$4h = Object.defineProperty;
var __getOwnPropSymbols$4h = Object.getOwnPropertySymbols;
var __hasOwnProp$4h = Object.prototype.hasOwnProperty;
var __propIsEnum$4h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4h = (obj, key, value) => key in obj ? __defProp$4h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4h.call(b, prop))
      __defNormalProp$4h(a, prop, b[prop]);
  if (__getOwnPropSymbols$4h)
    for (var prop of __getOwnPropSymbols$4h(b)) {
      if (__propIsEnum$4h.call(b, prop))
        __defNormalProp$4h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4h)
    for (var prop of __getOwnPropSymbols$4h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgExternalUsersSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M19.707 14.293a1 1 0 0 0-1.414 1.414L19.586 17H16a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.181 14.164a1.5 1.5 0 0 1 .655.655c.154.3.164.629.164.958v4.446c0 .12 0 .262-.01.387a1.508 1.508 0 0 1-.154.571 1.5 1.5 0 0 1-.655.655 1.508 1.508 0 0 1-.571.154c-.125.01-.268.01-.387.01H2.777c-.12 0-.262 0-.388-.01a1.508 1.508 0 0 1-.572-.154 1.501 1.501 0 0 1-.656-.66 1.507 1.507 0 0 1-.151-.571 4.877 4.877 0 0 1-.01-.387c.005-1.039-.026-2.153.38-3.131a5 5 0 0 1 2.706-2.706c.51-.212 1.048-.3 1.656-.34C6.335 14 7.063 14 7.964 14h3.26c.328 0 .657.01.957.164Zm2.392-11.248a1 1 0 0 1 1.302-.552 5.001 5.001 0 0 1 0 9.272 1 1 0 0 1-.75-1.854 3.001 3.001 0 0 0 0-5.564 1 1 0 0 1-.552-1.302Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4g = Object.defineProperty;
var __getOwnPropSymbols$4g = Object.getOwnPropertySymbols;
var __hasOwnProp$4g = Object.prototype.hasOwnProperty;
var __propIsEnum$4g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4g = (obj, key, value) => key in obj ? __defProp$4g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4g.call(b, prop))
      __defNormalProp$4g(a, prop, b[prop]);
  if (__getOwnPropSymbols$4g)
    for (var prop of __getOwnPropSymbols$4g(b)) {
      if (__propIsEnum$4g.call(b, prop))
        __defNormalProp$4g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4g)
    for (var prop of __getOwnPropSymbols$4g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEyeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2.42 12.713c-.136-.215-.205-.323-.243-.49a1.173 1.173 0 0 1 0-.446c.038-.167.107-.274.243-.49C3.545 9.505 6.895 5 12 5s8.455 4.505 9.58 6.287c.137.215.205.323.243.49.028.125.028.322 0 .446-.038.167-.107.274-.243.49C20.455 14.495 17.105 19 12 19s-8.455-4.505-9.58-6.287Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$4f = Object.defineProperty;
var __getOwnPropSymbols$4f = Object.getOwnPropertySymbols;
var __hasOwnProp$4f = Object.prototype.hasOwnProperty;
var __propIsEnum$4f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4f = (obj, key, value) => key in obj ? __defProp$4f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4f.call(b, prop))
      __defNormalProp$4f(a, prop, b[prop]);
  if (__getOwnPropSymbols$4f)
    for (var prop of __getOwnPropSymbols$4f(b)) {
      if (__propIsEnum$4f.call(b, prop))
        __defNormalProp$4f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4f)
    for (var prop of __getOwnPropSymbols$4f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgEyeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "currentColor", d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4C9.138 4 6.805 5.265 5.077 6.707c-1.726 1.441-2.91 3.107-3.503 4.046l-.024.038c-.117.185-.27.425-.347.762a2.159 2.159 0 0 0 0 .894c.077.337.23.577.347.762l.024.038c.593.939 1.777 2.605 3.503 4.046C6.805 18.735 9.138 20 12 20s5.195-1.265 6.923-2.707c1.727-1.441 2.91-3.107 3.503-4.046l.024-.038c.117-.185.27-.425.347-.762a2.156 2.156 0 0 0 0-.894c-.077-.337-.23-.577-.347-.762l-.024-.038c-.593-.939-1.776-2.605-3.503-4.046C17.195 5.265 14.862 4 12 4Zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$4e = Object.defineProperty;
var __getOwnPropSymbols$4e = Object.getOwnPropertySymbols;
var __hasOwnProp$4e = Object.prototype.hasOwnProperty;
var __propIsEnum$4e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4e = (obj, key, value) => key in obj ? __defProp$4e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4e.call(b, prop))
      __defNormalProp$4e(a, prop, b[prop]);
  if (__getOwnPropSymbols$4e)
    for (var prop of __getOwnPropSymbols$4e(b)) {
      if (__propIsEnum$4e.call(b, prop))
        __defNormalProp$4e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4e)
    for (var prop of __getOwnPropSymbols$4e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFigmahfeatured = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("g", { clipPath: "url(#figmahfeatured_svg__a)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#FCECA7",
        d: "M10.25 4.75c0-.483.392-.875.875-.875H12v1.75h-.875a.875.875 0 0 1-.875-.875Z"
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#2A8BFB",
        d: "M10.25 8.25c0-.483.392-.875.875-.875H12v.875a.875.875 0 0 1-1.75 0ZM12 6.5a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0Z"
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.3,
        d: "M12 3.875h-.875a.875.875 0 0 0 0 1.75M12 3.875v1.75m0-1.75h.875a.875.875 0 0 1 0 1.75m-.875 0h-.875m.875 0v1.75m0-1.75h.875m-1.75 0a.875.875 0 0 0 0 1.75m.875 0h-.875m.875 0v.875a.875.875 0 1 1-.875-.875m1.75-1.75a.875.875 0 1 1 0 1.75.875.875 0 0 1 0-1.75Z"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement("path", { stroke: "#AFB7BF", strokeWidth: 0.2, d: "M18 2.1H6" }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#EAEAEA", d: "M18 1h2v2h-2z" }),
    /* @__PURE__ */ React__namespace.createElement("rect", { width: 1, height: 1, x: 11.5, y: 1.5, fill: "#AAD1FD", rx: 0.5 }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#D9D9D9", d: "M4 1h2v2H4z" }),
    /* @__PURE__ */ React__namespace.createElement("path", { stroke: "#AFB7BF", strokeWidth: 0.2, d: "M18 11.1H6" }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#EAEAEA", d: "M18 10h2v2h-2z" }),
    /* @__PURE__ */ React__namespace.createElement("rect", { width: 1, height: 1, x: 11.5, y: 10.5, fill: "#AAD1FD", rx: 0.5 }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#EAEAEA", d: "M4 10h2v2H4z" }),
    /* @__PURE__ */ React__namespace.createElement("path", { stroke: "#AFB7BF", strokeWidth: 0.2, d: "M5.1 3v7" }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#EAEAEA", d: "M4 3V1h2v2z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "rect",
      {
        width: 1,
        height: 1,
        x: 4.55,
        y: 7.3,
        fill: "#AAD1FD",
        rx: 0.5,
        transform: "rotate(-90 4.55 7.3)"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("path", { stroke: "#AFB7BF", strokeWidth: 0.2, d: "M19.1 3v7" }),
    /* @__PURE__ */ React__namespace.createElement(
      "rect",
      {
        width: 1,
        height: 1,
        x: 18.55,
        y: 7.3,
        fill: "#AAD1FD",
        rx: 0.5,
        transform: "rotate(-90 18.55 7.3)"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "figmahfeatured_svg__a" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M9 3.5h6v6H9z" })))
  );
};

var __defProp$4d = Object.defineProperty;
var __getOwnPropSymbols$4d = Object.getOwnPropertySymbols;
var __hasOwnProp$4d = Object.prototype.hasOwnProperty;
var __propIsEnum$4d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4d = (obj, key, value) => key in obj ? __defProp$4d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4d.call(b, prop))
      __defNormalProp$4d(a, prop, b[prop]);
  if (__getOwnPropSymbols$4d)
    for (var prop of __getOwnPropSymbols$4d(b)) {
      if (__propIsEnum$4d.call(b, prop))
        __defNormalProp$4d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4d)
    for (var prop of __getOwnPropSymbols$4d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFileBlankDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 8 15.04 8 15.6 8h4.13",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8Z"
      }
    )
  );
};

var __defProp$4c = Object.defineProperty;
var __getOwnPropSymbols$4c = Object.getOwnPropertySymbols;
var __hasOwnProp$4c = Object.prototype.hasOwnProperty;
var __propIsEnum$4c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4c = (obj, key, value) => key in obj ? __defProp$4c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4c.call(b, prop))
      __defNormalProp$4c(a, prop, b[prop]);
  if (__getOwnPropSymbols$4c)
    for (var prop of __getOwnPropSymbols$4c(b)) {
      if (__propIsEnum$4c.call(b, prop))
        __defNormalProp$4c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4c)
    for (var prop of __getOwnPropSymbols$4c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFileBlankSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.999 1.952.001.064v4.416c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h4.417l.063.001A1.032 1.032 0 0 1 21 10v7.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1H12l.047.001c.494.023.928.458.952.951Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M19.469 6.926c-.12.074-.267.074-.561.074H15.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C15 6.62 15 6.48 15 6.2V3.092c0-.294 0-.44.074-.56a.536.536 0 0 1 .543-.225c.137.032.233.128.424.32l3.332 3.332c.192.191.287.287.32.424a.536.536 0 0 1-.224.543Z"
      }
    )
  );
};

var __defProp$4b = Object.defineProperty;
var __getOwnPropSymbols$4b = Object.getOwnPropertySymbols;
var __hasOwnProp$4b = Object.prototype.hasOwnProperty;
var __propIsEnum$4b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4b = (obj, key, value) => key in obj ? __defProp$4b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4b.call(b, prop))
      __defNormalProp$4b(a, prop, b[prop]);
  if (__getOwnPropSymbols$4b)
    for (var prop of __getOwnPropSymbols$4b(b)) {
      if (__propIsEnum$4b.call(b, prop))
        __defNormalProp$4b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4b)
    for (var prop of __getOwnPropSymbols$4b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFileCheckDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 16 2 2 4.5-4.5"
      }
    )
  );
};

var __defProp$4a = Object.defineProperty;
var __getOwnPropSymbols$4a = Object.getOwnPropertySymbols;
var __hasOwnProp$4a = Object.prototype.hasOwnProperty;
var __propIsEnum$4a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4a = (obj, key, value) => key in obj ? __defProp$4a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4a.call(b, prop))
      __defNormalProp$4a(a, prop, b[prop]);
  if (__getOwnPropSymbols$4a)
    for (var prop of __getOwnPropSymbols$4a(b)) {
      if (__propIsEnum$4a.call(b, prop))
        __defNormalProp$4a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4a)
    for (var prop of __getOwnPropSymbols$4a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFileCheckSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m13 2.016-.001-.064a1.032 1.032 0 0 0-.952-.95L12 1H8.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V10l-.001-.047A1.032 1.032 0 0 0 20.048 9H15.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 6.93 13 6.684 13 6.432V2.016Zm3.207 12.191a1 1 0 0 0-1.414-1.414L11 16.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.908 7c.294 0 .44 0 .56-.074a.536.536 0 0 0 .226-.543c-.034-.137-.13-.233-.32-.424L16.04 2.627c-.191-.192-.287-.288-.424-.32a.536.536 0 0 0-.543.224c-.074.12-.074.267-.074.561V6.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C15.38 7 15.52 7 15.8 7h3.108Z"
      }
    )
  );
};

var __defProp$49 = Object.defineProperty;
var __getOwnPropSymbols$49 = Object.getOwnPropertySymbols;
var __hasOwnProp$49 = Object.prototype.hasOwnProperty;
var __propIsEnum$49 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$49 = (obj, key, value) => key in obj ? __defProp$49(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$49 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$49.call(b, prop))
      __defNormalProp$49(a, prop, b[prop]);
  if (__getOwnPropSymbols$49)
    for (var prop of __getOwnPropSymbols$49(b)) {
      if (__propIsEnum$49.call(b, prop))
        __defNormalProp$49(a, prop, b[prop]);
    }
  return a;
};
var __objRest$49 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$49.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$49)
    for (var prop of __getOwnPropSymbols$49(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$49.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilePlus03Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$49(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$49({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 18v-6m-3 3h6"
      }
    )
  );
};

var __defProp$48 = Object.defineProperty;
var __getOwnPropSymbols$48 = Object.getOwnPropertySymbols;
var __hasOwnProp$48 = Object.prototype.hasOwnProperty;
var __propIsEnum$48 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$48 = (obj, key, value) => key in obj ? __defProp$48(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$48 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$48.call(b, prop))
      __defNormalProp$48(a, prop, b[prop]);
  if (__getOwnPropSymbols$48)
    for (var prop of __getOwnPropSymbols$48(b)) {
      if (__propIsEnum$48.call(b, prop))
        __defNormalProp$48(a, prop, b[prop]);
    }
  return a;
};
var __objRest$48 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$48.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$48)
    for (var prop of __getOwnPropSymbols$48(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$48.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilePlus03Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$48(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$48({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m13 2.016-.001-.064a1.032 1.032 0 0 0-.952-.95L12 1H8.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V10l-.001-.047A1.032 1.032 0 0 0 20.048 9H15.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 6.93 13 6.684 13 6.432V2.016ZM12 12a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.908 7c.294 0 .44 0 .56-.074a.536.536 0 0 0 .226-.543c-.034-.137-.13-.233-.32-.424L16.04 2.627c-.191-.192-.287-.288-.424-.32a.536.536 0 0 0-.543.224c-.074.12-.074.267-.074.561V6.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C15.38 7 15.52 7 15.8 7h3.108Z"
      }
    )
  );
};

var __defProp$47 = Object.defineProperty;
var __getOwnPropSymbols$47 = Object.getOwnPropertySymbols;
var __hasOwnProp$47 = Object.prototype.hasOwnProperty;
var __propIsEnum$47 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$47 = (obj, key, value) => key in obj ? __defProp$47(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$47 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$47.call(b, prop))
      __defNormalProp$47(a, prop, b[prop]);
  if (__getOwnPropSymbols$47)
    for (var prop of __getOwnPropSymbols$47(b)) {
      if (__propIsEnum$47.call(b, prop))
        __defNormalProp$47(a, prop, b[prop]);
    }
  return a;
};
var __objRest$47 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$47.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$47)
    for (var prop of __getOwnPropSymbols$47(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$47.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFileSecuredDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$47(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$47({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8m-6-6 6 6m-6-6v6h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13.75 14v-1.75a1.75 1.75 0 1 0-3.5 0V14m-.15 4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.74 14 14.46 14 13.9 14h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8.5 14.76 8.5 15.04 8.5 15.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C9.26 18 9.54 18 10.1 18Z"
      }
    )
  );
};

var __defProp$46 = Object.defineProperty;
var __getOwnPropSymbols$46 = Object.getOwnPropertySymbols;
var __hasOwnProp$46 = Object.prototype.hasOwnProperty;
var __propIsEnum$46 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$46 = (obj, key, value) => key in obj ? __defProp$46(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$46 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$46.call(b, prop))
      __defNormalProp$46(a, prop, b[prop]);
  if (__getOwnPropSymbols$46)
    for (var prop of __getOwnPropSymbols$46(b)) {
      if (__propIsEnum$46.call(b, prop))
        __defNormalProp$46(a, prop, b[prop]);
    }
  return a;
};
var __objRest$46 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$46.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$46)
    for (var prop of __getOwnPropSymbols$46(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$46.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFileSecuredSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$46(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$46({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.75 13.25V14h-1.5v-.75a.75.75 0 0 1 1.5 0ZM13.7 18c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C14.12 16 13.98 16 13.7 16h-3.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218c-.055.107-.055.247-.055.527v.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h3.4Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m13 2.016-.001-.064a1.032 1.032 0 0 0-.952-.95L12 1H8.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V10l-.001-.047A1.032 1.032 0 0 0 20.048 9H15.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 6.93 13 6.684 13 6.432V2.016ZM9.25 13.25a2.75 2.75 0 1 1 5.5 0v.778c.203.024.43.074.658.19a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77c-.017-.208-.017-.454-.017-.706v-.864c0-.252 0-.498.017-.706a2.03 2.03 0 0 1 .201-.77 2 2 0 0 1 .874-.874c.228-.116.456-.166.658-.19v-.778Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.908 7c.294 0 .44 0 .56-.074a.536.536 0 0 0 .226-.543c-.034-.137-.13-.233-.32-.424L16.04 2.627c-.191-.192-.287-.288-.424-.32a.536.536 0 0 0-.543.224c-.074.12-.074.267-.074.561V6.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C15.38 7 15.52 7 15.8 7h3.108Z"
      }
    )
  );
};

var __defProp$45 = Object.defineProperty;
var __getOwnPropSymbols$45 = Object.getOwnPropertySymbols;
var __hasOwnProp$45 = Object.prototype.hasOwnProperty;
var __propIsEnum$45 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$45 = (obj, key, value) => key in obj ? __defProp$45(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$45 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$45.call(b, prop))
      __defNormalProp$45(a, prop, b[prop]);
  if (__getOwnPropSymbols$45)
    for (var prop of __getOwnPropSymbols$45(b)) {
      if (__propIsEnum$45.call(b, prop))
        __defNormalProp$45(a, prop, b[prop]);
    }
  return a;
};
var __objRest$45 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$45.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$45)
    for (var prop of __getOwnPropSymbols$45(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$45.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilesDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$45(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$45({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m2 12 9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 12M2 17l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 17",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12.358 2.179a1.028 1.028 0 0 0-.266-.111.5.5 0 0 0-.184 0c-.069.012-.135.045-.266.11L2 7l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.013.135-.045.266-.11L22 7l-9.642-4.821Z"
      }
    )
  );
};

var __defProp$44 = Object.defineProperty;
var __getOwnPropSymbols$44 = Object.getOwnPropertySymbols;
var __hasOwnProp$44 = Object.prototype.hasOwnProperty;
var __propIsEnum$44 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$44 = (obj, key, value) => key in obj ? __defProp$44(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$44 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$44.call(b, prop))
      __defNormalProp$44(a, prop, b[prop]);
  if (__getOwnPropSymbols$44)
    for (var prop of __getOwnPropSymbols$44(b)) {
      if (__propIsEnum$44.call(b, prop))
        __defNormalProp$44(a, prop, b[prop]);
    }
  return a;
};
var __objRest$44 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$44.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$44)
    for (var prop of __getOwnPropSymbols$44(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$44.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilesSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$44(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$44({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.106 11.553a1 1 0 0 1 1.341-.447L12 15.882l9.553-4.776a1 1 0 1 1 .894 1.788l-9.642 4.821-.026.014c-.093.047-.286.146-.502.186a1.5 1.5 0 0 1-.554 0 1.885 1.885 0 0 1-.502-.186l-.026-.014-9.642-4.82a1 1 0 0 1-.447-1.342Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.106 16.553a1 1 0 0 1 1.341-.447L12 20.882l9.553-4.776a1 1 0 1 1 .894 1.788l-9.642 4.822-.026.012a1.86 1.86 0 0 1-.502.187 1.5 1.5 0 0 1-.554 0 1.885 1.885 0 0 1-.502-.186l-.026-.014-9.642-4.82a1 1 0 0 1-.447-1.342ZM11.723 1.085a1.5 1.5 0 0 1 .554 0 1.902 1.902 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014c-.093.047-.286.146-.502.186a1.5 1.5 0 0 1-.554 0 1.885 1.885 0 0 1-.502-.186l-.026-.013-9.642-4.822a1 1 0 0 1 0-1.788l9.642-4.822.026-.013c.093-.047.286-.146.502-.186Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$43 = Object.defineProperty;
var __getOwnPropSymbols$43 = Object.getOwnPropertySymbols;
var __hasOwnProp$43 = Object.prototype.hasOwnProperty;
var __propIsEnum$43 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$43 = (obj, key, value) => key in obj ? __defProp$43(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$43 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$43.call(b, prop))
      __defNormalProp$43(a, prop, b[prop]);
  if (__getOwnPropSymbols$43)
    for (var prop of __getOwnPropSymbols$43(b)) {
      if (__propIsEnum$43.call(b, prop))
        __defNormalProp$43(a, prop, b[prop]);
    }
  return a;
};
var __objRest$43 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$43.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$43)
    for (var prop of __getOwnPropSymbols$43(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$43.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilterDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$43(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$43({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3.386 5.667C2.63 4.822 2.252 4.399 2.237 4.04a1 1 0 0 1 .363-.811C2.877 3 3.444 3 4.579 3h14.843c1.134 0 1.7 0 1.978.229a1 1 0 0 1 .363.81c-.015.36-.393.783-1.15 1.628l-5.705 6.377c-.151.169-.226.253-.28.35a.996.996 0 0 0-.104.27c-.024.108-.024.221-.024.447v5.347c0 .196 0 .294-.032.378a.498.498 0 0 1-.132.196c-.066.06-.157.096-.339.17l-3.4 1.36c-.367.146-.551.22-.699.189a.5.5 0 0 1-.315-.213c-.083-.126-.083-.324-.083-.72v-6.707c0-.226 0-.339-.024-.446a1 1 0 0 0-.104-.272c-.053-.096-.129-.18-.28-.349L3.386 5.667Z"
      }
    )
  );
};

var __defProp$42 = Object.defineProperty;
var __getOwnPropSymbols$42 = Object.getOwnPropertySymbols;
var __hasOwnProp$42 = Object.prototype.hasOwnProperty;
var __propIsEnum$42 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$42 = (obj, key, value) => key in obj ? __defProp$42(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$42 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$42.call(b, prop))
      __defNormalProp$42(a, prop, b[prop]);
  if (__getOwnPropSymbols$42)
    for (var prop of __getOwnPropSymbols$42(b)) {
      if (__propIsEnum$42.call(b, prop))
        __defNormalProp$42(a, prop, b[prop]);
    }
  return a;
};
var __objRest$42 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$42.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$42)
    for (var prop of __getOwnPropSymbols$42(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$42.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilterOrganizationDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$42(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$42({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 3v10.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 18 6.12 18 7.8 18H15M3 8h12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$41 = Object.defineProperty;
var __getOwnPropSymbols$41 = Object.getOwnPropertySymbols;
var __hasOwnProp$41 = Object.prototype.hasOwnProperty;
var __propIsEnum$41 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$41 = (obj, key, value) => key in obj ? __defProp$41(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$41 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$41.call(b, prop))
      __defNormalProp$41(a, prop, b[prop]);
  if (__getOwnPropSymbols$41)
    for (var prop of __getOwnPropSymbols$41(b)) {
      if (__propIsEnum$41.call(b, prop))
        __defNormalProp$41(a, prop, b[prop]);
    }
  return a;
};
var __objRest$41 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$41.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$41)
    for (var prop of __getOwnPropSymbols$41(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$41.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilterOrganizationSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$41(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$41({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a1 1 0 1 0-2 0v10.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 19 6.954 19 7.758 19h6.368A4.002 4.002 0 0 0 22 18a4 4 0 0 0-7.874-1H7.8c-.857 0-1.439 0-1.889-.038-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C4 14.639 4 14.057 4 13.2V9h10.126A4.002 4.002 0 0 0 22 8a4 4 0 0 0-7.874-1H4V3Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$40 = Object.defineProperty;
var __getOwnPropSymbols$40 = Object.getOwnPropertySymbols;
var __hasOwnProp$40 = Object.prototype.hasOwnProperty;
var __propIsEnum$40 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$40 = (obj, key, value) => key in obj ? __defProp$40(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$40 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$40.call(b, prop))
      __defNormalProp$40(a, prop, b[prop]);
  if (__getOwnPropSymbols$40)
    for (var prop of __getOwnPropSymbols$40(b)) {
      if (__propIsEnum$40.call(b, prop))
        __defNormalProp$40(a, prop, b[prop]);
    }
  return a;
};
var __objRest$40 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$40.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$40)
    for (var prop of __getOwnPropSymbols$40(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$40.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFilterSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$40(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$40({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.533 2h14.934c.528 0 .991 0 1.355.033.349.031.827.105 1.215.425a2 2 0 0 1 .725 1.621c-.02.503-.284.909-.494 1.19-.218.292-.526.637-.879 1.031l-5.736 6.411-.149.17-.002.002v.003a6.011 6.011 0 0 0-.002.225v5.385c.002.138.005.423-.095.69a1.5 1.5 0 0 1-.396.586c-.21.19-.477.294-.605.344l-.036.014-3.427 1.37c-.16.064-.335.135-.49.181a1.53 1.53 0 0 1-.756.05 1.5 1.5 0 0 1-.945-.64 1.529 1.529 0 0 1-.236-.721 6.069 6.069 0 0 1-.014-.522v-6.737c0-.12 0-.181-.002-.225v-.003l-.002-.003a6.064 6.064 0 0 0-.149-.169L2.641 6.334 2.61 6.3a16.7 16.7 0 0 1-.88-1.032c-.209-.28-.473-.686-.493-1.189a2 2 0 0 1 .725-1.621c.388-.32.866-.394 1.215-.425C3.542 2 4.005 2 4.533 2Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3$ = Object.defineProperty;
var __getOwnPropSymbols$3$ = Object.getOwnPropertySymbols;
var __hasOwnProp$3$ = Object.prototype.hasOwnProperty;
var __propIsEnum$3$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3$ = (obj, key, value) => key in obj ? __defProp$3$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3$.call(b, prop))
      __defNormalProp$3$(a, prop, b[prop]);
  if (__getOwnPropSymbols$3$)
    for (var prop of __getOwnPropSymbols$3$(b)) {
      if (__propIsEnum$3$.call(b, prop))
        __defNormalProp$3$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3$)
    for (var prop of __getOwnPropSymbols$3$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFlag04Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3$(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13.5 6.5h6.206c.428 0 .643 0 .772.09a.5.5 0 0 1 .208.337c.023.156-.073.347-.265.73l-1.252 2.505a1.086 1.086 0 0 0-.106.252.502.502 0 0 0-.004.175c.01.066.038.13.094.256l1.347 3.03c.167.375.25.562.223.714a.5.5 0 0 1-.211.325c-.128.086-.333.086-.743.086H12.1c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437c-.109-.214-.109-.494-.109-1.054V11",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 21V3.5M3 11h8.9c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.74 2.5 12.46 2.5 11.9 2.5H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.26 3 3.54 3 4.1V11Z"
      }
    )
  );
};

var __defProp$3_ = Object.defineProperty;
var __getOwnPropSymbols$3_ = Object.getOwnPropertySymbols;
var __hasOwnProp$3_ = Object.prototype.hasOwnProperty;
var __propIsEnum$3_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3_ = (obj, key, value) => key in obj ? __defProp$3_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3_.call(b, prop))
      __defNormalProp$3_(a, prop, b[prop]);
  if (__getOwnPropSymbols$3_)
    for (var prop of __getOwnPropSymbols$3_(b)) {
      if (__propIsEnum$3_.call(b, prop))
        __defNormalProp$3_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3_)
    for (var prop of __getOwnPropSymbols$3_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFlag04Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3_(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.568 1.5c-.252 0-.498 0-.706.017a2.022 2.022 0 0 0-.77.201 2 2 0 0 0-.874.874c-.122.239-.17.476-.193.685C1.97 3.52 2 3.785 2 4.032V21a1 1 0 1 0 2 0v-9h5.5v1.432c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017H19.8c.177 0 .372 0 .537-.015a1.53 1.53 0 0 0 .736-.244 1.5 1.5 0 0 0 .634-.975 1.531 1.531 0 0 0-.076-.772 5.811 5.811 0 0 0-.205-.497l-1.32-2.972 1.224-2.448c.083-.167.173-.347.235-.506.066-.167.16-.452.11-.79a1.5 1.5 0 0 0-.624-1.01 1.536 1.536 0 0 0-.756-.256 6.464 6.464 0 0 0-.558-.015H14.5V4.068c0-.252 0-.498-.017-.706a2.022 2.022 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2.022 2.022 0 0 0-.77-.201c-.208-.017-.454-.017-.706-.017H4.568Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3Z = Object.defineProperty;
var __getOwnPropSymbols$3Z = Object.getOwnPropertySymbols;
var __hasOwnProp$3Z = Object.prototype.hasOwnProperty;
var __propIsEnum$3Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3Z = (obj, key, value) => key in obj ? __defProp$3Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3Z.call(b, prop))
      __defNormalProp$3Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$3Z)
    for (var prop of __getOwnPropSymbols$3Z(b)) {
      if (__propIsEnum$3Z.call(b, prop))
        __defNormalProp$3Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3Z)
    for (var prop of __getOwnPropSymbols$3Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderCheckDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3Z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 14 2 2 4.5-4.5M2 7h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Z"
      }
    )
  );
};

var __defProp$3Y = Object.defineProperty;
var __getOwnPropSymbols$3Y = Object.getOwnPropertySymbols;
var __hasOwnProp$3Y = Object.prototype.hasOwnProperty;
var __propIsEnum$3Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3Y = (obj, key, value) => key in obj ? __defProp$3Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3Y.call(b, prop))
      __defNormalProp$3Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$3Y)
    for (var prop of __getOwnPropSymbols$3Y(b)) {
      if (__propIsEnum$3Y.call(b, prop))
        __defNormalProp$3Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3Y)
    for (var prop of __getOwnPropSymbols$3Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderCheckSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3Y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162Zm9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231Zm6.117 8.152a1 1 0 0 0-1.414-1.414L11 14.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3X = Object.defineProperty;
var __getOwnPropSymbols$3X = Object.getOwnPropertySymbols;
var __hasOwnProp$3X = Object.prototype.hasOwnProperty;
var __propIsEnum$3X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3X = (obj, key, value) => key in obj ? __defProp$3X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3X.call(b, prop))
      __defNormalProp$3X(a, prop, b[prop]);
  if (__getOwnPropSymbols$3X)
    for (var prop of __getOwnPropSymbols$3X(b)) {
      if (__propIsEnum$3X.call(b, prop))
        __defNormalProp$3X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3X)
    for (var prop of __getOwnPropSymbols$3X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3X(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 7h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Z"
      }
    )
  );
};

var __defProp$3W = Object.defineProperty;
var __getOwnPropSymbols$3W = Object.getOwnPropertySymbols;
var __hasOwnProp$3W = Object.prototype.hasOwnProperty;
var __propIsEnum$3W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3W = (obj, key, value) => key in obj ? __defProp$3W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3W.call(b, prop))
      __defNormalProp$3W(a, prop, b[prop]);
  if (__getOwnPropSymbols$3W)
    for (var prop of __getOwnPropSymbols$3W(b)) {
      if (__propIsEnum$3W.call(b, prop))
        __defNormalProp$3W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3W)
    for (var prop of __getOwnPropSymbols$3W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderPlusDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3W(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 17v-6m-3 3h6M2 7h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Z"
      }
    )
  );
};

var __defProp$3V = Object.defineProperty;
var __getOwnPropSymbols$3V = Object.getOwnPropertySymbols;
var __hasOwnProp$3V = Object.prototype.hasOwnProperty;
var __propIsEnum$3V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3V = (obj, key, value) => key in obj ? __defProp$3V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3V.call(b, prop))
      __defNormalProp$3V(a, prop, b[prop]);
  if (__getOwnPropSymbols$3V)
    for (var prop of __getOwnPropSymbols$3V(b)) {
      if (__propIsEnum$3V.call(b, prop))
        __defNormalProp$3V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3V)
    for (var prop of __getOwnPropSymbols$3V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderPlusSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3V(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162Zm9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231ZM12 10a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3U = Object.defineProperty;
var __getOwnPropSymbols$3U = Object.getOwnPropertySymbols;
var __hasOwnProp$3U = Object.prototype.hasOwnProperty;
var __propIsEnum$3U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3U = (obj, key, value) => key in obj ? __defProp$3U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3U.call(b, prop))
      __defNormalProp$3U(a, prop, b[prop]);
  if (__getOwnPropSymbols$3U)
    for (var prop of __getOwnPropSymbols$3U(b)) {
      if (__propIsEnum$3U.call(b, prop))
        __defNormalProp$3U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3U)
    for (var prop of __getOwnPropSymbols$3U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3U(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6.162c0-.527 0-.982.03-1.357.033-.395.104-.788.297-1.167a3 3 0 0 1 1.311-1.31c.378-.194.772-.265 1.167-.297C4.18 2 4.635 2 5.161 2h3.986c.593-.002 1.115-.002 1.595.163a3 3 0 0 1 1.121.693c.363.355.596.822.86 1.354L13.618 6h3.623c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v4.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 17.71 1 17.046 1 16.242V6.161ZM9.022 4c.79 0 .947.013 1.068.055a1 1 0 0 1 .374.23c.09.09.173.224.526.931l.392.784H3c0-.465.004-.783.024-1.032.022-.272.06-.372.085-.422a1 1 0 0 1 .437-.437c.05-.025.15-.063.422-.085C4.25 4.001 4.623 4 5.2 4h3.822Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3T = Object.defineProperty;
var __getOwnPropSymbols$3T = Object.getOwnPropertySymbols;
var __hasOwnProp$3T = Object.prototype.hasOwnProperty;
var __propIsEnum$3T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3T = (obj, key, value) => key in obj ? __defProp$3T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3T.call(b, prop))
      __defNormalProp$3T(a, prop, b[prop]);
  if (__getOwnPropSymbols$3T)
    for (var prop of __getOwnPropSymbols$3T(b)) {
      if (__propIsEnum$3T.call(b, prop))
        __defNormalProp$3T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3T)
    for (var prop of __getOwnPropSymbols$3T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderXDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3T(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9.5 11.5 5 5m0-5-5 5M2 7h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Z"
      }
    )
  );
};

var __defProp$3S = Object.defineProperty;
var __getOwnPropSymbols$3S = Object.getOwnPropertySymbols;
var __hasOwnProp$3S = Object.prototype.hasOwnProperty;
var __propIsEnum$3S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3S = (obj, key, value) => key in obj ? __defProp$3S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3S.call(b, prop))
      __defNormalProp$3S(a, prop, b[prop]);
  if (__getOwnPropSymbols$3S)
    for (var prop of __getOwnPropSymbols$3S(b)) {
      if (__propIsEnum$3S.call(b, prop))
        __defNormalProp$3S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3S)
    for (var prop of __getOwnPropSymbols$3S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFolderXSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3S(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162Zm9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231Zm-1.297 6.738a1 1 0 0 1 1.414 0L12 12.586l1.793-1.793a1 1 0 0 1 1.414 1.414L13.414 14l1.793 1.793a1 1 0 0 1-1.414 1.414L12 15.414l-1.793 1.793a1 1 0 0 1-1.414-1.414L10.586 14l-1.793-1.793a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3R = Object.defineProperty;
var __getOwnPropSymbols$3R = Object.getOwnPropertySymbols;
var __hasOwnProp$3R = Object.prototype.hasOwnProperty;
var __propIsEnum$3R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3R = (obj, key, value) => key in obj ? __defProp$3R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3R.call(b, prop))
      __defNormalProp$3R(a, prop, b[prop]);
  if (__getOwnPropSymbols$3R)
    for (var prop of __getOwnPropSymbols$3R(b)) {
      if (__propIsEnum$3R.call(b, prop))
        __defNormalProp$3R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3R)
    for (var prop of __getOwnPropSymbols$3R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgFontshfeatured = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3R(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#2A8BFB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        d: "M3.5 2.833v7.334"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        d: "M8.5 2.833v7.334M4.96 2.833v7.334m.833-7.334H2.667M8.5 6.5H4.96m.833 3.667H2.667m6.667 0H7.667m1.667-7.334H7.667"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#FCECA7",
        d: "M14.071 10.109c-.311 0-.592-.058-.844-.173a1.422 1.422 0 0 1-.597-.508c-.145-.222-.218-.493-.218-.815 0-.277.054-.505.16-.684.107-.179.25-.32.432-.425.18-.104.383-.183.607-.237.223-.053.451-.093.684-.121l.716-.083c.183-.024.316-.06.4-.112.082-.051.124-.134.124-.25V6.68c0-.279-.079-.495-.237-.648-.155-.154-.387-.23-.696-.23-.322 0-.576.07-.761.214-.183.14-.31.297-.38.47l-.899-.205a1.73 1.73 0 0 1 .467-.722c.207-.186.444-.32.713-.403.268-.085.55-.128.847-.128.196 0 .403.023.623.07.222.045.428.128.62.25.194.121.353.295.476.52.124.224.186.515.186.873V10h-.934v-.671h-.038a1.362 1.362 0 0 1-.278.364c-.124.12-.282.219-.476.297a1.849 1.849 0 0 1-.697.119Zm.208-.767c.264 0 .49-.053.677-.157a1.083 1.083 0 0 0 .582-.956v-.632a.498.498 0 0 1-.198.095 3.08 3.08 0 0 1-.33.074c-.123.02-.243.037-.36.054l-.295.039a2.369 2.369 0 0 0-.508.118.872.872 0 0 0-.364.24.599.599 0 0 0-.134.409c0 .236.087.415.262.537.175.119.397.179.668.179Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.805 10.042a.779.779 0 0 1-.328-.067.552.552 0 0 1-.232-.197.566.566 0 0 1-.085-.317.458.458 0 0 1 .23-.431.88.88 0 0 1 .236-.093 2.35 2.35 0 0 1 .266-.047l.279-.032a.41.41 0 0 0 .155-.044c.032-.02.049-.052.049-.097V8.71a.336.336 0 0 0-.092-.253c-.06-.06-.151-.09-.271-.09a.474.474 0 0 0-.296.084.445.445 0 0 0-.148.183l-.35-.08a.672.672 0 0 1 .46-.437 1.082 1.082 0 0 1 .571-.023c.086.018.167.05.241.097a.536.536 0 0 1 .185.203c.049.087.072.2.072.34V10h-.362v-.261h-.015a.573.573 0 0 1-.293.257.719.719 0 0 1-.272.046Zm.081-.298c.103 0 .19-.02.264-.06a.427.427 0 0 0 .226-.373v-.246a.194.194 0 0 1-.077.038c-.037.01-.08.02-.128.028a14.973 14.973 0 0 1-.255.036.92.92 0 0 0-.198.046.34.34 0 0 0-.141.093.233.233 0 0 0-.053.16c0 .092.034.161.102.208.068.047.155.07.26.07Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeOpacity: 0.35,
        strokeWidth: 0.03,
        d: "M22 5.015H11m11 0H11m11 0H11m11 0H11m11 0H11"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeDasharray: "0.5 0.5",
        strokeOpacity: 0.35,
        strokeWidth: 0.03,
        d: "M22 8.015h-5m5 0h-5m5 0h-5m5 0h-5m5 0h-5"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeOpacity: 0.35,
        strokeWidth: 0.03,
        d: "M22 10.015H11m11 0H11m11 0H11m11 0H11m11 0H11"
      }
    )
  );
};

var __defProp$3Q = Object.defineProperty;
var __getOwnPropSymbols$3Q = Object.getOwnPropertySymbols;
var __hasOwnProp$3Q = Object.prototype.hasOwnProperty;
var __propIsEnum$3Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3Q = (obj, key, value) => key in obj ? __defProp$3Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3Q.call(b, prop))
      __defNormalProp$3Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$3Q)
    for (var prop of __getOwnPropSymbols$3Q(b)) {
      if (__propIsEnum$3Q.call(b, prop))
        __defNormalProp$3Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3Q)
    for (var prop of __getOwnPropSymbols$3Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGanttDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3Q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 9.5v3.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H3m10 0v3.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 2v20M3 9.5h16.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.74 21 8.46 21 7.9V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 4.5 19.96 4.5 19.4 4.5H3v5Z"
      }
    )
  );
};

var __defProp$3P = Object.defineProperty;
var __getOwnPropSymbols$3P = Object.getOwnPropertySymbols;
var __hasOwnProp$3P = Object.prototype.hasOwnProperty;
var __propIsEnum$3P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3P = (obj, key, value) => key in obj ? __defProp$3P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3P.call(b, prop))
      __defNormalProp$3P(a, prop, b[prop]);
  if (__getOwnPropSymbols$3P)
    for (var prop of __getOwnPropSymbols$3P(b)) {
      if (__propIsEnum$3P.call(b, prop))
        __defNormalProp$3P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3P)
    for (var prop of __getOwnPropSymbols$3P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGanttSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3P(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20.138 1.517c.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017H4V9h9.432c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017H4v1.5h5.432c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201 9.146 9.146 0 0 1-.706.017H3a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h16.432c.252 0 .498 0 .706.017Z"
      }
    )
  );
};

var __defProp$3O = Object.defineProperty;
var __getOwnPropSymbols$3O = Object.getOwnPropertySymbols;
var __hasOwnProp$3O = Object.prototype.hasOwnProperty;
var __propIsEnum$3O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3O = (obj, key, value) => key in obj ? __defProp$3O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3O.call(b, prop))
      __defNormalProp$3O(a, prop, b[prop]);
  if (__getOwnPropSymbols$3O)
    for (var prop of __getOwnPropSymbols$3O(b)) {
      if (__propIsEnum$3O.call(b, prop))
        __defNormalProp$3O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3O)
    for (var prop of __getOwnPropSymbols$3O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGaugeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3O(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 12a7 7 0 0 1 7-7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.5 7.5 12 12m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      }
    )
  );
};

var __defProp$3N = Object.defineProperty;
var __getOwnPropSymbols$3N = Object.getOwnPropertySymbols;
var __hasOwnProp$3N = Object.prototype.hasOwnProperty;
var __propIsEnum$3N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3N = (obj, key, value) => key in obj ? __defProp$3N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3N.call(b, prop))
      __defNormalProp$3N(a, prop, b[prop]);
  if (__getOwnPropSymbols$3N)
    for (var prop of __getOwnPropSymbols$3N(b)) {
      if (__propIsEnum$3N.call(b, prop))
        __defNormalProp$3N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3N)
    for (var prop of __getOwnPropSymbols$3N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGaugeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3N(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM6 12a6 6 0 0 1 6-6 1 1 0 1 0 0-2 8 8 0 0 0-8 8 1 1 0 1 0 2 0Zm11.207-3.793a1 1 0 0 0-1.414-1.414l-3.275 3.275A2.001 2.001 0 1 0 12 14a2 2 0 0 0 1.932-2.518l3.275-3.275Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3M = Object.defineProperty;
var __getOwnPropSymbols$3M = Object.getOwnPropertySymbols;
var __hasOwnProp$3M = Object.prototype.hasOwnProperty;
var __propIsEnum$3M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3M = (obj, key, value) => key in obj ? __defProp$3M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3M.call(b, prop))
      __defNormalProp$3M(a, prop, b[prop]);
  if (__getOwnPropSymbols$3M)
    for (var prop of __getOwnPropSymbols$3M(b)) {
      if (__propIsEnum$3M.call(b, prop))
        __defNormalProp$3M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3M)
    for (var prop of __getOwnPropSymbols$3M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGlobe03Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3M(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c-3-2-3.923-6.292-4-10 .077-3.708 1-8 4-10M2 12c2-3 6.292-3.923 10-4 3.708.077 8 1 10 4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 12c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m10 10c-1.363 2.044-3.79 3.124-6.371 3.629M12 22C6.477 22 2 17.523 2 12m10 10c2.044-1.363 3.124-3.79 3.629-6.371M2 12C2 6.477 6.477 2 12 2M2 12c2 3 6.292 3.923 10 4a21.382 21.382 0 0 0 3.629-.371M12 2c3 2 3.923 6.292 4 10a21.382 21.382 0 0 1-.371 3.629"
      }
    )
  );
};

var __defProp$3L = Object.defineProperty;
var __getOwnPropSymbols$3L = Object.getOwnPropertySymbols;
var __hasOwnProp$3L = Object.prototype.hasOwnProperty;
var __propIsEnum$3L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3L = (obj, key, value) => key in obj ? __defProp$3L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3L.call(b, prop))
      __defNormalProp$3L(a, prop, b[prop]);
  if (__getOwnPropSymbols$3L)
    for (var prop of __getOwnPropSymbols$3L(b)) {
      if (__propIsEnum$3L.call(b, prop))
        __defNormalProp$3L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3L)
    for (var prop of __getOwnPropSymbols$3L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGlobe03Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3L(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M23 12c0-6.075-4.924-11-10.998-11h-.004C5.924 1.001 1 5.926 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11ZM3.44 9.214A9.022 9.022 0 0 1 9.213 3.44c-.531.8-.942 1.684-1.256 2.595-.168.488-.31.988-.429 1.495a15.42 15.42 0 0 0-1.495.43 11.39 11.39 0 0 0-2.595 1.255Zm0 5.572a9.022 9.022 0 0 0 5.774 5.775c-.531-.8-.942-1.684-1.256-2.595-.168-.488-.31-.989-.429-1.495a15.403 15.403 0 0 1-1.495-.43 11.384 11.384 0 0 1-2.595-1.255Zm6.258 2.06c.048.158.098.314.151.469.484 1.403 1.185 2.59 2.151 3.43.966-.84 1.667-2.027 2.15-3.43.054-.155.104-.311.152-.47a23.937 23.937 0 0 1-2.323.155 23.937 23.937 0 0 1-2.28-.154Zm5.067-2.081c-.918.142-1.854.215-2.765.235a21.18 21.18 0 0 1-2.765-.235A21.166 21.166 0 0 1 9 12c.02-.91.093-1.847.235-2.765A21.163 21.163 0 0 1 12 9c.91.02 1.847.093 2.765.235.142.918.215 1.854.235 2.765-.02.91-.093 1.847-.235 2.765Zm1.706 1.706a15.398 15.398 0 0 1-.43 1.495 11.384 11.384 0 0 1-1.255 2.595 9.022 9.022 0 0 0 5.775-5.775c-.8.531-1.684.942-2.595 1.255a15.4 15.4 0 0 1-1.495.43Zm4.09-7.257a9.022 9.022 0 0 0-5.775-5.775c.531.8.942 1.684 1.255 2.595.169.488.31.988.43 1.495.507.12 1.007.261 1.495.43a11.39 11.39 0 0 1 2.595 1.255Zm-3.715.484c.158.048.314.098.469.151 1.403.484 2.59 1.185 3.43 2.151-.84.966-2.027 1.667-3.43 2.15-.155.054-.311.104-.47.152A23.937 23.937 0 0 0 17 11.979a23.937 23.937 0 0 0-.154-2.28Zm-2.544-2.544a12.488 12.488 0 0 0-.152-.469c-.483-1.403-1.184-2.59-2.15-3.43-.966.84-1.667 2.027-2.15 3.43-.054.155-.104.311-.152.47A23.944 23.944 0 0 1 12.021 7c.74.016 1.507.063 2.28.154ZM7.154 9.698A23.944 23.944 0 0 0 7 12.021c.016.74.063 1.507.154 2.28a12.481 12.481 0 0 1-.469-.15c-1.403-.484-2.59-1.185-3.43-2.151.84-.966 2.027-1.667 3.43-2.15.155-.054.311-.104.47-.152Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3K = Object.defineProperty;
var __getOwnPropSymbols$3K = Object.getOwnPropertySymbols;
var __hasOwnProp$3K = Object.prototype.hasOwnProperty;
var __propIsEnum$3K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3K = (obj, key, value) => key in obj ? __defProp$3K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3K.call(b, prop))
      __defNormalProp$3K(a, prop, b[prop]);
  if (__getOwnPropSymbols$3K)
    for (var prop of __getOwnPropSymbols$3K(b)) {
      if (__propIsEnum$3K.call(b, prop))
        __defNormalProp$3K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3K)
    for (var prop of __getOwnPropSymbols$3K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGlobe05Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3K(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.5 21.888v-2.203a.5.5 0 0 1 .12-.325l2.486-2.9a.5.5 0 0 0-.131-.76l-2.857-1.632a.5.5 0 0 1-.186-.187L8.07 10.62a.5.5 0 0 0-.478-.25l-5.528.492",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 2.458A9.996 9.996 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-1.715-.432-3.33-1.193-4.74M17 5.75h.005M21 6c0 2.21-2 4-4 6-2-2-4-3.79-4-6a4 4 0 0 1 8 0Zm-3.75-.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
      }
    )
  );
};

var __defProp$3J = Object.defineProperty;
var __getOwnPropSymbols$3J = Object.getOwnPropertySymbols;
var __hasOwnProp$3J = Object.prototype.hasOwnProperty;
var __propIsEnum$3J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3J = (obj, key, value) => key in obj ? __defProp$3J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3J.call(b, prop))
      __defNormalProp$3J(a, prop, b[prop]);
  if (__getOwnPropSymbols$3J)
    for (var prop of __getOwnPropSymbols$3J(b)) {
      if (__propIsEnum$3J.call(b, prop))
        __defNormalProp$3J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3J)
    for (var prop of __getOwnPropSymbols$3J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGlobe05Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3J(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1c1.04 0 2.047.144 3.002.415A5 5 0 0 1 22 6c0 .39-.049.765-.137 1.126A10.958 10.958 0 0 1 23 12c0 6.075-4.925 11-11 11S1 18.075 1 12a11.12 11.12 0 0 1 .073-1.27C1.703 5.253 6.354 1 12 1ZM3.284 9.748a9.004 9.004 0 0 1 9.678-6.697A4.978 4.978 0 0 0 12 6c0 1.422.647 2.636 1.458 3.689.674.876 1.538 1.731 2.37 2.557l.465.461a1 1 0 0 0 1.414 0l.464-.461c.833-.826 1.697-1.681 2.371-2.557.04-.051.078-.102.116-.154A9 9 0 0 1 11.5 20.986V19.87l2.366-2.76a1.5 1.5 0 0 0-.395-2.279l-2.738-1.564-1.794-3.144a1.5 1.5 0 0 0-1.436-.75l-4.219.375ZM17 4.5A1.25 1.25 0 1 0 17 7a1.25 1.25 0 0 0 0-2.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3I = Object.defineProperty;
var __getOwnPropSymbols$3I = Object.getOwnPropertySymbols;
var __hasOwnProp$3I = Object.prototype.hasOwnProperty;
var __propIsEnum$3I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3I = (obj, key, value) => key in obj ? __defProp$3I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3I.call(b, prop))
      __defNormalProp$3I(a, prop, b[prop]);
  if (__getOwnPropSymbols$3I)
    for (var prop of __getOwnPropSymbols$3I(b)) {
      if (__propIsEnum$3I.call(b, prop))
        __defNormalProp$3I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3I)
    for (var prop of __getOwnPropSymbols$3I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGroupDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3I(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11 4.5h7.3c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V9c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C19.898 12 19.432 12 18.5 12M13 19.5H5.7c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2.5 17.98 2.5 17.42 2.5 16.3V15c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C4.102 12 4.568 12 5.5 12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9.5 10.3c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218c.107-.055.247-.055.527-.055h3.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v3.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218c-.107.055-.247.055-.527.055h-3.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C9.5 14.12 9.5 13.98 9.5 13.7v-3.4Zm7.5 7.5c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C17.38 17 17.52 17 17.8 17h3.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v3.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C21.62 22 21.48 22 21.2 22h-3.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C17 21.62 17 21.48 17 21.2v-3.4ZM2 2.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219C2.38 2 2.52 2 2.8 2h3.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C7 2.38 7 2.52 7 2.8v3.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C6.62 7 6.48 7 6.2 7H2.8c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219C2 6.62 2 6.48 2 6.2V2.8Z"
      }
    )
  );
};

var __defProp$3H = Object.defineProperty;
var __getOwnPropSymbols$3H = Object.getOwnPropertySymbols;
var __hasOwnProp$3H = Object.prototype.hasOwnProperty;
var __propIsEnum$3H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3H = (obj, key, value) => key in obj ? __defProp$3H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3H.call(b, prop))
      __defNormalProp$3H(a, prop, b[prop]);
  if (__getOwnPropSymbols$3H)
    for (var prop of __getOwnPropSymbols$3H(b)) {
      if (__propIsEnum$3H.call(b, prop))
        __defNormalProp$3H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3H)
    for (var prop of __getOwnPropSymbols$3H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgGroupSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3H(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.532 5.524C19.25 5.5 18.877 5.5 18.3 5.5H11a1 1 0 1 1 0-2h7.339c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v1.371c0 .439 0 .817-.021 1.13a3.07 3.07 0 0 1-.207.986 3 3 0 0 1-1.624 1.624 3.07 3.07 0 0 1-.986.207c-.313.021-.691.021-1.13.021H18.5a1 1 0 1 1 0-2c.48 0 .79 0 1.026-.017.228-.015.315-.042.357-.06a1 1 0 0 0 .54-.54c.018-.042.045-.129.06-.357C20.5 9.79 20.5 9.48 20.5 9V7.7c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085ZM5.468 11H5.5a1 1 0 1 1 0 2c-.48 0-.79 0-1.026.017-.228.015-.315.042-.357.06a1 1 0 0 0-.54.54c-.018.042-.045.129-.06.357A16.91 16.91 0 0 0 3.5 15v1.3c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085.283.023.655.024 1.232.024H13a1 1 0 1 1 0 2H5.661c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167a17.9 17.9 0 0 1-.031-1.356v-1.371c0-.439 0-.817.021-1.13.023-.33.072-.66.207-.986a3 3 0 0 1 1.624-1.624 3.07 3.07 0 0 1 .986-.207C4.65 11 5.029 11 5.468 11Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.277 8.5h3.446c.12 0 .261 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .655.655c.112.218.142.426.154.571.01.125.01.268.01.387v3.446c0 .12 0 .261-.01.387a1.507 1.507 0 0 1-.154.571 1.5 1.5 0 0 1-.655.655 1.507 1.507 0 0 1-.571.154 4.92 4.92 0 0 1-.387.01h-3.446c-.12 0-.261 0-.387-.01a1.508 1.508 0 0 1-.571-.154 1.5 1.5 0 0 1-.655-.655 1.507 1.507 0 0 1-.154-.571 4.926 4.926 0 0 1-.01-.387v-3.446c0-.12 0-.261.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01Zm7.5 7.5h3.446c.12 0 .262 0 .387.01.145.012.353.042.571.153a1.5 1.5 0 0 1 .655.656c.112.218.142.426.154.571.01.125.01.268.01.387v3.446c0 .12 0 .262-.01.387a1.507 1.507 0 0 1-.153.571 1.5 1.5 0 0 1-.656.655 1.507 1.507 0 0 1-.571.154 4.92 4.92 0 0 1-.387.01h-3.446c-.12 0-.262 0-.387-.01a1.508 1.508 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.51 1.51 0 0 1-.154-.571c-.01-.125-.01-.268-.01-.387v-3.446c0-.12 0-.262.01-.387a1.51 1.51 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655 1.51 1.51 0 0 1 .571-.154c.125-.01.268-.01.387-.01Zm-15-15h3.446c.12 0 .262 0 .387.01.145.012.353.042.571.153a1.5 1.5 0 0 1 .656.656c.11.218.141.426.153.571.01.125.01.268.01.387v3.446c0 .12 0 .262-.01.387a1.508 1.508 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.508 1.508 0 0 1-.571.153C6.485 8 6.342 8 6.223 8H2.777c-.12 0-.262 0-.387-.01a1.508 1.508 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.508 1.508 0 0 1-.154-.571A4.926 4.926 0 0 1 1 6.223V2.777c0-.12 0-.262.01-.387a1.51 1.51 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3G = Object.defineProperty;
var __getOwnPropSymbols$3G = Object.getOwnPropertySymbols;
var __hasOwnProp$3G = Object.prototype.hasOwnProperty;
var __propIsEnum$3G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3G = (obj, key, value) => key in obj ? __defProp$3G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3G.call(b, prop))
      __defNormalProp$3G(a, prop, b[prop]);
  if (__getOwnPropSymbols$3G)
    for (var prop of __getOwnPropSymbols$3G(b)) {
      if (__propIsEnum$3G.call(b, prop))
        __defNormalProp$3G(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3G)
    for (var prop of __getOwnPropSymbols$3G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHamburgerDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3G(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 12h18M3 6h18M3 18h12"
      }
    )
  );
};

var __defProp$3F = Object.defineProperty;
var __getOwnPropSymbols$3F = Object.getOwnPropertySymbols;
var __hasOwnProp$3F = Object.prototype.hasOwnProperty;
var __propIsEnum$3F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3F = (obj, key, value) => key in obj ? __defProp$3F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3F.call(b, prop))
      __defNormalProp$3F(a, prop, b[prop]);
  if (__getOwnPropSymbols$3F)
    for (var prop of __getOwnPropSymbols$3F(b)) {
      if (__propIsEnum$3F.call(b, prop))
        __defNormalProp$3F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3F)
    for (var prop of __getOwnPropSymbols$3F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHamburgerSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3F(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0-6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3E = Object.defineProperty;
var __getOwnPropSymbols$3E = Object.getOwnPropertySymbols;
var __hasOwnProp$3E = Object.prototype.hasOwnProperty;
var __propIsEnum$3E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3E = (obj, key, value) => key in obj ? __defProp$3E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3E.call(b, prop))
      __defNormalProp$3E(a, prop, b[prop]);
  if (__getOwnPropSymbols$3E)
    for (var prop of __getOwnPropSymbols$3E(b)) {
      if (__propIsEnum$3E.call(b, prop))
        __defNormalProp$3E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3E)
    for (var prop of __getOwnPropSymbols$3E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHash01Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3E(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 3v18m8-18v18",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 8h16M4 16h16"
      }
    )
  );
};

var __defProp$3D = Object.defineProperty;
var __getOwnPropSymbols$3D = Object.getOwnPropertySymbols;
var __hasOwnProp$3D = Object.prototype.hasOwnProperty;
var __propIsEnum$3D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3D = (obj, key, value) => key in obj ? __defProp$3D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3D.call(b, prop))
      __defNormalProp$3D(a, prop, b[prop]);
  if (__getOwnPropSymbols$3D)
    for (var prop of __getOwnPropSymbols$3D(b)) {
      if (__propIsEnum$3D.call(b, prop))
        __defNormalProp$3D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3D)
    for (var prop of __getOwnPropSymbols$3D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHash01Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3D(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 0 1 1 1v4h6V3a1 1 0 1 1 2 0v4h3a1 1 0 1 1 0 2h-3v6h3a1 1 0 1 1 0 2h-3v4a1 1 0 1 1-2 0v-4H9v4a1 1 0 1 1-2 0v-4H4a1 1 0 1 1 0-2h3V9H4a1 1 0 0 1 0-2h3V3a1 1 0 0 1 1-1Zm7 13V9H9v6h6Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3C = Object.defineProperty;
var __getOwnPropSymbols$3C = Object.getOwnPropertySymbols;
var __hasOwnProp$3C = Object.prototype.hasOwnProperty;
var __propIsEnum$3C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3C = (obj, key, value) => key in obj ? __defProp$3C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3C.call(b, prop))
      __defNormalProp$3C(a, prop, b[prop]);
  if (__getOwnPropSymbols$3C)
    for (var prop of __getOwnPropSymbols$3C(b)) {
      if (__propIsEnum$3C.call(b, prop))
        __defNormalProp$3C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3C)
    for (var prop of __getOwnPropSymbols$3C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHeadlineDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3C(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 4v16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 4v16M9.5 4v16m2-16H4m14 8H9.5m2 8H4m16 0h-4m4-16h-4"
      }
    )
  );
};

var __defProp$3B = Object.defineProperty;
var __getOwnPropSymbols$3B = Object.getOwnPropertySymbols;
var __hasOwnProp$3B = Object.prototype.hasOwnProperty;
var __propIsEnum$3B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3B = (obj, key, value) => key in obj ? __defProp$3B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3B.call(b, prop))
      __defNormalProp$3B(a, prop, b[prop]);
  if (__getOwnPropSymbols$3B)
    for (var prop of __getOwnPropSymbols$3B(b)) {
      if (__propIsEnum$3B.call(b, prop))
        __defNormalProp$3B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3B)
    for (var prop of __getOwnPropSymbols$3B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHeadlineSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3B(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a1 1 0 0 0 0 2h1v14H4a1 1 0 1 0 0 2h7.5a1 1 0 1 0 0-2h-1v-6H17v6h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1V5h1a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2h1v6h-6.5V5h1a1 1 0 1 0 0-2H4Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3A = Object.defineProperty;
var __getOwnPropSymbols$3A = Object.getOwnPropertySymbols;
var __hasOwnProp$3A = Object.prototype.hasOwnProperty;
var __propIsEnum$3A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3A = (obj, key, value) => key in obj ? __defProp$3A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3A.call(b, prop))
      __defNormalProp$3A(a, prop, b[prop]);
  if (__getOwnPropSymbols$3A)
    for (var prop of __getOwnPropSymbols$3A(b)) {
      if (__propIsEnum$3A.call(b, prop))
        __defNormalProp$3A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3A)
    for (var prop of __getOwnPropSymbols$3A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHourglassDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3A(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 18.5h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17.4 2H6.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C5 2.76 5 3.04 5 3.6v2.075c0 .489 0 .733.055.963a2 2 0 0 0 .24.579c.123.201.296.374.642.72L8.87 10.87c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-2.932 2.932c-.346.346-.519.519-.642.72-.11.18-.19.374-.24.578-.055.23-.055.475-.055.965V20.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C5.76 22 6.04 22 6.6 22h10.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C19 21.24 19 20.96 19 20.4v-2.074c0-.49 0-.734-.055-.965a2.02 2.02 0 0 0-.24-.578c-.123-.201-.296-.374-.642-.72L15.13 13.13c-.396-.396-.594-.594-.668-.822a1 1 0 0 1 0-.618c.074-.228.272-.426.668-.822l2.932-2.932c.346-.346.519-.519.642-.72.11-.18.19-.374.24-.579.055-.23.055-.474.055-.963V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C18.24 2 17.96 2 17.4 2Z"
      }
    )
  );
};

var __defProp$3z = Object.defineProperty;
var __getOwnPropSymbols$3z = Object.getOwnPropertySymbols;
var __hasOwnProp$3z = Object.prototype.hasOwnProperty;
var __propIsEnum$3z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3z = (obj, key, value) => key in obj ? __defProp$3z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3z.call(b, prop))
      __defNormalProp$3z(a, prop, b[prop]);
  if (__getOwnPropSymbols$3z)
    for (var prop of __getOwnPropSymbols$3z(b)) {
      if (__propIsEnum$3z.call(b, prop))
        __defNormalProp$3z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3z)
    for (var prop of __getOwnPropSymbols$3z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHourglassSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.568 1c-.252 0-.498 0-.706.017a2.022 2.022 0 0 0-.77.201 2 2 0 0 0-.874.874 2.021 2.021 0 0 0-.2.77C4 3.07 4 3.316 4 3.568v2.19c0 .407 0 .765.083 1.114a3 3 0 0 0 .36.867c.186.306.44.559.728.846L8.586 12 5.17 15.415c-.288.287-.542.54-.729.846a3.001 3.001 0 0 0-.359.867c-.084.349-.083.707-.083 1.114v2.19c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.272.138.541.182.77.201.208.017.454.017.706.017h10.864c.252 0 .498 0 .706-.017a2.03 2.03 0 0 0 .77-.201 2 2 0 0 0 .874-.874c.138-.271.183-.541.201-.77.017-.208.017-.454.017-.706v-2.19c0-.407 0-.765-.083-1.114a3.001 3.001 0 0 0-.359-.867c-.187-.306-.441-.559-.73-.846L15.415 12l3.415-3.415c.288-.287.542-.54.729-.846a3 3 0 0 0 .36-.867C20 6.523 20 6.165 20 5.758v-2.19c0-.252 0-.498-.017-.706a2.022 2.022 0 0 0-.2-.77 2 2 0 0 0-.875-.874 2.022 2.022 0 0 0-.77-.201C17.93 1 17.684 1 17.432 1H6.568Zm10.788 6.23-3.302 3.301c-.172.173-.259.26-.36.322a.998.998 0 0 1-.289.12c-.115.027-.237.027-.482.027h-1.846c-.245 0-.367 0-.482-.028a.998.998 0 0 1-.289-.12c-.1-.061-.187-.148-.36-.32L6.644 7.23c-.38-.38-.45-.458-.497-.536a1 1 0 0 1-.12-.289C6.008 6.317 6 6.211 6 5.675V3.6c0-.297 0-.459.01-.575l.002-.014h.013C6.14 3 6.304 3 6.6 3h10.8c.297 0 .459 0 .576.01l.013.001v.014c.01.116.011.278.011.575v2.075c0 .536-.006.642-.027.73a.998.998 0 0 1-.12.29c-.048.077-.118.156-.497.535ZM9 17.5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3y = Object.defineProperty;
var __getOwnPropSymbols$3y = Object.getOwnPropertySymbols;
var __hasOwnProp$3y = Object.prototype.hasOwnProperty;
var __propIsEnum$3y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3y = (obj, key, value) => key in obj ? __defProp$3y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3y.call(b, prop))
      __defNormalProp$3y(a, prop, b[prop]);
  if (__getOwnPropSymbols$3y)
    for (var prop of __getOwnPropSymbols$3y(b)) {
      if (__propIsEnum$3y.call(b, prop))
        __defNormalProp$3y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3y)
    for (var prop of __getOwnPropSymbols$3y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHubDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 12a8 8 0 1 1 16 0M2 12a8 8 0 1 0 16 0",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }
    )
  );
};

var __defProp$3x = Object.defineProperty;
var __getOwnPropSymbols$3x = Object.getOwnPropertySymbols;
var __hasOwnProp$3x = Object.prototype.hasOwnProperty;
var __propIsEnum$3x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3x = (obj, key, value) => key in obj ? __defProp$3x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3x.call(b, prop))
      __defNormalProp$3x(a, prop, b[prop]);
  if (__getOwnPropSymbols$3x)
    for (var prop of __getOwnPropSymbols$3x(b)) {
      if (__propIsEnum$3x.call(b, prop))
        __defNormalProp$3x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3x)
    for (var prop of __getOwnPropSymbols$3x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgHubSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3x(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 19c.34 0 .673-.024 1-.07A7.001 7.001 0 0 1 5 12a9 9 0 0 1 18 0 1 1 0 1 1-2 0 7 7 0 0 0-8-6.93c3.392.486 6 3.404 6 6.93a9 9 0 1 1-18 0 1 1 0 1 1 2 0 7 7 0 0 0 7 7Zm2-9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3w = Object.defineProperty;
var __getOwnPropSymbols$3w = Object.getOwnPropertySymbols;
var __hasOwnProp$3w = Object.prototype.hasOwnProperty;
var __propIsEnum$3w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3w = (obj, key, value) => key in obj ? __defProp$3w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3w.call(b, prop))
      __defNormalProp$3w(a, prop, b[prop]);
  if (__getOwnPropSymbols$3w)
    for (var prop of __getOwnPropSymbols$3w(b)) {
      if (__propIsEnum$3w.call(b, prop))
        __defNormalProp$3w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3w)
    for (var prop of __getOwnPropSymbols$3w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgIDeleteDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3w(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 12h14"
      }
    )
  );
};

var __defProp$3v = Object.defineProperty;
var __getOwnPropSymbols$3v = Object.getOwnPropertySymbols;
var __hasOwnProp$3v = Object.prototype.hasOwnProperty;
var __propIsEnum$3v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3v = (obj, key, value) => key in obj ? __defProp$3v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3v.call(b, prop))
      __defNormalProp$3v(a, prop, b[prop]);
  if (__getOwnPropSymbols$3v)
    for (var prop of __getOwnPropSymbols$3v(b)) {
      if (__propIsEnum$3v.call(b, prop))
        __defNormalProp$3v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3v)
    for (var prop of __getOwnPropSymbols$3v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgIDeleteSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3v(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3u = Object.defineProperty;
var __getOwnPropSymbols$3u = Object.getOwnPropertySymbols;
var __hasOwnProp$3u = Object.prototype.hasOwnProperty;
var __propIsEnum$3u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3u = (obj, key, value) => key in obj ? __defProp$3u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3u.call(b, prop))
      __defNormalProp$3u(a, prop, b[prop]);
  if (__getOwnPropSymbols$3u)
    for (var prop of __getOwnPropSymbols$3u(b)) {
      if (__propIsEnum$3u.call(b, prop))
        __defNormalProp$3u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3u)
    for (var prop of __getOwnPropSymbols$3u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgIRemoveDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3u(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 7 7 17M7 7l10 10"
      }
    )
  );
};

var __defProp$3t = Object.defineProperty;
var __getOwnPropSymbols$3t = Object.getOwnPropertySymbols;
var __hasOwnProp$3t = Object.prototype.hasOwnProperty;
var __propIsEnum$3t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3t = (obj, key, value) => key in obj ? __defProp$3t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3t.call(b, prop))
      __defNormalProp$3t(a, prop, b[prop]);
  if (__getOwnPropSymbols$3t)
    for (var prop of __getOwnPropSymbols$3t(b)) {
      if (__propIsEnum$3t.call(b, prop))
        __defNormalProp$3t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3t)
    for (var prop of __getOwnPropSymbols$3t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgIRemoveSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3t(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.707 7.707a1 1 0 0 0-1.414-1.414L12 10.586 7.707 6.293a1 1 0 0 0-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414L12 13.414l4.293 4.293a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293Z"
      }
    )
  );
};

var __defProp$3s = Object.defineProperty;
var __getOwnPropSymbols$3s = Object.getOwnPropertySymbols;
var __hasOwnProp$3s = Object.prototype.hasOwnProperty;
var __propIsEnum$3s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3s = (obj, key, value) => key in obj ? __defProp$3s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3s.call(b, prop))
      __defNormalProp$3s(a, prop, b[prop]);
  if (__getOwnPropSymbols$3s)
    for (var prop of __getOwnPropSymbols$3s(b)) {
      if (__propIsEnum$3s.call(b, prop))
        __defNormalProp$3s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3s)
    for (var prop of __getOwnPropSymbols$3s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgIconshfeatured = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3s(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "g",
      {
        stroke: "#956FAC",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.3,
        clipPath: "url(#iconshfeatured_svg__a)"
      },
      /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", opacity: 0.4 }),
      /* @__PURE__ */ React__namespace.createElement("path", { d: "M11 6.5s.375.5 1 .5 1-.5 1-.5m.25-1.19a.486.486 0 0 1-.375.19.492.492 0 0 1-.375-.19m-1 0a.486.486 0 0 1-.375.19.492.492 0 0 1-.375-.19" })
    ),
    /* @__PURE__ */ React__namespace.createElement("g", { clipPath: "url(#iconshfeatured_svg__b)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#2A8BFB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.4,
        d: "m1.5 6 2.41 1.205a.25.25 0 0 0 .067.028c.015.003.03.003.046 0a.271.271 0 0 0 .066-.028L6.5 6m-5 1.25 2.41 1.205a.25.25 0 0 0 .067.028c.015.003.03.003.046 0a.271.271 0 0 0 .066-.028L6.5 7.25",
        opacity: 0.4
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#2A8BFB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.4,
        d: "M4.09 3.545a.272.272 0 0 0-.067-.028.125.125 0 0 0-.046 0 .272.272 0 0 0-.066.028L1.5 4.75l2.41 1.205a.25.25 0 0 0 .067.028c.015.003.03.003.046 0a.272.272 0 0 0 .066-.028L6.5 4.75 4.09 3.545Z"
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#956FAC",
        strokeOpacity: 0.35,
        strokeWidth: 0.03,
        d: "M6.015 3v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6M7 8.015H1m6 0H1m6 0H1m6 0H1m6 0H1m6-1H1m6 0H1m6 0H1m6 0H1m6 0H1m6-1H1m6 0H1m6 0H1m6 0H1m6 0H1m6-1H1m6 0H1m6 0H1m6 0H1m6 0H1m6-1H1m6 0H1m6 0H1m6 0H1m6 0H1"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement(
      "g",
      {
        stroke: "#FB802D",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.4,
        clipPath: "url(#iconshfeatured_svg__c)"
      },
      /* @__PURE__ */ React__namespace.createElement(
        "path",
        {
          d: "M21.28 6.84a5.073 5.073 0 0 1-.214.226c-1.074 1.074-2.42 1.47-3.005.884-.402-.402-.342-1.16.081-1.944m.58-.825c.071-.08.145-.159.223-.236 1.074-1.074 2.42-1.47 3.005-.884.402.402.342 1.161-.082 1.945",
          opacity: 0.4
        }
      ),
      /* @__PURE__ */ React__namespace.createElement("path", { d: "M21.066 4.945c1.074 1.074 1.47 2.419.884 3.005-.586.586-1.931.19-3.005-.884-1.074-1.074-1.47-2.42-.884-3.005.586-.586 1.931-.19 3.005.884Z" }),
      /* @__PURE__ */ React__namespace.createElement("path", { d: "M20 6.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Z" })
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#956FAC",
        strokeOpacity: 0.35,
        strokeWidth: 0.03,
        d: "M14.015 3v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6M15 8.015H9m6 0H9m6 0H9m6 0H9m6 0H9m6-1H9m6 0H9m6 0H9m6 0H9m6 0H9m6-1H9m6 0H9m6 0H9m6 0H9m6 0H9m6-1H9m6 0H9m6 0H9m6 0H9m6 0H9m6-1H9m6 0H9m6 0H9m6 0H9m6 0H9M22.015 3v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6m-1-6v6m0-6v6m0-6v6m0-6v6m0-6v6M23 8.015h-6m6 0h-6m6 0h-6m6 0h-6m6 0h-6m6-1h-6m6 0h-6m6 0h-6m6 0h-6m6 0h-6m6-1h-6m6 0h-6m6 0h-6m6 0h-6m6 0h-6m6-1h-6m6 0h-6m6 0h-6m6 0h-6m6 0h-6m6-1h-6m6 0h-6m6 0h-6m6 0h-6m6 0h-6"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "iconshfeatured_svg__a" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M9 3h6v6H9z" })), /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "iconshfeatured_svg__b" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M1 3h6v6H1z" })), /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "iconshfeatured_svg__c" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M17 3h6v6h-6z" })))
  );
};

var __defProp$3r = Object.defineProperty;
var __getOwnPropSymbols$3r = Object.getOwnPropertySymbols;
var __hasOwnProp$3r = Object.prototype.hasOwnProperty;
var __propIsEnum$3r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3r = (obj, key, value) => key in obj ? __defProp$3r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3r.call(b, prop))
      __defNormalProp$3r(a, prop, b[prop]);
  if (__getOwnPropSymbols$3r)
    for (var prop of __getOwnPropSymbols$3r(b)) {
      if (__propIsEnum$3r.call(b, prop))
        __defNormalProp$3r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3r)
    for (var prop of __getOwnPropSymbols$3r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgImage03Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3r(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m4.272 20.728 6.597-6.597c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L14 15m0 0 5.684 5.684M14 15l2.869-2.869c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L22 15M6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21Z"
      }
    )
  );
};

var __defProp$3q = Object.defineProperty;
var __getOwnPropSymbols$3q = Object.getOwnPropertySymbols;
var __hasOwnProp$3q = Object.prototype.hasOwnProperty;
var __propIsEnum$3q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3q = (obj, key, value) => key in obj ? __defProp$3q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3q.call(b, prop))
      __defNormalProp$3q(a, prop, b[prop]);
  if (__getOwnPropSymbols$3q)
    for (var prop of __getOwnPropSymbols$3q(b)) {
      if (__propIsEnum$3q.call(b, prop))
        __defNormalProp$3q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3q)
    for (var prop of __getOwnPropSymbols$3q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgImage03Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.241 2H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 6.29 1 6.954 1 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.119.01.243.017.374.023l.022.002c.214.019.48.019.75.019h12.212c.27 0 .536 0 .75-.019l.022-.002c.13-.006.255-.014.374-.023.562-.046 1.079-.145 1.564-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V7.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 2 18.046 2 17.242 2ZM21 12.586V7.8c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C18.639 4 18.057 4 17.2 4H6.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C3 6.361 3 6.943 3 7.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .739.798c.058-.088.116-.158.158-.209.138-.165.326-.352.517-.544l5.552-5.551c.179-.179.352-.353.512-.488.174-.148.396-.308.686-.402a2 2 0 0 1 1.236 0c.29.094.512.254.687.402.159.135.332.31.511.488l.184.184 2.184-2.184a9.18 9.18 0 0 1 .511-.488c.175-.148.397-.308.687-.402a2 2 0 0 1 1.236 0c.29.094.512.254.687.402.159.135.332.31.51.488L21 12.586Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3p = Object.defineProperty;
var __getOwnPropSymbols$3p = Object.getOwnPropertySymbols;
var __hasOwnProp$3p = Object.prototype.hasOwnProperty;
var __propIsEnum$3p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3p = (obj, key, value) => key in obj ? __defProp$3p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3p.call(b, prop))
      __defNormalProp$3p(a, prop, b[prop]);
  if (__getOwnPropSymbols$3p)
    for (var prop of __getOwnPropSymbols$3p(b)) {
      if (__propIsEnum$3p.call(b, prop))
        __defNormalProp$3p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3p)
    for (var prop of __getOwnPropSymbols$3p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgItalicDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3p(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m14 7-4 10"
      }
    )
  );
};

var __defProp$3o = Object.defineProperty;
var __getOwnPropSymbols$3o = Object.getOwnPropertySymbols;
var __hasOwnProp$3o = Object.prototype.hasOwnProperty;
var __propIsEnum$3o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3o = (obj, key, value) => key in obj ? __defProp$3o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3o.call(b, prop))
      __defNormalProp$3o(a, prop, b[prop]);
  if (__getOwnPropSymbols$3o)
    for (var prop of __getOwnPropSymbols$3o(b)) {
      if (__propIsEnum$3o.call(b, prop))
        __defNormalProp$3o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3o)
    for (var prop of __getOwnPropSymbols$3o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgItalicSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3o(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2Zm7.17 5.371a1 1 0 0 0-1.857-.743l-4 10a1 1 0 0 0 1.857.743l4-10Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3n = Object.defineProperty;
var __getOwnPropSymbols$3n = Object.getOwnPropertySymbols;
var __hasOwnProp$3n = Object.prototype.hasOwnProperty;
var __propIsEnum$3n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3n = (obj, key, value) => key in obj ? __defProp$3n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3n.call(b, prop))
      __defNormalProp$3n(a, prop, b[prop]);
  if (__getOwnPropSymbols$3n)
    for (var prop of __getOwnPropSymbols$3n(b)) {
      if (__propIsEnum$3n.call(b, prop))
        __defNormalProp$3n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3n)
    for (var prop of __getOwnPropSymbols$3n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLaughDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3n(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 9h.01M9 9h.01m6.49 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.5 8.5c2.5 0 4.5-1.833 4.5-3.5h-9c0 1.667 2 3.5 4.5 3.5Z"
      }
    )
  );
};

var __defProp$3m = Object.defineProperty;
var __getOwnPropSymbols$3m = Object.getOwnPropertySymbols;
var __hasOwnProp$3m = Object.prototype.hasOwnProperty;
var __propIsEnum$3m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3m = (obj, key, value) => key in obj ? __defProp$3m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3m.call(b, prop))
      __defNormalProp$3m(a, prop, b[prop]);
  if (__getOwnPropSymbols$3m)
    for (var prop of __getOwnPropSymbols$3m(b)) {
      if (__propIsEnum$3m.call(b, prop))
        __defNormalProp$3m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3m)
    for (var prop of __getOwnPropSymbols$3m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLaughSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3m(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M9.447 15.602A3.173 3.173 0 0 1 8.875 15h6.25a3.17 3.17 0 0 1-.572.602A4.057 4.057 0 0 1 12 16.5c-1.007 0-1.91-.37-2.553-.898Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm8-4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm6 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7.5 13a1 1 0 0 0-1 1c0 1.225.716 2.358 1.678 3.148A6.056 6.056 0 0 0 12 18.5c1.493 0 2.84-.546 3.822-1.352.962-.79 1.678-1.923 1.678-3.148a1 1 0 0 0-1-1h-9Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3l = Object.defineProperty;
var __getOwnPropSymbols$3l = Object.getOwnPropertySymbols;
var __hasOwnProp$3l = Object.prototype.hasOwnProperty;
var __propIsEnum$3l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3l = (obj, key, value) => key in obj ? __defProp$3l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3l.call(b, prop))
      __defNormalProp$3l(a, prop, b[prop]);
  if (__getOwnPropSymbols$3l)
    for (var prop of __getOwnPropSymbols$3l(b)) {
      if (__propIsEnum$3l.call(b, prop))
        __defNormalProp$3l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3l)
    for (var prop of __getOwnPropSymbols$3l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLayoutDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3l(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 12h9m-9-9v18",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3Z"
      }
    )
  );
};

var __defProp$3k = Object.defineProperty;
var __getOwnPropSymbols$3k = Object.getOwnPropertySymbols;
var __hasOwnProp$3k = Object.prototype.hasOwnProperty;
var __propIsEnum$3k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3k = (obj, key, value) => key in obj ? __defProp$3k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3k.call(b, prop))
      __defNormalProp$3k(a, prop, b[prop]);
  if (__getOwnPropSymbols$3k)
    for (var prop of __getOwnPropSymbols$3k(b)) {
      if (__propIsEnum$3k.call(b, prop))
        __defNormalProp$3k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3k)
    for (var prop of __getOwnPropSymbols$3k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLayoutSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3k(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 2 9.96 2 9.4 2H6.161c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H9.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.24 11 20.96 11 20.4V3.6Zm2 16.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 22 14.04 22 14.6 22h3.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V14.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 13 20.96 13 20.4 13h-5.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 13.76 13 14.04 13 14.6v5.8Zm7.4-9.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.24 22 9.96 22 9.4V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.839 2H14.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 2.76 13 3.04 13 3.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 11 14.04 11 14.6 11h5.8Z"
      }
    )
  );
};

var __defProp$3j = Object.defineProperty;
var __getOwnPropSymbols$3j = Object.getOwnPropertySymbols;
var __hasOwnProp$3j = Object.prototype.hasOwnProperty;
var __propIsEnum$3j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3j = (obj, key, value) => key in obj ? __defProp$3j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3j.call(b, prop))
      __defNormalProp$3j(a, prop, b[prop]);
  if (__getOwnPropSymbols$3j)
    for (var prop of __getOwnPropSymbols$3j(b)) {
      if (__propIsEnum$3j.call(b, prop))
        __defNormalProp$3j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3j)
    for (var prop of __getOwnPropSymbols$3j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLikeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3j(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 11v11",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20.391 19.456A3 3 0 0 1 17.426 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h2.35a1 1 0 0 0 .914-.594l3.52-7.918a.822.822 0 0 1 .75-.488A2.466 2.466 0 0 1 14 4.466V8a1 1 0 0 0 1 1h3.503a3 3 0 0 1 2.965 3.456l-1.077 7Z"
      }
    )
  );
};

var __defProp$3i = Object.defineProperty;
var __getOwnPropSymbols$3i = Object.getOwnPropertySymbols;
var __hasOwnProp$3i = Object.prototype.hasOwnProperty;
var __propIsEnum$3i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3i = (obj, key, value) => key in obj ? __defProp$3i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3i.call(b, prop))
      __defNormalProp$3i(a, prop, b[prop]);
  if (__getOwnPropSymbols$3i)
    for (var prop of __getOwnPropSymbols$3i(b)) {
      if (__propIsEnum$3i.call(b, prop))
        __defNormalProp$3i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3i)
    for (var prop of __getOwnPropSymbols$3i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLikeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3i(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M11.534 1c-.72 0-1.372.424-1.665 1.082L6.51 9.644a6.821 6.821 0 0 1-.16.344l-.003.006H6.34a6.828 6.828 0 0 1-.38.006h-.799c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 13.18 1 13.635 1 14.161v4.678c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031A.839.839 0 0 0 6 22.161V14a1 1 0 1 1 2 0v7.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 23 9.04 23 9.6 23h6.32c.698 0 1.278 0 1.756-.036.498-.038.958-.12 1.401-.32a4 4 0 0 0 1.7-1.458c.265-.408.416-.85.529-1.337.108-.466.197-1.04.303-1.73l.535-3.481c.141-.915.257-1.665.297-2.278.043-.631.015-1.22-.2-1.785a4 4 0 0 0-1.76-2.052c-.526-.299-1.105-.416-1.735-.47C18.135 8 17.376 8 16.45 8h-.85c-.296 0-.459 0-.575-.01l-.014-.001v-.014A8.205 8.205 0 0 1 15 7.4V4.466A3.466 3.466 0 0 0 11.534 1Z"
      }
    )
  );
};

var __defProp$3h = Object.defineProperty;
var __getOwnPropSymbols$3h = Object.getOwnPropertySymbols;
var __hasOwnProp$3h = Object.prototype.hasOwnProperty;
var __propIsEnum$3h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3h = (obj, key, value) => key in obj ? __defProp$3h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3h.call(b, prop))
      __defNormalProp$3h(a, prop, b[prop]);
  if (__getOwnPropSymbols$3h)
    for (var prop of __getOwnPropSymbols$3h(b)) {
      if (__propIsEnum$3h.call(b, prop))
        __defNormalProp$3h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3h)
    for (var prop of __getOwnPropSymbols$3h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLinkDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.5 17h.5a5 5 0 0 0 0-10h-2a5 5 0 0 0-5 5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7.5 7H7a5 5 0 0 0 0 10h2a5 5 0 0 0 5-5"
      }
    )
  );
};

var __defProp$3g = Object.defineProperty;
var __getOwnPropSymbols$3g = Object.getOwnPropertySymbols;
var __hasOwnProp$3g = Object.prototype.hasOwnProperty;
var __propIsEnum$3g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3g = (obj, key, value) => key in obj ? __defProp$3g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3g.call(b, prop))
      __defNormalProp$3g(a, prop, b[prop]);
  if (__getOwnPropSymbols$3g)
    for (var prop of __getOwnPropSymbols$3g(b)) {
      if (__propIsEnum$3g.call(b, prop))
        __defNormalProp$3g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3g)
    for (var prop of __getOwnPropSymbols$3g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLinkSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 8a4 4 0 1 0 0 8h2a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6H7A6 6 0 0 1 7 6h.5a1 1 0 0 1 0 2H7Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 8h-2a4 4 0 0 0-4 4 1 1 0 1 1-2 0 6 6 0 0 1 6-6h2a6 6 0 0 1 0 12h-.5a1 1 0 1 1 0-2h.5a4 4 0 0 0 0-8Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3f = Object.defineProperty;
var __getOwnPropSymbols$3f = Object.getOwnPropertySymbols;
var __hasOwnProp$3f = Object.prototype.hasOwnProperty;
var __propIsEnum$3f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3f = (obj, key, value) => key in obj ? __defProp$3f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3f.call(b, prop))
      __defNormalProp$3f(a, prop, b[prop]);
  if (__getOwnPropSymbols$3f)
    for (var prop of __getOwnPropSymbols$3f(b)) {
      if (__propIsEnum$3f.call(b, prop))
        __defNormalProp$3f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3f)
    for (var prop of __getOwnPropSymbols$3f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgListDotsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 12H9m12-6H9m12 12H9",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }
    )
  );
};

var __defProp$3e = Object.defineProperty;
var __getOwnPropSymbols$3e = Object.getOwnPropertySymbols;
var __hasOwnProp$3e = Object.prototype.hasOwnProperty;
var __propIsEnum$3e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3e = (obj, key, value) => key in obj ? __defProp$3e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3e.call(b, prop))
      __defNormalProp$3e(a, prop, b[prop]);
  if (__getOwnPropSymbols$3e)
    for (var prop of __getOwnPropSymbols$3e(b)) {
      if (__propIsEnum$3e.call(b, prop))
        __defNormalProp$3e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3e)
    for (var prop of __getOwnPropSymbols$3e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgListDotsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0-6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm-6-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$3d = Object.defineProperty;
var __getOwnPropSymbols$3d = Object.getOwnPropertySymbols;
var __hasOwnProp$3d = Object.prototype.hasOwnProperty;
var __propIsEnum$3d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3d = (obj, key, value) => key in obj ? __defProp$3d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3d.call(b, prop))
      __defNormalProp$3d(a, prop, b[prop]);
  if (__getOwnPropSymbols$3d)
    for (var prop of __getOwnPropSymbols$3d(b)) {
      if (__propIsEnum$3d.call(b, prop))
        __defNormalProp$3d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3d)
    for (var prop of __getOwnPropSymbols$3d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgListSelectDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 5H10m11 14H10m11-7H10",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 14a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0-7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      }
    )
  );
};

var __defProp$3c = Object.defineProperty;
var __getOwnPropSymbols$3c = Object.getOwnPropertySymbols;
var __hasOwnProp$3c = Object.prototype.hasOwnProperty;
var __propIsEnum$3c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3c = (obj, key, value) => key in obj ? __defProp$3c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3c.call(b, prop))
      __defNormalProp$3c(a, prop, b[prop]);
  if (__getOwnPropSymbols$3c)
    for (var prop of __getOwnPropSymbols$3c(b)) {
      if (__propIsEnum$3c.call(b, prop))
        __defNormalProp$3c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3c)
    for (var prop of __getOwnPropSymbols$3c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgListSelectSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M4.5 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM10 4h11a1 1 0 1 1 0 2H10a1 1 0 1 1 0-2Zm0 14h11a1 1 0 1 1 0 2H10a1 1 0 1 1 0-2Zm11-7H10a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2ZM4.5 16.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      }
    )
  );
};

var __defProp$3b = Object.defineProperty;
var __getOwnPropSymbols$3b = Object.getOwnPropertySymbols;
var __hasOwnProp$3b = Object.prototype.hasOwnProperty;
var __propIsEnum$3b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3b = (obj, key, value) => key in obj ? __defProp$3b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3b.call(b, prop))
      __defNormalProp$3b(a, prop, b[prop]);
  if (__getOwnPropSymbols$3b)
    for (var prop of __getOwnPropSymbols$3b(b)) {
      if (__propIsEnum$3b.call(b, prop))
        __defNormalProp$3b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3b)
    for (var prop of __getOwnPropSymbols$3b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLockDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 11V8A5 5 0 0 0 7 8v3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 15.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 11 7.12 11 8.8 11h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 13.28 20 14.12 20 15.8v.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 21 16.88 21 15.2 21H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 18.72 4 17.88 4 16.2v-.4Z"
      }
    )
  );
};

var __defProp$3a = Object.defineProperty;
var __getOwnPropSymbols$3a = Object.getOwnPropertySymbols;
var __hasOwnProp$3a = Object.prototype.hasOwnProperty;
var __propIsEnum$3a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3a = (obj, key, value) => key in obj ? __defProp$3a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3a.call(b, prop))
      __defNormalProp$3a(a, prop, b[prop]);
  if (__getOwnPropSymbols$3a)
    for (var prop of __getOwnPropSymbols$3a(b)) {
      if (__propIsEnum$3a.call(b, prop))
        __defNormalProp$3a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3a)
    for (var prop of __getOwnPropSymbols$3a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLockSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a6 6 0 0 0-6 6v2.15a3.365 3.365 0 0 0-.816.286 4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 14.29 3 14.954 3 15.758v.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 22 7.954 22 8.758 22h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748A3.365 3.365 0 0 0 18 10.15V8a6 6 0 0 0-6-6Zm4 8.002V8a4 4 0 0 0-8 0v2.002C8.238 10 8.49 10 8.759 10h6.482c.269 0 .521 0 .759.002Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$39 = Object.defineProperty;
var __getOwnPropSymbols$39 = Object.getOwnPropertySymbols;
var __hasOwnProp$39 = Object.prototype.hasOwnProperty;
var __propIsEnum$39 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$39 = (obj, key, value) => key in obj ? __defProp$39(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$39 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$39.call(b, prop))
      __defNormalProp$39(a, prop, b[prop]);
  if (__getOwnPropSymbols$39)
    for (var prop of __getOwnPropSymbols$39(b)) {
      if (__propIsEnum$39.call(b, prop))
        __defNormalProp$39(a, prop, b[prop]);
    }
  return a;
};
var __objRest$39 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$39.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$39)
    for (var prop of __getOwnPropSymbols$39(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$39.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLockUnlockedDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$39(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$39({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 11V8a5 5 0 0 1 9.9-1",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 15.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 11 7.12 11 8.8 11h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 13.28 20 14.12 20 15.8v.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 21 16.88 21 15.2 21H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 18.72 4 17.88 4 16.2v-.4Z"
      }
    )
  );
};

var __defProp$38 = Object.defineProperty;
var __getOwnPropSymbols$38 = Object.getOwnPropertySymbols;
var __hasOwnProp$38 = Object.prototype.hasOwnProperty;
var __propIsEnum$38 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$38 = (obj, key, value) => key in obj ? __defProp$38(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$38 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$38.call(b, prop))
      __defNormalProp$38(a, prop, b[prop]);
  if (__getOwnPropSymbols$38)
    for (var prop of __getOwnPropSymbols$38(b)) {
      if (__propIsEnum$38.call(b, prop))
        __defNormalProp$38(a, prop, b[prop]);
    }
  return a;
};
var __objRest$38 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$38.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$38)
    for (var prop of __getOwnPropSymbols$38(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$38.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLockUnlockedSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$38(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$38({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M6 8a6 6 0 0 1 11.88-1.199 1 1 0 1 1-1.96.398A4.002 4.002 0 0 0 8 8v2.002C8.238 10 8.49 10 8.759 10h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 17.71 3 17.046 3 16.242v-.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.262-.134.533-.224.816-.286V8Z"
      }
    )
  );
};

var __defProp$37 = Object.defineProperty;
var __getOwnPropSymbols$37 = Object.getOwnPropertySymbols;
var __hasOwnProp$37 = Object.prototype.hasOwnProperty;
var __propIsEnum$37 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$37 = (obj, key, value) => key in obj ? __defProp$37(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$37 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$37.call(b, prop))
      __defNormalProp$37(a, prop, b[prop]);
  if (__getOwnPropSymbols$37)
    for (var prop of __getOwnPropSymbols$37(b)) {
      if (__propIsEnum$37.call(b, prop))
        __defNormalProp$37(a, prop, b[prop]);
    }
  return a;
};
var __objRest$37 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$37.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$37)
    for (var prop of __getOwnPropSymbols$37(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$37.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLockedAccessDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$37(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$37({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7.101 10H7V8a5 5 0 0 1 10 0v2h-.101",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 14v2m7-1a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
      }
    )
  );
};

var __defProp$36 = Object.defineProperty;
var __getOwnPropSymbols$36 = Object.getOwnPropertySymbols;
var __hasOwnProp$36 = Object.prototype.hasOwnProperty;
var __propIsEnum$36 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$36 = (obj, key, value) => key in obj ? __defProp$36(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$36 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$36.call(b, prop))
      __defNormalProp$36(a, prop, b[prop]);
  if (__getOwnPropSymbols$36)
    for (var prop of __getOwnPropSymbols$36(b)) {
      if (__propIsEnum$36.call(b, prop))
        __defNormalProp$36(a, prop, b[prop]);
    }
  return a;
};
var __objRest$36 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$36.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$36)
    for (var prop of __getOwnPropSymbols$36(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$36.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLockedAccessSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$36(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$36({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 8v1.708a8 8 0 1 0 12 0V8A6 6 0 0 0 6 8Zm6-4a4 4 0 0 0-4 4v.07A7.963 7.963 0 0 1 12 7c1.457 0 2.823.39 4 1.07V8a4 4 0 0 0-4-4Zm1 10a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$35 = Object.defineProperty;
var __getOwnPropSymbols$35 = Object.getOwnPropertySymbols;
var __hasOwnProp$35 = Object.prototype.hasOwnProperty;
var __propIsEnum$35 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$35 = (obj, key, value) => key in obj ? __defProp$35(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$35 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$35.call(b, prop))
      __defNormalProp$35(a, prop, b[prop]);
  if (__getOwnPropSymbols$35)
    for (var prop of __getOwnPropSymbols$35(b)) {
      if (__propIsEnum$35.call(b, prop))
        __defNormalProp$35(a, prop, b[prop]);
    }
  return a;
};
var __objRest$35 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$35.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$35)
    for (var prop of __getOwnPropSymbols$35(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$35.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLogIn03Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$35(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$35({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 17c0 .351 0 .527.016.68a3 3 0 0 0 2.286 2.611c.15.036.324.06.672.105l6.592.88c1.876.25 2.814.375 3.542.085a3 3 0 0 0 1.509-1.32c.383-.684.383-1.63.383-3.524V7.482c0-1.893 0-2.84-.383-3.523a3 3 0 0 0-1.509-1.32c-.728-.29-1.666-.165-3.542.086l-6.592.878c-.349.047-.523.07-.672.106A3 3 0 0 0 6.016 6.32C6 6.473 6 6.65 6 7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 8 4 4m0 0-4 4m4-4H3"
      }
    )
  );
};

var __defProp$34 = Object.defineProperty;
var __getOwnPropSymbols$34 = Object.getOwnPropertySymbols;
var __hasOwnProp$34 = Object.prototype.hasOwnProperty;
var __propIsEnum$34 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$34 = (obj, key, value) => key in obj ? __defProp$34(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$34 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$34.call(b, prop))
      __defNormalProp$34(a, prop, b[prop]);
  if (__getOwnPropSymbols$34)
    for (var prop of __getOwnPropSymbols$34(b)) {
      if (__propIsEnum$34.call(b, prop))
        __defNormalProp$34(a, prop, b[prop]);
    }
  return a;
};
var __objRest$34 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$34.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$34)
    for (var prop of __getOwnPropSymbols$34(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$34.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLogIn03Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$34(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$34({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.815 3.478c-.508.024-1.162.11-2.117.238l-6.592.879c-.372.05-.484.066-.571.086A2 2 0 0 0 7.01 6.422C7.001 6.512 7 6.625 7 7a1 1 0 1 1-2 0v-.051c0-.302 0-.526.02-.73a4 4 0 0 1 3.05-3.483c.2-.048.422-.077.72-.117l6.687-.891c.901-.12 1.64-.22 2.244-.248.623-.029 1.203.01 1.757.23a4 4 0 0 1 2.011 1.76c.292.52.406 1.09.46 1.712C22 5.784 22 6.529 22 7.438v9.124c0 .909 0 1.654-.052 2.256-.053.621-.167 1.191-.459 1.712a4 4 0 0 1-2.011 1.76c-.554.22-1.134.259-1.757.23-.604-.029-1.343-.127-2.244-.247l-6.686-.892a7.38 7.38 0 0 1-.722-.117 4 4 0 0 1-3.048-3.482 7.398 7.398 0 0 1-.021-.73V17a1 1 0 1 1 2 0c0 .375.001.488.01.578a2 2 0 0 0 1.525 1.74c.087.021.2.038.57.087l6.593.88c.955.127 1.61.213 2.117.237.497.023.75-.021.924-.09a2 2 0 0 0 1.005-.88c.092-.164.17-.409.212-.905.043-.506.044-1.165.044-2.13V7.482c0-.964 0-1.623-.044-2.13-.043-.495-.12-.74-.212-.904a2 2 0 0 0-1.005-.88c-.174-.069-.427-.113-.924-.09Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M11.293 7.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.586 13H3a1 1 0 1 1 0-2h10.586l-2.293-2.293a1 1 0 0 1 0-1.414Z"
      }
    )
  );
};

var __defProp$33 = Object.defineProperty;
var __getOwnPropSymbols$33 = Object.getOwnPropertySymbols;
var __hasOwnProp$33 = Object.prototype.hasOwnProperty;
var __propIsEnum$33 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$33 = (obj, key, value) => key in obj ? __defProp$33(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$33 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$33.call(b, prop))
      __defNormalProp$33(a, prop, b[prop]);
  if (__getOwnPropSymbols$33)
    for (var prop of __getOwnPropSymbols$33(b)) {
      if (__propIsEnum$33.call(b, prop))
        __defNormalProp$33(a, prop, b[prop]);
    }
  return a;
};
var __objRest$33 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$33.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$33)
    for (var prop of __getOwnPropSymbols$33(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$33.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLogOutDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$33(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$33({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H9",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m16 17 5-5m0 0-5-5m5 5H9"
      }
    )
  );
};

var __defProp$32 = Object.defineProperty;
var __getOwnPropSymbols$32 = Object.getOwnPropertySymbols;
var __hasOwnProp$32 = Object.prototype.hasOwnProperty;
var __propIsEnum$32 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$32 = (obj, key, value) => key in obj ? __defProp$32(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$32 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$32.call(b, prop))
      __defNormalProp$32(a, prop, b[prop]);
  if (__getOwnPropSymbols$32)
    for (var prop of __getOwnPropSymbols$32(b)) {
      if (__propIsEnum$32.call(b, prop))
        __defNormalProp$32(a, prop, b[prop]);
    }
  return a;
};
var __objRest$32 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$32.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$32)
    for (var prop of __getOwnPropSymbols$32(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$32.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLogOutSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$32(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$32({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M7.759 2H9a1 1 0 1 1 0 2H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20H9a1 1 0 1 1 0 2H7.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L18.586 13H9a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414Z"
      }
    )
  );
};

var __defProp$31 = Object.defineProperty;
var __getOwnPropSymbols$31 = Object.getOwnPropertySymbols;
var __hasOwnProp$31 = Object.prototype.hasOwnProperty;
var __propIsEnum$31 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$31 = (obj, key, value) => key in obj ? __defProp$31(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$31 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$31.call(b, prop))
      __defNormalProp$31(a, prop, b[prop]);
  if (__getOwnPropSymbols$31)
    for (var prop of __getOwnPropSymbols$31(b)) {
      if (__propIsEnum$31.call(b, prop))
        __defNormalProp$31(a, prop, b[prop]);
    }
  return a;
};
var __objRest$31 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$31.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$31)
    for (var prop of __getOwnPropSymbols$31(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$31.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMailDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$31(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$31({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "rect",
      {
        width: 20,
        height: 16,
        x: 2,
        y: 4,
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        opacity: 0.4,
        rx: 3
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13.835 12.715c-.661.463-.992.695-1.351.784a2 2 0 0 1-.968 0c-.36-.09-.69-.32-1.351-.784L2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3l-8.165 5.715Z"
      }
    )
  );
};

var __defProp$30 = Object.defineProperty;
var __getOwnPropSymbols$30 = Object.getOwnPropertySymbols;
var __hasOwnProp$30 = Object.prototype.hasOwnProperty;
var __propIsEnum$30 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$30 = (obj, key, value) => key in obj ? __defProp$30(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$30 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$30.call(b, prop))
      __defNormalProp$30(a, prop, b[prop]);
  if (__getOwnPropSymbols$30)
    for (var prop of __getOwnPropSymbols$30(b)) {
      if (__propIsEnum$30.call(b, prop))
        __defNormalProp$30(a, prop, b[prop]);
    }
  return a;
};
var __objRest$30 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$30.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$30)
    for (var prop of __getOwnPropSymbols$30(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$30.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMailSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$30(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$30({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M2.134 8.181c-.3-.214-.45-.32-.581-.335a.506.506 0 0 0-.488.251C1 8.212 1 8.394 1 8.76v6.482c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 21 5.954 21 6.758 21h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758c0-.179 0-.268-.016-.33a.503.503 0 0 0-.655-.344c-.06.022-.135.074-.284.177l-7.742 5.36c-.549.381-1.03.716-1.578.849a3 3 0 0 1-1.457-.011c-.545-.14-1.022-.483-1.565-.872L2.133 8.18Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M22.133 5.769c.184-.128.277-.192.333-.295a.564.564 0 0 0 .06-.297c-.014-.116-.063-.193-.162-.347a4.033 4.033 0 0 0-1.548-1.394c-.485-.247-1.002-.346-1.564-.392C18.71 3 18.046 3 17.242 3H6.758c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4.005 4.005 0 0 0-1.41 1.197c-.115.158-.173.237-.192.356a.56.56 0 0 0 .05.308c.055.107.15.176.343.313l8.775 6.268c.727.52.882.61 1.018.645a1 1 0 0 0 .486.004c.137-.033.292-.121 1.027-.63l8.852-6.128Z"
      }
    )
  );
};

var __defProp$2$ = Object.defineProperty;
var __getOwnPropSymbols$2$ = Object.getOwnPropertySymbols;
var __hasOwnProp$2$ = Object.prototype.hasOwnProperty;
var __propIsEnum$2$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2$ = (obj, key, value) => key in obj ? __defProp$2$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2$.call(b, prop))
      __defNormalProp$2$(a, prop, b[prop]);
  if (__getOwnPropSymbols$2$)
    for (var prop of __getOwnPropSymbols$2$(b)) {
      if (__propIsEnum$2$.call(b, prop))
        __defNormalProp$2$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2$)
    for (var prop of __getOwnPropSymbols$2$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMarketDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2$(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 13.374c3.532.695 6 2.28 6 4.126 0 2.485-4.477 4.5-10 4.5S2 19.985 2 17.5c0-1.845 2.468-3.431 6-4.126",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 17V9m0 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$2_ = Object.defineProperty;
var __getOwnPropSymbols$2_ = Object.getOwnPropertySymbols;
var __hasOwnProp$2_ = Object.prototype.hasOwnProperty;
var __propIsEnum$2_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2_ = (obj, key, value) => key in obj ? __defProp$2_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2_.call(b, prop))
      __defNormalProp$2_(a, prop, b[prop]);
  if (__getOwnPropSymbols$2_)
    for (var prop of __getOwnPropSymbols$2_(b)) {
      if (__propIsEnum$2_.call(b, prop))
        __defNormalProp$2_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2_)
    for (var prop of __getOwnPropSymbols$2_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMarketSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2_(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 2a4 4 0 0 0-1 7.874V17a1 1 0 1 0 2 0V9.874A4.002 4.002 0 0 0 12 2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8.193 14.355a1 1 0 1 0-.386-1.962c-1.85.364-3.488.972-4.69 1.783C1.935 14.973 1 16.095 1 17.5c0 1.881 1.646 3.251 3.519 4.094C6.485 22.478 9.13 23 12 23s5.515-.522 7.481-1.406C21.354 20.75 23 19.38 23 17.5c0-1.405-.936-2.527-2.116-3.324-1.203-.81-2.84-1.42-4.691-1.783a1 1 0 0 0-.386 1.962c1.682.331 3.044.863 3.958 1.48.937.63 1.235 1.225 1.235 1.665 0 .604-.592 1.484-2.34 2.27C17.009 20.514 14.654 21 12 21s-5.008-.486-6.66-1.23C3.591 18.984 3 18.104 3 17.5c0-.44.298-1.034 1.235-1.665.914-.617 2.276-1.149 3.958-1.48Z"
      }
    )
  );
};

var __defProp$2Z = Object.defineProperty;
var __getOwnPropSymbols$2Z = Object.getOwnPropertySymbols;
var __hasOwnProp$2Z = Object.prototype.hasOwnProperty;
var __propIsEnum$2Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Z = (obj, key, value) => key in obj ? __defProp$2Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2Z.call(b, prop))
      __defNormalProp$2Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Z)
    for (var prop of __getOwnPropSymbols$2Z(b)) {
      if (__propIsEnum$2Z.call(b, prop))
        __defNormalProp$2Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Z)
    for (var prop of __getOwnPropSymbols$2Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMaximizeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2Z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m14 10 7-7M10 14l-7 7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 3h6v6M9 21H3v-6"
      }
    )
  );
};

var __defProp$2Y = Object.defineProperty;
var __getOwnPropSymbols$2Y = Object.getOwnPropertySymbols;
var __hasOwnProp$2Y = Object.prototype.hasOwnProperty;
var __propIsEnum$2Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Y = (obj, key, value) => key in obj ? __defProp$2Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2Y.call(b, prop))
      __defNormalProp$2Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Y)
    for (var prop of __getOwnPropSymbols$2Y(b)) {
      if (__propIsEnum$2Y.call(b, prop))
        __defNormalProp$2Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Y)
    for (var prop of __getOwnPropSymbols$2Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMaximizeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2Y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M14 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L18.586 4H15a1 1 0 0 1-1-1ZM5.414 20l5.293-5.293a1 1 0 0 0-1.414-1.414L4 18.586V15a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H5.414Z"
      }
    )
  );
};

var __defProp$2X = Object.defineProperty;
var __getOwnPropSymbols$2X = Object.getOwnPropertySymbols;
var __hasOwnProp$2X = Object.prototype.hasOwnProperty;
var __propIsEnum$2X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2X = (obj, key, value) => key in obj ? __defProp$2X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2X.call(b, prop))
      __defNormalProp$2X(a, prop, b[prop]);
  if (__getOwnPropSymbols$2X)
    for (var prop of __getOwnPropSymbols$2X(b)) {
      if (__propIsEnum$2X.call(b, prop))
        __defNormalProp$2X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2X)
    for (var prop of __getOwnPropSymbols$2X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaOverviewDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2X(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m18 10-3.434 3.434c-.198.198-.297.297-.412.334a.499.499 0 0 1-.309 0c-.114-.037-.213-.136-.41-.334l-2.87-2.868c-.197-.198-.296-.297-.41-.334a.499.499 0 0 0-.31 0c-.114.037-.213.136-.41.334L6 14"
      }
    )
  );
};

var __defProp$2W = Object.defineProperty;
var __getOwnPropSymbols$2W = Object.getOwnPropertySymbols;
var __hasOwnProp$2W = Object.prototype.hasOwnProperty;
var __propIsEnum$2W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2W = (obj, key, value) => key in obj ? __defProp$2W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2W.call(b, prop))
      __defNormalProp$2W(a, prop, b[prop]);
  if (__getOwnPropSymbols$2W)
    for (var prop of __getOwnPropSymbols$2W(b)) {
      if (__propIsEnum$2W.call(b, prop))
        __defNormalProp$2W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2W)
    for (var prop of __getOwnPropSymbols$2W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaOverviewSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2W(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11Zm-5.293-8.293a1 1 0 0 1-1.414-1.414l3.45-3.45c.085-.085.185-.186.281-.267.111-.094.28-.22.512-.295a1.5 1.5 0 0 1 .928 0c.232.075.4.2.512.295.096.081.196.182.28.266L14 12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-3.45 3.45c-.085.085-.185.186-.281.267a1.52 1.52 0 0 1-.513.296 1.5 1.5 0 0 1-.926 0 1.508 1.508 0 0 1-.513-.296c-.096-.081-.196-.182-.28-.266L10 11.414l-3.293 3.293Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2V = Object.defineProperty;
var __getOwnPropSymbols$2V = Object.getOwnPropertySymbols;
var __hasOwnProp$2V = Object.prototype.hasOwnProperty;
var __propIsEnum$2V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2V = (obj, key, value) => key in obj ? __defProp$2V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2V.call(b, prop))
      __defNormalProp$2V(a, prop, b[prop]);
  if (__getOwnPropSymbols$2V)
    for (var prop of __getOwnPropSymbols$2V(b)) {
      if (__propIsEnum$2V.call(b, prop))
        __defNormalProp$2V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2V)
    for (var prop of __getOwnPropSymbols$2V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaTypeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2V(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M10 6.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C10.38 6 10.52 6 10.8 6h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C14 6.38 14 6.52 14 6.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C13.62 10 13.48 10 13.2 10h-2.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C10 9.62 10 9.48 10 9.2V6.8Zm-7 6c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C3.38 12 3.52 12 3.8 12h2.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218C7 12.38 7 12.52 7 12.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C6.62 16 6.48 16 6.2 16H3.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C3 15.62 3 15.48 3 15.2v-2.4Zm-1-10c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219C2.38 2 2.52 2 2.8 2h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C6 2.38 6 2.52 6 2.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C5.62 6 5.48 6 5.2 6H2.8c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219C2 5.62 2 5.48 2 5.2V2.8Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21.2 22c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 21.62 22 21.48 22 21.2V10.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 10 21.48 10 21.2 10h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C18 10.38 18 10.52 18 10.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C17.62 14 17.48 14 17.2 14h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C14 14.38 14 14.52 14 14.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C13.62 18 13.48 18 13.2 18h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C10 18.38 10 18.52 10 18.8v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h10.4Z"
      }
    )
  );
};

var __defProp$2U = Object.defineProperty;
var __getOwnPropSymbols$2U = Object.getOwnPropertySymbols;
var __hasOwnProp$2U = Object.prototype.hasOwnProperty;
var __propIsEnum$2U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2U = (obj, key, value) => key in obj ? __defProp$2U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2U.call(b, prop))
      __defNormalProp$2U(a, prop, b[prop]);
  if (__getOwnPropSymbols$2U)
    for (var prop of __getOwnPropSymbols$2U(b)) {
      if (__propIsEnum$2U.call(b, prop))
        __defNormalProp$2U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2U)
    for (var prop of __getOwnPropSymbols$2U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaTypeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2U(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.777 9h2.446c.12 0 .262 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .655.655c.112.218.142.426.154.571.01.125.01.268.01.387v10.446c0 .12 0 .262-.01.387a1.507 1.507 0 0 1-.153.571 1.5 1.5 0 0 1-.656.655 1.507 1.507 0 0 1-.571.154c-.125.01-.268.01-.387.01H10.777c-.12 0-.261 0-.387-.01a1.508 1.508 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.507 1.507 0 0 1-.154-.571 4.927 4.927 0 0 1-.01-.387v-2.446c0-.12 0-.262.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655 1.51 1.51 0 0 1 .571-.154c.125-.01.268-.01.387-.01H13v-2.223c0-.12 0-.261.01-.387a1.51 1.51 0 0 1 .154-.571 1.5 1.5 0 0 1 .655-.655 1.51 1.51 0 0 1 .571-.154c.125-.01.268-.01.387-.01H17v-2.223c0-.12 0-.261.01-.387a1.51 1.51 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01Zm-8-4h2.446c.12 0 .261 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .655.655c.112.218.142.426.154.571.01.126.01.268.01.387v2.446c0 .12 0 .262-.01.387a1.508 1.508 0 0 1-.154.571 1.5 1.5 0 0 1-.655.655 1.507 1.507 0 0 1-.571.154 4.92 4.92 0 0 1-.387.01h-2.446c-.12 0-.261 0-.387-.01a1.508 1.508 0 0 1-.571-.154 1.5 1.5 0 0 1-.655-.655 1.508 1.508 0 0 1-.154-.571A4.928 4.928 0 0 1 9 9.223V6.777c0-.12 0-.261.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01Zm-7 6h2.446c.12 0 .262 0 .387.01.145.012.353.043.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.125.01.268.01.387v2.446c0 .12 0 .261-.01.387a1.507 1.507 0 0 1-.153.571 1.5 1.5 0 0 1-.656.655 1.508 1.508 0 0 1-.571.154c-.125.01-.268.01-.387.01H3.777c-.12 0-.262 0-.387-.01a1.508 1.508 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.507 1.507 0 0 1-.154-.571 4.926 4.926 0 0 1-.01-.387v-2.446c0-.12 0-.261.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655 1.51 1.51 0 0 1 .571-.154c.125-.01.268-.01.387-.01Zm-1-10h2.446c.12 0 .262 0 .387.01.145.012.353.042.571.153a1.5 1.5 0 0 1 .656.656c.11.218.141.426.153.571.01.125.01.268.01.387v2.446c0 .12 0 .262-.01.387a1.508 1.508 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.508 1.508 0 0 1-.571.153C5.485 7 5.342 7 5.223 7H2.777c-.12 0-.262 0-.387-.01a1.508 1.508 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.508 1.508 0 0 1-.154-.571A4.926 4.926 0 0 1 1 5.223V2.777c0-.12 0-.262.01-.387a1.51 1.51 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2T = Object.defineProperty;
var __getOwnPropSymbols$2T = Object.getOwnPropertySymbols;
var __hasOwnProp$2T = Object.prototype.hasOwnProperty;
var __propIsEnum$2T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2T = (obj, key, value) => key in obj ? __defProp$2T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2T.call(b, prop))
      __defNormalProp$2T(a, prop, b[prop]);
  if (__getOwnPropSymbols$2T)
    for (var prop of __getOwnPropSymbols$2T(b)) {
      if (__propIsEnum$2T.call(b, prop))
        __defNormalProp$2T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2T)
    for (var prop of __getOwnPropSymbols$2T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaplan1Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2T(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17.5 17h-11m11-4h-11",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 9h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
      }
    )
  );
};

var __defProp$2S = Object.defineProperty;
var __getOwnPropSymbols$2S = Object.getOwnPropertySymbols;
var __hasOwnProp$2S = Object.prototype.hasOwnProperty;
var __propIsEnum$2S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2S = (obj, key, value) => key in obj ? __defProp$2S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2S.call(b, prop))
      __defNormalProp$2S(a, prop, b[prop]);
  if (__getOwnPropSymbols$2S)
    for (var prop of __getOwnPropSymbols$2S(b)) {
      if (__propIsEnum$2S.call(b, prop))
        __defNormalProp$2S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2S)
    for (var prop of __getOwnPropSymbols$2S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaplan1Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2S(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M14.138 1.517c.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017H4V9h15.432c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017H4v1.5h5.432c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201 9.149 9.149 0 0 1-.706.017H3a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h10.432c.252 0 .498 0 .706.017Z"
      }
    )
  );
};

var __defProp$2R = Object.defineProperty;
var __getOwnPropSymbols$2R = Object.getOwnPropertySymbols;
var __hasOwnProp$2R = Object.prototype.hasOwnProperty;
var __propIsEnum$2R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2R = (obj, key, value) => key in obj ? __defProp$2R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2R.call(b, prop))
      __defNormalProp$2R(a, prop, b[prop]);
  if (__getOwnPropSymbols$2R)
    for (var prop of __getOwnPropSymbols$2R(b)) {
      if (__propIsEnum$2R.call(b, prop))
        __defNormalProp$2R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2R)
    for (var prop of __getOwnPropSymbols$2R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaplanDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2R(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 9.5V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C16.24 4.5 15.96 4.5 15.4 4.5H3m10 10v3.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 2v20m0-7.5h16.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 13.74 21 13.46 21 12.9v-1.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 9.5 19.96 9.5 19.4 9.5H3v5Z"
      }
    )
  );
};

var __defProp$2Q = Object.defineProperty;
var __getOwnPropSymbols$2Q = Object.getOwnPropertySymbols;
var __hasOwnProp$2Q = Object.prototype.hasOwnProperty;
var __propIsEnum$2Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Q = (obj, key, value) => key in obj ? __defProp$2Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2Q.call(b, prop))
      __defNormalProp$2Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Q)
    for (var prop of __getOwnPropSymbols$2Q(b)) {
      if (__propIsEnum$2Q.call(b, prop))
        __defNormalProp$2Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Q)
    for (var prop of __getOwnPropSymbols$2Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaplanReportDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2Q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.24 3 19.96 3 19.4V3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21 7-5.434 5.434c-.198.198-.297.297-.412.334a.499.499 0 0 1-.309 0c-.114-.037-.213-.136-.41-.334l-1.87-1.868c-.197-.198-.296-.297-.41-.334a.499.499 0 0 0-.31 0c-.114.037-.213.136-.41.334L7 15m14-8h-4m4 0v4"
      }
    )
  );
};

var __defProp$2P = Object.defineProperty;
var __getOwnPropSymbols$2P = Object.getOwnPropertySymbols;
var __hasOwnProp$2P = Object.prototype.hasOwnProperty;
var __propIsEnum$2P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2P = (obj, key, value) => key in obj ? __defProp$2P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2P.call(b, prop))
      __defNormalProp$2P(a, prop, b[prop]);
  if (__getOwnPropSymbols$2P)
    for (var prop of __getOwnPropSymbols$2P(b)) {
      if (__propIsEnum$2P.call(b, prop))
        __defNormalProp$2P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2P)
    for (var prop of __getOwnPropSymbols$2P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaplanReportSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2P(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3 2a1 1 0 0 1 1 1v16.4c0 .297 0 .459.01.575l.001.013.014.002c.116.01.278.01.575.01H21a1 1 0 1 1 0 2H4.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C2 19.93 2 19.684 2 19.432V3a1 1 0 0 1 1-1Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20 9.414V11a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1h-4a1 1 0 1 0 0 2h1.586L15 11.586l-1.744-1.744c-.084-.084-.184-.185-.28-.266a1.506 1.506 0 0 0-.513-.295 1.5 1.5 0 0 0-.926 0 1.506 1.506 0 0 0-.513.295c-.096.081-.196.182-.28.266l-4.451 4.45a1 1 0 1 0 1.414 1.415L12 11.414l1.744 1.744c.084.084.184.185.28.266.111.094.28.22.513.296a1.5 1.5 0 0 0 .926 0 1.52 1.52 0 0 0 .513-.296c.096-.081.196-.182.28-.266L20 9.414Z"
      }
    )
  );
};

var __defProp$2O = Object.defineProperty;
var __getOwnPropSymbols$2O = Object.getOwnPropertySymbols;
var __hasOwnProp$2O = Object.prototype.hasOwnProperty;
var __propIsEnum$2O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2O = (obj, key, value) => key in obj ? __defProp$2O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2O.call(b, prop))
      __defNormalProp$2O(a, prop, b[prop]);
  if (__getOwnPropSymbols$2O)
    for (var prop of __getOwnPropSymbols$2O(b)) {
      if (__propIsEnum$2O.call(b, prop))
        __defNormalProp$2O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2O)
    for (var prop of __getOwnPropSymbols$2O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediaplanSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2O(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.838 2H6.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161c0 .464.375.839.839.839H21.16a.839.839 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.838 2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22 10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 9 20.96 9 20.4 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v7.239c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V10.6ZM5.5 13a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2N = Object.defineProperty;
var __getOwnPropSymbols$2N = Object.getOwnPropertySymbols;
var __hasOwnProp$2N = Object.prototype.hasOwnProperty;
var __propIsEnum$2N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2N = (obj, key, value) => key in obj ? __defProp$2N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2N.call(b, prop))
      __defNormalProp$2N(a, prop, b[prop]);
  if (__getOwnPropSymbols$2N)
    for (var prop of __getOwnPropSymbols$2N(b)) {
      if (__propIsEnum$2N.call(b, prop))
        __defNormalProp$2N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2N)
    for (var prop of __getOwnPropSymbols$2N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediatoolLogoDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2N(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("g", { clipPath: "url(#mediatool-logo-duo_svg__a)" }, /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "mediatool-logo-duo_svg__b",
        width: 20,
        height: 20,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "alpha"
        }
      },
      /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 0H0v20h20V0Z" })
    ), /* @__PURE__ */ React__namespace.createElement("g", { mask: "url(#mediatool-logo-duo_svg__b)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.198 18.849c-1.523-1.154-2.745-2.892-3.375-4.972a9.64 9.64 0 0 1-.156-.582 8.34 8.34 0 0 0 2.255.31c3.718 0 7.487-2.39 9.32-6.277.043-.093.083-.186.124-.28.323.919.5 1.905.5 2.933 0 4.822-3.87 8.755-8.668 8.868ZM1.108 9.98c0-.59.06-1.167.17-1.725.738 2 2.167 3.658 4.161 4.585.08.45.185.904.322 1.357.538 1.776 1.46 3.311 2.618 4.507-4.13-.759-7.27-4.38-7.27-8.724Zm8.88-8.872c1.553 0 3.014.402 4.286 1.105a7.462 7.462 0 0 0-1.306-.117c-.693 0-1.39.099-2.077.306-3.63 1.098-5.827 4.883-5.605 9.085-1.852-1.131-3.014-3.078-3.323-5.3 1.426-3 4.486-5.08 8.024-5.08Zm7.694 4.458c-.138.442-.308.88-.511 1.31-1.585 3.361-4.9 5.619-8.249 5.619-.861 0-1.693-.15-2.478-.444-.193-1.66.028-3.3.66-4.754.837-1.925 2.296-3.286 4.108-3.834a6.065 6.065 0 0 1 1.757-.26c1.417 0 2.796.477 4.006 1.313.26.332.496.683.707 1.05Zm1.96 1.852a9.895 9.895 0 0 0-1.616-3.354A9.968 9.968 0 0 0 9.987 0a9.974 9.974 0 0 0-8.063 4.093A9.943 9.943 0 0 0 0 9.98c0 5.468 4.4 9.906 9.853 9.978.045 0 .09.004.134.004.62 0 1.227-.06 1.817-.168 4.648-.854 8.17-4.922 8.17-9.814 0-.886-.116-1.744-.333-2.562Z",
        clipRule: "evenodd"
      }
    ))),
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "mediatool-logo-duo_svg__a" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })))
  );
};

var __defProp$2M = Object.defineProperty;
var __getOwnPropSymbols$2M = Object.getOwnPropertySymbols;
var __hasOwnProp$2M = Object.prototype.hasOwnProperty;
var __propIsEnum$2M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2M = (obj, key, value) => key in obj ? __defProp$2M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2M.call(b, prop))
      __defNormalProp$2M(a, prop, b[prop]);
  if (__getOwnPropSymbols$2M)
    for (var prop of __getOwnPropSymbols$2M(b)) {
      if (__propIsEnum$2M.call(b, prop))
        __defNormalProp$2M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2M)
    for (var prop of __getOwnPropSymbols$2M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMediatoolLogoSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2M(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.644 4.97c-.32 2.126-1.873 3.976-3.697 5.432-1.949 1.555-4.284 2.41-6.576 2.41a8.301 8.301 0 0 1-2.54-.382c-.265-2.151.085-4.27 1.017-6.063 1.07-2.057 2.79-3.392 4.817-3.879.844-.202 1.618-.328 2.085-.328 0 0 1.474-.12 2.82.465a6 6 0 0 0 1.195 1.066c.335.396.63.824.879 1.28ZM20 10.001c0 5.443-4.346 9.87-9.755 9.999a9.021 9.021 0 0 1-1.08-.852c-1.541-1.42-2.656-3.41-3.144-5.609a9.41 9.41 0 0 0 2.35.29c2.521 0 5.082-.936 7.209-2.632 1.688-1.348 2.861-3.26 3.597-5.134.465 1.154.823 2.618.823 3.938ZM5.947 5.898C5.001 7.715 4.6 9.831 4.766 11.992a6.642 6.642 0 0 1-2.192-1.782c-1.09-1.365-1.555-3.062-1.451-4.816A9.999 9.999 0 0 1 10 0c2.114 0 4.074.656 5.689 1.776a7.938 7.938 0 0 0-2.628-.454c-.541 0-1.084.058-1.613.174-2.335.509-4.29 2.072-5.5 4.402Zm-.928 7.817c.543 2.491 1.792 4.642 3.444 6.17C3.67 19.146 0 15.003 0 10.003c0-.807.096-1.59.275-2.34a7.648 7.648 0 0 0 4.638 5.51c.032.18.066.361.106.542Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2L = Object.defineProperty;
var __getOwnPropSymbols$2L = Object.getOwnPropertySymbols;
var __hasOwnProp$2L = Object.prototype.hasOwnProperty;
var __propIsEnum$2L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2L = (obj, key, value) => key in obj ? __defProp$2L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2L.call(b, prop))
      __defNormalProp$2L(a, prop, b[prop]);
  if (__getOwnPropSymbols$2L)
    for (var prop of __getOwnPropSymbols$2L(b)) {
      if (__propIsEnum$2L.call(b, prop))
        __defNormalProp$2L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2L)
    for (var prop of __getOwnPropSymbols$2L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMessageDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2L(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 18 17.88 18 16.2 18h-2.516c-.624 0-.936 0-1.235.061a2.997 2.997 0 0 0-.761.267c-.272.14-.516.334-1.003.724L8.3 20.96c-.416.333-.624.5-.8.5a.5.5 0 0 1-.39-.188C7 21.135 7 20.868 7 20.336V18c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C3 15.395 3 14.93 3 14V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 8.5h5M7 12h8"
      }
    )
  );
};

var __defProp$2K = Object.defineProperty;
var __getOwnPropSymbols$2K = Object.getOwnPropertySymbols;
var __hasOwnProp$2K = Object.prototype.hasOwnProperty;
var __propIsEnum$2K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2K = (obj, key, value) => key in obj ? __defProp$2K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2K.call(b, prop))
      __defNormalProp$2K(a, prop, b[prop]);
  if (__getOwnPropSymbols$2K)
    for (var prop of __getOwnPropSymbols$2K(b)) {
      if (__propIsEnum$2K.call(b, prop))
        __defNormalProp$2K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2K)
    for (var prop of __getOwnPropSymbols$2K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMessageSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2K(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v5.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044h-2.558c-.664 0-.858.005-1.034.04a2.002 2.002 0 0 0-.508.179c-.16.082-.313.199-.832.614l-2.413 1.93c-.184.147-.371.297-.536.406-.157.104-.462.29-.86.29a1.5 1.5 0 0 1-1.173-.564c-.248-.31-.293-.665-.31-.852C6 20.846 6 20.605 6 20.37v-1.38a4.542 4.542 0 0 1-1.035-.127 4 4 0 0 1-2.829-2.829C2 15.524 2 14.933 2 14.138v-6.38c0-.804 0-1.469.044-2.01.046-.562.145-1.079.392-1.564a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2ZM6 8.5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM7 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2J = Object.defineProperty;
var __getOwnPropSymbols$2J = Object.getOwnPropertySymbols;
var __hasOwnProp$2J = Object.prototype.hasOwnProperty;
var __propIsEnum$2J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2J = (obj, key, value) => key in obj ? __defProp$2J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2J.call(b, prop))
      __defNormalProp$2J(a, prop, b[prop]);
  if (__getOwnPropSymbols$2J)
    for (var prop of __getOwnPropSymbols$2J(b)) {
      if (__propIsEnum$2J.call(b, prop))
        __defNormalProp$2J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2J)
    for (var prop of __getOwnPropSymbols$2J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMessageSquare02Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2J(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 18 17.88 18 16.2 18h-2.516c-.624 0-.936 0-1.235.061a2.997 2.997 0 0 0-.761.267c-.272.14-.516.334-1.003.724L8.3 20.96c-.416.333-.624.5-.8.5a.5.5 0 0 1-.39-.188C7 21.135 7 20.868 7 20.336V18c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C3 15.395 3 14.93 3 14V7.8Z"
      }
    )
  );
};

var __defProp$2I = Object.defineProperty;
var __getOwnPropSymbols$2I = Object.getOwnPropertySymbols;
var __hasOwnProp$2I = Object.prototype.hasOwnProperty;
var __propIsEnum$2I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2I = (obj, key, value) => key in obj ? __defProp$2I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2I.call(b, prop))
      __defNormalProp$2I(a, prop, b[prop]);
  if (__getOwnPropSymbols$2I)
    for (var prop of __getOwnPropSymbols$2I(b)) {
      if (__propIsEnum$2I.call(b, prop))
        __defNormalProp$2I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2I)
    for (var prop of __getOwnPropSymbols$2I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMessageSquare02Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2I(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v5.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044h-2.558c-.664 0-.858.005-1.034.04a2.002 2.002 0 0 0-.508.179c-.16.082-.313.199-.832.614l-2.413 1.93c-.184.147-.371.297-.536.406-.157.104-.462.29-.86.29a1.5 1.5 0 0 1-1.173-.564c-.248-.31-.293-.665-.31-.852C6 20.846 6 20.605 6 20.37v-1.38a4.542 4.542 0 0 1-1.035-.127 4 4 0 0 1-2.829-2.829C2 15.524 2 14.933 2 14.138V7.759c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2H = Object.defineProperty;
var __getOwnPropSymbols$2H = Object.getOwnPropertySymbols;
var __hasOwnProp$2H = Object.prototype.hasOwnProperty;
var __propIsEnum$2H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2H = (obj, key, value) => key in obj ? __defProp$2H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2H.call(b, prop))
      __defNormalProp$2H(a, prop, b[prop]);
  if (__getOwnPropSymbols$2H)
    for (var prop of __getOwnPropSymbols$2H(b)) {
      if (__propIsEnum$2H.call(b, prop))
        __defNormalProp$2H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2H)
    for (var prop of __getOwnPropSymbols$2H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMinusSquareDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2H(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 12h8"
      }
    )
  );
};

var __defProp$2G = Object.defineProperty;
var __getOwnPropSymbols$2G = Object.getOwnPropertySymbols;
var __hasOwnProp$2G = Object.prototype.hasOwnProperty;
var __propIsEnum$2G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2G = (obj, key, value) => key in obj ? __defProp$2G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2G.call(b, prop))
      __defNormalProp$2G(a, prop, b[prop]);
  if (__getOwnPropSymbols$2G)
    for (var prop of __getOwnPropSymbols$2G(b)) {
      if (__propIsEnum$2G.call(b, prop))
        __defNormalProp$2G(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2G)
    for (var prop of __getOwnPropSymbols$2G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMinusSquareSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2G(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.838 2H6.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.838 2ZM8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2F = Object.defineProperty;
var __getOwnPropSymbols$2F = Object.getOwnPropertySymbols;
var __hasOwnProp$2F = Object.prototype.hasOwnProperty;
var __propIsEnum$2F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2F = (obj, key, value) => key in obj ? __defProp$2F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2F.call(b, prop))
      __defNormalProp$2F(a, prop, b[prop]);
  if (__getOwnPropSymbols$2F)
    for (var prop of __getOwnPropSymbols$2F(b)) {
      if (__propIsEnum$2F.call(b, prop))
        __defNormalProp$2F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2F)
    for (var prop of __getOwnPropSymbols$2F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMoneyDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2F(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18.8 19c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 10v4m12-4v4m-3.5-2a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      }
    )
  );
};

var __defProp$2E = Object.defineProperty;
var __getOwnPropSymbols$2E = Object.getOwnPropertySymbols;
var __hasOwnProp$2E = Object.prototype.hasOwnProperty;
var __propIsEnum$2E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2E = (obj, key, value) => key in obj ? __defProp$2E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2E.call(b, prop))
      __defNormalProp$2E(a, prop, b[prop]);
  if (__getOwnPropSymbols$2E)
    for (var prop of __getOwnPropSymbols$2E(b)) {
      if (__propIsEnum$2E.call(b, prop))
        __defNormalProp$2E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2E)
    for (var prop of __getOwnPropSymbols$2E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMoneySolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2E(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.161 4H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v7.678c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 16.82 1 16.365 1 15.839V8.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 4 4.635 4 5.161 4ZM8.5 12a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM6 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm13 1a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2D = Object.defineProperty;
var __getOwnPropSymbols$2D = Object.getOwnPropertySymbols;
var __hasOwnProp$2D = Object.prototype.hasOwnProperty;
var __propIsEnum$2D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2D = (obj, key, value) => key in obj ? __defProp$2D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2D.call(b, prop))
      __defNormalProp$2D(a, prop, b[prop]);
  if (__getOwnPropSymbols$2D)
    for (var prop of __getOwnPropSymbols$2D(b)) {
      if (__propIsEnum$2D.call(b, prop))
        __defNormalProp$2D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2D)
    for (var prop of __getOwnPropSymbols$2D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMoreOptionsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2D(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 9.25H3M12 4H3m18 10.75H3M21 20H3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 9.4c0 .515 0 .772-.106.908a.5.5 0 0 1-.384.192c-.172.004-.378-.151-.79-.46l-3.867-2.9c-.29-.217-.434-.326-.486-.459a.5.5 0 0 1 0-.362c.052-.133.197-.242.486-.459l3.867-2.9c.412-.309.618-.463.79-.46a.5.5 0 0 1 .384.192c.106.136.106.393.106.908v5.8Z"
      }
    )
  );
};

var __defProp$2C = Object.defineProperty;
var __getOwnPropSymbols$2C = Object.getOwnPropertySymbols;
var __hasOwnProp$2C = Object.prototype.hasOwnProperty;
var __propIsEnum$2C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2C = (obj, key, value) => key in obj ? __defProp$2C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2C.call(b, prop))
      __defNormalProp$2C(a, prop, b[prop]);
  if (__getOwnPropSymbols$2C)
    for (var prop of __getOwnPropSymbols$2C(b)) {
      if (__propIsEnum$2C.call(b, prop))
        __defNormalProp$2C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2C)
    for (var prop of __getOwnPropSymbols$2C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMoreOptionsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2C(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20.531 1.5c-.388-.008-.691.163-.85.262-.165.1-.352.24-.533.377L15.23 5.077a5.679 5.679 0 0 0-.379.3 1.52 1.52 0 0 0-.417.58 1.5 1.5 0 0 0 0 1.087c.11.28.293.467.417.579.113.101.254.207.379.3l3.917 2.938c.181.136.368.276.532.377.16.099.463.27.851.262a1.5 1.5 0 0 0 1.15-.575c.24-.306.284-.651.302-.838.017-.192.017-.425.017-.652v-5.87c0-.227 0-.46-.017-.652-.018-.187-.063-.532-.302-.838a1.5 1.5 0 0 0-1.15-.575ZM3 3a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H3Zm0 5.25a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H3Zm-1 6.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"
      }
    )
  );
};

var __defProp$2B = Object.defineProperty;
var __getOwnPropSymbols$2B = Object.getOwnPropertySymbols;
var __hasOwnProp$2B = Object.prototype.hasOwnProperty;
var __propIsEnum$2B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2B = (obj, key, value) => key in obj ? __defProp$2B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2B.call(b, prop))
      __defNormalProp$2B(a, prop, b[prop]);
  if (__getOwnPropSymbols$2B)
    for (var prop of __getOwnPropSymbols$2B(b)) {
      if (__propIsEnum$2B.call(b, prop))
        __defNormalProp$2B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2B)
    for (var prop of __getOwnPropSymbols$2B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMultipleDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2B(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 16v2.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C9.52 22 10.08 22 11.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 8 19.92 8 18.8 8H16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 3.52 16 4.08 16 5.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 16 13.92 16 12.8 16H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.48 2 13.92 2 12.8V5.2Z"
      }
    )
  );
};

var __defProp$2A = Object.defineProperty;
var __getOwnPropSymbols$2A = Object.getOwnPropertySymbols;
var __hasOwnProp$2A = Object.prototype.hasOwnProperty;
var __propIsEnum$2A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2A = (obj, key, value) => key in obj ? __defProp$2A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2A.call(b, prop))
      __defNormalProp$2A(a, prop, b[prop]);
  if (__getOwnPropSymbols$2A)
    for (var prop of __getOwnPropSymbols$2A(b)) {
      if (__propIsEnum$2A.call(b, prop))
        __defNormalProp$2A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2A)
    for (var prop of __getOwnPropSymbols$2A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgMultipleSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2A(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.161 17h7.678c.527 0 .981 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V5.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C13.82 1 13.365 1 12.839 1H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 4.18 1 4.635 1 5.161v7.678c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.838 23h-7.677c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A15.193 15.193 0 0 1 7 19h5.88c.49 0 1.02 0 1.478-.037.519-.043 1.205-.148 1.912-.508a5 5 0 0 0 2.185-2.185c.36-.707.465-1.393.508-1.912.037-.459.037-.989.037-1.477V7c.459 0 .86.003 1.195.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v7.678c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031Z"
      }
    )
  );
};

var __defProp$2z = Object.defineProperty;
var __getOwnPropSymbols$2z = Object.getOwnPropertySymbols;
var __hasOwnProp$2z = Object.prototype.hasOwnProperty;
var __propIsEnum$2z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2z = (obj, key, value) => key in obj ? __defProp$2z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2z.call(b, prop))
      __defNormalProp$2z(a, prop, b[prop]);
  if (__getOwnPropSymbols$2z)
    for (var prop of __getOwnPropSymbols$2z(b)) {
      if (__propIsEnum$2z.call(b, prop))
        __defNormalProp$2z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2z)
    for (var prop of __getOwnPropSymbols$2z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgNetworkDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m8.59 13.51 6.83 3.98m-.01-10.98-6.82 3.98",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm12 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$2y = Object.defineProperty;
var __getOwnPropSymbols$2y = Object.getOwnPropertySymbols;
var __hasOwnProp$2y = Object.prototype.hasOwnProperty;
var __propIsEnum$2y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2y = (obj, key, value) => key in obj ? __defProp$2y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2y.call(b, prop))
      __defNormalProp$2y(a, prop, b[prop]);
  if (__getOwnPropSymbols$2y)
    for (var prop of __getOwnPropSymbols$2y(b)) {
      if (__propIsEnum$2y.call(b, prop))
        __defNormalProp$2y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2y)
    for (var prop of __getOwnPropSymbols$2y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgNetworkSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M14 5a4 4 0 1 1 1.158 2.815L9.85 10.912a4.003 4.003 0 0 1 0 2.175l5.311 3.095a4 4 0 1 1-1.01 1.726l-5.309-3.094a4 4 0 1 1 0-5.63L14.15 6.09A4.003 4.003 0 0 1 14 5Z"
      }
    )
  );
};

var __defProp$2x = Object.defineProperty;
var __getOwnPropSymbols$2x = Object.getOwnPropertySymbols;
var __hasOwnProp$2x = Object.prototype.hasOwnProperty;
var __propIsEnum$2x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2x = (obj, key, value) => key in obj ? __defProp$2x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2x.call(b, prop))
      __defNormalProp$2x(a, prop, b[prop]);
  if (__getOwnPropSymbols$2x)
    for (var prop of __getOwnPropSymbols$2x(b)) {
      if (__propIsEnum$2x.call(b, prop))
        __defNormalProp$2x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2x)
    for (var prop of __getOwnPropSymbols$2x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgNorthlightLogoXs = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2x(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("g", { fill: "#2A8BFB", clipPath: "url(#northlight-logo-xs_svg__a)" }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4.079 3.948c.047.824.085 1.65.113 2.475.036.62.064 1.238-.016 1.856a5.55 5.55 0 0 1-.098.62h-.032C3.87 8.08 3.88 7.25 3.933 6.422c.027-.826.065-1.65.113-2.475h.032Zm-1.692.222c.045 1.033.086 2.537.113 3.587.036.897.064 1.794-.015 2.69-.023.299-.052.598-.098.897h-.032c-.177-1.19-.167-2.39-.113-3.587.027-1.054.068-2.548.113-3.587h.032Zm10.149 0c.044 1.033.085 2.537.113 3.587.036.897.064 1.794-.016 2.69-.022.299-.051.598-.097.897h-.033c-.177-1.19-.167-2.39-.113-3.587.028-1.054.068-2.548.113-3.587h.033ZM5.77 2.093c.045.717.086 1.761.113 2.49.036.624.064 1.247-.016 1.87-.02.208-.053.416-.097.622h-.032c-.177-.823-.168-1.659-.114-2.491.028-.732.069-1.77.114-2.491h.032Zm1.691-.928c.048.76.086 1.521.114 2.282.035.571.064 1.142-.016 1.712a4.78 4.78 0 0 1-.098.57H7.43c-.176-.752-.167-1.519-.113-2.282.027-.76.064-1.521.113-2.282h.032Zm1.692 1.012c.048.779.085 1.557.113 2.337.036.585.064 1.169-.016 1.752-.02.197-.053.392-.097.584H9.12c-.176-.77-.167-1.555-.113-2.336a86.8 86.8 0 0 1 .113-2.337h.033Zm1.691 1.771c.048.824.086 1.65.113 2.475.036.62.064 1.238-.015 1.856a5.669 5.669 0 0 1-.098.62h-.032c-.177-.818-.167-1.649-.114-2.476.027-.826.065-1.65.114-2.475h.032ZM4.078 9.632c.048.57.086 1.141.114 1.713.054.573.062 1.153-.114 1.712h-.032c-.176-.559-.167-1.139-.113-1.712.027-.572.065-1.142.113-1.713h.032ZM5.77 7.778c.045.878.086 2.156.113 3.048.036.763.064 1.525-.015 2.287a8.315 8.315 0 0 1-.098.762h-.032c-.177-1.01-.167-2.03-.114-3.049.028-.896.069-2.165.114-3.048h.032Zm1.691-.928c.045 1.08.086 2.649.114 3.745.035.936.064 1.872-.016 2.808a12.43 12.43 0 0 1-.098.936H7.43c-.177-1.243-.167-2.495-.113-3.744.027-1.1.068-2.66.113-3.745h.032Zm1.692 1.03c.045.825.086 2.023.113 2.86.036.716.064 1.43-.016 2.145a7.33 7.33 0 0 1-.097.715H9.12c-.176-.946-.167-1.905-.113-2.86.028-.84.068-2.03.113-2.86h.033Zm1.691 1.752c.048.57.086 1.141.113 1.713.054.573.063 1.153-.113 1.712h-.032c-.176-.559-.168-1.139-.114-1.712a45.62 45.62 0 0 1 .114-1.713h.032ZM2.997 1.95l.084.147.155.08-.155.08-.084.146-.085-.146-.154-.08.154-.08.085-.146ZM.24 6.849l.084.146.154.08-.154.08-.085.146-.084-.146L0 7.075l.155-.08.084-.146ZM7.377 0l.084.146.155.08-.155.08-.084.146-.085-.146-.154-.08.154-.08L7.377 0Zm3.853 1.302.085.146.154.08-.154.08-.085.146-.084-.146-.155-.08.155-.08.084-.146Zm2.53 7.878.085.146.155.08-.155.08-.085.146-.084-.146-.155-.08.155-.08.085-.146ZM1.103 5.018a.118.118 0 0 1-.022.068.128.128 0 0 1-.058.045.137.137 0 0 1-.141-.027.117.117 0 0 1-.028-.134.124.124 0 0 1 .047-.055.135.135 0 0 1 .164.016.123.123 0 0 1 .038.087Zm4.088-3.264a.118.118 0 0 1-.022.069.128.128 0 0 1-.058.045.137.137 0 0 1-.141-.027.117.117 0 0 1-.028-.134.124.124 0 0 1 .047-.055.135.135 0 0 1 .164.016.123.123 0 0 1 .038.086ZM2.887 12.39a.118.118 0 0 1-.021.069.128.128 0 0 1-.059.045.137.137 0 0 1-.141-.026.117.117 0 0 1-.028-.134.124.124 0 0 1 .048-.055.135.135 0 0 1 .163.015.12.12 0 0 1 .038.087Zm3.713-.422c.071 0 .13-.055.13-.123a.126.126 0 0 0-.13-.123.126.126 0 0 0-.13.123c0 .068.058.123.13.123Zm1.936 2.909a.118.118 0 0 1-.022.069.13.13 0 0 1-.058.045.137.137 0 0 1-.142-.027.117.117 0 0 1-.028-.134.125.125 0 0 1 .048-.055.135.135 0 0 1 .164.016.122.122 0 0 1 .038.086Zm3.614-1.82a.119.119 0 0 1-.023.068.13.13 0 0 1-.058.046.137.137 0 0 1-.141-.027.117.117 0 0 1-.028-.134.125.125 0 0 1 .047-.055.135.135 0 0 1 .164.015.117.117 0 0 1 .038.087ZM6.6 7.424c.071 0 .13-.055.13-.123a.126.126 0 0 0-.13-.123.126.126 0 0 0-.13.123c0 .068.058.123.13.123Zm3.122-5.896a.118.118 0 0 1-.021.068.128.128 0 0 1-.059.046.137.137 0 0 1-.141-.027.117.117 0 0 1-.028-.134.125.125 0 0 1 .048-.055.135.135 0 0 1 .163.015.123.123 0 0 1 .038.087Zm3.93 4.324a.118.118 0 0 1-.022.068.129.129 0 0 1-.058.045.137.137 0 0 1-.141-.026.12.12 0 0 1-.036-.063.116.116 0 0 1 .008-.071.124.124 0 0 1 .047-.055.136.136 0 0 1 .164.015.12.12 0 0 1 .038.087Z" })),
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "northlight-logo-xs_svg__a" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M0 0h14v15H0z" })))
  );
};

var __defProp$2w = Object.defineProperty;
var __getOwnPropSymbols$2w = Object.getOwnPropertySymbols;
var __hasOwnProp$2w = Object.prototype.hasOwnProperty;
var __propIsEnum$2w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2w = (obj, key, value) => key in obj ? __defProp$2w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2w.call(b, prop))
      __defNormalProp$2w(a, prop, b[prop]);
  if (__getOwnPropSymbols$2w)
    for (var prop of __getOwnPropSymbols$2w(b)) {
      if (__propIsEnum$2w.call(b, prop))
        __defNormalProp$2w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2w)
    for (var prop of __getOwnPropSymbols$2w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgNorthlightLogo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2w(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2w({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      id: "northlight-logo_svg__Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 560.269 678.696",
      width: 24,
      height: 24,
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement(
      "linearGradient",
      {
        id: "northlight-logo_svg__linear-gradient",
        x1: 154.978,
        x2: 154.978,
        y1: -304.91,
        y2: 170.839,
        gradientTransform: "matrix(1 0 0 -.6402 0 283.818)",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement("stop", { offset: 0.474, stopColor: "#fff" }),
      /* @__PURE__ */ React__namespace.createElement("stop", { offset: 0.513, stopColor: "#f4f4f4" }),
      /* @__PURE__ */ React__namespace.createElement("stop", { offset: 0.581, stopColor: "#d5d5d5" }),
      /* @__PURE__ */ React__namespace.createElement("stop", { offset: 0.671, stopColor: "#a4a4a4" }),
      /* @__PURE__ */ React__namespace.createElement("stop", { offset: 0.78, stopColor: "#606060" }),
      /* @__PURE__ */ React__namespace.createElement("stop", { offset: 0.903, stopColor: "#0b0b0b" }),
      /* @__PURE__ */ React__namespace.createElement("stop", { offset: 0.918 })
    ), /* @__PURE__ */ React__namespace.createElement(
      "linearGradient",
      {
        xlinkHref: "#northlight-logo_svg__linear-gradient",
        id: "northlight-logo_svg__linear-gradient-2",
        x1: 94.978,
        x2: 94.978,
        y1: -397.066,
        y2: 123.127
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "linearGradient",
      {
        xlinkHref: "#northlight-logo_svg__linear-gradient",
        id: "northlight-logo_svg__linear-gradient-3",
        x1: 499.639,
        x2: 499.639,
        y1: -374.589,
        y2: 145.605
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "linearGradient",
      {
        xlinkHref: "#northlight-logo_svg__linear-gradient",
        id: "northlight-logo_svg__linear-gradient-4",
        x1: 241.978,
        x2: 241.978,
        y1: -178.391,
        y2: 297.358
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "linearGradient",
      {
        xlinkHref: "#northlight-logo_svg__linear-gradient",
        id: "northlight-logo_svg__linear-gradient-5",
        x1: 294.978,
        x2: 294.978,
        y1: -178.391,
        y2: 297.358
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "linearGradient",
      {
        xlinkHref: "#northlight-logo_svg__linear-gradient",
        id: "northlight-logo_svg__linear-gradient-7",
        x1: 436.978,
        x2: 436.978,
        y1: -318.968,
        y2: 156.782
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "northlight-logo_svg__mask",
        width: 477.053,
        height: 304.584,
        x: -83.548,
        y: 174.443,
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement(
        "path",
        {
          d: "M-83.548 174.443h477.053v304.584H-83.548z",
          style: {
            fill: "url(#northlight-logo_svg__linear-gradient)"
          }
        }
      )
    ), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "northlight-logo_svg__mask-2",
        width: 477.053,
        height: 333.038,
        x: -143.548,
        y: 204.989,
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement(
        "path",
        {
          d: "M-143.548 204.989h477.053v333.038h-477.053z",
          style: {
            fill: "url(#northlight-logo_svg__linear-gradient-2)"
          }
        }
      )
    ), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "northlight-logo_svg__mask-3",
        width: 477.053,
        height: 333.427,
        x: 261.113,
        y: 190.598,
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement(
        "path",
        {
          d: "M261.113 190.598h477.053v333.038H261.113z",
          style: {
            fill: "url(#northlight-logo_svg__linear-gradient-3)"
          }
        }
      )
    ), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "northlight-logo_svg__mask-4",
        width: 477.053,
        height: 304.584,
        x: 3.452,
        y: 93.443,
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement(
        "path",
        {
          d: "M3.452 93.443h477.053v304.584H3.452z",
          style: {
            fill: "url(#northlight-logo_svg__linear-gradient-4)"
          }
        }
      )
    ), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "northlight-logo_svg__mask-5",
        width: 477.053,
        height: 304.584,
        x: 56.452,
        y: 93.443,
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement(
        "path",
        {
          d: "M56.452 93.443h477.053v304.584H56.452z",
          style: {
            fill: "url(#northlight-logo_svg__linear-gradient-5)"
          }
        }
      )
    ), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "northlight-logo_svg__mask-7",
        width: 477.053,
        height: 304.584,
        x: 198.452,
        y: 183.443,
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement(
        "path",
        {
          d: "M198.452 183.443h477.053v304.584H198.452z",
          style: {
            fill: "url(#northlight-logo_svg__linear-gradient-7)"
          }
        }
      )
    ), /* @__PURE__ */ React__namespace.createElement("style", null, ".northlight-logo_svg__cls-8{fill:#fff}.northlight-logo_svg__cls-12{mask:url(#northlight-logo_svg__mask-5)}.northlight-logo_svg__cls-14{fill:#f1f2f2}")),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M163.208 211.131q2.872 52.337 4.532 104.718c1.433 26.208 2.561 52.384-.627 78.539a247.218 247.218 0 0 1-3.905 26.18h-1.295c-7.066-34.57-6.694-69.727-4.532-104.719q1.621-52.38 4.532-104.718Z",
        className: "northlight-logo_svg__cls-8",
        style: {
          mask: "url(#northlight-logo_svg__mask)"
        }
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M95.517 220.533c1.793 43.722 3.434 107.321 4.532 151.746 1.433 37.956 2.563 75.89-.626 113.81-.9 12.646-2.05 25.291-3.906 37.937h-1.294c-7.09-50.349-6.682-101.106-4.532-151.747 1.107-44.59 2.733-107.768 4.532-151.745h1.294Z",
        className: "northlight-logo_svg__cls-8",
        style: {
          mask: "url(#northlight-logo_svg__mask-2)"
        }
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M501.659 220.533c1.792 43.722 3.433 107.321 4.531 151.746 1.433 37.956 2.563 75.89-.626 113.81-.9 12.646-2.05 25.291-3.905 37.937h-1.295c-7.09-50.349-6.682-101.106-4.532-151.747 1.107-44.59 2.733-107.768 4.532-151.745h1.295Z",
        className: "northlight-logo_svg__cls-8",
        style: {
          mask: "url(#northlight-logo_svg__mask-3)"
        }
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M230.898 132.672c1.792 30.358 3.433 74.52 4.531 105.38 1.434 26.374 2.562 52.715-.626 79.036a250.253 250.253 0 0 1-3.905 26.346h-1.295c-7.067-34.794-6.694-70.17-4.531-105.381 1.107-30.976 2.733-74.846 4.531-105.38h1.295Z",
        className: "northlight-logo_svg__cls-8",
        style: {
          mask: "url(#northlight-logo_svg__mask-4)"
        }
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("g", { className: "northlight-logo_svg__cls-12" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M298.588 93.443q2.872 48.243 4.532 96.535c1.433 24.164 2.561 48.294-.626 72.401a211.336 211.336 0 0 1-3.906 24.134h-1.295c-7.058-31.815-6.698-64.264-4.531-96.535q1.62-48.291 4.531-96.535Z",
        className: "northlight-logo_svg__cls-8"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement("g", { className: "northlight-logo_svg__cls-12" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M366.278 136.234q2.872 49.403 4.532 98.85c1.434 24.742 2.561 49.451-.626 74.138a221.158 221.158 0 0 1-3.906 24.712h-1.295c-7.06-32.594-6.697-65.81-4.531-98.85q1.62-49.448 4.531-98.85Z",
        className: "northlight-logo_svg__cls-8"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M433.968 211.131q2.873 52.337 4.532 104.718c1.434 26.208 2.562 52.384-.626 78.539a247.218 247.218 0 0 1-3.906 26.18h-1.295c-7.065-34.57-6.693-69.727-4.531-104.719q1.621-52.38 4.531-104.718Z",
        className: "northlight-logo_svg__cls-8",
        style: {
          mask: "url(#northlight-logo_svg__mask-7)"
        }
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M163.208 451.623q2.87 36.188 4.532 72.44c2.165 24.268 2.503 48.798-4.532 72.44h-1.295c-7.035-23.643-6.696-48.171-4.53-72.44q1.62-36.251 4.53-72.44Zm67.69-78.459c1.792 37.159 3.434 91.213 4.532 128.976 1.433 32.268 2.563 64.509-.626 96.733-.9 10.748-2.05 21.496-3.906 32.244h-1.295c-7.082-42.718-6.685-85.915-4.531-128.977 1.107-37.903 2.733-91.6 4.532-128.975h1.294Zm67.69-39.23c1.792 45.64 3.434 112.027 4.532 158.399 1.432 39.618 2.563 79.215-.626 118.8-.9 13.2-2.05 26.399-3.906 39.6h-1.295c-7.092-52.576-6.68-105.544-4.531-158.4 1.107-46.544 2.733-112.492 4.532-158.397h1.294Zm67.69 43.59c1.792 34.855 3.434 85.559 4.532 120.983 1.433 30.27 2.563 60.513-.626 90.738-.9 10.083-2.05 20.164-3.906 30.246h-1.295c-7.077-40.035-6.687-80.582-4.531-120.984 1.107-35.556 2.733-85.924 4.532-120.982h1.294Zm67.69 74.099q2.87 36.188 4.532 72.44c2.165 24.268 2.503 48.798-4.532 72.44h-1.295c-7.035-23.643-6.697-48.17-4.53-72.44q1.62-36.251 4.53-72.44Z",
        className: "northlight-logo_svg__cls-8"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "m119.917 126.667 3.382 6.184 6.184 3.383-6.184 3.382-3.382 6.184-3.382-6.184-6.185-3.382 6.185-3.383 3.382-6.184zm-110.35 207.2 3.382 6.184 6.184 3.383-6.184 3.382L9.567 353l-3.383-6.184L0 343.434l6.184-3.383 3.383-6.184zM304.545 0l3.382 6.184 6.185 3.383-6.185 3.382-3.382 6.184-3.382-6.184-6.184-3.382 6.184-3.383L304.545 0zm144.894 99.227 3.383 6.185 6.184 3.382-6.184 3.382-3.383 6.185-3.382-6.185-6.184-3.382 6.184-3.382 3.382-6.185zm101.263 333.262 3.382 6.185 6.185 3.382-6.185 3.382-3.382 6.185-3.382-6.185-6.185-3.382 6.185-3.382 3.382-6.185zM44.167 256.402a5.192 5.192 0 1 1-5.192-5.192 5.192 5.192 0 0 1 5.192 5.192ZM207.75 118.36a5.192 5.192 0 1 1-5.192-5.192 5.192 5.192 0 0 1 5.192 5.193Zm-92.208 449.955a5.192 5.192 0 1 1-5.192-5.193 5.192 5.192 0 0 1 5.192 5.193Z",
        className: "northlight-logo_svg__cls-14"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "circle",
      {
        cx: 264.118,
        cy: 545.239,
        r: 5.192,
        className: "northlight-logo_svg__cls-14"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M341.592 673.503a5.192 5.192 0 1 1-5.193-5.192 5.192 5.192 0 0 1 5.193 5.192Zm144.61-77.001a5.192 5.192 0 1 1-5.192-5.192 5.192 5.192 0 0 1 5.192 5.192Z",
        className: "northlight-logo_svg__cls-14"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "circle",
      {
        cx: 264.118,
        cy: 353,
        r: 5.192,
        className: "northlight-logo_svg__cls-14"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M389.09 108.794a5.192 5.192 0 1 1-5.192-5.192 5.192 5.192 0 0 1 5.192 5.192Zm157.238 182.911a5.192 5.192 0 1 1-5.193-5.192 5.192 5.192 0 0 1 5.193 5.192Z",
        className: "northlight-logo_svg__cls-14"
      }
    )
  );
};

var __defProp$2v = Object.defineProperty;
var __getOwnPropSymbols$2v = Object.getOwnPropertySymbols;
var __hasOwnProp$2v = Object.prototype.hasOwnProperty;
var __propIsEnum$2v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2v = (obj, key, value) => key in obj ? __defProp$2v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2v.call(b, prop))
      __defNormalProp$2v(a, prop, b[prop]);
  if (__getOwnPropSymbols$2v)
    for (var prop of __getOwnPropSymbols$2v(b)) {
      if (__propIsEnum$2v.call(b, prop))
        __defNormalProp$2v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2v)
    for (var prop of __getOwnPropSymbols$2v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgOctocatW = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2v(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#fff",
        d: "M.24 12.288c0 1.066.101 2.03.3 2.892.2.861.475 1.613.828 2.249a6.368 6.368 0 0 0 1.347 1.68 7.749 7.749 0 0 0 1.77 1.185c.637.307 1.364.557 2.18.747.816.192 1.651.326 2.5.403.853.077 1.786.115 2.806.115 1.028 0 1.966-.038 2.818-.115a18.143 18.143 0 0 0 2.508-.403c.82-.192 1.55-.442 2.191-.747a7.74 7.74 0 0 0 1.783-1.185 6.316 6.316 0 0 0 1.356-1.68c.358-.636.634-1.385.836-2.25.199-.86.3-1.825.3-2.891 0-1.9-.636-3.547-1.908-4.935.07-.184.132-.393.19-.626a8.66 8.66 0 0 0 .16-1c.05-.435.031-.934-.058-1.5a7.929 7.929 0 0 0-.49-1.738l-.172-.034c-.122-.024-.324-.017-.605.017-.28.036-.605.103-.977.206s-.852.303-1.437.598c-.586.295-1.205.665-1.858 1.109-1.118-.308-2.657-.461-4.613-.461-1.946 0-3.48.153-4.6.46a15.961 15.961 0 0 0-1.87-1.108c-.595-.295-1.068-.495-1.42-.598a5.526 5.526 0 0 0-.99-.201c-.307-.032-.501-.041-.58-.03a1.007 1.007 0 0 0-.19.042c-.238.59-.4 1.168-.49 1.737-.088.567-.108 1.068-.057 1.5.05.435.103.766.16 1.001.058.235.12.442.19.626C.876 8.743.24 10.387.24 12.288Zm2.887 2.887c0-1.104.502-2.117 1.508-3.036a3.02 3.02 0 0 1 1.046-.626c.398-.142.85-.223 1.351-.243.502-.019.984-.014 1.443.012.46.027 1.027.063 1.701.108.675.046 1.258.07 1.747.07.49 0 1.073-.024 1.748-.07a175.24 175.24 0 0 1 1.701-.108 15.1 15.1 0 0 1 1.443-.012c.501.02.952.101 1.35.243.4.141.747.35 1.047.626 1.003.905 1.507 1.918 1.507 3.036 0 .66-.081 1.243-.247 1.755-.165.508-.377.938-.633 1.281-.257.346-.615.638-1.07.88-.457.243-.9.428-1.335.558-.435.13-.989.232-1.668.304-.68.073-1.284.118-1.817.133a76.33 76.33 0 0 1-2.03.024c-.821 0-1.498-.008-2.03-.024a23.32 23.32 0 0 1-1.818-.133c-.679-.072-1.233-.175-1.668-.304a7.458 7.458 0 0 1-1.334-.557c-.456-.243-.814-.535-1.07-.881a4.437 4.437 0 0 1-.634-1.281c-.166-.51-.238-1.095-.238-1.755Zm11.813-.23c0-1.217.658-2.206 1.469-2.206s1.469.986 1.469 2.206c0 1.216-.658 2.205-1.469 2.205s-1.469-.988-1.469-2.205Zm-8.82 0c0-1.217.658-2.206 1.469-2.206s1.469.986 1.469 2.206c0 1.216-.658 2.205-1.469 2.205s-1.469-.988-1.469-2.205Z"
      }
    )
  );
};

var __defProp$2u = Object.defineProperty;
var __getOwnPropSymbols$2u = Object.getOwnPropertySymbols;
var __hasOwnProp$2u = Object.prototype.hasOwnProperty;
var __propIsEnum$2u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2u = (obj, key, value) => key in obj ? __defProp$2u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2u.call(b, prop))
      __defNormalProp$2u(a, prop, b[prop]);
  if (__getOwnPropSymbols$2u)
    for (var prop of __getOwnPropSymbols$2u(b)) {
      if (__propIsEnum$2u.call(b, prop))
        __defNormalProp$2u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2u)
    for (var prop of __getOwnPropSymbols$2u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPaperDesignDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2u(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12.778 15 9 11.222",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 22c2 0 4.608.342 5.975-1.025a3.5 3.5 0 0 0-4.95-4.95C1.658 17.392 3.025 20 2 22Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 16c-.491-.491-.737-.737-.876-.994a2 2 0 0 1 .038-1.968c.148-.251.403-.488.913-.96l9.868-9.137a2.205 2.205 0 0 1 3.116 3.116l-9.137 9.868c-.473.51-.709.764-.96.913a2 2 0 0 1-1.968.038c-.257-.139-.503-.385-.994-.876Z"
      }
    )
  );
};

var __defProp$2t = Object.defineProperty;
var __getOwnPropSymbols$2t = Object.getOwnPropertySymbols;
var __hasOwnProp$2t = Object.prototype.hasOwnProperty;
var __propIsEnum$2t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2t = (obj, key, value) => key in obj ? __defProp$2t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2t.call(b, prop))
      __defNormalProp$2t(a, prop, b[prop]);
  if (__getOwnPropSymbols$2t)
    for (var prop of __getOwnPropSymbols$2t(b)) {
      if (__propIsEnum$2t.call(b, prop))
        __defNormalProp$2t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2t)
    for (var prop of __getOwnPropSymbols$2t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPaperDesignSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2t(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.264 2.208a3.204 3.204 0 0 1 4.528 4.528l-6.39 6.902c-.394.425-.591.638-.823.72a1 1 0 0 1-.633.013c-.235-.074-.44-.279-.85-.689l-2.778-2.778c-.41-.41-.615-.615-.689-.85a1 1 0 0 1 .013-.633c.082-.232.295-.429.72-.823l6.902-6.39Zm-8.502 9.968c-.41-.41-.616-.615-.86-.687a1.084 1.084 0 0 0-.655.031c-.237.095-.385.275-.681.635a2.956 2.956 0 0 0-.682 1.861 4.49 4.49 0 0 0-3.566 1.302c-1.031 1.031-.973 2.482-.934 3.471l.005.126c.045 1.112.078 1.933-.279 2.629A1 1 0 0 0 2 23c.272 0 .583.008.915.017.752.02 1.613.042 2.39-.02 1.144-.091 2.437-.375 3.377-1.315a4.49 4.49 0 0 0 1.302-3.566 2.946 2.946 0 0 0 1.861-.682c.36-.296.54-.444.635-.681.076-.192.09-.457.031-.654-.071-.245-.277-.45-.687-.861l-3.062-3.062Z"
      }
    )
  );
};

var __defProp$2s = Object.defineProperty;
var __getOwnPropSymbols$2s = Object.getOwnPropertySymbols;
var __hasOwnProp$2s = Object.prototype.hasOwnProperty;
var __propIsEnum$2s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2s = (obj, key, value) => key in obj ? __defProp$2s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2s.call(b, prop))
      __defNormalProp$2s(a, prop, b[prop]);
  if (__getOwnPropSymbols$2s)
    for (var prop of __getOwnPropSymbols$2s(b)) {
      if (__propIsEnum$2s.call(b, prop))
        __defNormalProp$2s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2s)
    for (var prop of __getOwnPropSymbols$2s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPasscodeLockDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2s(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 11V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 15 4.08 15 5.2 15H11m1-5h.005M17 10h.005M7 10h.005m5.245 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M19.25 17v-1.75a1.75 1.75 0 1 0-3.5 0V17m-.15 4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 17.76 14 18.04 14 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21Z"
      }
    )
  );
};

var __defProp$2r = Object.defineProperty;
var __getOwnPropSymbols$2r = Object.getOwnPropertySymbols;
var __hasOwnProp$2r = Object.prototype.hasOwnProperty;
var __propIsEnum$2r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2r = (obj, key, value) => key in obj ? __defProp$2r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2r.call(b, prop))
      __defNormalProp$2r(a, prop, b[prop]);
  if (__getOwnPropSymbols$2r)
    for (var prop of __getOwnPropSymbols$2r(b)) {
      if (__propIsEnum$2r.call(b, prop))
        __defNormalProp$2r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2r)
    for (var prop of __getOwnPropSymbols$2r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPasscodeLockSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2r(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5.161 4H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V11a1 1 0 1 1-2 0V8.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C19.75 6 19.377 6 18.8 6H5.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3 7.25 3 7.623 3 8.2v3.6c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C4.25 14 4.623 14 5.2 14H11a1 1 0 1 1 0 2H5.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 12.82 1 12.365 1 11.839V8.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 4 4.635 4 5.161 4Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5.75 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM12 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.75 15.25a2.75 2.75 0 1 1 5.5 0v.778c.203.024.43.074.658.19a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 19.93 13 19.684 13 19.432v-.864c0-.252 0-.498.017-.706a2.02 2.02 0 0 1 .201-.77 2 2 0 0 1 .874-.874 1.93 1.93 0 0 1 .658-.19v-.778Zm3.5 0V16h-1.5v-.75a.75.75 0 0 1 1.5 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2q = Object.defineProperty;
var __getOwnPropSymbols$2q = Object.getOwnPropertySymbols;
var __hasOwnProp$2q = Object.prototype.hasOwnProperty;
var __propIsEnum$2q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2q = (obj, key, value) => key in obj ? __defProp$2q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2q.call(b, prop))
      __defNormalProp$2q(a, prop, b[prop]);
  if (__getOwnPropSymbols$2q)
    for (var prop of __getOwnPropSymbols$2q(b)) {
      if (__propIsEnum$2q.call(b, prop))
        __defNormalProp$2q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2q)
    for (var prop of __getOwnPropSymbols$2q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPayeeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m19 21-3-3m0 0 3-3m-3 3h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
      }
    )
  );
};

var __defProp$2p = Object.defineProperty;
var __getOwnPropSymbols$2p = Object.getOwnPropertySymbols;
var __hasOwnProp$2p = Object.prototype.hasOwnProperty;
var __propIsEnum$2p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2p = (obj, key, value) => key in obj ? __defProp$2p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2p.call(b, prop))
      __defNormalProp$2p(a, prop, b[prop]);
  if (__getOwnPropSymbols$2p)
    for (var prop of __getOwnPropSymbols$2p(b)) {
      if (__propIsEnum$2p.call(b, prop))
        __defNormalProp$2p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2p)
    for (var prop of __getOwnPropSymbols$2p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPayeeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2p(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M19.707 15.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L18.414 19H22a1 1 0 1 0 0-2h-3.586l1.293-1.293Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.786 14.5h4.437c.12 0 .262 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.507 1.507 0 0 1-.153.571 1.5 1.5 0 0 1-.656.655 1.507 1.507 0 0 1-.571.154c-.125.01-.268.01-.387.01-2.877-.001-5.755-.015-8.632 0-.072 0-.215.001-.351-.023a1.5 1.5 0 0 1-1.217-1.216C.999 20.623 1 20.48 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076ZM4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2o = Object.defineProperty;
var __getOwnPropSymbols$2o = Object.getOwnPropertySymbols;
var __hasOwnProp$2o = Object.prototype.hasOwnProperty;
var __propIsEnum$2o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2o = (obj, key, value) => key in obj ? __defProp$2o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2o.call(b, prop))
      __defNormalProp$2o(a, prop, b[prop]);
  if (__getOwnPropSymbols$2o)
    for (var prop of __getOwnPropSymbols$2o(b)) {
      if (__propIsEnum$2o.call(b, prop))
        __defNormalProp$2o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2o)
    for (var prop of __getOwnPropSymbols$2o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPayorDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2o(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m19 21 3-3m0 0-3-3m3 3h-6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
      }
    )
  );
};

var __defProp$2n = Object.defineProperty;
var __getOwnPropSymbols$2n = Object.getOwnPropertySymbols;
var __hasOwnProp$2n = Object.prototype.hasOwnProperty;
var __propIsEnum$2n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2n = (obj, key, value) => key in obj ? __defProp$2n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2n.call(b, prop))
      __defNormalProp$2n(a, prop, b[prop]);
  if (__getOwnPropSymbols$2n)
    for (var prop of __getOwnPropSymbols$2n(b)) {
      if (__propIsEnum$2n.call(b, prop))
        __defNormalProp$2n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2n)
    for (var prop of __getOwnPropSymbols$2n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPayorSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2n(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M19.707 14.293a1 1 0 0 0-1.414 1.414L19.586 17H16a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.786 14.5h4.437c.12 0 .262 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.507 1.507 0 0 1-.153.571 1.5 1.5 0 0 1-.656.655 1.507 1.507 0 0 1-.571.154c-.125.01-.268.01-.387.01-2.877-.001-5.755-.015-8.632 0-.072 0-.215.001-.351-.023a1.5 1.5 0 0 1-1.217-1.216C.999 20.623 1 20.48 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076ZM4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2m = Object.defineProperty;
var __getOwnPropSymbols$2m = Object.getOwnPropertySymbols;
var __hasOwnProp$2m = Object.prototype.hasOwnProperty;
var __propIsEnum$2m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2m = (obj, key, value) => key in obj ? __defProp$2m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2m.call(b, prop))
      __defNormalProp$2m(a, prop, b[prop]);
  if (__getOwnPropSymbols$2m)
    for (var prop of __getOwnPropSymbols$2m(b)) {
      if (__propIsEnum$2m.call(b, prop))
        __defNormalProp$2m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2m)
    for (var prop of __getOwnPropSymbols$2m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPenDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2m(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 20h9",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 18.326c0-.49 0-.734.055-.965a2 2 0 0 1 .24-.578c.123-.201.296-.374.642-.72L16.5 3.5a2.121 2.121 0 0 1 3 3L6.937 19.063c-.346.346-.519.519-.72.642-.18.11-.374.19-.578.24-.23.055-.475.055-.964.055H3v-1.674Z"
      }
    )
  );
};

var __defProp$2l = Object.defineProperty;
var __getOwnPropSymbols$2l = Object.getOwnPropertySymbols;
var __hasOwnProp$2l = Object.prototype.hasOwnProperty;
var __propIsEnum$2l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2l = (obj, key, value) => key in obj ? __defProp$2l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2l.call(b, prop))
      __defNormalProp$2l(a, prop, b[prop]);
  if (__getOwnPropSymbols$2l)
    for (var prop of __getOwnPropSymbols$2l(b)) {
      if (__propIsEnum$2l.call(b, prop))
        __defNormalProp$2l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2l)
    for (var prop of __getOwnPropSymbols$2l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPenSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2l(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 20a1 1 0 0 1 1-1h9a1 1 0 0 1 0 2h-9a1 1 0 0 1-1-1Zm4.793-17.207a3.121 3.121 0 1 1 4.414 4.414L7.644 19.77l-.059.059c-.287.288-.54.542-.846.729a3 3 0 0 1-.867.36C5.523 21 5.165 21 4.758 21H3a1 1 0 0 1-1-1v-1.758c0-.407 0-.765.083-1.114a3 3 0 0 1 .36-.867c.186-.306.44-.56.728-.846l.06-.06L15.792 2.794Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2k = Object.defineProperty;
var __getOwnPropSymbols$2k = Object.getOwnPropertySymbols;
var __hasOwnProp$2k = Object.prototype.hasOwnProperty;
var __propIsEnum$2k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2k = (obj, key, value) => key in obj ? __defProp$2k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2k.call(b, prop))
      __defNormalProp$2k(a, prop, b[prop]);
  if (__getOwnPropSymbols$2k)
    for (var prop of __getOwnPropSymbols$2k(b)) {
      if (__propIsEnum$2k.call(b, prop))
        __defNormalProp$2k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2k)
    for (var prop of __getOwnPropSymbols$2k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPencilDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2k(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m18 2 4 4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6.68 20.724c.305-.084.458-.125.6-.19.127-.056.247-.126.36-.207.125-.092.237-.204.46-.428L18.435 9.566c.198-.198.297-.297.334-.412a.499.499 0 0 0 0-.309c-.037-.114-.136-.213-.334-.41l-2.868-2.87c-.198-.197-.297-.296-.412-.333a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334L4.1 15.899c-.224.224-.336.336-.428.462a2.001 2.001 0 0 0-.208.358c-.064.143-.105.296-.189.6L2 22l4.68-1.276Z"
      }
    )
  );
};

var __defProp$2j = Object.defineProperty;
var __getOwnPropSymbols$2j = Object.getOwnPropertySymbols;
var __hasOwnProp$2j = Object.prototype.hasOwnProperty;
var __propIsEnum$2j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2j = (obj, key, value) => key in obj ? __defProp$2j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2j.call(b, prop))
      __defNormalProp$2j(a, prop, b[prop]);
  if (__getOwnPropSymbols$2j)
    for (var prop of __getOwnPropSymbols$2j(b)) {
      if (__propIsEnum$2j.call(b, prop))
        __defNormalProp$2j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2j)
    for (var prop of __getOwnPropSymbols$2j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPencilSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2j(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.707 1.293a1 1 0 1 0-1.414 1.414l4 4a1 1 0 1 0 1.414-1.414l-4-4Zm-4.17 2.987a1.5 1.5 0 0 1 .926 0c.233.076.402.202.513.296.096.081.196.182.28.266l2.902 2.901c.084.085.185.185.266.281.094.111.22.28.296.512a1.5 1.5 0 0 1 0 .927 1.508 1.508 0 0 1-.296.513c-.081.096-.182.196-.266.28L8.77 20.644a4.486 4.486 0 0 1-.542.49 3.004 3.004 0 0 1-.538.313c-.215.097-.44.158-.695.227l-4.732 1.29a1 1 0 0 1-1.228-1.227l1.29-4.732c.07-.255.131-.48.228-.695a3 3 0 0 1 .312-.538c.14-.19.304-.356.491-.542L13.744 4.842c.084-.084.184-.185.28-.266.111-.094.28-.22.513-.296Z"
      }
    )
  );
};

var __defProp$2i = Object.defineProperty;
var __getOwnPropSymbols$2i = Object.getOwnPropertySymbols;
var __hasOwnProp$2i = Object.prototype.hasOwnProperty;
var __propIsEnum$2i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2i = (obj, key, value) => key in obj ? __defProp$2i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2i.call(b, prop))
      __defNormalProp$2i(a, prop, b[prop]);
  if (__getOwnPropSymbols$2i)
    for (var prop of __getOwnPropSymbols$2i(b)) {
      if (__propIsEnum$2i.call(b, prop))
        __defNormalProp$2i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2i)
    for (var prop of __getOwnPropSymbols$2i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPinDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2i(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15v7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6.878 4.194c-.294-.735-.441-1.102-.38-1.397a1 1 0 0 1 .427-.63C7.175 2 7.572 2 8.363 2h7.274c.791 0 1.187 0 1.439.167a1 1 0 0 1 .426.63c.061.295-.086.662-.38 1.397l-1.008 2.52c-.042.107-.064.16-.079.215a.997.997 0 0 0-.029.15c-.006.056-.006.114-.006.23v2.13c0 .208 0 .312.02.411a1 1 0 0 0 .09.254c.046.09.11.172.24.334l1.57 1.962c.666.833.999 1.249 1 1.599a1 1 0 0 1-.377.782c-.273.219-.806.219-1.872.219H7.329c-1.066 0-1.599 0-1.872-.219A1 1 0 0 1 5.08 14c0-.35.333-.766.999-1.599l1.57-1.962a2.03 2.03 0 0 0 .24-.334.985.985 0 0 0 .09-.254c.02-.1.02-.203.02-.411V7.31c0-.116 0-.174-.007-.23a1 1 0 0 0-.028-.15c-.015-.055-.037-.108-.08-.215l-1.007-2.52Z"
      }
    )
  );
};

var __defProp$2h = Object.defineProperty;
var __getOwnPropSymbols$2h = Object.getOwnPropertySymbols;
var __hasOwnProp$2h = Object.prototype.hasOwnProperty;
var __propIsEnum$2h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2h = (obj, key, value) => key in obj ? __defProp$2h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2h.call(b, prop))
      __defNormalProp$2h(a, prop, b[prop]);
  if (__getOwnPropSymbols$2h)
    for (var prop of __getOwnPropSymbols$2h(b)) {
      if (__propIsEnum$2h.call(b, prop))
        __defNormalProp$2h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2h)
    for (var prop of __getOwnPropSymbols$2h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPinSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.324 1c-.362 0-.698 0-.973.025-.288.026-.647.088-.979.308a2 2 0 0 0-.853 1.26c-.081.39-.005.746.077 1.023.08.265.204.577.338.913l1.023 2.556c.014.035.035.073.042.11L7 7.307v2.13c0 .07.001.14-.002.21l-.002.003a6.053 6.053 0 0 1-.127.163L5.27 11.81c-.31.387-.583.729-.775 1.019-.187.283-.415.684-.415 1.169a2 2 0 0 0 .752 1.565c.379.302.834.375 1.172.406.347.031.785.031 1.28.031H11v6a1 1 0 1 0 2 0v-6h3.715c.495 0 .933 0 1.28-.031.338-.031.793-.104 1.172-.406a2 2 0 0 0 .752-1.565c0-.485-.228-.886-.415-1.169-.192-.29-.466-.632-.775-1.019l-1.598-1.996c-.043-.055-.088-.11-.13-.165v-.003A5.995 5.995 0 0 1 17 9.439V7.193l.043-.108 1.023-2.556c.134-.336.259-.648.338-.913.082-.277.158-.633.077-1.023a2 2 0 0 0-.853-1.26c-.332-.22-.69-.282-.979-.308C16.374 1 16.038 1 15.676 1H8.324Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2g = Object.defineProperty;
var __getOwnPropSymbols$2g = Object.getOwnPropertySymbols;
var __hasOwnProp$2g = Object.prototype.hasOwnProperty;
var __propIsEnum$2g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2g = (obj, key, value) => key in obj ? __defProp$2g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2g.call(b, prop))
      __defNormalProp$2g(a, prop, b[prop]);
  if (__getOwnPropSymbols$2g)
    for (var prop of __getOwnPropSymbols$2g(b)) {
      if (__propIsEnum$2g.call(b, prop))
        __defNormalProp$2g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2g)
    for (var prop of __getOwnPropSymbols$2g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlaySquareDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9.5 8.965c0-.477 0-.716.1-.849a.5.5 0 0 1 .364-.199c.166-.012.367.117.769.375l4.72 3.035c.349.224.523.336.583.478a.5.5 0 0 1 0 .39c-.06.142-.234.254-.583.478l-4.72 3.035c-.402.258-.603.387-.769.375a.5.5 0 0 1-.364-.2c-.1-.132-.1-.371-.1-.848v-6.07Z"
      }
    )
  );
};

var __defProp$2f = Object.defineProperty;
var __getOwnPropSymbols$2f = Object.getOwnPropertySymbols;
var __hasOwnProp$2f = Object.prototype.hasOwnProperty;
var __propIsEnum$2f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2f = (obj, key, value) => key in obj ? __defProp$2f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2f.call(b, prop))
      __defNormalProp$2f(a, prop, b[prop]);
  if (__getOwnPropSymbols$2f)
    for (var prop of __getOwnPropSymbols$2f(b)) {
      if (__propIsEnum$2f.call(b, prop))
        __defNormalProp$2f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2f)
    for (var prop of __getOwnPropSymbols$2f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlaySquareSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.838 2H6.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.838 2ZM9.6 8.116c-.1.133-.1.372-.1.85v6.069c0 .477 0 .716.1.849a.5.5 0 0 0 .364.199c.166.012.367-.117.769-.375l4.72-3.035c.349-.224.523-.336.583-.479a.5.5 0 0 0 0-.389c-.06-.142-.234-.254-.583-.478l-4.72-3.035c-.402-.258-.603-.387-.769-.375a.5.5 0 0 0-.364.2Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2e = Object.defineProperty;
var __getOwnPropSymbols$2e = Object.getOwnPropertySymbols;
var __hasOwnProp$2e = Object.prototype.hasOwnProperty;
var __propIsEnum$2e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2e = (obj, key, value) => key in obj ? __defProp$2e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2e.call(b, prop))
      __defNormalProp$2e(a, prop, b[prop]);
  if (__getOwnPropSymbols$2e)
    for (var prop of __getOwnPropSymbols$2e(b)) {
      if (__propIsEnum$2e.call(b, prop))
        __defNormalProp$2e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2e)
    for (var prop of __getOwnPropSymbols$2e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlugDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 12h10",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 17H7A5 5 0 0 1 7 7h2m6.778 10H17a5 5 0 0 0 0-10h-1.222a.778.778 0 0 0-.778.778v8.444c0 .43.348.778.778.778Z"
      }
    )
  );
};

var __defProp$2d = Object.defineProperty;
var __getOwnPropSymbols$2d = Object.getOwnPropertySymbols;
var __hasOwnProp$2d = Object.prototype.hasOwnProperty;
var __propIsEnum$2d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2d = (obj, key, value) => key in obj ? __defProp$2d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2d.call(b, prop))
      __defNormalProp$2d(a, prop, b[prop]);
  if (__getOwnPropSymbols$2d)
    for (var prop of __getOwnPropSymbols$2d(b)) {
      if (__propIsEnum$2d.call(b, prop))
        __defNormalProp$2d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2d)
    for (var prop of __getOwnPropSymbols$2d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlugSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M7 8a4 4 0 1 0 0 8h2a1 1 0 1 1 0 2H7A6 6 0 0 1 7 6h2a1 1 0 0 1 0 2H7Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 12a1 1 0 0 1 1-1h6V7.778C14 6.796 14.796 6 15.778 6H17a6 6 0 0 1 0 12h-1.222A1.778 1.778 0 0 1 14 16.222V13H8a1 1 0 0 1-1-1Zm9 1v3h1a4 4 0 0 0 0-8h-1v3h2a1 1 0 1 1 0 2h-2Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$2c = Object.defineProperty;
var __getOwnPropSymbols$2c = Object.getOwnPropertySymbols;
var __hasOwnProp$2c = Object.prototype.hasOwnProperty;
var __propIsEnum$2c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2c = (obj, key, value) => key in obj ? __defProp$2c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2c.call(b, prop))
      __defNormalProp$2c(a, prop, b[prop]);
  if (__getOwnPropSymbols$2c)
    for (var prop of __getOwnPropSymbols$2c(b)) {
      if (__propIsEnum$2c.call(b, prop))
        __defNormalProp$2c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2c)
    for (var prop of __getOwnPropSymbols$2c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlusDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 5v14m-7-7h14"
      }
    )
  );
};

var __defProp$2b = Object.defineProperty;
var __getOwnPropSymbols$2b = Object.getOwnPropertySymbols;
var __hasOwnProp$2b = Object.prototype.hasOwnProperty;
var __propIsEnum$2b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2b = (obj, key, value) => key in obj ? __defProp$2b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2b.call(b, prop))
      __defNormalProp$2b(a, prop, b[prop]);
  if (__getOwnPropSymbols$2b)
    for (var prop of __getOwnPropSymbols$2b(b)) {
      if (__propIsEnum$2b.call(b, prop))
        __defNormalProp$2b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2b)
    for (var prop of __getOwnPropSymbols$2b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlusSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5Z"
      }
    )
  );
};

var __defProp$2a = Object.defineProperty;
var __getOwnPropSymbols$2a = Object.getOwnPropertySymbols;
var __hasOwnProp$2a = Object.prototype.hasOwnProperty;
var __propIsEnum$2a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2a = (obj, key, value) => key in obj ? __defProp$2a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2a.call(b, prop))
      __defNormalProp$2a(a, prop, b[prop]);
  if (__getOwnPropSymbols$2a)
    for (var prop of __getOwnPropSymbols$2a(b)) {
      if (__propIsEnum$2a.call(b, prop))
        __defNormalProp$2a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2a)
    for (var prop of __getOwnPropSymbols$2a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlusSquareDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 8v8m-4-4h8M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
      }
    )
  );
};

var __defProp$29 = Object.defineProperty;
var __getOwnPropSymbols$29 = Object.getOwnPropertySymbols;
var __hasOwnProp$29 = Object.prototype.hasOwnProperty;
var __propIsEnum$29 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$29 = (obj, key, value) => key in obj ? __defProp$29(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$29 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$29.call(b, prop))
      __defNormalProp$29(a, prop, b[prop]);
  if (__getOwnPropSymbols$29)
    for (var prop of __getOwnPropSymbols$29(b)) {
      if (__propIsEnum$29.call(b, prop))
        __defNormalProp$29(a, prop, b[prop]);
    }
  return a;
};
var __objRest$29 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$29.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$29)
    for (var prop of __getOwnPropSymbols$29(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$29.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlusSquareSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$29(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$29({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.838 2H6.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.838 2ZM12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$28 = Object.defineProperty;
var __getOwnPropSymbols$28 = Object.getOwnPropertySymbols;
var __hasOwnProp$28 = Object.prototype.hasOwnProperty;
var __propIsEnum$28 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$28 = (obj, key, value) => key in obj ? __defProp$28(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$28 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$28.call(b, prop))
      __defNormalProp$28(a, prop, b[prop]);
  if (__getOwnPropSymbols$28)
    for (var prop of __getOwnPropSymbols$28(b)) {
      if (__propIsEnum$28.call(b, prop))
        __defNormalProp$28(a, prop, b[prop]);
    }
  return a;
};
var __objRest$28 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$28.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$28)
    for (var prop of __getOwnPropSymbols$28(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$28.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPositionMarkerDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$28(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$28({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 13.374c3.532.695 6 2.28 6 4.126 0 2.485-4.477 4.5-10 4.5S2 19.985 2 17.5c0-1.845 2.468-3.431 6-4.126",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 17V3l5.318 3.272c.388.24.581.358.643.509a.5.5 0 0 1-.011.407c-.07.146-.271.254-.672.47L12 10.5"
      }
    )
  );
};

var __defProp$27 = Object.defineProperty;
var __getOwnPropSymbols$27 = Object.getOwnPropertySymbols;
var __hasOwnProp$27 = Object.prototype.hasOwnProperty;
var __propIsEnum$27 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$27 = (obj, key, value) => key in obj ? __defProp$27(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$27 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$27.call(b, prop))
      __defNormalProp$27(a, prop, b[prop]);
  if (__getOwnPropSymbols$27)
    for (var prop of __getOwnPropSymbols$27(b)) {
      if (__propIsEnum$27.call(b, prop))
        __defNormalProp$27(a, prop, b[prop]);
    }
  return a;
};
var __objRest$27 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$27.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$27)
    for (var prop of __getOwnPropSymbols$27(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$27.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPositionMarkerSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$27(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$27({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.004 2a.997.997 0 0 1 .539.16l5.327 3.278c.169.104.35.215.492.322.145.109.388.31.524.64a1.5 1.5 0 0 1-.035 1.221 1.542 1.542 0 0 1-.56.61 6.81 6.81 0 0 1-.51.292L13 11.097V17a1 1 0 1 1-2 0V3.015a.996.996 0 0 1 .231-.654A1 1 0 0 1 12 2h.004Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8.193 14.355a1 1 0 1 0-.386-1.962c-1.85.364-3.488.972-4.69 1.783C1.935 14.973 1 16.095 1 17.5c0 1.881 1.646 3.251 3.519 4.094C6.485 22.478 9.13 23 12 23s5.515-.522 7.481-1.406C21.354 20.75 23 19.38 23 17.5c0-1.405-.936-2.527-2.116-3.324-1.203-.81-2.84-1.42-4.691-1.783a1 1 0 0 0-.386 1.962c1.682.331 3.044.863 3.958 1.48.937.63 1.235 1.225 1.235 1.665 0 .604-.592 1.484-2.34 2.27C17.009 20.514 14.654 21 12 21s-5.008-.486-6.66-1.23C3.591 18.984 3 18.104 3 17.5c0-.44.298-1.034 1.235-1.665.914-.617 2.276-1.149 3.958-1.48Z"
      }
    )
  );
};

var __defProp$26 = Object.defineProperty;
var __getOwnPropSymbols$26 = Object.getOwnPropertySymbols;
var __hasOwnProp$26 = Object.prototype.hasOwnProperty;
var __propIsEnum$26 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$26 = (obj, key, value) => key in obj ? __defProp$26(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$26 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$26.call(b, prop))
      __defNormalProp$26(a, prop, b[prop]);
  if (__getOwnPropSymbols$26)
    for (var prop of __getOwnPropSymbols$26(b)) {
      if (__propIsEnum$26.call(b, prop))
        __defNormalProp$26(a, prop, b[prop]);
    }
  return a;
};
var __objRest$26 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$26.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$26)
    for (var prop of __getOwnPropSymbols$26(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$26.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPrincipleshfeatured = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$26(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$26({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("g", { clipPath: "url(#principleshfeatured_svg__a)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#2A8BFB",
        strokeWidth: 0.3,
        d: "M20 2.667c-1.3 0-1.95.666-3.25.666s-1.95-.666-3.25-.666-1.95.666-3.25.666S8.3 2.667 7 2.667"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement("g", { clipPath: "url(#principleshfeatured_svg__b)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#EAEAEA",
        strokeWidth: 0.3,
        d: "M20 4.667c-1.3 0-1.95.666-3.25.666s-1.95-.666-3.25-.666-1.95.666-3.25.666S8.3 4.667 7 4.667"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement("g", { clipPath: "url(#principleshfeatured_svg__c)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeWidth: 0.3,
        d: "M20 7.667c-1.3 0-1.95.666-3.25.666s-1.95-.666-3.25-.666-1.95.666-3.25.666S8.3 7.667 7 7.667"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement("g", { clipPath: "url(#principleshfeatured_svg__d)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#EAEAEA",
        strokeWidth: 0.3,
        d: "M20 9.667c-1.3 0-1.95.666-3.25.666s-1.95-.666-3.25-.666-1.95.666-3.25.666S8.3 9.667 7 9.667"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#FF9694",
        fillRule: "evenodd",
        d: "M4 7.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm.618 1.215a.167.167 0 0 1 0 .236L4.236 9l.382.382a.167.167 0 0 1-.236.236L4 9.236l-.382.382a.167.167 0 0 1-.236-.236L3.765 9l-.383-.382a.167.167 0 0 1 .236-.236L4 8.764l.382-.382a.167.167 0 0 1 .236 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#2A8BFB",
        fillRule: "evenodd",
        d: "M4 2.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm.868 1.45a.167.167 0 0 0-.236-.235l-.882.882-.382-.382a.167.167 0 0 0-.236.236l.5.5a.167.167 0 0 0 .236 0l1-1Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "principleshfeatured_svg__a" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 4V2H7v2z" })), /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "principleshfeatured_svg__b" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 6V4H7v2z" })), /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "principleshfeatured_svg__c" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 9V7H7v2z" })), /* @__PURE__ */ React__namespace.createElement("clipPath", { id: "principleshfeatured_svg__d" }, /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 11V9H7v2z" })))
  );
};

var __defProp$25 = Object.defineProperty;
var __getOwnPropSymbols$25 = Object.getOwnPropertySymbols;
var __hasOwnProp$25 = Object.prototype.hasOwnProperty;
var __propIsEnum$25 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$25 = (obj, key, value) => key in obj ? __defProp$25(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$25 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$25.call(b, prop))
      __defNormalProp$25(a, prop, b[prop]);
  if (__getOwnPropSymbols$25)
    for (var prop of __getOwnPropSymbols$25(b)) {
      if (__propIsEnum$25.call(b, prop))
        __defNormalProp$25(a, prop, b[prop]);
    }
  return a;
};
var __objRest$25 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$25.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$25)
    for (var prop of __getOwnPropSymbols$25(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$25.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPrincipleshfeaturedcs = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$25(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$25({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("g", { opacity: 0.2 }, /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "principleshfeaturedcs_svg__a",
        width: 13,
        height: 2,
        x: 7,
        y: 2,
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "luminance"
        }
      },
      /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 2v2H7V2h13Z" })
    ), /* @__PURE__ */ React__namespace.createElement("g", { mask: "url(#principleshfeaturedcs_svg__a)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#2A8BFB",
        strokeWidth: 0.3,
        d: "M20 2.667c-1.3 0-1.95.666-3.25.666s-1.95-.667-3.25-.667-1.95.667-3.25.667S8.3 2.666 7 2.666"
      }
    )), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "principleshfeaturedcs_svg__b",
        width: 13,
        height: 2,
        x: 7,
        y: 4,
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "luminance"
        }
      },
      /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 4v2H7V4h13Z" })
    ), /* @__PURE__ */ React__namespace.createElement("g", { mask: "url(#principleshfeaturedcs_svg__b)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#EAEAEA",
        strokeWidth: 0.3,
        d: "M20 4.667c-1.3 0-1.95.666-3.25.666s-1.95-.667-3.25-.667-1.95.667-3.25.667S8.3 4.666 7 4.666"
      }
    )), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "principleshfeaturedcs_svg__c",
        width: 13,
        height: 2,
        x: 7,
        y: 7,
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "luminance"
        }
      },
      /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 7v2H7V7h13Z" })
    ), /* @__PURE__ */ React__namespace.createElement("g", { mask: "url(#principleshfeaturedcs_svg__c)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeWidth: 0.3,
        d: "M20 7.667c-1.3 0-1.95.666-3.25.666s-1.95-.667-3.25-.667-1.95.667-3.25.667S8.3 7.666 7 7.666"
      }
    )), /* @__PURE__ */ React__namespace.createElement(
      "mask",
      {
        id: "principleshfeaturedcs_svg__d",
        width: 13,
        height: 2,
        x: 7,
        y: 9,
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "luminance"
        }
      },
      /* @__PURE__ */ React__namespace.createElement("path", { fill: "#fff", d: "M20 9v2H7V9h13Z" })
    ), /* @__PURE__ */ React__namespace.createElement("g", { mask: "url(#principleshfeaturedcs_svg__d)" }, /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "#EAEAEA",
        strokeWidth: 0.3,
        d: "M20 9.666c-1.3 0-1.95.667-3.25.667s-1.95-.667-3.25-.667-1.95.667-3.25.667S8.3 9.666 7 9.666"
      }
    )), /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#FF9694",
        fillRule: "evenodd",
        d: "M4 7.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm.618 1.215a.167.167 0 0 1 0 .236L4.236 9l.382.382a.167.167 0 0 1-.236.236L4 9.236l-.382.382a.167.167 0 0 1-.236-.236L3.765 9l-.383-.382a.167.167 0 0 1 .236-.236L4 8.764l.382-.382a.167.167 0 0 1 .236 0Z",
        clipRule: "evenodd"
      }
    ), /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#2A8BFB",
        fillRule: "evenodd",
        d: "M4 2.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm.868 1.45a.167.167 0 0 0-.236-.235l-.882.882-.382-.382a.167.167 0 0 0-.236.236l.5.5a.167.167 0 0 0 .236 0l1-1Z",
        clipRule: "evenodd"
      }
    )),
    /* @__PURE__ */ React__namespace.createElement(
      "rect",
      {
        width: 16,
        height: 3,
        x: 3,
        y: 4.5,
        fill: "#BFBFBF",
        fillOpacity: 0.2,
        rx: 0.3
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m4.532 5.8.057.116-.362.178v.007l.362.184-.057.119-.477-.254v-.108l.477-.243Zm1.824 0 .477.242v.108l-.477.254-.057-.119.362-.184v-.007l-.362-.178.057-.117Zm1.112.058a.624.624 0 0 0-.133-.023.215.215 0 0 0-.174.072.315.315 0 0 0-.06.208c0 .091.02.161.061.21.042.05.1.075.173.075a.231.231 0 0 0 .061-.008.93.93 0 0 0 .072-.023l.027-.113.126.028-.039.185-.03.014a.537.537 0 0 1-.422-.001.324.324 0 0 1-.137-.137.484.484 0 0 1-.049-.23c0-.085.016-.158.048-.218a.33.33 0 0 1 .137-.14.414.414 0 0 1 .205-.049.482.482 0 0 1 .224.05l.028.017.037.183-.128.029-.027-.13Zm.553.036c.065 0 .12.013.167.038a.251.251 0 0 1 .105.11.363.363 0 0 1 .037.168.316.316 0 0 1-.082.231.3.3 0 0 1-.227.084.336.336 0 0 1-.163-.038.255.255 0 0 1-.104-.108.38.38 0 0 1-.035-.169c0-.066.011-.122.035-.169a.253.253 0 0 1 .104-.11.336.336 0 0 1 .163-.037Zm0 .121c-.052 0-.091.017-.118.05a.23.23 0 0 0-.039.145.23.23 0 0 0 .04.146c.026.034.065.05.117.05.054 0 .094-.016.121-.05a.23.23 0 0 0 .04-.146c0-.063-.013-.111-.04-.144-.027-.034-.067-.05-.12-.05Zm.396.485v-.118h.108v-.32l-.124-.04.04-.119.184.06a.298.298 0 0 1 .191-.069c.035 0 .068.006.099.018.03.013.056.03.075.055a.371.371 0 0 1 .088-.052.275.275 0 0 1 .106-.02c.081 0 .14.019.177.058.036.039.054.104.054.195v.234h.11V6.5h-.309v-.118h.051v-.226c0-.049-.008-.083-.023-.103-.016-.021-.043-.031-.081-.031a.178.178 0 0 0-.064.013.182.182 0 0 0-.054.03v.317h.05V6.5h-.25v-.118h.051v-.226c0-.049-.007-.083-.023-.103-.015-.021-.042-.031-.08-.031a.178.178 0 0 0-.064.013.201.201 0 0 0-.056.03v.317h.053V6.5h-.31Zm1.193-.581h.257v.463h.108V6.5H9.61v-.118h.108v-.346H9.61v-.117Zm.169-.282c.027 0 .049.008.065.025a.088.088 0 0 1 .025.064.088.088 0 0 1-.025.066.088.088 0 0 1-.065.024.088.088 0 0 1-.065-.024.09.09 0 0 1-.023-.066.09.09 0 0 1 .023-.064.088.088 0 0 1 .065-.025Zm.286.863v-.118h.11v-.316l-.125-.043.038-.118.18.062a.504.504 0 0 1 .103-.053.351.351 0 0 1 .124-.02.24.24 0 0 1 .13.031c.034.021.059.05.074.088a.3.3 0 0 1 .025.124v.245h.108V6.5h-.31v-.118h.055v-.225a.155.155 0 0 0-.027-.098c-.019-.024-.049-.036-.09-.036a.261.261 0 0 0-.138.044v.315h.053V6.5h-.31Zm1.12-.15a.334.334 0 0 1-.205-.055.193.193 0 0 1-.073-.162c0-.073.025-.131.076-.174a.305.305 0 0 1 .204-.065c.033 0 .062.003.087.008.025.005.05.014.073.027l.196-.069.045.13-.158.024a.12.12 0 0 1 .03.054.25.25 0 0 1 .007.059.202.202 0 0 1-.039.129.218.218 0 0 1-.102.072.425.425 0 0 1-.14.022Zm.01.463a.665.665 0 0 1-.298-.066l.053-.116c.04.018.081.031.121.04a.493.493 0 0 0 .217.006.094.094 0 0 0 .05-.026.049.049 0 0 0 .014-.034.054.054 0 0 0-.021-.044c-.014-.011-.042-.017-.085-.017h-.204v-.254l.117.026v.106h.106c.077 0 .134.016.173.048a.163.163 0 0 1 .057.134.158.158 0 0 1-.04.113.227.227 0 0 1-.11.064.506.506 0 0 1-.15.02Zm-.007-.573c.044 0 .079-.01.104-.031a.105.105 0 0 0 .038-.083c0-.04-.013-.069-.038-.089a.155.155 0 0 0-.104-.031.16.16 0 0 0-.105.031.11.11 0 0 0-.037.089c0 .033.013.061.038.083.025.02.06.031.104.031Zm1.102.286a.776.776 0 0 1-.286-.05l-.024-.178.122-.014.015.095a.47.47 0 0 0 .253.014.158.158 0 0 0 .067-.037.09.09 0 0 0 .024-.065.103.103 0 0 0-.026-.07c-.016-.02-.051-.035-.105-.043l-.094-.016a.351.351 0 0 1-.179-.078.193.193 0 0 1-.062-.15c0-.049.013-.09.04-.124a.239.239 0 0 1 .11-.076.436.436 0 0 1 .154-.026.68.68 0 0 1 .165.021.556.556 0 0 1 .078.027l.025.191-.132.015-.017-.117a.403.403 0 0 0-.125-.02.23.23 0 0 0-.12.028c-.029.017-.043.04-.043.071 0 .03.01.054.031.072a.252.252 0 0 0 .105.037l.098.016c.084.013.144.038.18.077a.202.202 0 0 1 .053.145c0 .05-.01.092-.03.125a.21.21 0 0 1-.072.078.307.307 0 0 1-.1.04.502.502 0 0 1-.105.012Zm.718-.632c.065 0 .12.013.167.038a.252.252 0 0 1 .105.11.363.363 0 0 1 .036.168.316.316 0 0 1-.082.231.3.3 0 0 1-.226.084.336.336 0 0 1-.164-.038.255.255 0 0 1-.104-.108.38.38 0 0 1-.035-.169.38.38 0 0 1 .035-.169.253.253 0 0 1 .104-.11.336.336 0 0 1 .164-.037Zm0 .121c-.052 0-.091.017-.118.05a.23.23 0 0 0-.04.145c0 .063.014.112.04.146.027.034.066.05.118.05.054 0 .094-.016.121-.05a.23.23 0 0 0 .04-.146c0-.063-.013-.111-.04-.144-.027-.034-.067-.05-.12-.05Zm.721-.12c.065 0 .12.012.167.037a.252.252 0 0 1 .105.11.363.363 0 0 1 .036.168.316.316 0 0 1-.082.231.3.3 0 0 1-.226.084.336.336 0 0 1-.164-.038.255.255 0 0 1-.104-.108.38.38 0 0 1-.035-.169.38.38 0 0 1 .035-.169.253.253 0 0 1 .104-.11.336.336 0 0 1 .164-.037Zm0 .12c-.052 0-.091.017-.118.05a.23.23 0 0 0-.04.145c0 .063.014.112.04.146.027.034.066.05.118.05.054 0 .094-.016.121-.05a.23.23 0 0 0 .04-.146c0-.063-.013-.111-.04-.144-.027-.034-.067-.05-.12-.05Zm.396.485v-.118h.11v-.316l-.125-.043.038-.118.18.062a.504.504 0 0 1 .103-.053.352.352 0 0 1 .124-.02.24.24 0 0 1 .13.031c.034.021.058.05.074.088a.3.3 0 0 1 .025.124v.245h.108V6.5h-.31v-.118h.055v-.225a.155.155 0 0 0-.027-.098c-.019-.024-.049-.036-.09-.036a.261.261 0 0 0-.138.044v.315h.053V6.5h-.31Zm1.332-.7.057.116-.36.178v.007l.36.184-.057.119-.477-.254v-.108l.477-.243Zm2.328 0 .477.242v.108l-.477.254-.058-.119.362-.184v-.007l-.361-.178.057-.117Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#2A8BFB",
        d: "m4.698 5.734.336.002v.13H4.96l-.002.182h.328l.001-.182h-.075v-.132h.335v.132h-.109l-.001.503h.11V6.5h-.334v-.131h.073v-.191h-.328v.19h.073V6.5h-.334v-.131h.11l.002-.503h-.11v-.132Zm1.23-.02h.098v.655h.195V6.5h-.553v-.131h.207v-.433l-.153.127-.086-.106.292-.244Zm10.031.02h.147l-.422.936h-.149l.424-.936Zm.168 0 .335.002v.13h-.074l-.001.182h.327l.002-.182h-.076v-.132h.335v.132h-.109l-.001.503h.11V6.5h-.334v-.131h.073v-.191h-.327v.19h.072V6.5h-.334v-.131h.11l.002-.503h-.11v-.132Zm1.23-.02h.097v.655h.195V6.5h-.552v-.131h.206v-.433l-.153.127-.086-.106.293-.244Z"
      }
    )
  );
};

var __defProp$24 = Object.defineProperty;
var __getOwnPropSymbols$24 = Object.getOwnPropertySymbols;
var __hasOwnProp$24 = Object.prototype.hasOwnProperty;
var __propIsEnum$24 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$24 = (obj, key, value) => key in obj ? __defProp$24(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$24 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$24.call(b, prop))
      __defNormalProp$24(a, prop, b[prop]);
  if (__getOwnPropSymbols$24)
    for (var prop of __getOwnPropSymbols$24(b)) {
      if (__propIsEnum$24.call(b, prop))
        __defNormalProp$24(a, prop, b[prop]);
    }
  return a;
};
var __objRest$24 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$24.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$24)
    for (var prop of __getOwnPropSymbols$24(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$24.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPrintDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$24(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$24({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 7V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 2 15.92 2 14.8 2H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 3.52 6 4.08 6 5.2V7m9 3.5h3",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 18c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C2 15.395 2 14.93 2 14v-2.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 7 5.12 7 6.8 7h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8V14c0 .93 0 1.395-.102 1.777a3 3 0 0 1-2.122 2.12C19.395 18 18.93 18 18 18m-8.8 4h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C18 20.48 18 19.92 18 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 14 15.92 14 14.8 14H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 15.52 6 16.08 6 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C7.52 22 8.08 22 9.2 22Z"
      }
    )
  );
};

var __defProp$23 = Object.defineProperty;
var __getOwnPropSymbols$23 = Object.getOwnPropertySymbols;
var __hasOwnProp$23 = Object.prototype.hasOwnProperty;
var __propIsEnum$23 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$23 = (obj, key, value) => key in obj ? __defProp$23(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$23 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$23.call(b, prop))
      __defNormalProp$23(a, prop, b[prop]);
  if (__getOwnPropSymbols$23)
    for (var prop of __getOwnPropSymbols$23(b)) {
      if (__propIsEnum$23.call(b, prop))
        __defNormalProp$23(a, prop, b[prop]);
    }
  return a;
};
var __objRest$23 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$23.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$23)
    for (var prop of __getOwnPropSymbols$23(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$23.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPrintSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$23(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$23({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.161 1h5.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v.866c.087.005.17.01.252.017.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v2.38c0 .795 0 1.386-.136 1.897a4 4 0 0 1-2.829 2.829c-.307.082-.643.115-1.035.128 0 .462-.003.865-.03 1.203-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H9.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167-.028-.338-.03-.74-.031-1.203-.392-.013-.728-.046-1.035-.128a4 4 0 0 1-2.829-2.829C1 15.524 1 14.933 1 14.138v-2.38c0-.804 0-1.469.044-2.01.046-.562.145-1.079.392-1.564a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392A9.58 9.58 0 0 1 5 6.027v-.866c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C8.18 1 8.635 1 9.161 1ZM7 6h10v-.8c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C15.75 3 15.377 3 14.8 3H9.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C7 4.25 7 4.623 7 5.2V6Zm0 12.8c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C8.25 21 8.623 21 9.2 21h5.6c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C17 19.75 17 19.377 17 18.8v-1.6c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085a4.574 4.574 0 0 0-.11-.008A21.388 21.388 0 0 0 14.8 15H9.2c-.576 0-.948 0-1.232.024-.271.022-.372.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C7.001 16.25 7 16.623 7 17.2v1.6Zm7-8.3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$22 = Object.defineProperty;
var __getOwnPropSymbols$22 = Object.getOwnPropertySymbols;
var __hasOwnProp$22 = Object.prototype.hasOwnProperty;
var __propIsEnum$22 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$22 = (obj, key, value) => key in obj ? __defProp$22(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$22 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$22.call(b, prop))
      __defNormalProp$22(a, prop, b[prop]);
  if (__getOwnPropSymbols$22)
    for (var prop of __getOwnPropSymbols$22(b)) {
      if (__propIsEnum$22.call(b, prop))
        __defNormalProp$22(a, prop, b[prop]);
    }
  return a;
};
var __objRest$22 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$22.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$22)
    for (var prop of __getOwnPropSymbols$22(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$22.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPrivacyDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$22(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$22({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 2.068a1 1 0 0 1 .143.01c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.422 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543V12c0 4.909-5.354 8.479-7.302 9.615-.221.13-.332.194-.488.227a1.04 1.04 0 0 1-.21.02",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m6.076 4.221 5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .143-.01v19.794a1.04 1.04 0 0 1-.21-.02c-.156-.033-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.275-.243.65-.383 1.398-.664Z"
      }
    )
  );
};

var __defProp$21 = Object.defineProperty;
var __getOwnPropSymbols$21 = Object.getOwnPropertySymbols;
var __hasOwnProp$21 = Object.prototype.hasOwnProperty;
var __propIsEnum$21 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$21 = (obj, key, value) => key in obj ? __defProp$21(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$21 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$21.call(b, prop))
      __defNormalProp$21(a, prop, b[prop]);
  if (__getOwnPropSymbols$21)
    for (var prop of __getOwnPropSymbols$21(b)) {
      if (__propIsEnum$21.call(b, prop))
        __defNormalProp$21(a, prop, b[prop]);
    }
  return a;
};
var __objRest$21 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$21.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$21)
    for (var prop of __getOwnPropSymbols$21(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$21.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPrivacySolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$21(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$21({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M11 2.462c0-.388 0-.582-.082-.707a.5.5 0 0 0-.309-.214c-.145-.033-.327.035-.69.171L5.595 3.334c-.618.23-1.16.433-1.578.801a3 3 0 0 0-.82 1.184c-.199.52-.198 1.1-.197 1.76V12c0 2.827 1.537 5.183 3.2 6.915a20.212 20.212 0 0 0 3.64 2.99c.353.227.53.34.696.329.14-.01.28-.087.364-.2.1-.132.1-.351.1-.79V2.463Zm2 18.783c0 .438 0 .657.1.79a.515.515 0 0 0 .364.199c.166.012.343-.102.697-.329a20.215 20.215 0 0 0 3.64-2.99C19.463 17.183 21 14.827 21 12V7.078c.001-.66.002-1.238-.196-1.759a3 3 0 0 0-.82-1.184c-.418-.368-.96-.57-1.579-.801l-4.324-1.622c-.363-.136-.545-.204-.69-.171a.5.5 0 0 0-.31.214C13 1.88 13 2.074 13 2.462v18.783Z"
      }
    )
  );
};

var __defProp$20 = Object.defineProperty;
var __getOwnPropSymbols$20 = Object.getOwnPropertySymbols;
var __hasOwnProp$20 = Object.prototype.hasOwnProperty;
var __propIsEnum$20 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$20 = (obj, key, value) => key in obj ? __defProp$20(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$20 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$20.call(b, prop))
      __defNormalProp$20(a, prop, b[prop]);
  if (__getOwnPropSymbols$20)
    for (var prop of __getOwnPropSymbols$20(b)) {
      if (__propIsEnum$20.call(b, prop))
        __defNormalProp$20(a, prop, b[prop]);
    }
  return a;
};
var __objRest$20 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$20.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$20)
    for (var prop of __getOwnPropSymbols$20(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$20.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgProductDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$20(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$20({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 12v9.5m0-9.5L3.5 7.278M12 12l8.5-4.722",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11.223 2.432c.284-.158.425-.237.576-.268a1 1 0 0 1 .402 0c.15.031.292.11.576.268l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.152.05.324.05.666v8.118c0 .342 0 .514-.05.666a1 1 0 0 1-.215.364c-.109.119-.258.202-.558.368l-7.4 4.111c-.284.158-.425.237-.575.267a.998.998 0 0 1-.403 0c-.15-.03-.292-.11-.576-.267l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.94c0-.342 0-.514.05-.666a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111Z"
      }
    )
  );
};

var __defProp$1$ = Object.defineProperty;
var __getOwnPropSymbols$1$ = Object.getOwnPropertySymbols;
var __hasOwnProp$1$ = Object.prototype.hasOwnProperty;
var __propIsEnum$1$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1$ = (obj, key, value) => key in obj ? __defProp$1$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1$.call(b, prop))
      __defNormalProp$1$(a, prop, b[prop]);
  if (__getOwnPropSymbols$1$)
    for (var prop of __getOwnPropSymbols$1$(b)) {
      if (__propIsEnum$1$.call(b, prop))
        __defNormalProp$1$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1$)
    for (var prop of __getOwnPropSymbols$1$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgProductSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1$(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.403 1.185a2 2 0 0 0-.806 0c-.307.063-.582.217-.8.34l-.06.033-6.426 3.571c-.409.227-.613.34-.68.49a.5.5 0 0 0-.002.412c.068.15.271.265.679.494l7.3 4.107c.143.08.214.12.29.136a.502.502 0 0 0 .204 0c.076-.016.147-.056.29-.136l7.3-4.107c.408-.229.611-.343.679-.494a.5.5 0 0 0-.001-.411c-.068-.15-.273-.264-.68-.49l-6.427-3.572-.06-.034c-.218-.122-.493-.276-.8-.339Zm9.593 7.705c0-.448 0-.672-.095-.803a.5.5 0 0 0-.35-.204c-.16-.018-.356.092-.747.312l-7.396 4.16c-.149.084-.223.125-.277.184a.5.5 0 0 0-.106.182c-.025.076-.025.161-.025.331v8.176c0 .447 0 .67.094.801a.5.5 0 0 0 .348.205c.16.019.355-.09.745-.306l6.476-3.597.063-.034c.23-.128.522-.288.745-.53.193-.21.339-.457.428-.728.103-.313.102-.644.101-.908v-.072c0-1.963-.003-5.303-.004-7.169ZM9.814 21.928c.39.216.584.325.744.306a.5.5 0 0 0 .348-.205c.094-.13.094-.354.094-.801v-8.176c0-.17 0-.255-.025-.331a.5.5 0 0 0-.106-.181c-.054-.06-.128-.101-.277-.185l-7.396-4.16c-.391-.22-.587-.33-.748-.312a.5.5 0 0 0-.349.204c-.094.13-.095.355-.095.803C2.003 10.756 2 14.096 2 16.06v.072c-.001.264-.002.595.101.908a2 2 0 0 0 .428.728c.223.242.514.402.745.53l.063.034 6.477 3.597Z"
      }
    )
  );
};

var __defProp$1_ = Object.defineProperty;
var __getOwnPropSymbols$1_ = Object.getOwnPropertySymbols;
var __hasOwnProp$1_ = Object.prototype.hasOwnProperty;
var __propIsEnum$1_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1_ = (obj, key, value) => key in obj ? __defProp$1_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1_.call(b, prop))
      __defNormalProp$1_(a, prop, b[prop]);
  if (__getOwnPropSymbols$1_)
    for (var prop of __getOwnPropSymbols$1_(b)) {
      if (__propIsEnum$1_.call(b, prop))
        __defNormalProp$1_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1_)
    for (var prop of __getOwnPropSymbols$1_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRefreshDataDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1_(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 2s.85.121 4.364 3.636A9 9 0 0 1 14 20.776M10 22s-.85-.122-4.364-3.636A9 9 0 0 1 10 3.224",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 22h6v-6M20 2h-6v6"
      }
    )
  );
};

var __defProp$1Z = Object.defineProperty;
var __getOwnPropSymbols$1Z = Object.getOwnPropertySymbols;
var __hasOwnProp$1Z = Object.prototype.hasOwnProperty;
var __propIsEnum$1Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Z = (obj, key, value) => key in obj ? __defProp$1Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1Z.call(b, prop))
      __defNormalProp$1Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Z)
    for (var prop of __getOwnPropSymbols$1Z(b)) {
      if (__propIsEnum$1Z.call(b, prop))
        __defNormalProp$1Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Z)
    for (var prop of __getOwnPropSymbols$1Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRefreshDataSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1Z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M19.071 19.071c3.905-3.905 3.905-10.237 0-14.142A50.859 50.859 0 0 0 17.046 3H20a1 1 0 1 0 0-2h-6a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V3.874c.617.513 1.479 1.291 2.657 2.47A8 8 0 0 1 13.779 19.8a1 1 0 0 0 .442 1.95 9.957 9.957 0 0 0 4.85-2.68ZM10.221 4.2a1 1 0 1 0-.442-1.951 9.958 9.958 0 0 0-4.85 2.68c-3.905 3.905-3.905 10.237 0 14.142A50.834 50.834 0 0 0 6.954 21H4a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1v-6a1 1 0 1 0-2 0v4.126c-.616-.512-1.478-1.29-2.657-2.47A8 8 0 0 1 10.221 4.2Z"
      }
    )
  );
};

var __defProp$1Y = Object.defineProperty;
var __getOwnPropSymbols$1Y = Object.getOwnPropertySymbols;
var __hasOwnProp$1Y = Object.prototype.hasOwnProperty;
var __propIsEnum$1Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Y = (obj, key, value) => key in obj ? __defProp$1Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1Y.call(b, prop))
      __defNormalProp$1Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Y)
    for (var prop of __getOwnPropSymbols$1Y(b)) {
      if (__propIsEnum$1Y.call(b, prop))
        __defNormalProp$1Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Y)
    for (var prop of __getOwnPropSymbols$1Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRefreshDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1Y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 14s.121.85 3.636 4.364A9 9 0 0 0 20.776 14M22 10s-.121-.85-3.636-4.364A9 9 0 0 0 3.224 10",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 4v6h-6M2 20v-6h6"
      }
    )
  );
};

var __defProp$1X = Object.defineProperty;
var __getOwnPropSymbols$1X = Object.getOwnPropertySymbols;
var __hasOwnProp$1X = Object.prototype.hasOwnProperty;
var __propIsEnum$1X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1X = (obj, key, value) => key in obj ? __defProp$1X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1X.call(b, prop))
      __defNormalProp$1X(a, prop, b[prop]);
  if (__getOwnPropSymbols$1X)
    for (var prop of __getOwnPropSymbols$1X(b)) {
      if (__propIsEnum$1X.call(b, prop))
        __defNormalProp$1X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1X)
    for (var prop of __getOwnPropSymbols$1X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRefreshSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1X(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M4.929 4.929c3.905-3.905 10.237-3.905 14.142 0 .798.798 1.43 1.466 1.929 2.025V4a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h4.126c-.513-.617-1.291-1.479-2.47-2.657A8 8 0 0 0 4.2 10.221a1 1 0 1 1-1.95-.442 9.958 9.958 0 0 1 2.68-4.85Zm14.871 8.85a1 1 0 0 1 1.951.442 9.957 9.957 0 0 1-2.68 4.85c-3.905 3.905-10.237 3.905-14.142 0A50.798 50.798 0 0 1 3 17.046V20a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3.874c.512.616 1.29 1.478 2.47 2.657A8 8 0 0 0 19.8 13.779Z"
      }
    )
  );
};

var __defProp$1W = Object.defineProperty;
var __getOwnPropSymbols$1W = Object.getOwnPropertySymbols;
var __hasOwnProp$1W = Object.prototype.hasOwnProperty;
var __propIsEnum$1W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1W = (obj, key, value) => key in obj ? __defProp$1W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1W.call(b, prop))
      __defNormalProp$1W(a, prop, b[prop]);
  if (__getOwnPropSymbols$1W)
    for (var prop of __getOwnPropSymbols$1W(b)) {
      if (__propIsEnum$1W.call(b, prop))
        __defNormalProp$1W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1W)
    for (var prop of __getOwnPropSymbols$1W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReloadDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1W(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 10s.121-.85 3.636-4.364A9 9 0 0 1 20.776 10M22 14s-.121.85-3.636 4.364A9 9 0 0 1 3.224 14",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 20v-6h-6M2 4v6h6"
      }
    )
  );
};

var __defProp$1V = Object.defineProperty;
var __getOwnPropSymbols$1V = Object.getOwnPropertySymbols;
var __hasOwnProp$1V = Object.prototype.hasOwnProperty;
var __propIsEnum$1V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1V = (obj, key, value) => key in obj ? __defProp$1V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1V.call(b, prop))
      __defNormalProp$1V(a, prop, b[prop]);
  if (__getOwnPropSymbols$1V)
    for (var prop of __getOwnPropSymbols$1V(b)) {
      if (__propIsEnum$1V.call(b, prop))
        __defNormalProp$1V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1V)
    for (var prop of __getOwnPropSymbols$1V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReloadSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1V(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M19.071 4.929c-3.905-3.905-10.237-3.905-14.142 0A50.851 50.851 0 0 0 3 6.954V4a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H3.874c.513-.617 1.291-1.479 2.47-2.657A8 8 0 0 1 19.8 10.221a1 1 0 0 0 1.95-.442 9.958 9.958 0 0 0-2.68-4.85ZM4.2 13.779a1 1 0 0 0-1.951.442 9.957 9.957 0 0 0 2.68 4.85c3.905 3.905 10.237 3.905 14.142 0A50.767 50.767 0 0 0 21 17.046V20a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h4.126c-.512.616-1.29 1.478-2.47 2.657A8 8 0 0 1 4.2 13.779Z"
      }
    )
  );
};

var __defProp$1U = Object.defineProperty;
var __getOwnPropSymbols$1U = Object.getOwnPropertySymbols;
var __hasOwnProp$1U = Object.prototype.hasOwnProperty;
var __propIsEnum$1U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1U = (obj, key, value) => key in obj ? __defProp$1U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1U.call(b, prop))
      __defNormalProp$1U(a, prop, b[prop]);
  if (__getOwnPropSymbols$1U)
    for (var prop of __getOwnPropSymbols$1U(b)) {
      if (__propIsEnum$1U.call(b, prop))
        __defNormalProp$1U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1U)
    for (var prop of __getOwnPropSymbols$1U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRepeat01Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1U(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 18h13.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V13M3 18l4 4m-4-4 4-4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m17 2 4 4m0 0-4 4m4-4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 8.28 3 9.12 3 10.8v.2"
      }
    )
  );
};

var __defProp$1T = Object.defineProperty;
var __getOwnPropSymbols$1T = Object.getOwnPropertySymbols;
var __hasOwnProp$1T = Object.prototype.hasOwnProperty;
var __propIsEnum$1T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1T = (obj, key, value) => key in obj ? __defProp$1T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1T.call(b, prop))
      __defNormalProp$1T(a, prop, b[prop]);
  if (__getOwnPropSymbols$1T)
    for (var prop of __getOwnPropSymbols$1T(b)) {
      if (__propIsEnum$1T.call(b, prop))
        __defNormalProp$1T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1T)
    for (var prop of __getOwnPropSymbols$1T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRepeat01Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1T(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M16.293 1.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 7H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 9.361 4 9.943 4 10.8v.2a1 1 0 1 1-2 0v-.241c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 5 6.954 5 7.758 5h10.828l-2.293-2.293a1 1 0 0 1 0-1.414ZM21 12a1 1 0 0 0-1 1v.2c0 .857 0 1.439-.038 1.889-.035.438-.1.663-.18.819a2 2 0 0 1-.874.874c-.156.08-.38.145-.819.18-.45.037-1.032.038-1.889.038H5.414l2.293-2.293a1 1 0 1 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L5.414 19h10.827c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V13a1 1 0 0 0-1-1Z"
      }
    )
  );
};

var __defProp$1S = Object.defineProperty;
var __getOwnPropSymbols$1S = Object.getOwnPropertySymbols;
var __hasOwnProp$1S = Object.prototype.hasOwnProperty;
var __propIsEnum$1S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1S = (obj, key, value) => key in obj ? __defProp$1S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1S.call(b, prop))
      __defNormalProp$1S(a, prop, b[prop]);
  if (__getOwnPropSymbols$1S)
    for (var prop of __getOwnPropSymbols$1S(b)) {
      if (__propIsEnum$1S.call(b, prop))
        __defNormalProp$1S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1S)
    for (var prop of __getOwnPropSymbols$1S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReplyDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1S(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 20v-1.4c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C8.56 9 10.24 9 13.6 9H20",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m15 14 5-5-5-5"
      }
    )
  );
};

var __defProp$1R = Object.defineProperty;
var __getOwnPropSymbols$1R = Object.getOwnPropertySymbols;
var __hasOwnProp$1R = Object.prototype.hasOwnProperty;
var __propIsEnum$1R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1R = (obj, key, value) => key in obj ? __defProp$1R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1R.call(b, prop))
      __defNormalProp$1R(a, prop, b[prop]);
  if (__getOwnPropSymbols$1R)
    for (var prop of __getOwnPropSymbols$1R(b)) {
      if (__propIsEnum$1R.call(b, prop))
        __defNormalProp$1R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1R)
    for (var prop of __getOwnPropSymbols$1R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReplySolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1R(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.707 3.293a1 1 0 1 0-1.414 1.414L17.586 8h-4.03c-1.643 0-2.937 0-3.978.085-1.063.087-1.95.267-2.756.678a7 7 0 0 0-3.059 3.06c-.41.805-.591 1.692-.678 2.755C3 15.619 3 16.913 3 18.556V20a1 1 0 1 0 2 0v-1.4c0-1.697 0-2.909.078-3.86.077-.938.224-1.533.467-2.01a5 5 0 0 1 2.185-2.185c.477-.243 1.072-.39 2.01-.467.951-.077 2.163-.078 3.86-.078h3.986l-3.293 3.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Z"
      }
    )
  );
};

var __defProp$1Q = Object.defineProperty;
var __getOwnPropSymbols$1Q = Object.getOwnPropertySymbols;
var __hasOwnProp$1Q = Object.prototype.hasOwnProperty;
var __propIsEnum$1Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Q = (obj, key, value) => key in obj ? __defProp$1Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1Q.call(b, prop))
      __defNormalProp$1Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Q)
    for (var prop of __getOwnPropSymbols$1Q(b)) {
      if (__propIsEnum$1Q.call(b, prop))
        __defNormalProp$1Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Q)
    for (var prop of __getOwnPropSymbols$1Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReportDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1Q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 16v5m6 0-3.951-3.293c-.73-.607-1.094-.91-1.5-1.027a2 2 0 0 0-1.098 0c-.406.116-.77.42-1.5 1.027L6 21",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 11v1m4-3v3m4-5v5m6-9H2m1 0h18v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 16 17.88 16 16.2 16H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 13.72 3 12.88 3 11.2V3Z"
      }
    )
  );
};

var __defProp$1P = Object.defineProperty;
var __getOwnPropSymbols$1P = Object.getOwnPropertySymbols;
var __hasOwnProp$1P = Object.prototype.hasOwnProperty;
var __propIsEnum$1P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1P = (obj, key, value) => key in obj ? __defProp$1P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1P.call(b, prop))
      __defNormalProp$1P(a, prop, b[prop]);
  if (__getOwnPropSymbols$1P)
    for (var prop of __getOwnPropSymbols$1P(b)) {
      if (__propIsEnum$1P.call(b, prop))
        __defNormalProp$1P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1P)
    for (var prop of __getOwnPropSymbols$1P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReportSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1P(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2v7.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044h-1.48l3.878 3.232a1 1 0 1 1-1.28 1.536L13 18.135V21a1 1 0 1 1-2 0v-2.865l-4.36 3.633a1 1 0 1 1-1.28-1.536L9.238 17h-1.48c-.804 0-1.469 0-2.01-.044-.562-.046-1.079-.145-1.564-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 12.71 2 12.046 2 11.242V4a1 1 0 0 1-1-1Zm16 4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V7Zm-5 1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1O = Object.defineProperty;
var __getOwnPropSymbols$1O = Object.getOwnPropertySymbols;
var __hasOwnProp$1O = Object.prototype.hasOwnProperty;
var __propIsEnum$1O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1O = (obj, key, value) => key in obj ? __defProp$1O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1O.call(b, prop))
      __defNormalProp$1O(a, prop, b[prop]);
  if (__getOwnPropSymbols$1O)
    for (var prop of __getOwnPropSymbols$1O(b)) {
      if (__propIsEnum$1O.call(b, prop))
        __defNormalProp$1O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1O)
    for (var prop of __getOwnPropSymbols$1O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgResistanceBandDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1O(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15.05 9H5.5a2.5 2.5 0 0 1 0-5h9.55m-6.1 16h9.55a2.5 2.5 0 0 0 0-5H8.95",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6.5 21a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm11-11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
      }
    )
  );
};

var __defProp$1N = Object.defineProperty;
var __getOwnPropSymbols$1N = Object.getOwnPropertySymbols;
var __hasOwnProp$1N = Object.prototype.hasOwnProperty;
var __propIsEnum$1N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1N = (obj, key, value) => key in obj ? __defProp$1N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1N.call(b, prop))
      __defNormalProp$1N(a, prop, b[prop]);
  if (__getOwnPropSymbols$1N)
    for (var prop of __getOwnPropSymbols$1N(b)) {
      if (__propIsEnum$1N.call(b, prop))
        __defNormalProp$1N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1N)
    for (var prop of __getOwnPropSymbols$1N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgResistanceBandSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1N(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 3h5.06c.483 0 .725 0 .849.08a.45.45 0 0 1 .215.306c.034.143-.06.403-.246.923A6.487 6.487 0 0 0 11 6.5c0 .769.133 1.506.378 2.19.187.52.28.78.246.924a.45.45 0 0 1-.215.306c-.124.08-.366.08-.85.08H5.5a3.5 3.5 0 1 1 0-7Zm12 8a4.5 4.5 0 1 0-2.82-8.007L14.67 3A4.491 4.491 0 0 0 13 6.5c0 1.414.652 2.675 1.671 3.5.773.625 1.757 1 2.829 1Zm-11 2c1.072 0 2.056.375 2.829 1A4.491 4.491 0 0 1 11 17.5 4.491 4.491 0 0 1 9.329 21 4.5 4.5 0 1 1 6.5 13Zm6.94 1c-.483 0-.725 0-.849.08a.45.45 0 0 0-.215.306c-.034.143.06.403.246.923A6.49 6.49 0 0 1 13 17.5a6.48 6.48 0 0 1-.378 2.19c-.187.52-.28.78-.246.924a.45.45 0 0 0 .215.306c.124.08.366.08.85.08H18.5a3.5 3.5 0 1 0 0-7h-5.06Z"
      }
    )
  );
};

var __defProp$1M = Object.defineProperty;
var __getOwnPropSymbols$1M = Object.getOwnPropertySymbols;
var __hasOwnProp$1M = Object.prototype.hasOwnProperty;
var __propIsEnum$1M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1M = (obj, key, value) => key in obj ? __defProp$1M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1M.call(b, prop))
      __defNormalProp$1M(a, prop, b[prop]);
  if (__getOwnPropSymbols$1M)
    for (var prop of __getOwnPropSymbols$1M(b)) {
      if (__propIsEnum$1M.call(b, prop))
        __defNormalProp$1M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1M)
    for (var prop of __getOwnPropSymbols$1M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgResultsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1M(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 13v4m8-6v6M12 7v10"
      }
    )
  );
};

var __defProp$1L = Object.defineProperty;
var __getOwnPropSymbols$1L = Object.getOwnPropertySymbols;
var __hasOwnProp$1L = Object.prototype.hasOwnProperty;
var __propIsEnum$1L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1L = (obj, key, value) => key in obj ? __defProp$1L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1L.call(b, prop))
      __defNormalProp$1L(a, prop, b[prop]);
  if (__getOwnPropSymbols$1L)
    for (var prop of __getOwnPropSymbols$1L(b)) {
      if (__propIsEnum$1L.call(b, prop))
        __defNormalProp$1L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1L)
    for (var prop of __getOwnPropSymbols$1L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgResultsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1L(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm1 6a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V7Zm3 3a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm-8 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1K = Object.defineProperty;
var __getOwnPropSymbols$1K = Object.getOwnPropertySymbols;
var __hasOwnProp$1K = Object.prototype.hasOwnProperty;
var __propIsEnum$1K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1K = (obj, key, value) => key in obj ? __defProp$1K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1K.call(b, prop))
      __defNormalProp$1K(a, prop, b[prop]);
  if (__getOwnPropSymbols$1K)
    for (var prop of __getOwnPropSymbols$1K(b)) {
      if (__propIsEnum$1K.call(b, prop))
        __defNormalProp$1K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1K)
    for (var prop of __getOwnPropSymbols$1K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReuploadDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1K(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 7h10a6 6 0 0 1 0 12H4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 3 4 7l4 4"
      }
    )
  );
};

var __defProp$1J = Object.defineProperty;
var __getOwnPropSymbols$1J = Object.getOwnPropertySymbols;
var __hasOwnProp$1J = Object.prototype.hasOwnProperty;
var __propIsEnum$1J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1J = (obj, key, value) => key in obj ? __defProp$1J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1J.call(b, prop))
      __defNormalProp$1J(a, prop, b[prop]);
  if (__getOwnPropSymbols$1J)
    for (var prop of __getOwnPropSymbols$1J(b)) {
      if (__propIsEnum$1J.call(b, prop))
        __defNormalProp$1J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1J)
    for (var prop of __getOwnPropSymbols$1J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgReuploadSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1J(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8.707 3.707a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L6.414 8H14a5 5 0 0 1 0 10H4a1 1 0 1 0 0 2h10a7 7 0 1 0 0-14H6.414l2.293-2.293Z"
      }
    )
  );
};

var __defProp$1I = Object.defineProperty;
var __getOwnPropSymbols$1I = Object.getOwnPropertySymbols;
var __hasOwnProp$1I = Object.prototype.hasOwnProperty;
var __propIsEnum$1I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1I = (obj, key, value) => key in obj ? __defProp$1I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1I.call(b, prop))
      __defNormalProp$1I(a, prop, b[prop]);
  if (__getOwnPropSymbols$1I)
    for (var prop of __getOwnPropSymbols$1I(b)) {
      if (__propIsEnum$1I.call(b, prop))
        __defNormalProp$1I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1I)
    for (var prop of __getOwnPropSymbols$1I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRouteOpenDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1I(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 12h6m8 0h6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      }
    )
  );
};

var __defProp$1H = Object.defineProperty;
var __getOwnPropSymbols$1H = Object.getOwnPropertySymbols;
var __hasOwnProp$1H = Object.prototype.hasOwnProperty;
var __propIsEnum$1H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1H = (obj, key, value) => key in obj ? __defProp$1H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1H.call(b, prop))
      __defNormalProp$1H(a, prop, b[prop]);
  if (__getOwnPropSymbols$1H)
    for (var prop of __getOwnPropSymbols$1H(b)) {
      if (__propIsEnum$1H.call(b, prop))
        __defNormalProp$1H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1H)
    for (var prop of __getOwnPropSymbols$1H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRouteOpenSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1H(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.9 11a5.002 5.002 0 0 0-9.8 0H2a1 1 0 1 0 0 2h5.1a5.002 5.002 0 0 0 9.8 0H22a1 1 0 0 0 0-2h-5.1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1G = Object.defineProperty;
var __getOwnPropSymbols$1G = Object.getOwnPropertySymbols;
var __hasOwnProp$1G = Object.prototype.hasOwnProperty;
var __propIsEnum$1G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1G = (obj, key, value) => key in obj ? __defProp$1G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1G.call(b, prop))
      __defNormalProp$1G(a, prop, b[prop]);
  if (__getOwnPropSymbols$1G)
    for (var prop of __getOwnPropSymbols$1G(b)) {
      if (__propIsEnum$1G.call(b, prop))
        __defNormalProp$1G(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1G)
    for (var prop of __getOwnPropSymbols$1G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRowTableDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1G(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 9h18M3 15h18",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3Z"
      }
    )
  );
};

var __defProp$1F = Object.defineProperty;
var __getOwnPropSymbols$1F = Object.getOwnPropertySymbols;
var __hasOwnProp$1F = Object.prototype.hasOwnProperty;
var __propIsEnum$1F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1F = (obj, key, value) => key in obj ? __defProp$1F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1F.call(b, prop))
      __defNormalProp$1F(a, prop, b[prop]);
  if (__getOwnPropSymbols$1F)
    for (var prop of __getOwnPropSymbols$1F(b)) {
      if (__propIsEnum$1F.call(b, prop))
        __defNormalProp$1F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1F)
    for (var prop of __getOwnPropSymbols$1F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgRowTableSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1F(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20.4 7c.574 0 .861 0 1.078-.113.188-.097.346-.26.438-.45.107-.22.1-.492.085-1.037a11.026 11.026 0 0 0-.032-.595c-.032-.395-.103-.789-.296-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167-.017.198-.026.396-.032.595-.015.545-.022.817.085 1.037.092.19.25.353.438.45C2.739 7 3.026 7 3.6 7h16.8ZM3.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 15 3.04 15 3.6 15h16.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 14.24 22 13.96 22 13.4v-2.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 9 20.96 9 20.4 9H3.6ZM22 18.6c.016-.545.023-.817-.084-1.037a1.017 1.017 0 0 0-.438-.45C21.261 17 20.974 17 20.4 17H3.6c-.574 0-.861 0-1.078.113-.187.097-.346.26-.438.45-.107.22-.1.492-.085 1.037.006.199.015.397.032.595.032.395.103.789.296 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.017-.198.026-.396.032-.595Z"
      }
    )
  );
};

var __defProp$1E = Object.defineProperty;
var __getOwnPropSymbols$1E = Object.getOwnPropertySymbols;
var __hasOwnProp$1E = Object.prototype.hasOwnProperty;
var __propIsEnum$1E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1E = (obj, key, value) => key in obj ? __defProp$1E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1E.call(b, prop))
      __defNormalProp$1E(a, prop, b[prop]);
  if (__getOwnPropSymbols$1E)
    for (var prop of __getOwnPropSymbols$1E(b)) {
      if (__propIsEnum$1E.call(b, prop))
        __defNormalProp$1E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1E)
    for (var prop of __getOwnPropSymbols$1E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSaveLaterDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1E(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 3h7.675c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963V17",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12.5 10H8.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7 9.24 7 8.96 7 8.4V6.5M13.5 21v-4.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.74 15 12.46 15 11.9 15H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 15.76 7 16.04 7 16.6V21m10.5-10.837V17.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C15.98 21 15.42 21 14.3 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V9.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 6.5 5.08 6.5 6.2 6.5h7.637c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l2.062 2.063c.173.173.26.26.322.36.054.09.095.188.12.29.027.115.027.237.027.482Z"
      }
    )
  );
};

var __defProp$1D = Object.defineProperty;
var __getOwnPropSymbols$1D = Object.getOwnPropertySymbols;
var __hasOwnProp$1D = Object.prototype.hasOwnProperty;
var __propIsEnum$1D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1D = (obj, key, value) => key in obj ? __defProp$1D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1D.call(b, prop))
      __defNormalProp$1D(a, prop, b[prop]);
  if (__getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(b)) {
      if (__propIsEnum$1D.call(b, prop))
        __defNormalProp$1D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSaveLaterSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1D(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.405 4.028c-.088-.022-.194-.028-.73-.028H7a1 1 0 0 1 0-2h7.758c.407 0 .766 0 1.114.083a3 3 0 0 1 .867.36c.306.186.559.44.846.728l.06.06 3.125 3.125.059.058c.288.288.542.541.729.847a3 3 0 0 1 .36.867c.083.349.082.707.082 1.114V17a1 1 0 1 1-2 0V9.325c0-.536-.006-.642-.028-.73a.998.998 0 0 0-.12-.29c-.047-.077-.117-.156-.496-.535L16.23 4.644c-.38-.38-.459-.45-.536-.497a1 1 0 0 0-.289-.12Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.888 5.5c.19 0 .43-.001.665.055a2 2 0 0 1 .578.24c.206.126.375.296.509.43l.036.036 2.062 2.063.037.036c.134.134.304.303.43.51.11.178.19.373.24.577a2.8 2.8 0 0 1 .055.665v7.727c0 .527 0 .981-.03 1.356-.033.395-.104.788-.297 1.167a3 3 0 0 1-1.311 1.31c-.378.194-.772.265-1.167.297-.375.031-.83.03-1.357.03H6.162c-.527 0-.981.001-1.356-.03-.395-.032-.789-.103-1.167-.296a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C2 18.82 2 18.365 2 17.838V9.662c0-.527 0-.982.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296.375-.031.83-.031 1.356-.031h7.727ZM11.9 15H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 15.76 7 16.04 7 16.6V20h6.5v-3.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.74 15 12.46 15 11.9 15ZM8 8.5a1 1 0 1 0-2 0v.026c0 .21 0 .415.012.59.013.19.043.415.14.65a2 2 0 0 0 1.083 1.082c.234.097.46.127.65.14.174.012.378.012.589.012H12.5a1 1 0 1 0 0-2H8v-.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1C = Object.defineProperty;
var __getOwnPropSymbols$1C = Object.getOwnPropertySymbols;
var __hasOwnProp$1C = Object.prototype.hasOwnProperty;
var __propIsEnum$1C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1C = (obj, key, value) => key in obj ? __defProp$1C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1C.call(b, prop))
      __defNormalProp$1C(a, prop, b[prop]);
  if (__getOwnPropSymbols$1C)
    for (var prop of __getOwnPropSymbols$1C(b)) {
      if (__propIsEnum$1C.call(b, prop))
        __defNormalProp$1C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1C)
    for (var prop of __getOwnPropSymbols$1C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgScreenMaximazeDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1C(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 3h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H16"
      }
    )
  );
};

var __defProp$1B = Object.defineProperty;
var __getOwnPropSymbols$1B = Object.getOwnPropertySymbols;
var __hasOwnProp$1B = Object.prototype.hasOwnProperty;
var __propIsEnum$1B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1B = (obj, key, value) => key in obj ? __defProp$1B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1B.call(b, prop))
      __defNormalProp$1B(a, prop, b[prop]);
  if (__getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(b)) {
      if (__propIsEnum$1B.call(b, prop))
        __defNormalProp$1B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgScreenMaximazeSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1B(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2H8a1 1 0 1 1 0 2h-.2c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8V8a1 1 0 1 1-2 0v-.241c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2ZM3 15a1 1 0 0 1 1 1v.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20H8a1 1 0 1 1 0 2h-.241c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V16a1 1 0 0 1 1-1ZM18.089 4.038C17.639 4 17.057 4 16.2 4H16a1 1 0 1 1 0-2h.241c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758V8a1 1 0 1 1-2 0v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18ZM21 15a1 1 0 0 1 1 1v.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H16a1 1 0 1 1 0-2h.2c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V16a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1A = Object.defineProperty;
var __getOwnPropSymbols$1A = Object.getOwnPropertySymbols;
var __hasOwnProp$1A = Object.prototype.hasOwnProperty;
var __propIsEnum$1A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1A = (obj, key, value) => key in obj ? __defProp$1A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1A.call(b, prop))
      __defNormalProp$1A(a, prop, b[prop]);
  if (__getOwnPropSymbols$1A)
    for (var prop of __getOwnPropSymbols$1A(b)) {
      if (__propIsEnum$1A.call(b, prop))
        __defNormalProp$1A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1A)
    for (var prop of __getOwnPropSymbols$1A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSearchDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1A(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 11a5 5 0 0 0-5-5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21 21-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      }
    )
  );
};

var __defProp$1z = Object.defineProperty;
var __getOwnPropSymbols$1z = Object.getOwnPropertySymbols;
var __hasOwnProp$1z = Object.prototype.hasOwnProperty;
var __propIsEnum$1z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1z = (obj, key, value) => key in obj ? __defProp$1z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1z.call(b, prop))
      __defNormalProp$1z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1z)
    for (var prop of __getOwnPropSymbols$1z(b)) {
      if (__propIsEnum$1z.call(b, prop))
        __defNormalProp$1z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1z)
    for (var prop of __getOwnPropSymbols$1z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSearchSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M10 6a1 1 0 0 1 1-1 6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1-1-1Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 11a9 9 0 1 1 16.032 5.618l3.675 3.675a1 1 0 0 1-1.414 1.414l-3.675-3.675A9 9 0 0 1 2 11Zm9-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1y = Object.defineProperty;
var __getOwnPropSymbols$1y = Object.getOwnPropertySymbols;
var __hasOwnProp$1y = Object.prototype.hasOwnProperty;
var __propIsEnum$1y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1y = (obj, key, value) => key in obj ? __defProp$1y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1y.call(b, prop))
      __defNormalProp$1y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(b)) {
      if (__propIsEnum$1y.call(b, prop))
        __defNormalProp$1y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSendDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.5 12H5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2.574 4.73c-.182-.547-.272-.82-.206-.99a.5.5 0 0 1 .331-.298c.174-.049.437.07.963.306l16.717 7.522c.514.232.771.348.85.508a.5.5 0 0 1 0 .444c-.079.16-.336.276-.85.508L3.667 20.25c-.527.237-.79.355-.964.307a.5.5 0 0 1-.332-.3c-.066-.169.026-.443.21-.99l2.334-6.976a1.06 1.06 0 0 0 .054-.188.5.5 0 0 0 0-.129 1.056 1.056 0 0 0-.053-.188L2.574 4.729Z"
      }
    )
  );
};

var __defProp$1x = Object.defineProperty;
var __getOwnPropSymbols$1x = Object.getOwnPropertySymbols;
var __hasOwnProp$1x = Object.prototype.hasOwnProperty;
var __propIsEnum$1x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1x = (obj, key, value) => key in obj ? __defProp$1x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1x.call(b, prop))
      __defNormalProp$1x(a, prop, b[prop]);
  if (__getOwnPropSymbols$1x)
    for (var prop of __getOwnPropSymbols$1x(b)) {
      if (__propIsEnum$1x.call(b, prop))
        __defNormalProp$1x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1x)
    for (var prop of __getOwnPropSymbols$1x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSendSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1x(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M22.126 12.665a1.5 1.5 0 0 0 0-1.33c-.182-.369-.503-.562-.668-.655a8.472 8.472 0 0 0-.636-.306L4.038 2.82a8.65 8.65 0 0 0-.662-.278c-.18-.062-.543-.177-.945-.065a1.5 1.5 0 0 0-.994.898c-.153.388-.076.76-.032.946.047.202.128.445.208.688l1.625 4.894c.13.394.196.591.318.737a1 1 0 0 0 .4.29c.177.069.385.069.8.069H12a1 1 0 1 1 0 2H4.775c-.414 0-.621 0-.797.07a1 1 0 0 0-.401.288c-.122.145-.188.341-.32.734L1.62 18.984a8.784 8.784 0 0 0-.21.688c-.045.186-.122.56.03.948.17.44.54.773.994.9.402.112.766-.002.946-.065.197-.068.43-.173.664-.278l16.778-7.55c.228-.103.457-.206.636-.306.166-.094.486-.287.668-.656Z"
      }
    )
  );
};

var __defProp$1w = Object.defineProperty;
var __getOwnPropSymbols$1w = Object.getOwnPropertySymbols;
var __hasOwnProp$1w = Object.prototype.hasOwnProperty;
var __propIsEnum$1w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1w = (obj, key, value) => key in obj ? __defProp$1w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1w.call(b, prop))
      __defNormalProp$1w(a, prop, b[prop]);
  if (__getOwnPropSymbols$1w)
    for (var prop of __getOwnPropSymbols$1w(b)) {
      if (__propIsEnum$1w.call(b, prop))
        __defNormalProp$1w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1w)
    for (var prop of __getOwnPropSymbols$1w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSensorDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1w(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$1v = Object.defineProperty;
var __getOwnPropSymbols$1v = Object.getOwnPropertySymbols;
var __hasOwnProp$1v = Object.prototype.hasOwnProperty;
var __propIsEnum$1v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1v = (obj, key, value) => key in obj ? __defProp$1v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1v.call(b, prop))
      __defNormalProp$1v(a, prop, b[prop]);
  if (__getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(b)) {
      if (__propIsEnum$1v.call(b, prop))
        __defNormalProp$1v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSensorSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1v(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm3 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1u = Object.defineProperty;
var __getOwnPropSymbols$1u = Object.getOwnPropertySymbols;
var __hasOwnProp$1u = Object.prototype.hasOwnProperty;
var __propIsEnum$1u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1u = (obj, key, value) => key in obj ? __defProp$1u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1u.call(b, prop))
      __defNormalProp$1u(a, prop, b[prop]);
  if (__getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(b)) {
      if (__propIsEnum$1u.call(b, prop))
        __defNormalProp$1u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgServer01Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1u(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 10 19.92 10 18.8 10H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 8.48 2 7.92 2 6.8V5.2Zm0 12c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 14 4.08 14 5.2 14h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 15.52 22 16.08 22 17.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 22 19.92 22 18.8 22H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.48 2 19.92 2 18.8v-1.6Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 6h.01M6 18h.01"
      }
    )
  );
};

var __defProp$1t = Object.defineProperty;
var __getOwnPropSymbols$1t = Object.getOwnPropertySymbols;
var __hasOwnProp$1t = Object.prototype.hasOwnProperty;
var __propIsEnum$1t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1t = (obj, key, value) => key in obj ? __defProp$1t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1t.call(b, prop))
      __defNormalProp$1t(a, prop, b[prop]);
  if (__getOwnPropSymbols$1t)
    for (var prop of __getOwnPropSymbols$1t(b)) {
      if (__propIsEnum$1t.call(b, prop))
        __defNormalProp$1t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1t)
    for (var prop of __getOwnPropSymbols$1t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgServer01Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1t(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.838 1H5.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 4.18 1 4.635 1 5.161V6.84c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H18.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.03-.376.03-.831.03-1.357V5.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 1 19.365 1 18.838 1ZM6 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM18.838 13H5.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 16.18 1 16.635 1 17.161v1.677c0 .528 0 .982.03 1.357.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h13.677c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V17.16c0-.527 0-.982-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296-.375-.03-.83-.03-1.357-.03ZM4.75 18a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1s = Object.defineProperty;
var __getOwnPropSymbols$1s = Object.getOwnPropertySymbols;
var __hasOwnProp$1s = Object.prototype.hasOwnProperty;
var __propIsEnum$1s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1s = (obj, key, value) => key in obj ? __defProp$1s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1s.call(b, prop))
      __defNormalProp$1s(a, prop, b[prop]);
  if (__getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(b)) {
      if (__propIsEnum$1s.call(b, prop))
        __defNormalProp$1s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSettingsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1s(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9.395 19.371.585 1.315a2.213 2.213 0 0 0 4.044 0l.585-1.315a2.426 2.426 0 0 1 2.47-1.423l1.43.152a2.212 2.212 0 0 0 2.022-3.502l-.847-1.164a2.429 2.429 0 0 1-.46-1.434c0-.513.163-1.014.465-1.429l.846-1.163a2.211 2.211 0 0 0-2.022-3.502l-1.43.152a2.433 2.433 0 0 1-1.47-.312 2.426 2.426 0 0 1-1-1.117l-.589-1.315a2.212 2.212 0 0 0-4.044 0L9.395 4.63c-.207.468-.557.86-1 1.117-.445.256-.96.365-1.47.312l-1.434-.152a2.212 2.212 0 0 0-2.023 3.502l.847 1.163a2.43 2.43 0 0 1 0 2.858l-.847 1.163a2.21 2.21 0 0 0 .786 3.273c.382.195.811.274 1.237.23l1.43-.153a2.434 2.434 0 0 1 2.474 1.43Z"
      }
    )
  );
};

var __defProp$1r = Object.defineProperty;
var __getOwnPropSymbols$1r = Object.getOwnPropertySymbols;
var __hasOwnProp$1r = Object.prototype.hasOwnProperty;
var __propIsEnum$1r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1r = (obj, key, value) => key in obj ? __defProp$1r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1r.call(b, prop))
      __defNormalProp$1r(a, prop, b[prop]);
  if (__getOwnPropSymbols$1r)
    for (var prop of __getOwnPropSymbols$1r(b)) {
      if (__propIsEnum$1r.call(b, prop))
        __defNormalProp$1r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1r)
    for (var prop of __getOwnPropSymbols$1r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSettingsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1r(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m9.742 21.554-.652-1.446a2.682 2.682 0 0 0-1.122-1.228 2.75 2.75 0 0 0-1.64-.344l-1.597.168a2.504 2.504 0 0 1-1.381-.252 2.457 2.457 0 0 1-1.019-.952 2.404 2.404 0 0 1 .142-2.649l.945-1.28a2.645 2.645 0 0 0 0-3.143l-.945-1.28A2.41 2.41 0 0 1 2.33 6.5a2.455 2.455 0 0 1 1.019-.952 2.502 2.502 0 0 1 1.38-.252l1.602.168a2.75 2.75 0 0 0 1.641-.344A2.682 2.682 0 0 0 9.09 3.892l.652-1.446c.194-.43.51-.796.911-1.053a2.497 2.497 0 0 1 2.694 0c.4.257.717.622.91 1.053l.658 1.446a2.68 2.68 0 0 0 1.117 1.228 2.75 2.75 0 0 0 1.64.344l1.598-.168c.475-.05.954.038 1.38.252.426.213.78.544 1.019.952a2.403 2.403 0 0 1-.142 2.649l-.945 1.28A2.645 2.645 0 0 0 20.063 12a2.645 2.645 0 0 0 .514 1.578l.945 1.28a2.41 2.41 0 0 1 .142 2.648 2.454 2.454 0 0 1-1.019.953 2.502 2.502 0 0 1-1.38.251l-1.597-.167a2.75 2.75 0 0 0-1.641.343c-.494.281-.885.71-1.117 1.222l-.652 1.446c-.194.43-.51.796-.911 1.053a2.497 2.497 0 0 1-2.694 0 2.444 2.444 0 0 1-.91-1.053ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1q = Object.defineProperty;
var __getOwnPropSymbols$1q = Object.getOwnPropertySymbols;
var __hasOwnProp$1q = Object.prototype.hasOwnProperty;
var __propIsEnum$1q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1q = (obj, key, value) => key in obj ? __defProp$1q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1q.call(b, prop))
      __defNormalProp$1q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(b)) {
      if (__propIsEnum$1q.call(b, prop))
        __defNormalProp$1q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSetupOptionsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 8h12m-6 8h12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$1p = Object.defineProperty;
var __getOwnPropSymbols$1p = Object.getOwnPropertySymbols;
var __hasOwnProp$1p = Object.prototype.hasOwnProperty;
var __propIsEnum$1p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1p = (obj, key, value) => key in obj ? __defProp$1p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1p.call(b, prop))
      __defNormalProp$1p(a, prop, b[prop]);
  if (__getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(b)) {
      if (__propIsEnum$1p.call(b, prop))
        __defNormalProp$1p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSetupOptionsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1p(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 9h11.126A4.002 4.002 0 0 0 22 8a4 4 0 0 0-7.874-1H3a1 1 0 0 0 0 2Zm18 6H9.874A4.002 4.002 0 0 0 2 16a4 4 0 0 0 7.874 1H21a1 1 0 1 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1o = Object.defineProperty;
var __getOwnPropSymbols$1o = Object.getOwnPropertySymbols;
var __hasOwnProp$1o = Object.prototype.hasOwnProperty;
var __propIsEnum$1o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1o = (obj, key, value) => key in obj ? __defProp$1o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1o.call(b, prop))
      __defNormalProp$1o(a, prop, b[prop]);
  if (__getOwnPropSymbols$1o)
    for (var prop of __getOwnPropSymbols$1o(b)) {
      if (__propIsEnum$1o.call(b, prop))
        __defNormalProp$1o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1o)
    for (var prop of __getOwnPropSymbols$1o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgShapesDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1o(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 2.5V12m8.5 4.722-7.723-4.29c-.284-.158-.425-.237-.575-.268a.998.998 0 0 0-.403 0c-.15.031-.292.11-.576.268L3.5 16.722",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-5.441V7.94c0-.342 0-.513-.05-.666a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.268a1 1 0 0 0-.403 0c-.15.031-.292.11-.576.268l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.94v8.118c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a1 1 0 0 0 .215-.364c.05-.152.05-.324.05-.666Z"
      }
    )
  );
};

var __defProp$1n = Object.defineProperty;
var __getOwnPropSymbols$1n = Object.getOwnPropertySymbols;
var __hasOwnProp$1n = Object.prototype.hasOwnProperty;
var __propIsEnum$1n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1n = (obj, key, value) => key in obj ? __defProp$1n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1n.call(b, prop))
      __defNormalProp$1n(a, prop, b[prop]);
  if (__getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(b)) {
      if (__propIsEnum$1n.call(b, prop))
        __defNormalProp$1n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgShapesSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1n(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M11 2.262a.5.5 0 0 0-.743-.437L3.686 5.481a.5.5 0 0 0 0 .874l6.571 3.65A.5.5 0 0 0 11 9.568V2.262ZM2.743 8.119A.5.5 0 0 0 2 8.556l.003 7.122a.5.5 0 0 0 .743.437l6.408-3.56a.5.5 0 0 0 0-.874l-6.41-3.562Zm1.15 9.647a.5.5 0 0 0 0 .874l6.364 3.536a.5.5 0 0 0 .743-.437v-7.072a.5.5 0 0 0-.743-.437l-6.364 3.536ZM13 21.739a.5.5 0 0 0 .743.437l6.364-3.536a.5.5 0 0 0 0-.874l-6.364-3.536a.5.5 0 0 0-.743.437v7.072Zm8.254-5.624a.5.5 0 0 0 .743-.437L22 8.556a.5.5 0 0 0-.743-.437l-6.411 3.562a.5.5 0 0 0 0 .874l6.408 3.56Zm-.94-9.76a.5.5 0 0 0 0-.874l-6.57-3.656a.5.5 0 0 0-.744.437v7.306a.5.5 0 0 0 .743.437l6.57-3.65Z"
      }
    )
  );
};

var __defProp$1m = Object.defineProperty;
var __getOwnPropSymbols$1m = Object.getOwnPropertySymbols;
var __hasOwnProp$1m = Object.prototype.hasOwnProperty;
var __propIsEnum$1m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1m = (obj, key, value) => key in obj ? __defProp$1m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1m.call(b, prop))
      __defNormalProp$1m(a, prop, b[prop]);
  if (__getOwnPropSymbols$1m)
    for (var prop of __getOwnPropSymbols$1m(b)) {
      if (__propIsEnum$1m.call(b, prop))
        __defNormalProp$1m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1m)
    for (var prop of __getOwnPropSymbols$1m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgShareDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1m(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V14",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 6h-3.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C13 8.28 13 9.12 13 10.8V12m8-6-3-3m3 3-3 3"
      }
    )
  );
};

var __defProp$1l = Object.defineProperty;
var __getOwnPropSymbols$1l = Object.getOwnPropertySymbols;
var __hasOwnProp$1l = Object.prototype.hasOwnProperty;
var __propIsEnum$1l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1l = (obj, key, value) => key in obj ? __defProp$1l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1l.call(b, prop))
      __defNormalProp$1l(a, prop, b[prop]);
  if (__getOwnPropSymbols$1l)
    for (var prop of __getOwnPropSymbols$1l(b)) {
      if (__propIsEnum$1l.call(b, prop))
        __defNormalProp$1l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1l)
    for (var prop of __getOwnPropSymbols$1l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgShareSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1l(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M7.759 2H10a1 1 0 1 1 0 2H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V14a1 1 0 1 1 2 0v2.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m18.586 7-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L18.586 5h-.827c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C12 9.29 12 9.954 12 10.758V12a1 1 0 1 0 2 0v-1.2c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C16.361 7 16.943 7 17.8 7h.786Z"
      }
    )
  );
};

var __defProp$1k = Object.defineProperty;
var __getOwnPropSymbols$1k = Object.getOwnPropertySymbols;
var __hasOwnProp$1k = Object.prototype.hasOwnProperty;
var __propIsEnum$1k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1k = (obj, key, value) => key in obj ? __defProp$1k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1k.call(b, prop))
      __defNormalProp$1k(a, prop, b[prop]);
  if (__getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(b)) {
      if (__propIsEnum$1k.call(b, prop))
        __defNormalProp$1k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSignal03Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1k(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.243 16.243a6 6 0 1 0-8.486 0",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.586 13.414a2 2 0 1 1 2.828 0M4.93 19.071c-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142"
      }
    )
  );
};

var __defProp$1j = Object.defineProperty;
var __getOwnPropSymbols$1j = Object.getOwnPropertySymbols;
var __hasOwnProp$1j = Object.prototype.hasOwnProperty;
var __propIsEnum$1j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1j = (obj, key, value) => key in obj ? __defProp$1j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1j.call(b, prop))
      __defNormalProp$1j(a, prop, b[prop]);
  if (__getOwnPropSymbols$1j)
    for (var prop of __getOwnPropSymbols$1j(b)) {
      if (__propIsEnum$1j.call(b, prop))
        __defNormalProp$1j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1j)
    for (var prop of __getOwnPropSymbols$1j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSignal03Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1j(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.536 8.464a5 5 0 1 0-7.072 7.072A1 1 0 1 1 7.05 16.95a7 7 0 1 1 9.9 0 1 1 0 1 1-1.414-1.414 5 5 0 0 0 0-7.072Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.707 11.293a1 1 0 0 0-1.414 1.414 1 1 0 0 1-1.414 1.414 3 3 0 1 1 4.242 0 1 1 0 0 1-1.414-1.414 1 1 0 0 0 0-1.414Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.364 5.636A9 9 0 0 0 5.636 18.364a1 1 0 1 1-1.414 1.414c-4.296-4.296-4.296-11.26 0-15.556 4.296-4.296 11.26-4.296 15.556 0 4.296 4.296 4.296 11.26 0 15.556a1 1 0 0 1-1.414-1.414 9 9 0 0 0 0-12.728Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1i = Object.defineProperty;
var __getOwnPropSymbols$1i = Object.getOwnPropertySymbols;
var __hasOwnProp$1i = Object.prototype.hasOwnProperty;
var __propIsEnum$1i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1i = (obj, key, value) => key in obj ? __defProp$1i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1i.call(b, prop))
      __defNormalProp$1i(a, prop, b[prop]);
  if (__getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(b)) {
      if (__propIsEnum$1i.call(b, prop))
        __defNormalProp$1i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSlashOctagonDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1i(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m4.93 4.93 14.14 14.14",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7.391 2.469c.173-.173.26-.26.36-.322a1 1 0 0 1 .29-.12C8.156 2 8.278 2 8.523 2h6.954c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.922 4.923c.173.173.26.26.322.36.054.09.095.188.12.29.027.115.027.237.027.482v6.954c0 .245 0 .367-.028.482a.998.998 0 0 1-.12.29c-.061.1-.148.187-.32.36l-4.923 4.922c-.173.173-.26.26-.36.322a.998.998 0 0 1-.29.12c-.115.027-.237.027-.482.027H8.523c-.245 0-.367 0-.482-.028a.998.998 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32L2.47 16.608c-.173-.173-.26-.26-.322-.36a1 1 0 0 1-.12-.29C2 15.844 2 15.722 2 15.477V8.523c0-.245 0-.367.028-.482a1 1 0 0 1 .12-.29c.061-.1.148-.187.32-.36L7.392 2.47Z"
      }
    )
  );
};

var __defProp$1h = Object.defineProperty;
var __getOwnPropSymbols$1h = Object.getOwnPropertySymbols;
var __hasOwnProp$1h = Object.prototype.hasOwnProperty;
var __propIsEnum$1h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1h = (obj, key, value) => key in obj ? __defProp$1h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1h.call(b, prop))
      __defNormalProp$1h(a, prop, b[prop]);
  if (__getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(b)) {
      if (__propIsEnum$1h.call(b, prop))
        __defNormalProp$1h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSlashOctagonSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.523 1h-.051c-.19 0-.43-.001-.665.055a2 2 0 0 0-.578.24c-.206.126-.375.296-.509.43l-.036.037-4.923 4.922-.036.036c-.134.134-.304.303-.43.51a2 2 0 0 0-.24.577C1 8.043 1 8.282 1 8.472v7.056c0 .19-.001.43.055.665a2 2 0 0 0 .24.578c.126.206.296.375.43.509l.036.036 4.923 4.922.036.037c.134.134.303.304.51.43.178.11.373.19.577.24a2.8 2.8 0 0 0 .665.055h7.056c.19 0 .43.001.665-.055.204-.05.399-.13.578-.24.206-.126.375-.296.509-.43l.036-.037 4.922-4.922.037-.036c.134-.134.304-.303.43-.51a2 2 0 0 0 .24-.577c.056-.236.055-.475.055-.665V8.472c0-.19.001-.43-.055-.665a2 2 0 0 0-.24-.578c-.126-.206-.296-.375-.43-.509l-.037-.036-4.922-4.922-.036-.037c-.134-.134-.303-.304-.51-.43a1.999 1.999 0 0 0-.577-.24C15.957 1 15.718 1 15.528 1H8.523ZM19.07 17.656l1.754-1.754c.093-.093.139-.14.171-.175l.002-.002v-.004c.003-.047.003-.113.003-.244V8.523c0-.131 0-.197-.003-.244v-.004l-.002-.002a6.356 6.356 0 0 0-.17-.175l-4.923-4.922a6.29 6.29 0 0 0-.175-.171l-.002-.002h-.004A6.186 6.186 0 0 0 15.477 3H8.523c-.131 0-.197 0-.244.002h-.004l-.002.003c-.67.61-1.929 1.925-1.929 1.925L19.07 17.656ZM4.93 6.344 17.656 19.07l-1.754 1.754c-.093.093-.14.139-.175.171l-.002.002h-.004a6.132 6.132 0 0 1-.244.003H8.523c-.131 0-.197 0-.244-.002h-.004l-.002-.003a6.16 6.16 0 0 1-.175-.17l-4.922-4.923a6.19 6.19 0 0 1-.171-.175l-.002-.002v-.004A6.18 6.18 0 0 1 3 15.477V8.523c0-.131 0-.197.002-.244v-.004l.003-.002a6.2 6.2 0 0 1 .17-.175L4.93 6.344Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1g = Object.defineProperty;
var __getOwnPropSymbols$1g = Object.getOwnPropertySymbols;
var __hasOwnProp$1g = Object.prototype.hasOwnProperty;
var __propIsEnum$1g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1g = (obj, key, value) => key in obj ? __defProp$1g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1g.call(b, prop))
      __defNormalProp$1g(a, prop, b[prop]);
  if (__getOwnPropSymbols$1g)
    for (var prop of __getOwnPropSymbols$1g(b)) {
      if (__propIsEnum$1g.call(b, prop))
        __defNormalProp$1g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1g)
    for (var prop of __getOwnPropSymbols$1g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSlideshowDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 17-5 5m11-5 5 5M12 2v2m0 18v-5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v6.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 17 19.92 17 18.8 17H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 15.48 2 14.92 2 13.8V7.2Z"
      }
    )
  );
};

var __defProp$1f = Object.defineProperty;
var __getOwnPropSymbols$1f = Object.getOwnPropertySymbols;
var __hasOwnProp$1f = Object.prototype.hasOwnProperty;
var __propIsEnum$1f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1f = (obj, key, value) => key in obj ? __defProp$1f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1f.call(b, prop))
      __defNormalProp$1f(a, prop, b[prop]);
  if (__getOwnPropSymbols$1f)
    for (var prop of __getOwnPropSymbols$1f(b)) {
      if (__propIsEnum$1f.call(b, prop))
        __defNormalProp$1f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1f)
    for (var prop of __getOwnPropSymbols$1f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSlideshowSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 1a1 1 0 0 1 1 1v1h5.838c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v6.678c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031h-1.425l3.293 3.293a1 1 0 0 1-1.414 1.414L14.586 18H13v4a1 1 0 1 1-2 0v-4H9.414l-4.707 4.707a1 1 0 0 1-1.414-1.414L6.586 18H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 14.82 1 14.365 1 13.839V7.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 3 4.635 3 5.161 3H11V2a1 1 0 0 1 1-1Z"
      }
    )
  );
};

var __defProp$1e = Object.defineProperty;
var __getOwnPropSymbols$1e = Object.getOwnPropertySymbols;
var __hasOwnProp$1e = Object.prototype.hasOwnProperty;
var __propIsEnum$1e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1e = (obj, key, value) => key in obj ? __defProp$1e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1e.call(b, prop))
      __defNormalProp$1e(a, prop, b[prop]);
  if (__getOwnPropSymbols$1e)
    for (var prop of __getOwnPropSymbols$1e(b)) {
      if (__propIsEnum$1e.call(b, prop))
        __defNormalProp$1e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1e)
    for (var prop of __getOwnPropSymbols$1e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSmileyDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 14s1.5 2 4 2 4-2 4-2m1-4.76c-.395.485-.935.76-1.5.76s-1.09-.275-1.5-.76m-4 0c-.395.485-.935.76-1.5.76S7.41 9.725 7 9.24"
      }
    )
  );
};

var __defProp$1d = Object.defineProperty;
var __getOwnPropSymbols$1d = Object.getOwnPropertySymbols;
var __hasOwnProp$1d = Object.prototype.hasOwnProperty;
var __propIsEnum$1d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1d = (obj, key, value) => key in obj ? __defProp$1d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1d.call(b, prop))
      __defNormalProp$1d(a, prop, b[prop]);
  if (__getOwnPropSymbols$1d)
    for (var prop of __getOwnPropSymbols$1d(b)) {
      if (__propIsEnum$1d.call(b, prop))
        __defNormalProp$1d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1d)
    for (var prop of __getOwnPropSymbols$1d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSmileySolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm-1.225 8.872a1 1 0 0 0-1.55-1.263C8.995 8.89 8.727 9 8.5 9c-.217 0-.479-.1-.736-.406a1 1 0 0 0-1.528 1.292C6.8 10.55 7.587 11 8.5 11c.903 0 1.715-.44 2.275-1.128Zm6.856-1.407a1 1 0 0 1 .144 1.407C17.215 10.559 16.403 11 15.5 11c-.913 0-1.701-.449-2.264-1.114a1 1 0 0 1 1.528-1.292c.257.305.519.406.736.406.227 0 .495-.11.725-.391a1 1 0 0 1 1.406-.144Zm-8.834 4.93A1 1 0 0 0 7.2 14.6a5.62 5.62 0 0 0 .351.404c.213.222.522.513.923.805.798.58 2 1.191 3.526 1.191 1.526 0 2.728-.61 3.526-1.191a6.951 6.951 0 0 0 1.17-1.08l.104-.129a1 1 0 0 0-1.597-1.204l-.005.006a3.654 3.654 0 0 1-.194.219 4.947 4.947 0 0 1-.655.57c-.577.42-1.374.809-2.349.809-.974 0-1.772-.389-2.35-.809a4.952 4.952 0 0 1-.815-.748 1.965 1.965 0 0 1-.033-.041l-.005-.006Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1c = Object.defineProperty;
var __getOwnPropSymbols$1c = Object.getOwnPropertySymbols;
var __hasOwnProp$1c = Object.prototype.hasOwnProperty;
var __propIsEnum$1c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1c = (obj, key, value) => key in obj ? __defProp$1c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1c.call(b, prop))
      __defNormalProp$1c(a, prop, b[prop]);
  if (__getOwnPropSymbols$1c)
    for (var prop of __getOwnPropSymbols$1c(b)) {
      if (__propIsEnum$1c.call(b, prop))
        __defNormalProp$1c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1c)
    for (var prop of __getOwnPropSymbols$1c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSquareSetDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M19.4 14h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 14.76 14 15.04 14 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 14 19.96 14 19.4 14Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 10 4.04 10 4.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 3 8.96 3 8.4 3Zm11 0h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 3.76 14 4.04 14 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 10 15.04 10 15.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 9.24 21 8.96 21 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3Zm-11 11H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 14.76 3 15.04 3 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 20.24 10 19.96 10 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 14 8.96 14 8.4 14Z"
      }
    )
  );
};

var __defProp$1b = Object.defineProperty;
var __getOwnPropSymbols$1b = Object.getOwnPropertySymbols;
var __hasOwnProp$1b = Object.prototype.hasOwnProperty;
var __propIsEnum$1b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1b = (obj, key, value) => key in obj ? __defProp$1b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1b.call(b, prop))
      __defNormalProp$1b(a, prop, b[prop]);
  if (__getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(b)) {
      if (__propIsEnum$1b.call(b, prop))
        __defNormalProp$1b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSquareSetSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.568 2h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201C8.93 11 8.684 11 8.432 11H4.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C2 8.93 2 8.684 2 8.432V4.568c0-.252 0-.498.017-.706a2.03 2.03 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.03 2.03 0 0 1 .77-.201C4.07 2 4.316 2 4.568 2Zm0 11h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201C8.93 22 8.684 22 8.432 22H4.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C2 19.93 2 19.684 2 19.432v-3.864c0-.252 0-.498.017-.706a2.03 2.03 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.02 2.02 0 0 1 .77-.201C4.07 13 4.316 13 4.568 13Zm11-11h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 8.93 13 8.684 13 8.432V4.568c0-.252 0-.498.017-.706a2.02 2.02 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.03 2.03 0 0 1 .77-.201C15.07 2 15.316 2 15.568 2Zm0 11h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 19.93 13 19.684 13 19.432v-3.864c0-.252 0-.498.017-.706a2.02 2.02 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.02 2.02 0 0 1 .77-.201c.208-.017.454-.017.706-.017Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1a = Object.defineProperty;
var __getOwnPropSymbols$1a = Object.getOwnPropertySymbols;
var __hasOwnProp$1a = Object.prototype.hasOwnProperty;
var __propIsEnum$1a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1a = (obj, key, value) => key in obj ? __defProp$1a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1a.call(b, prop))
      __defNormalProp$1a(a, prop, b[prop]);
  if (__getOwnPropSymbols$1a)
    for (var prop of __getOwnPropSymbols$1a(b)) {
      if (__propIsEnum$1a.call(b, prop))
        __defNormalProp$1a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1a)
    for (var prop of __getOwnPropSymbols$1a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStackDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 9.5 2 12l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 12l-5-2.5m-10 5L2 17l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 17l-5-2.5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12.358 2.179a1.028 1.028 0 0 0-.266-.111.5.5 0 0 0-.184 0c-.069.012-.135.045-.266.11L2 7l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.013.135-.045.266-.11L22 7l-9.642-4.821Z"
      }
    )
  );
};

var __defProp$19 = Object.defineProperty;
var __getOwnPropSymbols$19 = Object.getOwnPropertySymbols;
var __hasOwnProp$19 = Object.prototype.hasOwnProperty;
var __propIsEnum$19 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$19 = (obj, key, value) => key in obj ? __defProp$19(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$19 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$19.call(b, prop))
      __defNormalProp$19(a, prop, b[prop]);
  if (__getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(b)) {
      if (__propIsEnum$19.call(b, prop))
        __defNormalProp$19(a, prop, b[prop]);
    }
  return a;
};
var __objRest$19 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$19.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$19.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStackSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$19(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$19({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.723 1.085a1.5 1.5 0 0 1 .554 0 1.902 1.902 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014c-.093.047-.286.146-.502.186a1.5 1.5 0 0 1-.554 0 1.885 1.885 0 0 1-.502-.186l-.026-.013-9.642-4.822a1 1 0 0 1 0-1.788l9.642-4.822.026-.013c.093-.047.286-.146.502-.186Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m2.528 10.618-.975.487a1 1 0 0 0 0 1.79l9.642 4.82.026.013c.093.048.286.147.502.187a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.187l.026-.013 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.886-.011.006c-.05.025-.17.085-.29.138a3.495 3.495 0 0 1-2.043.233 3.495 3.495 0 0 1-.754-.233 6.215 6.215 0 0 1-.289-.138l-.011-.005-7.773-3.887Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m2.528 15.618-.975.487a1 1 0 0 0 0 1.79l9.642 4.82.026.013c.093.048.286.147.502.187a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.187l.026-.013 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.886-.011.006a5.936 5.936 0 0 1-.29.137 3.489 3.489 0 0 1-2.043.234 3.489 3.489 0 0 1-.754-.234 5.936 5.936 0 0 1-.289-.137l-.011-.006-7.773-3.886Z"
      }
    )
  );
};

var __defProp$18 = Object.defineProperty;
var __getOwnPropSymbols$18 = Object.getOwnPropertySymbols;
var __hasOwnProp$18 = Object.prototype.hasOwnProperty;
var __propIsEnum$18 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$18 = (obj, key, value) => key in obj ? __defProp$18(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$18 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$18.call(b, prop))
      __defNormalProp$18(a, prop, b[prop]);
  if (__getOwnPropSymbols$18)
    for (var prop of __getOwnPropSymbols$18(b)) {
      if (__propIsEnum$18.call(b, prop))
        __defNormalProp$18(a, prop, b[prop]);
    }
  return a;
};
var __objRest$18 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$18.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$18)
    for (var prop of __getOwnPropSymbols$18(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$18.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStagesDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$18(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$18({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$17 = Object.defineProperty;
var __getOwnPropSymbols$17 = Object.getOwnPropertySymbols;
var __hasOwnProp$17 = Object.prototype.hasOwnProperty;
var __propIsEnum$17 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$17 = (obj, key, value) => key in obj ? __defProp$17(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$17 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$17.call(b, prop))
      __defNormalProp$17(a, prop, b[prop]);
  if (__getOwnPropSymbols$17)
    for (var prop of __getOwnPropSymbols$17(b)) {
      if (__propIsEnum$17.call(b, prop))
        __defNormalProp$17(a, prop, b[prop]);
    }
  return a;
};
var __objRest$17 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$17.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$17)
    for (var prop of __getOwnPropSymbols$17(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$17.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStagesSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$17(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$17({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$16 = Object.defineProperty;
var __getOwnPropSymbols$16 = Object.getOwnPropertySymbols;
var __hasOwnProp$16 = Object.prototype.hasOwnProperty;
var __propIsEnum$16 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$16 = (obj, key, value) => key in obj ? __defProp$16(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$16 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$16.call(b, prop))
      __defNormalProp$16(a, prop, b[prop]);
  if (__getOwnPropSymbols$16)
    for (var prop of __getOwnPropSymbols$16(b)) {
      if (__propIsEnum$16.call(b, prop))
        __defNormalProp$16(a, prop, b[prop]);
    }
  return a;
};
var __objRest$16 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$16.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$16)
    for (var prop of __getOwnPropSymbols$16(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$16.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStar01Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$16(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$16({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11.283 3.453c.23-.467.345-.7.502-.775a.5.5 0 0 1 .43 0c.157.075.272.308.502.775l2.187 4.43c.068.138.102.207.152.26a.5.5 0 0 0 .155.114c.066.03.143.042.295.064l4.891.715c.515.075.773.113.892.238a.5.5 0 0 1 .133.41c-.023.172-.21.353-.583.716l-3.538 3.446c-.11.108-.165.162-.2.226a.5.5 0 0 0-.06.183c-.009.072.004.148.03.3l.835 4.867c.088.514.132.77.05.922a.5.5 0 0 1-.349.253c-.17.032-.4-.09-.862-.332l-4.373-2.3c-.136-.07-.204-.107-.276-.12a.498.498 0 0 0-.192 0c-.072.013-.14.05-.276.12l-4.373 2.3c-.461.243-.692.364-.862.332a.5.5 0 0 1-.348-.253c-.083-.152-.039-.409.049-.922l.835-4.867c.026-.152.039-.228.03-.3a.5.5 0 0 0-.06-.184c-.035-.063-.09-.117-.2-.225L3.16 10.4c-.373-.363-.56-.544-.583-.716a.5.5 0 0 1 .133-.41c.12-.125.377-.163.892-.238l4.891-.715c.152-.022.228-.034.295-.064a.5.5 0 0 0 .155-.113c.05-.054.084-.123.152-.26l2.187-4.43Z"
      }
    )
  );
};

var __defProp$15 = Object.defineProperty;
var __getOwnPropSymbols$15 = Object.getOwnPropertySymbols;
var __hasOwnProp$15 = Object.prototype.hasOwnProperty;
var __propIsEnum$15 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$15 = (obj, key, value) => key in obj ? __defProp$15(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$15 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$15.call(b, prop))
      __defNormalProp$15(a, prop, b[prop]);
  if (__getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(b)) {
      if (__propIsEnum$15.call(b, prop))
        __defNormalProp$15(a, prop, b[prop]);
    }
  return a;
};
var __objRest$15 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$15.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$15.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStar01Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$15(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$15({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.646 1.776a1.5 1.5 0 0 0-1.292 0c-.353.168-.547.46-.645.62a7.735 7.735 0 0 0-.307.583L8.245 7.346l-4.822.705a7.57 7.57 0 0 0-.65.113c-.182.044-.52.139-.789.423a1.5 1.5 0 0 0-.398 1.228c.051.387.27.663.391.805.127.148.295.312.46.472l3.488 3.397-.823 4.799a7.752 7.752 0 0 0-.095.652c-.014.187-.029.538.158.882a1.5 1.5 0 0 0 1.045.759c.384.071.714-.051.887-.123a7.79 7.79 0 0 0 .591-.291L12 18.9l4.31 2.267c.204.107.412.216.592.29.174.073.503.195.887.124a1.5 1.5 0 0 0 1.045-.76c.187-.343.172-.694.158-.881a7.757 7.757 0 0 0-.095-.652l-.822-4.799 3.487-3.397c.165-.16.333-.324.46-.472.122-.142.34-.418.39-.805a1.5 1.5 0 0 0-.397-1.228c-.27-.284-.607-.38-.79-.423a7.477 7.477 0 0 0-.649-.113l-4.822-.705L13.6 2.98a7.736 7.736 0 0 0-.308-.582c-.098-.16-.292-.453-.645-.621Z"
      }
    )
  );
};

var __defProp$14 = Object.defineProperty;
var __getOwnPropSymbols$14 = Object.getOwnPropertySymbols;
var __hasOwnProp$14 = Object.prototype.hasOwnProperty;
var __propIsEnum$14 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$14 = (obj, key, value) => key in obj ? __defProp$14(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$14 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$14.call(b, prop))
      __defNormalProp$14(a, prop, b[prop]);
  if (__getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(b)) {
      if (__propIsEnum$14.call(b, prop))
        __defNormalProp$14(a, prop, b[prop]);
    }
  return a;
};
var __objRest$14 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$14.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$14.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStar02Duo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$14(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$14({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11.306 3.207c.228-.396.342-.594.49-.66a.5.5 0 0 1 .408 0c.148.066.262.264.49.66l1.955 3.402c.084.147.126.22.185.273a.5.5 0 0 0 .18.105c.077.024.161.024.33.024l3.924-.008c.457-.001.685-.002.817.094a.5.5 0 0 1 .203.353c.017.162-.097.36-.326.754l-1.97 3.395c-.084.146-.126.219-.143.297a.503.503 0 0 0 0 .208c.017.078.059.151.144.297l1.969 3.395c.229.395.343.592.326.754a.5.5 0 0 1-.203.353c-.132.096-.36.095-.817.094l-3.924-.008c-.169 0-.253 0-.33.024a.501.501 0 0 0-.18.105c-.059.053-.101.126-.185.273l-1.955 3.402c-.228.396-.342.594-.49.66a.5.5 0 0 1-.408 0c-.148-.066-.262-.264-.49-.66l-1.955-3.402c-.084-.147-.126-.22-.185-.273a.5.5 0 0 0-.18-.105c-.077-.024-.161-.024-.33-.024l-3.924.008c-.457.001-.685.002-.817-.094a.5.5 0 0 1-.203-.353c-.017-.162.097-.36.326-.754l1.97-3.395c.084-.146.126-.219.143-.297a.5.5 0 0 0 0-.208c-.017-.078-.059-.151-.144-.297L4.038 8.204c-.229-.395-.343-.592-.326-.754a.5.5 0 0 1 .203-.353c.132-.096.36-.095.817-.094l3.924.008c.169 0 .253 0 .33-.024a.5.5 0 0 0 .18-.105c.059-.053.101-.126.185-.273l1.955-3.402Z"
      }
    )
  );
};

var __defProp$13 = Object.defineProperty;
var __getOwnPropSymbols$13 = Object.getOwnPropertySymbols;
var __hasOwnProp$13 = Object.prototype.hasOwnProperty;
var __propIsEnum$13 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$13 = (obj, key, value) => key in obj ? __defProp$13(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$13 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$13.call(b, prop))
      __defNormalProp$13(a, prop, b[prop]);
  if (__getOwnPropSymbols$13)
    for (var prop of __getOwnPropSymbols$13(b)) {
      if (__propIsEnum$13.call(b, prop))
        __defNormalProp$13(a, prop, b[prop]);
    }
  return a;
};
var __objRest$13 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$13.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$13)
    for (var prop of __getOwnPropSymbols$13(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$13.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStar02Solid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$13(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$13({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.611 1.634a1.5 1.5 0 0 0-1.222 0 1.537 1.537 0 0 0-.626.544c-.102.146-.208.33-.307.502L8.542 6.01l-3.84-.007c-.2 0-.412-.001-.59.015-.181.016-.494.06-.784.27a1.5 1.5 0 0 0-.611 1.058 1.55 1.55 0 0 0 .158.814c.075.162.182.345.282.517L5.084 12l-1.927 3.322c-.1.173-.207.356-.282.518a1.543 1.543 0 0 0-.158.814 1.5 1.5 0 0 0 .611 1.058c.29.21.603.254.784.27.178.016.39.016.59.015l3.84-.008 1.914 3.33c.099.173.205.357.307.503.105.15.3.398.626.544a1.5 1.5 0 0 0 1.222 0c.327-.146.521-.395.626-.544.102-.146.208-.33.307-.502l1.914-3.33 3.841.007c.2 0 .411.001.589-.015.181-.016.494-.06.784-.27a1.5 1.5 0 0 0 .611-1.058 1.542 1.542 0 0 0-.158-.814 6.821 6.821 0 0 0-.282-.518L18.916 12l1.927-3.323c.1-.172.207-.355.282-.517a1.55 1.55 0 0 0 .158-.814 1.5 1.5 0 0 0-.611-1.059 1.543 1.543 0 0 0-.784-.27 6.828 6.828 0 0 0-.589-.014l-3.84.007-1.915-3.33a6.852 6.852 0 0 0-.307-.502 1.53 1.53 0 0 0-.626-.544Z"
      }
    )
  );
};

var __defProp$12 = Object.defineProperty;
var __getOwnPropSymbols$12 = Object.getOwnPropertySymbols;
var __hasOwnProp$12 = Object.prototype.hasOwnProperty;
var __propIsEnum$12 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$12 = (obj, key, value) => key in obj ? __defProp$12(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$12 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$12.call(b, prop))
      __defNormalProp$12(a, prop, b[prop]);
  if (__getOwnPropSymbols$12)
    for (var prop of __getOwnPropSymbols$12(b)) {
      if (__propIsEnum$12.call(b, prop))
        __defNormalProp$12(a, prop, b[prop]);
    }
  return a;
};
var __objRest$12 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$12.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$12)
    for (var prop of __getOwnPropSymbols$12(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$12.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStatusPinDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$12(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$12({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("circle", { cx: 17, cy: 11, r: 10, stroke: "currentColor", strokeWidth: 2 }),
    /* @__PURE__ */ React__namespace.createElement("g", { filter: "url(#status-pin-duo_svg__a)", opacity: 0.4 }, /* @__PURE__ */ React__namespace.createElement("circle", { cx: 17, cy: 11, r: 4.545, fill: "currentColor" })),
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement(
      "filter",
      {
        id: "status-pin-duo_svg__a",
        width: 33.091,
        height: 33.091,
        x: 0.455,
        y: 4.455,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
      /* @__PURE__ */ React__namespace.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement(
        "feMorphology",
        {
          in: "SourceAlpha",
          radius: 2,
          result: "effect1_dropShadow_49_2307"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement("feOffset", { dy: 4 }),
      /* @__PURE__ */ React__namespace.createElement("feGaussianBlur", { stdDeviation: 3 }),
      /* @__PURE__ */ React__namespace.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" }),
      /* @__PURE__ */ React__namespace.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_49_2307" }),
      /* @__PURE__ */ React__namespace.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement(
        "feMorphology",
        {
          in: "SourceAlpha",
          radius: 3,
          result: "effect2_dropShadow_49_2307"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement("feOffset", { dy: 10 }),
      /* @__PURE__ */ React__namespace.createElement("feGaussianBlur", { stdDeviation: 7.5 }),
      /* @__PURE__ */ React__namespace.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ React__namespace.createElement(
        "feBlend",
        {
          in2: "effect1_dropShadow_49_2307",
          result: "effect2_dropShadow_49_2307"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement(
        "feBlend",
        {
          in: "SourceGraphic",
          in2: "effect2_dropShadow_49_2307",
          result: "shape"
        }
      )
    ))
  );
};

var __defProp$11 = Object.defineProperty;
var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$11 = (obj, key, value) => key in obj ? __defProp$11(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$11 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$11.call(b, prop))
      __defNormalProp$11(a, prop, b[prop]);
  if (__getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(b)) {
      if (__propIsEnum$11.call(b, prop))
        __defNormalProp$11(a, prop, b[prop]);
    }
  return a;
};
var __objRest$11 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$11.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$11.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStatusPinSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$11(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$11({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("circle", { cx: 17, cy: 11, r: 10, stroke: "currentColor", strokeWidth: 2 }),
    /* @__PURE__ */ React__namespace.createElement("g", { filter: "url(#status-pin-solid_svg__a)" }, /* @__PURE__ */ React__namespace.createElement("circle", { cx: 17, cy: 11, r: 4.545, fill: "currentColor" })),
    /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement(
      "filter",
      {
        id: "status-pin-solid_svg__a",
        width: 33.091,
        height: 33.091,
        x: 0.455,
        y: 4.455,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React__namespace.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
      /* @__PURE__ */ React__namespace.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement(
        "feMorphology",
        {
          in: "SourceAlpha",
          radius: 2,
          result: "effect1_dropShadow_130_378"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement("feOffset", { dy: 4 }),
      /* @__PURE__ */ React__namespace.createElement("feGaussianBlur", { stdDeviation: 3 }),
      /* @__PURE__ */ React__namespace.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" }),
      /* @__PURE__ */ React__namespace.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_130_378" }),
      /* @__PURE__ */ React__namespace.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement(
        "feMorphology",
        {
          in: "SourceAlpha",
          radius: 3,
          result: "effect2_dropShadow_130_378"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement("feOffset", { dy: 10 }),
      /* @__PURE__ */ React__namespace.createElement("feGaussianBlur", { stdDeviation: 7.5 }),
      /* @__PURE__ */ React__namespace.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ React__namespace.createElement(
        "feBlend",
        {
          in2: "effect1_dropShadow_130_378",
          result: "effect2_dropShadow_130_378"
        }
      ),
      /* @__PURE__ */ React__namespace.createElement(
        "feBlend",
        {
          in: "SourceGraphic",
          in2: "effect2_dropShadow_130_378",
          result: "shape"
        }
      )
    ))
  );
};

var __defProp$10 = Object.defineProperty;
var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$10 = (obj, key, value) => key in obj ? __defProp$10(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$10 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$10.call(b, prop))
      __defNormalProp$10(a, prop, b[prop]);
  if (__getOwnPropSymbols$10)
    for (var prop of __getOwnPropSymbols$10(b)) {
      if (__propIsEnum$10.call(b, prop))
        __defNormalProp$10(a, prop, b[prop]);
    }
  return a;
};
var __objRest$10 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$10.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$10)
    for (var prop of __getOwnPropSymbols$10(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$10.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStatusWorkingDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$10(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$10({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20.453 12.893A8.5 8.5 0 0 1 4.638 16.25l-.25-.433m-.842-4.71A8.5 8.5 0 0 1 19.361 7.75l.25.433M3.493 18.066l.732-2.732 2.733.732m10.085-8.132 2.732.732.732-2.732",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 7.5V12l2.5 1.5"
      }
    )
  );
};

var __defProp$$ = Object.defineProperty;
var __getOwnPropSymbols$$ = Object.getOwnPropertySymbols;
var __hasOwnProp$$ = Object.prototype.hasOwnProperty;
var __propIsEnum$$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$$ = (obj, key, value) => key in obj ? __defProp$$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$$.call(b, prop))
      __defNormalProp$$(a, prop, b[prop]);
  if (__getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(b)) {
      if (__propIsEnum$$.call(b, prop))
        __defNormalProp$$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStatusWorkingSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$$(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m19.54 5.675-.108.406C16.553 2.457 11.379 1.389 7.25 3.773a9.488 9.488 0 0 0-4.698 7.229 1 1 0 0 0 1.989.211A7.502 7.502 0 0 1 17.645 7.06l-.344-.092a1 1 0 1 0-.517 1.932l2.732.732a1 1 0 0 0 1.225-.707l.732-2.732a1 1 0 1 0-1.932-.518Zm1.02 6.224a1 1 0 0 1 .888 1.1 9.488 9.488 0 0 1-4.698 7.228c-4.129 2.384-9.303 1.316-12.182-2.308l-.109.406a1 1 0 1 1-1.932-.518l.733-2.732a1 1 0 0 1 1.224-.707l2.732.732a1 1 0 1 1-.517 1.932l-.345-.092a7.503 7.503 0 0 0 13.105-4.153 1 1 0 0 1 1.1-.889Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13 7.5a1 1 0 0 0-2 0V12a1 1 0 0 0 .486.857l2.5 1.5a1 1 0 1 0 1.028-1.714L13 11.433V7.5Z"
      }
    )
  );
};

var __defProp$_ = Object.defineProperty;
var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$_ = (obj, key, value) => key in obj ? __defProp$_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$_.call(b, prop))
      __defNormalProp$_(a, prop, b[prop]);
  if (__getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(b)) {
      if (__propIsEnum$_.call(b, prop))
        __defNormalProp$_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStrikethroughDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$_(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 12h12m-7 0h2a2.5 2.5 0 0 1 0 5h-2.167a2.334 2.334 0 0 1-2.18-1.5m6.694-7a2.334 2.334 0 0 0-2.18-1.5H11a2.5 2.5 0 0 0-2.292 1.5"
      }
    )
  );
};

var __defProp$Z = Object.defineProperty;
var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Z = (obj, key, value) => key in obj ? __defProp$Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Z.call(b, prop))
      __defNormalProp$Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$Z)
    for (var prop of __getOwnPropSymbols$Z(b)) {
      if (__propIsEnum$Z.call(b, prop))
        __defNormalProp$Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Z)
    for (var prop of __getOwnPropSymbols$Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgStrikethroughSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$Z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2Zm.033 6.1A3.5 3.5 0 0 1 11 6h2.167c1.423 0 2.635.891 3.114 2.143a1 1 0 1 1-1.868.714A1.334 1.334 0 0 0 13.167 8H11a1.5 1.5 0 0 0-1.376.9 1 1 0 0 1-1.832-.8ZM5 12a1 1 0 0 0 1 1h7a1.5 1.5 0 0 1 0 3h-2.167a1.334 1.334 0 0 1-1.246-.857 1 1 0 1 0-1.868.714A3.334 3.334 0 0 0 10.833 18H13a3.5 3.5 0 0 0 3.163-5H18a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$Y = Object.defineProperty;
var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Y = (obj, key, value) => key in obj ? __defProp$Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Y.call(b, prop))
      __defNormalProp$Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(b)) {
      if (__propIsEnum$Y.call(b, prop))
        __defNormalProp$Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSubtitlesDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$Y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 18 17.88 18 16.2 18h-2.516c-.624 0-.936 0-1.235.061a2.997 2.997 0 0 0-.761.267c-.272.14-.516.334-1.003.724L8.3 20.96c-.416.333-.624.5-.8.5a.5.5 0 0 1-.39-.188C7 21.135 7 20.868 7 20.336V18c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C3 15.395 3 14.93 3 14V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7.5 10.5h.01m4.49 0h.01m4.49 0h.01M8 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
      }
    )
  );
};

var __defProp$X = Object.defineProperty;
var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
var __hasOwnProp$X = Object.prototype.hasOwnProperty;
var __propIsEnum$X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$X = (obj, key, value) => key in obj ? __defProp$X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$X.call(b, prop))
      __defNormalProp$X(a, prop, b[prop]);
  if (__getOwnPropSymbols$X)
    for (var prop of __getOwnPropSymbols$X(b)) {
      if (__propIsEnum$X.call(b, prop))
        __defNormalProp$X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$X)
    for (var prop of __getOwnPropSymbols$X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSubtitlesSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$X(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.241 2H7.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v6.38c0 .795 0 1.386.136 1.897a4 4 0 0 0 2.829 2.829c.307.082.643.115 1.035.128v1.379c0 .235 0 .475.018.672.017.188.062.542.31.852a1.5 1.5 0 0 0 1.174.565c.397 0 .702-.187.86-.291.164-.109.351-.259.535-.406l2.413-1.93c.519-.415.673-.532.832-.614.161-.082.332-.142.508-.178.176-.036.37-.041 1.034-.041h2.557c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V7.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C17.71 2 17.046 2 16.242 2ZM6 10.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm4.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$W = Object.defineProperty;
var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
var __hasOwnProp$W = Object.prototype.hasOwnProperty;
var __propIsEnum$W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$W = (obj, key, value) => key in obj ? __defProp$W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$W.call(b, prop))
      __defNormalProp$W(a, prop, b[prop]);
  if (__getOwnPropSymbols$W)
    for (var prop of __getOwnPropSymbols$W(b)) {
      if (__propIsEnum$W.call(b, prop))
        __defNormalProp$W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$W)
    for (var prop of __getOwnPropSymbols$W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSwapVerticalDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$W(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 4v16m0 0-4-4m4 4 4-4",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 20V4m0 0L3 8m4-4 4 4"
      }
    )
  );
};

var __defProp$V = Object.defineProperty;
var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
var __hasOwnProp$V = Object.prototype.hasOwnProperty;
var __propIsEnum$V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$V = (obj, key, value) => key in obj ? __defProp$V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$V.call(b, prop))
      __defNormalProp$V(a, prop, b[prop]);
  if (__getOwnPropSymbols$V)
    for (var prop of __getOwnPropSymbols$V(b)) {
      if (__propIsEnum$V.call(b, prop))
        __defNormalProp$V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$V)
    for (var prop of __getOwnPropSymbols$V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSwapVerticalSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$V(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M7.707 3.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L6 6.414V20a1 1 0 1 0 2 0V6.414l2.293 2.293a1 1 0 1 0 1.414-1.414l-4-4ZM18 17.586V4a1 1 0 1 0-2 0v13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L18 17.586Z"
      }
    )
  );
};

var __defProp$U = Object.defineProperty;
var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
var __hasOwnProp$U = Object.prototype.hasOwnProperty;
var __propIsEnum$U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$U = (obj, key, value) => key in obj ? __defProp$U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$U.call(b, prop))
      __defNormalProp$U(a, prop, b[prop]);
  if (__getOwnPropSymbols$U)
    for (var prop of __getOwnPropSymbols$U(b)) {
      if (__propIsEnum$U.call(b, prop))
        __defNormalProp$U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$U)
    for (var prop of __getOwnPropSymbols$U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTableFileDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$U(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 3h.01M3 21h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01M7.5 21h.01M16.5 3h.01m-.01 18h.01M21 3h.01M21 21h.01M21 16.5h.01m-.01-9h.01",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 3h.01M12 21h.01M12 16.5h.01m-.01-9h.01M3 12h.01m4.49 0h.01m8.99 0h.01M12 12h.01M21 12h.01"
      }
    )
  );
};

var __defProp$T = Object.defineProperty;
var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
var __hasOwnProp$T = Object.prototype.hasOwnProperty;
var __propIsEnum$T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$T = (obj, key, value) => key in obj ? __defProp$T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$T.call(b, prop))
      __defNormalProp$T(a, prop, b[prop]);
  if (__getOwnPropSymbols$T)
    for (var prop of __getOwnPropSymbols$T(b)) {
      if (__propIsEnum$T.call(b, prop))
        __defNormalProp$T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$T)
    for (var prop of __getOwnPropSymbols$T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTableFileSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$T(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0-4.5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0-9a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1ZM6.5 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7.5a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1Zm9-18a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM11 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm0-4.5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm0-9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1ZM20 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1Zm0 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1Zm0-4.5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1Zm0-9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$S = Object.defineProperty;
var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
var __hasOwnProp$S = Object.prototype.hasOwnProperty;
var __propIsEnum$S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$S = (obj, key, value) => key in obj ? __defProp$S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$S.call(b, prop))
      __defNormalProp$S(a, prop, b[prop]);
  if (__getOwnPropSymbols$S)
    for (var prop of __getOwnPropSymbols$S(b)) {
      if (__propIsEnum$S.call(b, prop))
        __defNormalProp$S(a, prop, b[prop]);
    }
  return a;
};
var __objRest$S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$S)
    for (var prop of __getOwnPropSymbols$S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTableLayoutDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$S(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 9v12M21 9v7.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V9",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 3v6M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8V9H3V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
      }
    )
  );
};

var __defProp$R = Object.defineProperty;
var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
var __hasOwnProp$R = Object.prototype.hasOwnProperty;
var __propIsEnum$R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$R = (obj, key, value) => key in obj ? __defProp$R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$R.call(b, prop))
      __defNormalProp$R(a, prop, b[prop]);
  if (__getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(b)) {
      if (__propIsEnum$R.call(b, prop))
        __defNormalProp$R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTableLayoutSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$R(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 2 6.96 2 6.4 2h-.239c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 8 3.04 8 3.6 8h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 7.24 8 6.96 8 6.4V3.6ZM3.6 10c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.76 2 11.04 2 11.6v6.239c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H6.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.24 8 20.96 8 20.4v-8.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 10 6.96 10 6.4 10H3.6ZM10 20.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22h6.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V11.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 10 20.96 10 20.4 10h-8.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 10.76 10 11.04 10 11.6v8.8Zm12-14c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.24 8 20.96 8 20.4 8h-8.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C10 7.24 10 6.96 10 6.4V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C10.76 2 11.04 2 11.6 2h6.239c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V6.4Z"
      }
    )
  );
};

var __defProp$Q = Object.defineProperty;
var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Q = (obj, key, value) => key in obj ? __defProp$Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Q.call(b, prop))
      __defNormalProp$Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$Q)
    for (var prop of __getOwnPropSymbols$Q(b)) {
      if (__propIsEnum$Q.call(b, prop))
        __defNormalProp$Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Q)
    for (var prop of __getOwnPropSymbols$Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTagCheckDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$Q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C7.28 3 8.12 3 9.8 3h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 5.28 19 6.12 19 7.8V21l-7-4-7 4V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 10.5 2 2L15.5 8"
      }
    )
  );
};

var __defProp$P = Object.defineProperty;
var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
var __hasOwnProp$P = Object.prototype.hasOwnProperty;
var __propIsEnum$P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$P = (obj, key, value) => key in obj ? __defProp$P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$P.call(b, prop))
      __defNormalProp$P(a, prop, b[prop]);
  if (__getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(b)) {
      if (__propIsEnum$P.call(b, prop))
        __defNormalProp$P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTagCheckSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$P(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.241 2H9.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 6.29 4 6.954 4 7.758V21a1 1 0 0 0 1.496.868L12 18.152l6.504 3.716A1 1 0 0 0 20 21V7.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C15.71 2 15.046 2 14.242 2Zm1.966 6.707a1 1 0 0 0-1.414-1.414L11 11.086 9.707 9.793a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$O = Object.defineProperty;
var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
var __hasOwnProp$O = Object.prototype.hasOwnProperty;
var __propIsEnum$O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$O = (obj, key, value) => key in obj ? __defProp$O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$O.call(b, prop))
      __defNormalProp$O(a, prop, b[prop]);
  if (__getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(b)) {
      if (__propIsEnum$O.call(b, prop))
        __defNormalProp$O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTagDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$O(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 8h.01m.49 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2.937 11.937c-.346-.346-.519-.519-.642-.72a2.001 2.001 0 0 1-.24-.579C2 10.409 2 10.165 2 9.676V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h4.475c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l7.669 7.669c1.188 1.188 1.782 1.782 2.004 2.467a3 3 0 0 1 0 1.854c-.222.685-.816 1.28-2.004 2.467l-2.212 2.212c-1.188 1.188-1.782 1.782-2.467 2.004a3 3 0 0 1-1.854 0c-.685-.222-1.28-.816-2.467-2.004l-7.669-7.669Z"
      }
    )
  );
};

var __defProp$N = Object.defineProperty;
var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
var __hasOwnProp$N = Object.prototype.hasOwnProperty;
var __propIsEnum$N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$N = (obj, key, value) => key in obj ? __defProp$N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$N.call(b, prop))
      __defNormalProp$N(a, prop, b[prop]);
  if (__getOwnPropSymbols$N)
    for (var prop of __getOwnPropSymbols$N(b)) {
      if (__propIsEnum$N.call(b, prop))
        __defNormalProp$N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$N)
    for (var prop of __getOwnPropSymbols$N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTagSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$N(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.327 2.638a3 3 0 0 1 1.311-1.31c.378-.194.772-.265 1.167-.297C4.18 1 4.635 1 5.16 1h4.597c.407-.001.765-.002 1.114.082a3 3 0 0 1 .867.36c.306.186.559.44.846.728l7.757 7.757c.57.57 1.04 1.039 1.39 1.453.366.43.661.865.83 1.383a4 4 0 0 1 0 2.472c-.169.518-.464.953-.83 1.383-.35.414-.82.884-1.39 1.453l-2.27 2.27c-.57.57-1.039 1.04-1.453 1.39-.43.366-.865.661-1.383.83a4 4 0 0 1-2.472 0c-.518-.169-.953-.464-1.383-.83-.414-.35-.884-.82-1.453-1.39L2.17 12.585c-.288-.288-.542-.541-.729-.847a3 3 0 0 1-.36-.867C1 10.524 1 10.165 1 9.758V5.162c0-.528 0-.982.03-1.357.033-.395.104-.788.297-1.167ZM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$M = Object.defineProperty;
var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
var __hasOwnProp$M = Object.prototype.hasOwnProperty;
var __propIsEnum$M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$M = (obj, key, value) => key in obj ? __defProp$M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$M.call(b, prop))
      __defNormalProp$M(a, prop, b[prop]);
  if (__getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(b)) {
      if (__propIsEnum$M.call(b, prop))
        __defNormalProp$M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTagsStackDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$M(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21 11-7.594-7.594c-.519-.519-.778-.778-1.081-.964a3.001 3.001 0 0 0-.867-.36C11.112 2 10.745 2 10.012 2H6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3.937 12.937c-.346-.346-.519-.519-.642-.72a2.001 2.001 0 0 1-.24-.579C3 11.409 3 11.165 3 10.676V8.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 5.5 5.08 5.5 6.2 5.5h2.975c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l7.3 7.3c.792.792 1.188 1.188 1.337 1.645a2 2 0 0 1 0 1.236c-.149.457-.545.853-1.337 1.645l-2.474 2.474c-.792.792-1.188 1.188-1.645 1.337a2 2 0 0 1-1.236 0c-.457-.149-.853-.545-1.645-1.337l-7.8-7.8Z"
      }
    )
  );
};

var __defProp$L = Object.defineProperty;
var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
var __hasOwnProp$L = Object.prototype.hasOwnProperty;
var __propIsEnum$L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$L = (obj, key, value) => key in obj ? __defProp$L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$L.call(b, prop))
      __defNormalProp$L(a, prop, b[prop]);
  if (__getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(b)) {
      if (__propIsEnum$L.call(b, prop))
        __defNormalProp$L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTagsStackSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$L(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5 2a1 1 0 0 1 1-1h4.114c.635 0 1.114 0 1.577.11a4 4 0 0 1 1.156.48c.406.248.745.587 1.194 1.037l7.666 7.666a1 1 0 0 1-1.414 1.414l-7.594-7.594c-.553-.553-.718-.709-.897-.818a2.001 2.001 0 0 0-.578-.24c-.203-.049-.43-.055-1.212-.055H6a1 1 0 0 1-1-1Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3.638 4.827a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 7.68 2 8.135 2 8.662v2.096c0 .407 0 .766.083 1.114a3 3 0 0 0 .36.867c.186.306.44.56.728.847l7.886 7.886c.373.372.695.694.981.937.303.257.631.485 1.035.616a3 3 0 0 0 1.854 0c.404-.131.732-.359 1.035-.616.286-.243.608-.564.98-.937l2.53-2.53c.372-.372.694-.694.937-.98.257-.302.485-.631.616-1.035a3 3 0 0 0 0-1.854c-.131-.404-.36-.732-.616-1.035a17.906 17.906 0 0 0-.937-.98L12.085 5.67c-.287-.288-.54-.542-.846-.729a3 3 0 0 0-.867-.359c-.349-.084-.707-.083-1.114-.083H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297Z"
      }
    )
  );
};

var __defProp$K = Object.defineProperty;
var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
var __hasOwnProp$K = Object.prototype.hasOwnProperty;
var __propIsEnum$K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$K = (obj, key, value) => key in obj ? __defProp$K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$K.call(b, prop))
      __defNormalProp$K(a, prop, b[prop]);
  if (__getOwnPropSymbols$K)
    for (var prop of __getOwnPropSymbols$K(b)) {
      if (__propIsEnum$K.call(b, prop))
        __defNormalProp$K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$K)
    for (var prop of __getOwnPropSymbols$K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTargetDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$K(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 12a8 8 0 0 1-8 8m8-8a8 8 0 0 0-8-8m8 8h2m-10 8a8 8 0 0 1-8-8m8 8v2M4 12a8 8 0 0 1 8-8m-8 8H2m10-8V2",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      }
    )
  );
};

var __defProp$J = Object.defineProperty;
var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
var __hasOwnProp$J = Object.prototype.hasOwnProperty;
var __propIsEnum$J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$J = (obj, key, value) => key in obj ? __defProp$J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$J.call(b, prop))
      __defNormalProp$J(a, prop, b[prop]);
  if (__getOwnPropSymbols$J)
    for (var prop of __getOwnPropSymbols$J(b)) {
      if (__propIsEnum$J.call(b, prop))
        __defNormalProp$J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$J)
    for (var prop of __getOwnPropSymbols$J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTargetSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$J(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "currentColor", d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 2a1 1 0 1 0-2 0v1.055A9.004 9.004 0 0 0 3.055 11H2a1 1 0 1 0 0 2h1.055A9.004 9.004 0 0 0 11 20.945V22a1 1 0 1 0 2 0v-1.055A9.004 9.004 0 0 0 20.945 13H22a1 1 0 1 0 0-2h-1.055A9.004 9.004 0 0 0 13 3.055V2ZM7 12a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$I = Object.defineProperty;
var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
var __hasOwnProp$I = Object.prototype.hasOwnProperty;
var __propIsEnum$I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$I = (obj, key, value) => key in obj ? __defProp$I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$I.call(b, prop))
      __defNormalProp$I(a, prop, b[prop]);
  if (__getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(b)) {
      if (__propIsEnum$I.call(b, prop))
        __defNormalProp$I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTextDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$I(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.25 4v16",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 7c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C5.602 4 6.068 4 7 4h10c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 5.602 20 6.068 20 7M8 20h8M13.75 4v16"
      }
    )
  );
};

var __defProp$H = Object.defineProperty;
var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
var __hasOwnProp$H = Object.prototype.hasOwnProperty;
var __propIsEnum$H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$H = (obj, key, value) => key in obj ? __defProp$H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$H.call(b, prop))
      __defNormalProp$H(a, prop, b[prop]);
  if (__getOwnPropSymbols$H)
    for (var prop of __getOwnPropSymbols$H(b)) {
      if (__propIsEnum$H.call(b, prop))
        __defNormalProp$H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$H)
    for (var prop of __getOwnPropSymbols$H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTextFieldDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$H(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 8.52 2 9.08 2 10.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 17 4.08 17 5.2 17H13m4-10h1.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 8.52 22 9.08 22 10.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 17 19.92 17 18.8 17H17",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 21V3m2.5 0h-5m5 18h-5"
      }
    )
  );
};

var __defProp$G = Object.defineProperty;
var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
var __hasOwnProp$G = Object.prototype.hasOwnProperty;
var __propIsEnum$G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$G = (obj, key, value) => key in obj ? __defProp$G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$G.call(b, prop))
      __defNormalProp$G(a, prop, b[prop]);
  if (__getOwnPropSymbols$G)
    for (var prop of __getOwnPropSymbols$G(b)) {
      if (__propIsEnum$G.call(b, prop))
        __defNormalProp$G(a, prop, b[prop]);
    }
  return a;
};
var __objRest$G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$G)
    for (var prop of __getOwnPropSymbols$G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTextFieldSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$G(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 4h-1.5a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2H18v2h.838c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.357v3.676c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H18v2h1.5a1 1 0 1 1 0 2h-5a1 1 0 1 1 0-2H16V4Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5.161 6H13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 14.82 1 14.365 1 13.839V10.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 6 4.635 6 5.161 6Z"
      }
    )
  );
};

var __defProp$F = Object.defineProperty;
var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
var __hasOwnProp$F = Object.prototype.hasOwnProperty;
var __propIsEnum$F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$F = (obj, key, value) => key in obj ? __defProp$F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$F.call(b, prop))
      __defNormalProp$F(a, prop, b[prop]);
  if (__getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(b)) {
      if (__propIsEnum$F.call(b, prop))
        __defNormalProp$F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTextSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$F(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.968 3h10.064c.439 0 .817 0 1.13.021.33.023.66.072.986.207a3 3 0 0 1 1.624 1.624c.135.326.184.656.207.986.021.313.021.691.021 1.13V7a1 1 0 1 1-2 0c0-.48 0-.79-.017-1.026-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06A16.908 16.908 0 0 0 17 5h-2.25v14H16a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h1.25V5H7c-.48 0-.79 0-1.026.017-.228.015-.315.042-.357.06a1 1 0 0 0-.54.54c-.018.042-.045.129-.06.357C5 6.21 5 6.52 5 7a1 1 0 1 1-2 0v-.032c0-.439 0-.817.021-1.13.023-.33.072-.66.207-.986a3 3 0 0 1 1.624-1.624 3.07 3.07 0 0 1 .986-.207C6.15 3 6.529 3 6.968 3Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$E = Object.defineProperty;
var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
var __hasOwnProp$E = Object.prototype.hasOwnProperty;
var __propIsEnum$E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$E = (obj, key, value) => key in obj ? __defProp$E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$E.call(b, prop))
      __defNormalProp$E(a, prop, b[prop]);
  if (__getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(b)) {
      if (__propIsEnum$E.call(b, prop))
        __defNormalProp$E(a, prop, b[prop]);
    }
  return a;
};
var __objRest$E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTimelineDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$E(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 10c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C17 8.398 17 7.932 17 7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C15.398 4 14.932 4 14 4H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 5.602 3 6.068 3 7c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 10 5.068 10 6 10h8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 20c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C21 18.398 21 17.932 21 17c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C19.398 14 18.932 14 18 14H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 15.602 3 16.068 3 17c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 20 5.068 20 6 20h12Z"
      }
    )
  );
};

var __defProp$D = Object.defineProperty;
var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
var __hasOwnProp$D = Object.prototype.hasOwnProperty;
var __propIsEnum$D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$D = (obj, key, value) => key in obj ? __defProp$D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$D.call(b, prop))
      __defNormalProp$D(a, prop, b[prop]);
  if (__getOwnPropSymbols$D)
    for (var prop of __getOwnPropSymbols$D(b)) {
      if (__propIsEnum$D.call(b, prop))
        __defNormalProp$D(a, prop, b[prop]);
    }
  return a;
};
var __objRest$D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$D)
    for (var prop of __getOwnPropSymbols$D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTimelineSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$D(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 7.032v-.064c0-.439 0-.817-.021-1.13a3.072 3.072 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3.07 3.07 0 0 0-.986-.207C14.85 3 14.471 3 14.032 3H5.968c-.439 0-.817 0-1.13.021a3.07 3.07 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3.07 3.07 0 0 0-.207.986C2 6.15 2 6.529 2 6.968v.064c0 .439 0 .817.021 1.13.023.33.072.66.207.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207.313.021.691.021 1.13.021h8.064c.439 0 .817 0 1.13-.021.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624c.135-.326.184-.656.207-.986C18 7.85 18 7.471 18 7.032Zm4 10v-.064c0-.439 0-.817-.021-1.13a3.072 3.072 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3.073 3.073 0 0 0-.986-.207C18.85 13 18.471 13 18.032 13H5.968c-.439 0-.817 0-1.13.021a3.07 3.07 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3.069 3.069 0 0 0-.207.986C2 16.15 2 16.529 2 16.968v.064c0 .439 0 .817.021 1.13.023.33.072.66.207.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207.313.021.691.021 1.13.021h12.064c.439 0 .817 0 1.13-.021.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624c.135-.326.184-.656.207-.986.021-.313.021-.691.021-1.13Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$C = Object.defineProperty;
var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
var __hasOwnProp$C = Object.prototype.hasOwnProperty;
var __propIsEnum$C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$C = (obj, key, value) => key in obj ? __defProp$C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$C.call(b, prop))
      __defNormalProp$C(a, prop, b[prop]);
  if (__getOwnPropSymbols$C)
    for (var prop of __getOwnPropSymbols$C(b)) {
      if (__propIsEnum$C.call(b, prop))
        __defNormalProp$C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$C)
    for (var prop of __getOwnPropSymbols$C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTokenshfeatured = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$C(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#C5C5C5", d: "M5.343 7.833V5.041H2.545v2.792h2.798Z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#0129F3",
        d: "M8.305 6.437c0-.758.616-1.372 1.376-1.372a1.374 1.374 0 1 1 0 2.745c-.76 0-1.376-.615-1.376-1.373Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#57E2C5",
        d: "M19.686 6.437c0-.758.616-1.372 1.375-1.372a1.373 1.373 0 1 1 0 2.745 1.374 1.374 0 0 1-1.375-1.373Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#D7D7D7", d: "M4.826 7.265V4.521h-2.75v2.744h2.75Z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#074CF7",
        d: "M7.789 5.94c0-.77.616-1.395 1.375-1.395.76 0 1.375.625 1.375 1.395 0 .771-.616 1.396-1.375 1.396-.76 0-1.375-.625-1.375-1.396Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#FFDA46", d: "M14.045 5.064V7.81h2.703V5.064h-2.703Z" }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#FFE66C", d: "M13.48 4.544V7.29h2.75V4.544h-2.75Z" }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#EAEAEA", d: "M4.349 6.792V4H1.55v2.792h2.798Z" }),
    /* @__PURE__ */ React__namespace.createElement("path", { fill: "#FFF2A6", d: "M12.952 4.024V6.72h2.703V4.024h-2.703Z" }),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#7CEBD7",
        d: "M19.17 5.94c0-.77.615-1.395 1.375-1.395s1.375.625 1.375 1.395c0 .771-.616 1.396-1.375 1.396-.76 0-1.375-.625-1.375-1.396Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#2A8BFB",
        d: "M7.264 5.396c0-.758.616-1.372 1.376-1.372.759 0 1.375.614 1.375 1.372 0 .758-.616 1.372-1.375 1.372-.76 0-1.376-.614-1.376-1.372Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "#B2F5EA",
        d: "M18.645 5.396c0-.758.616-1.372 1.375-1.372a1.373 1.373 0 1 1 0 2.744c-.76 0-1.375-.614-1.375-1.372Z"
      }
    )
  );
};

var __defProp$B = Object.defineProperty;
var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
var __hasOwnProp$B = Object.prototype.hasOwnProperty;
var __propIsEnum$B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$B = (obj, key, value) => key in obj ? __defProp$B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$B.call(b, prop))
      __defNormalProp$B(a, prop, b[prop]);
  if (__getOwnPropSymbols$B)
    for (var prop of __getOwnPropSymbols$B(b)) {
      if (__propIsEnum$B.call(b, prop))
        __defNormalProp$B(a, prop, b[prop]);
    }
  return a;
};
var __objRest$B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$B)
    for (var prop of __getOwnPropSymbols$B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTrashDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$B(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 6v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2V6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 6h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.72 5 18.88 5 17.2V6"
      }
    )
  );
};

var __defProp$A = Object.defineProperty;
var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
var __hasOwnProp$A = Object.prototype.hasOwnProperty;
var __propIsEnum$A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$A = (obj, key, value) => key in obj ? __defProp$A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$A.call(b, prop))
      __defNormalProp$A(a, prop, b[prop]);
  if (__getOwnPropSymbols$A)
    for (var prop of __getOwnPropSymbols$A(b)) {
      if (__propIsEnum$A.call(b, prop))
        __defNormalProp$A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$A)
    for (var prop of __getOwnPropSymbols$A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTrashFullDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$A(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 6v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2V6m2 5.5v5m4-5v5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 6h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.72 5 18.88 5 17.2V6"
      }
    )
  );
};

var __defProp$z = Object.defineProperty;
var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
var __hasOwnProp$z = Object.prototype.hasOwnProperty;
var __propIsEnum$z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$z = (obj, key, value) => key in obj ? __defProp$z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$z.call(b, prop))
      __defNormalProp$z(a, prop, b[prop]);
  if (__getOwnPropSymbols$z)
    for (var prop of __getOwnPropSymbols$z(b)) {
      if (__propIsEnum$z.call(b, prop))
        __defNormalProp$z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$z)
    for (var prop of __getOwnPropSymbols$z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTrashFullSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$z(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.162 1h1.676c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.028.336.03.736.031 1.195h4a1 1 0 1 1 0 2h-1v10.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H9.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C4 18.71 4 18.046 4 17.242V7H3a1 1 0 1 1 0-2h4c0-.459.003-.86.03-1.195.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C10.18 1 10.635 1 11.162 1ZM10 10.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm5 1a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$y = Object.defineProperty;
var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
var __hasOwnProp$y = Object.prototype.hasOwnProperty;
var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$y = (obj, key, value) => key in obj ? __defProp$y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$y.call(b, prop))
      __defNormalProp$y(a, prop, b[prop]);
  if (__getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(b)) {
      if (__propIsEnum$y.call(b, prop))
        __defNormalProp$y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTrashSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$y(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.162 1h1.676c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.028.336.03.736.031 1.195h4a1 1 0 1 1 0 2h-1v10.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H9.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C4 18.71 4 18.046 4 17.242V7H3a1 1 0 1 1 0-2h4c0-.459.003-.86.03-1.195.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C10.18 1 10.635 1 11.162 1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$x = Object.defineProperty;
var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
var __hasOwnProp$x = Object.prototype.hasOwnProperty;
var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$x = (obj, key, value) => key in obj ? __defProp$x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$x.call(b, prop))
      __defNormalProp$x(a, prop, b[prop]);
  if (__getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(b)) {
      if (__propIsEnum$x.call(b, prop))
        __defNormalProp$x(a, prop, b[prop]);
    }
  return a;
};
var __objRest$x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUnderlineDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$x(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15.5 7v3.5a3.5 3.5 0 1 1-7 0V7M8 17h8"
      }
    )
  );
};

var __defProp$w = Object.defineProperty;
var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
var __hasOwnProp$w = Object.prototype.hasOwnProperty;
var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$w = (obj, key, value) => key in obj ? __defProp$w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$w.call(b, prop))
      __defNormalProp$w(a, prop, b[prop]);
  if (__getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(b)) {
      if (__propIsEnum$w.call(b, prop))
        __defNormalProp$w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUnderlineSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$w(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2ZM9.5 7a1 1 0 1 0-2 0v3.5a4.5 4.5 0 1 0 9 0V7a1 1 0 1 0-2 0v3.5a2.5 2.5 0 0 1-5 0V7ZM8 16a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$v = Object.defineProperty;
var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
var __hasOwnProp$v = Object.prototype.hasOwnProperty;
var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$v = (obj, key, value) => key in obj ? __defProp$v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$v.call(b, prop))
      __defNormalProp$v(a, prop, b[prop]);
  if (__getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(b)) {
      if (__propIsEnum$v.call(b, prop))
        __defNormalProp$v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUploadCloudDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$v(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 16.743A5.5 5.5 0 0 0 16.5 7v0a.62.62 0 0 1-.534-.302 7.5 7.5 0 1 0-11.78 9.096",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m8 16 4-4m0 0 4 4m-4-4v9"
      }
    )
  );
};

var __defProp$u = Object.defineProperty;
var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
var __hasOwnProp$u = Object.prototype.hasOwnProperty;
var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$u = (obj, key, value) => key in obj ? __defProp$u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$u.call(b, prop))
      __defNormalProp$u(a, prop, b[prop]);
  if (__getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(b)) {
      if (__propIsEnum$u.call(b, prop))
        __defNormalProp$u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUploadCloudSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$u(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 21a9 9 0 1 1 6.742-14.962A7.5 7.5 0 1 1 16.5 21H9Zm-1.707-7.293a1 1 0 0 0 1.414 0L11 11.414V17a1 1 0 1 0 2 0v-5.586l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$t = Object.defineProperty;
var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
var __hasOwnProp$t = Object.prototype.hasOwnProperty;
var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$t = (obj, key, value) => key in obj ? __defProp$t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$t.call(b, prop))
      __defNormalProp$t(a, prop, b[prop]);
  if (__getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(b)) {
      if (__propIsEnum$t.call(b, prop))
        __defNormalProp$t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUserSquareDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$t(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 21.82c0-.81.005-1.24.077-1.6a4 4 0 0 1 3.143-3.143C7.606 17 8.07 17 9 17h6c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.072.36.077.79.077 1.6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 13.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 4.28 22 5.12 22 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8Z"
      }
    )
  );
};

var __defProp$s = Object.defineProperty;
var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$s = (obj, key, value) => key in obj ? __defProp$s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$s.call(b, prop))
      __defNormalProp$s(a, prop, b[prop]);
  if (__getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(b)) {
      if (__propIsEnum$s.call(b, prop))
        __defNormalProp$s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUserSquareSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$s(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 9.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.241 1H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 5.29 1 5.954 1 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 23 5.954 23 6.758 23h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V6.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 1 18.046 1 17.242 1ZM4.092 3.218c.156-.08.38-.145.819-.18C5.361 3 5.943 3 6.8 3h10.4c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C21 5.361 21 5.943 21 6.8v10.4c0 .857 0 1.439-.038 1.889a2.78 2.78 0 0 1-.118.671 5 5 0 0 0-4.354-3.736C16.245 16 15.967 16 15.558 16H8.442c-.408 0-.687 0-.932.024a5 5 0 0 0-4.354 3.736 2.783 2.783 0 0 1-.118-.671C3 18.639 3 18.057 3 17.2V6.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$r = Object.defineProperty;
var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$r.call(b, prop))
      __defNormalProp$r(a, prop, b[prop]);
  if (__getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(b)) {
      if (__propIsEnum$r.call(b, prop))
        __defNormalProp$r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUsersDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$r(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 21v-2a4.002 4.002 0 0 0-3-3.874M15.5 3.291a4.001 4.001 0 0 1 0 7.418",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 21c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.165C13.796 15 12.864 15 11 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      }
    )
  );
};

var __defProp$q = Object.defineProperty;
var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$q.call(b, prop))
      __defNormalProp$q(a, prop, b[prop]);
  if (__getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(b)) {
      if (__propIsEnum$q.call(b, prop))
        __defNormalProp$q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgUsersSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$q(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.032 14.877a1 1 0 0 1 1.217-.72A5.002 5.002 0 0 1 23 19v2a1 1 0 1 1-2 0v-2a3.002 3.002 0 0 0-2.25-2.905 1 1 0 0 1-.718-1.218ZM14.573 2.916a1 1 0 0 1 1.302-.552 5.001 5.001 0 0 1 0 9.272 1 1 0 0 1-.75-1.854 3.001 3.001 0 0 0 0-5.564 1 1 0 0 1-.552-1.302ZM7.179 14h4.642c1.09 0 1.835 0 2.473.17a5 5 0 0 1 3.536 3.536c.23.86.163 1.778.17 2.658.001.107.003.323-.051.524a1.5 1.5 0 0 1-1.06 1.06 1.97 1.97 0 0 1-.525.052 860.579 860.579 0 0 0-13.728 0 1.993 1.993 0 0 1-.524-.051 1.5 1.5 0 0 1-1.06-1.06A1.97 1.97 0 0 1 1 20.364c.007-.878-.06-1.8.17-2.658a5 5 0 0 1 3.536-3.536C5.344 14 6.088 14 7.179 14Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$p = Object.defineProperty;
var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$p.call(b, prop))
      __defNormalProp$p(a, prop, b[prop]);
  if (__getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(b)) {
      if (__propIsEnum$p.call(b, prop))
        __defNormalProp$p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVerifiedDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$p(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11.302 21.615c.221.129.332.194.488.227.122.026.298.026.42 0 .156-.033.267-.098.488-.227C14.646 20.478 20 16.908 20 12V7.218c0-.8 0-1.2-.13-1.543a2 2 0 0 0-.548-.79c-.275-.243-.65-.383-1.398-.664l-5.362-2.01c-.208-.078-.312-.117-.419-.133a1 1 0 0 0-.286 0c-.107.016-.21.055-.419.133L6.076 4.22c-.748.281-1.122.421-1.398.665a2 2 0 0 0-.547.789C4 6.018 4 6.418 4 7.218V12c0 4.908 5.354 8.478 7.302 9.615Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 11.5 2 2L15.5 9"
      }
    )
  );
};

var __defProp$o = Object.defineProperty;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$o.call(b, prop))
      __defNormalProp$o(a, prop, b[prop]);
  if (__getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(b)) {
      if (__propIsEnum$o.call(b, prop))
        __defNormalProp$o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVerifiedSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$o(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.714 1.088a2 2 0 0 1 .572 0c.219.032.422.109.584.17l.043.016 5.492 2.06c.618.23 1.16.433 1.578.801a3 3 0 0 1 .82 1.184c.199.52.198 1.1.197 1.759V12c0 2.826-1.537 5.183-3.199 6.914-1.673 1.743-3.587 2.974-4.6 3.564l-.04.024c-.185.109-.425.25-.742.318a2.13 2.13 0 0 1-.838 0 2.42 2.42 0 0 1-.742-.317l-.04-.024c-1.013-.591-2.927-1.822-4.6-3.565C4.537 17.184 3 14.826 3 12V7.078c-.001-.66-.002-1.239.196-1.76a3 3 0 0 1 .82-1.183c.418-.368.96-.57 1.579-.801l5.492-2.06.043-.016c.162-.061.365-.138.584-.17Zm4.493 8.62a1 1 0 0 0-1.414-1.415L11 12.086l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$n = Object.defineProperty;
var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$n.call(b, prop))
      __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(b)) {
      if (__propIsEnum$n.call(b, prop))
        __defNormalProp$n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionAddDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$n(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 10.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 21v-6m-3 3h6"
      }
    )
  );
};

var __defProp$m = Object.defineProperty;
var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$m.call(b, prop))
      __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(b)) {
      if (__propIsEnum$m.call(b, prop))
        __defNormalProp$m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionAddSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$m(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20 15a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23c2.098 0 4.202.05 6.302.024.517-.006.775-.01.889-.076.132-.077.163-.114.217-.257.046-.123-.012-.487-.128-1.215A3.022 3.022 0 0 1 16 21a3 3 0 1 1 0-6 3 3 0 0 1 3.399-2.974c.776.103 1.165.155 1.286.107.145-.058.175-.084.251-.22.064-.114.064-.39.064-.939V6.76c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1Z"
      }
    )
  );
};

var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$l.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(b)) {
      if (__propIsEnum$l.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionDownloadDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$l(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m15 19 3 3m0 0 3-3m-3 3v-6"
      }
    )
  );
};

var __defProp$k = Object.defineProperty;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$k.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(b)) {
      if (__propIsEnum$k.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionDownloadSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$k(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M20 16a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L20 19.586V16Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23c1.692 0 3.384.003 5.075.003.603 0 .904 0 1.044-.12a.5.5 0 0 0 .174-.42c-.015-.184-.228-.397-.654-.824l-.518-.518A3 3 0 0 1 16 16a3 3 0 0 1 3.399-2.974c.776.103 1.165.155 1.286.107.145-.058.175-.084.251-.22.064-.114.064-.39.064-.939V6.76c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1Z"
      }
    )
  );
};

var __defProp$j = Object.defineProperty;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionLockedDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$j(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h1.7",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M19.25 17v-1.75a1.75 1.75 0 1 0-3.5 0V17m-.15 4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 17.76 14 18.04 14 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21Z"
      }
    )
  );
};

var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionLockedSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$i(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.5 13.5a2.75 2.75 0 0 0-2.75 2.75v.778a1.93 1.93 0 0 0-.658.19 2 2 0 0 0-.874.874 2.02 2.02 0 0 0-.201.77c-.017.208-.017.454-.017.706v.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h3.864c.252 0 .498 0 .706-.017a2.03 2.03 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2.03 2.03 0 0 0 .201-.77c.017-.208.017-.454.017-.706v-.864c0-.252 0-.498-.017-.706a2.022 2.022 0 0 0-.201-.77 2 2 0 0 0-.874-.874 1.926 1.926 0 0 0-.658-.19v-.778a2.75 2.75 0 0 0-2.75-2.75Zm.75 3.5v-.75a.75.75 0 0 0-1.5 0V17h1.5Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.5 13.5a2.75 2.75 0 0 0-2.75 2.75v.778a1.93 1.93 0 0 0-.658.19 2 2 0 0 0-.874.874 2.02 2.02 0 0 0-.201.77c-.017.208-.017.454-.017.706v.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h3.864c.252 0 .498 0 .706-.017a2.03 2.03 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2.03 2.03 0 0 0 .201-.77c.017-.208.017-.454.017-.706v-.864c0-.252 0-.498-.017-.706a2.022 2.022 0 0 0-.201-.77 2 2 0 0 0-.874-.874 1.926 1.926 0 0 0-.658-.19v-.778a2.75 2.75 0 0 0-2.75-2.75Zm.75 3.5v-.75a.75.75 0 0 0-1.5 0V17h1.5Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h2.392c.46 0 .688 0 .804-.067a.42.42 0 0 0 .22-.26c.046-.126-.002-.408-.1-.972a4.536 4.536 0 0 1-.05-.4C12 21.007 12 20.682 12 20.453v-.906c0-.23 0-.554.024-.848.028-.352.106-.915.412-1.515a4 4 0 0 1 1.35-1.515 4.75 4.75 0 0 1 5.897-4.02c.552.141.829.212.963.171a.432.432 0 0 0 .281-.218c.073-.12.073-.357.073-.83V6.76c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1Z"
      }
    )
  );
};

var __defProp$h = Object.defineProperty;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionPendingDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$h(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m14.5 19 2 2 4.5-4.5",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21.985 12.55c.01-.182.015-.366.015-.55 0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.435 4.337 9.858 9.739 9.997M12 6v6l3.738 1.87"
      }
    )
  );
};

var __defProp$g = Object.defineProperty;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionPendingSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$g(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22.707 16.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.793-3.793a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11a11.2 11.2 0 0 0 1.105-.055l-.038.004c.386-.05.567-.557.3-.84l.012.012a3 3 0 0 1 4.118-4.36l2.382-2.382a2.99 2.99 0 0 1 2.025-.877c.355-.012.532-.017.627-.062a.44.44 0 0 0 .204-.18c.057-.087.078-.212.119-.46.096-.586.146-1.187.146-1.8 0-6.075-4.925-11-11-11Zm0 4a1 1 0 0 1 1 1v5.382l3.447 1.724a1 1 0 1 1-.894 1.788l-4-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$f = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionRejectedDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$f(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 12V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m16 16 5 5m0-5-5 5"
      }
    )
  );
};

var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionRejectedSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$e(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.707 16.293a1 1 0 0 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 0 0 1.414 1.414l1.793-1.793 1.793 1.793a1 1 0 0 0 1.414-1.414L20.914 19.5l1.793-1.793a1 1 0 0 0-1.414-1.414L19.5 18.086l-1.793-1.793Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8.759 1h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758v6.847c0 .197 0 .296-.024.37a.425.425 0 0 1-.103.18c-.053.059-.164.124-.386.254a3 3 0 0 0-.608.47l-.379.378-.379-.378a3 3 0 1 0-4.242 4.242l.378.379-.378.379a2.99 2.99 0 0 0-.877 2.01c-.018.498-.027.746-.083.85a.406.406 0 0 1-.218.209c-.105.052-.29.052-.66.052H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1Z"
      }
    )
  );
};

var __defProp$d = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionSavedDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$d(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m14.5 19 2 2 4.5-4.5"
      }
    )
  );
};

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionSavedSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$c(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22.707 16.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.793-3.793a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M8.759 1h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758v7.347c0 .197 0 .296-.024.37a.425.425 0 0 1-.103.18c-.053.059-.164.124-.386.254a3 3 0 0 0-.608.47l-2.382 2.382a3 3 0 0 0-4.118 4.36l.037.038a.5.5 0 0 1-.348.84l-.053.001H8.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1Z"
      }
    )
  );
};

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionSettingsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$b(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 9.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.5 15.002a2.249 2.249 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01"
      }
    )
  );
};

var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionSettingsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$a(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17.988 14.672a1.248 1.248 0 0 1 1.881 1.078v.002c0 .218-.177.52-.679.854a4.287 4.287 0 0 1-.879.443l-.009.003h.001a1 1 0 0 0 .634 1.897h.001l.043-.016a6.15 6.15 0 0 0 .397-.16c.246-.109.58-.275.922-.503.622-.415 1.569-1.238 1.57-2.517a3.248 3.248 0 0 0-6.313-1.083 1 1 0 1 0 1.886.664c.098-.278.291-.512.545-.662ZM18.65 20a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483l.26-.001c.388-.028.55-.256.448-.631a21.843 21.843 0 0 0-.13-.373A2.995 2.995 0 0 1 15.65 21c0-.536.14-1.04.387-1.475a3.014 3.014 0 0 1-.414-1.654 3 3 0 0 1-1.953-3.865 5.248 5.248 0 0 1 6.106-3.377c.499.112.748.169.88.126a.442.442 0 0 0 .273-.22c.071-.118.071-.335.071-.77V6.76c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1Z"
      }
    )
  );
};

var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __objRest$9 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionWorkingDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$9(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$9({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 11.941V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 17h6"
      }
    )
  );
};

var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __objRest$8 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionWorkingSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$8(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$8({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 17a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.061-.12.092-.18.099-.282a.563.563 0 0 0-.303-.494c-.094-.04-.188-.04-.377-.04H15a3 3 0 1 1 0-6h5.2c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C21 13.62 21 13.48 21 13.2V6.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1Z"
      }
    )
  );
};

var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionsDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$7(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$7({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 16v5m0 0h-5m5 0-6-6M3 3l6 6",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 3h5m0 0v5m0-5L3 21"
      }
    )
  );
};

var __defProp$6 = Object.defineProperty;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVersionsSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$6(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$6({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M16 2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414L3.707 21.707a1 1 0 0 1-1.414-1.414L18.586 4H16a1 1 0 1 1 0-2Zm-12.293.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414-1.414l-6-6Z"
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15.707 14.293 20 18.586V16a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 1 1 0-2h2.586l-4.293-4.293a1 1 0 0 1 1.414-1.414Z"
      }
    )
  );
};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgXCloseDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$5(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$5({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18 6 6 18M6 6l12 12"
      }
    )
  );
};

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgXCloseSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$4(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$4({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293Z"
      }
    )
  );
};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgZoomInDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$3(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$3({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21 21-4.35-4.35",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11 8v6m-3-3h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      }
    )
  );
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgZoomInSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$2(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$2({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 2a9 9 0 1 0 5.618 16.032l3.675 3.675a1 1 0 0 0 1.414-1.414l-3.675-3.675A9 9 0 0 0 11 2Zm0 5a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H8a1 1 0 1 1 0-2h2V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  );
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgZoomOutDuo = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest$1(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues$1({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21 21-4.35-4.35",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 11h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      }
    )
  );
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgZoomOutSolid = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React__namespace.createElement(
    "svg",
    __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React__namespace.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React__namespace.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 2a9 9 0 1 0 5.618 16.032l3.675 3.675a1 1 0 0 0 1.414-1.414l-3.675-3.675A9 9 0 0 0 11 2Zm-3 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H8Z",
        clipRule: "evenodd"
      }
    )
  );
};

exports.AgencyDuo = SvgAgencyDuo;
exports.AgencySolid = SvgAgencySolid;
exports.AlarmDuo = SvgAlarmDuo;
exports.AlarmSolid = SvgAlarmSolid;
exports.AlertCircleDuo = SvgAlertCircleDuo;
exports.AlertCircleSolid = SvgAlertCircleSolid;
exports.AlertOctagonDuo = SvgAlertOctagonDuo;
exports.AlertOctagonSolid = SvgAlertOctagonSolid;
exports.AlertTriangleDuo = SvgAlertTriangleDuo;
exports.AlertTriangleSolid = SvgAlertTriangleSolid;
exports.AlphaOrderAzDuo = SvgAlphaOrderAzDuo;
exports.AlphaOrderAzSolid = SvgAlphaOrderAzSolid;
exports.AlphaOrderZaDuo = SvgAlphaOrderZaDuo;
exports.AlphaOrderZaSolid = SvgAlphaOrderZaSolid;
exports.AnnotationQuestionDuo = SvgAnnotationQuestionDuo;
exports.AnnotationQuestionSolid = SvgAnnotationQuestionSolid;
exports.Announcement01Duo = SvgAnnouncement01Duo;
exports.Announcement01Solid = SvgAnnouncement01Solid;
exports.ArcheryTargetDuo = SvgArcheryTargetDuo;
exports.ArcheryTargetSolid = SvgArcheryTargetSolid;
exports.ArchiveDuo = SvgArchiveDuo;
exports.ArchiveSolid = SvgArchiveSolid;
exports.ArrowBottomLeftDuo = SvgArrowBottomLeftDuo;
exports.ArrowBottomLeftSolid = SvgArrowBottomLeftSolid;
exports.ArrowBottomRightDuo = SvgArrowBottomRightDuo;
exports.ArrowBottomRightSolid = SvgArrowBottomRightSolid;
exports.ArrowCircleDownDuo = SvgArrowCircleDownDuo;
exports.ArrowCircleDownSolid = SvgArrowCircleDownSolid;
exports.ArrowCircleLeftDuo = SvgArrowCircleLeftDuo;
exports.ArrowCircleLeftSolid = SvgArrowCircleLeftSolid;
exports.ArrowCircleRightDuo = SvgArrowCircleRightDuo;
exports.ArrowCircleRightSolid = SvgArrowCircleRightSolid;
exports.ArrowCircleUpDuo = SvgArrowCircleUpDuo;
exports.ArrowCircleUpSolid = SvgArrowCircleUpSolid;
exports.ArrowDownDuo = SvgArrowDownDuo;
exports.ArrowDownSolid = SvgArrowDownSolid;
exports.ArrowLeftDuo = SvgArrowLeftDuo;
exports.ArrowLeftSolid = SvgArrowLeftSolid;
exports.ArrowRightDuo = SvgArrowRightDuo;
exports.ArrowRightSolid = SvgArrowRightSolid;
exports.ArrowTopLeftDuo = SvgArrowTopLeftDuo;
exports.ArrowTopLeftSolid = SvgArrowTopLeftSolid;
exports.ArrowTopRightDuo = SvgArrowTopRightDuo;
exports.ArrowTopRightSolid = SvgArrowTopRightSolid;
exports.ArrowUpDuo = SvgArrowUpDuo;
exports.ArrowUpSolid = SvgArrowUpSolid;
exports.ArrowsDownDuo = SvgArrowsDownDuo;
exports.ArrowsDownSolid = SvgArrowsDownSolid;
exports.AttachmentDuo = SvgAttachmentDuo;
exports.AttachmentSolid = SvgAttachmentSolid;
exports.BadgeDuo = SvgBadgeDuo;
exports.BadgeSolid = SvgBadgeSolid;
exports.BanDuo = SvgBanDuo;
exports.BanSolid = SvgBanSolid;
exports.BellDuo = SvgBellDuo;
exports.BellSolid = SvgBellSolid;
exports.BezierCurve03Duo = SvgBezierCurve03Duo;
exports.BezierCurve03Solid = SvgBezierCurve03Solid;
exports.BillDuo = SvgBillDuo;
exports.BillSolid = SvgBillSolid;
exports.BlockqouteDuo = SvgBlockqouteDuo;
exports.BlockqouteSolid = SvgBlockqouteSolid;
exports.BookOpenDuo = SvgBookOpenDuo;
exports.BookOpenSolid = SvgBookOpenSolid;
exports.BotDuo = SvgBotDuo;
exports.BotSolid = SvgBotSolid;
exports.BrandDuo = SvgBrandDuo;
exports.BrandSolid = SvgBrandSolid;
exports.BrightnessDuo = SvgBrightnessDuo;
exports.BrightnessSolid = SvgBrightnessSolid;
exports.BrowserDuo = SvgBrowserDuo;
exports.BrowserSolid = SvgBrowserSolid;
exports.Building05Duo = SvgBuilding05Duo;
exports.Building05Solid = SvgBuilding05Solid;
exports.BusinessContactDuo = SvgBusinessContactDuo;
exports.BusinessContactSolid = SvgBusinessContactSolid;
exports.CDeleteDuo = SvgCDeleteDuo;
exports.CDeleteSolid = SvgCDeleteSolid;
exports.CRemoveDuo = SvgCRemoveDuo;
exports.CRemoveSolid = SvgCRemoveSolid;
exports.CalculationDuo = SvgCalculationDuo;
exports.CalculationSolid = SvgCalculationSolid;
exports.CalculatorDuo = SvgCalculatorDuo;
exports.CalculatorSolid = SvgCalculatorSolid;
exports.CalendarAdd1Duo = SvgCalendarAdd1Duo;
exports.CalendarAdd1Solid = SvgCalendarAdd1Solid;
exports.CalendarAddDuo = SvgCalendarAddDuo;
exports.CalendarAddSolid = SvgCalendarAddSolid;
exports.CalendarCheck1Duo = SvgCalendarCheck1Duo;
exports.CalendarCheck1Solid = SvgCalendarCheck1Solid;
exports.CalendarCheckDuo = SvgCalendarCheckDuo;
exports.CalendarCheckSolid = SvgCalendarCheckSolid;
exports.CalendarDateDuo = SvgCalendarDateDuo;
exports.CalendarDateSolid = SvgCalendarDateSolid;
exports.CalendarDuo = SvgCalendarDuo;
exports.CalendarMinusDuo = SvgCalendarMinusDuo;
exports.CalendarMinusSolid = SvgCalendarMinusSolid;
exports.CalendarSolid = SvgCalendarSolid;
exports.CampaignDuo = SvgCampaignDuo;
exports.CampaignSolid = SvgCampaignSolid;
exports.CartDuo = SvgCartDuo;
exports.CartSolid = SvgCartSolid;
exports.CentralizeDuo = SvgCentralizeDuo;
exports.CentralizeSolid = SvgCentralizeSolid;
exports.ChartBarDuo = SvgChartBarDuo;
exports.ChartBarSolid = SvgChartBarSolid;
exports.ChartPieDuo = SvgChartPieDuo;
exports.ChartPieSolid = SvgChartPieSolid;
exports.CheckCircleDuo = SvgCheckCircleDuo;
exports.CheckCircleSolid = SvgCheckCircleSolid;
exports.CheckDone02Duo = SvgCheckDone02Duo;
exports.CheckDone02Solid = SvgCheckDone02Solid;
exports.CheckDuo = SvgCheckDuo;
exports.CheckSolid = SvgCheckSolid;
exports.ChevronDownDuo = SvgChevronDownDuo;
exports.ChevronDownSolid = SvgChevronDownSolid;
exports.ChevronLeftDuo = SvgChevronLeftDuo;
exports.ChevronLeftSolid = SvgChevronLeftSolid;
exports.ChevronRightDuo = SvgChevronRightDuo;
exports.ChevronRightSolid = SvgChevronRightSolid;
exports.ChevronSelectorVerticalDuo = SvgChevronSelectorVerticalDuo;
exports.ChevronSelectorVerticalSolid = SvgChevronSelectorVerticalSolid;
exports.ChevronUpDuo = SvgChevronUpDuo;
exports.ChevronUpSolid = SvgChevronUpSolid;
exports.CircleDuo = SvgCircleDuo;
exports.CircleSolid = SvgCircleSolid;
exports.ClientsDuo = SvgClientsDuo;
exports.ClientsSolid = SvgClientsSolid;
exports.ClipboardCheckDuo = SvgClipboardCheckDuo;
exports.ClipboardCheckSolid = SvgClipboardCheckSolid;
exports.ClockDuo = SvgClockDuo;
exports.ClockRewindDuo = SvgClockRewindDuo;
exports.ClockRewindSolid = SvgClockRewindSolid;
exports.ClockSolid = SvgClockSolid;
exports.ColorsDuo = SvgColorsDuo;
exports.ColorsSolid = SvgColorsSolid;
exports.Compohfeatured = SvgCompohfeatured;
exports.ContractDuo = SvgContractDuo;
exports.ContractSolid = SvgContractSolid;
exports.ConversationDuo = SvgConversationDuo;
exports.ConversationSolid = SvgConversationSolid;
exports.CopyDuo = SvgCopyDuo;
exports.CopySolid = SvgCopySolid;
exports.CreditCardDuo = SvgCreditCardDuo;
exports.CreditCardSolid = SvgCreditCardSolid;
exports.CurrencyExchangeDuo = SvgCurrencyExchangeDuo;
exports.CurrencyExchangeSolid = SvgCurrencyExchangeSolid;
exports.DataLineDuo = SvgDataLineDuo;
exports.DataLineSolid = SvgDataLineSolid;
exports.DataTableDuo = SvgDataTableDuo;
exports.DataTableSolid = SvgDataTableSolid;
exports.DataUploadDuo = SvgDataUploadDuo;
exports.DataUploadSolid = SvgDataUploadSolid;
exports.DatabaseDuo = SvgDatabaseDuo;
exports.DatabaseSolid = SvgDatabaseSolid;
exports.Dataflow01Duo = SvgDataflow01Duo;
exports.Dataflow01Solid = SvgDataflow01Solid;
exports.Dataflow02Duo = SvgDataflow02Duo;
exports.Dataflow02Solid = SvgDataflow02Solid;
exports.Dataflow04Duo = SvgDataflow04Duo;
exports.Dataflow04Solid = SvgDataflow04Solid;
exports.DecisionProcessDuo = SvgDecisionProcessDuo;
exports.DecisionProcessSolid = SvgDecisionProcessSolid;
exports.DiamondDuo = SvgDiamondDuo;
exports.DiamondSolid = SvgDiamondSolid;
exports.DocumentsDuo = SvgDocumentsDuo;
exports.DocumentsSolid = SvgDocumentsSolid;
exports.DotsHorizontalDuo = SvgDotsHorizontalDuo;
exports.DotsHorizontalSolid = SvgDotsHorizontalSolid;
exports.DotsMatrixDuo = SvgDotsMatrixDuo;
exports.DotsMatrixSolid = SvgDotsMatrixSolid;
exports.DotsVerticalDuo = SvgDotsVerticalDuo;
exports.DotsVerticalSolid = SvgDotsVerticalSolid;
exports.DownloadDuo = SvgDownloadDuo;
exports.DownloadSolid = SvgDownloadSolid;
exports.DragDuo = SvgDragDuo;
exports.DragSolid = SvgDragSolid;
exports.DropperDuo = SvgDropperDuo;
exports.DropperSolid = SvgDropperSolid;
exports.EditBoxDuo = SvgEditBoxDuo;
exports.EditBoxSolid = SvgEditBoxSolid;
exports.EditDuo = SvgEditDuo;
exports.EditSolid = SvgEditSolid;
exports.EmptyAreaDuo = SvgEmptyAreaDuo;
exports.EmptyAreaSolid = SvgEmptyAreaSolid;
exports.EmptyDuo = SvgEmptyDuo;
exports.EmptySolid = SvgEmptySolid;
exports.ExampleDataDuo = SvgExampleDataDuo;
exports.ExampleDataSolid = SvgExampleDataSolid;
exports.ExploreDuo = SvgExploreDuo;
exports.ExploreSolid = SvgExploreSolid;
exports.ExternalUsersDuo = SvgExternalUsersDuo;
exports.ExternalUsersSolid = SvgExternalUsersSolid;
exports.EyeDuo = SvgEyeDuo;
exports.EyeSolid = SvgEyeSolid;
exports.Figmahfeatured = SvgFigmahfeatured;
exports.FileBlankDuo = SvgFileBlankDuo;
exports.FileBlankSolid = SvgFileBlankSolid;
exports.FileCheckDuo = SvgFileCheckDuo;
exports.FileCheckSolid = SvgFileCheckSolid;
exports.FilePlus03Duo = SvgFilePlus03Duo;
exports.FilePlus03Solid = SvgFilePlus03Solid;
exports.FileSecuredDuo = SvgFileSecuredDuo;
exports.FileSecuredSolid = SvgFileSecuredSolid;
exports.FilesDuo = SvgFilesDuo;
exports.FilesSolid = SvgFilesSolid;
exports.FilterDuo = SvgFilterDuo;
exports.FilterOrganizationDuo = SvgFilterOrganizationDuo;
exports.FilterOrganizationSolid = SvgFilterOrganizationSolid;
exports.FilterSolid = SvgFilterSolid;
exports.Flag04Duo = SvgFlag04Duo;
exports.Flag04Solid = SvgFlag04Solid;
exports.FolderCheckDuo = SvgFolderCheckDuo;
exports.FolderCheckSolid = SvgFolderCheckSolid;
exports.FolderDuo = SvgFolderDuo;
exports.FolderPlusDuo = SvgFolderPlusDuo;
exports.FolderPlusSolid = SvgFolderPlusSolid;
exports.FolderSolid = SvgFolderSolid;
exports.FolderXDuo = SvgFolderXDuo;
exports.FolderXSolid = SvgFolderXSolid;
exports.Fontshfeatured = SvgFontshfeatured;
exports.GanttDuo = SvgGanttDuo;
exports.GanttSolid = SvgGanttSolid;
exports.GaugeDuo = SvgGaugeDuo;
exports.GaugeSolid = SvgGaugeSolid;
exports.Globe03Duo = SvgGlobe03Duo;
exports.Globe03Solid = SvgGlobe03Solid;
exports.Globe05Duo = SvgGlobe05Duo;
exports.Globe05Solid = SvgGlobe05Solid;
exports.GroupDuo = SvgGroupDuo;
exports.GroupSolid = SvgGroupSolid;
exports.HamburgerDuo = SvgHamburgerDuo;
exports.HamburgerSolid = SvgHamburgerSolid;
exports.Hash01Duo = SvgHash01Duo;
exports.Hash01Solid = SvgHash01Solid;
exports.HeadlineDuo = SvgHeadlineDuo;
exports.HeadlineSolid = SvgHeadlineSolid;
exports.HourglassDuo = SvgHourglassDuo;
exports.HourglassSolid = SvgHourglassSolid;
exports.HubDuo = SvgHubDuo;
exports.HubSolid = SvgHubSolid;
exports.IDeleteDuo = SvgIDeleteDuo;
exports.IDeleteSolid = SvgIDeleteSolid;
exports.IRemoveDuo = SvgIRemoveDuo;
exports.IRemoveSolid = SvgIRemoveSolid;
exports.Iconshfeatured = SvgIconshfeatured;
exports.Image03Duo = SvgImage03Duo;
exports.Image03Solid = SvgImage03Solid;
exports.ItalicDuo = SvgItalicDuo;
exports.ItalicSolid = SvgItalicSolid;
exports.LaughDuo = SvgLaughDuo;
exports.LaughSolid = SvgLaughSolid;
exports.LayoutDuo = SvgLayoutDuo;
exports.LayoutSolid = SvgLayoutSolid;
exports.LikeDuo = SvgLikeDuo;
exports.LikeSolid = SvgLikeSolid;
exports.LinkDuo = SvgLinkDuo;
exports.LinkSolid = SvgLinkSolid;
exports.ListDotsDuo = SvgListDotsDuo;
exports.ListDotsSolid = SvgListDotsSolid;
exports.ListSelectDuo = SvgListSelectDuo;
exports.ListSelectSolid = SvgListSelectSolid;
exports.LockDuo = SvgLockDuo;
exports.LockSolid = SvgLockSolid;
exports.LockUnlockedDuo = SvgLockUnlockedDuo;
exports.LockUnlockedSolid = SvgLockUnlockedSolid;
exports.LockedAccessDuo = SvgLockedAccessDuo;
exports.LockedAccessSolid = SvgLockedAccessSolid;
exports.LogIn03Duo = SvgLogIn03Duo;
exports.LogIn03Solid = SvgLogIn03Solid;
exports.LogOutDuo = SvgLogOutDuo;
exports.LogOutSolid = SvgLogOutSolid;
exports.MailDuo = SvgMailDuo;
exports.MailSolid = SvgMailSolid;
exports.MarketDuo = SvgMarketDuo;
exports.MarketSolid = SvgMarketSolid;
exports.MaximizeDuo = SvgMaximizeDuo;
exports.MaximizeSolid = SvgMaximizeSolid;
exports.MediaOverviewDuo = SvgMediaOverviewDuo;
exports.MediaOverviewSolid = SvgMediaOverviewSolid;
exports.MediaTypeDuo = SvgMediaTypeDuo;
exports.MediaTypeSolid = SvgMediaTypeSolid;
exports.Mediaplan1Duo = SvgMediaplan1Duo;
exports.Mediaplan1Solid = SvgMediaplan1Solid;
exports.MediaplanDuo = SvgMediaplanDuo;
exports.MediaplanReportDuo = SvgMediaplanReportDuo;
exports.MediaplanReportSolid = SvgMediaplanReportSolid;
exports.MediaplanSolid = SvgMediaplanSolid;
exports.MediatoolLogoDuo = SvgMediatoolLogoDuo;
exports.MediatoolLogoSolid = SvgMediatoolLogoSolid;
exports.MessageDuo = SvgMessageDuo;
exports.MessageSolid = SvgMessageSolid;
exports.MessageSquare02Duo = SvgMessageSquare02Duo;
exports.MessageSquare02Solid = SvgMessageSquare02Solid;
exports.MinusSquareDuo = SvgMinusSquareDuo;
exports.MinusSquareSolid = SvgMinusSquareSolid;
exports.MoneyDuo = SvgMoneyDuo;
exports.MoneySolid = SvgMoneySolid;
exports.MoreOptionsDuo = SvgMoreOptionsDuo;
exports.MoreOptionsSolid = SvgMoreOptionsSolid;
exports.MultipleDuo = SvgMultipleDuo;
exports.MultipleSolid = SvgMultipleSolid;
exports.NetworkDuo = SvgNetworkDuo;
exports.NetworkSolid = SvgNetworkSolid;
exports.NorthlightLogo = SvgNorthlightLogo;
exports.NorthlightLogoXs = SvgNorthlightLogoXs;
exports.OctocatW = SvgOctocatW;
exports.PaperDesignDuo = SvgPaperDesignDuo;
exports.PaperDesignSolid = SvgPaperDesignSolid;
exports.PasscodeLockDuo = SvgPasscodeLockDuo;
exports.PasscodeLockSolid = SvgPasscodeLockSolid;
exports.PayeeDuo = SvgPayeeDuo;
exports.PayeeSolid = SvgPayeeSolid;
exports.PayorDuo = SvgPayorDuo;
exports.PayorSolid = SvgPayorSolid;
exports.PenDuo = SvgPenDuo;
exports.PenSolid = SvgPenSolid;
exports.PencilDuo = SvgPencilDuo;
exports.PencilSolid = SvgPencilSolid;
exports.PinDuo = SvgPinDuo;
exports.PinSolid = SvgPinSolid;
exports.PlaySquareDuo = SvgPlaySquareDuo;
exports.PlaySquareSolid = SvgPlaySquareSolid;
exports.PlugDuo = SvgPlugDuo;
exports.PlugSolid = SvgPlugSolid;
exports.PlusDuo = SvgPlusDuo;
exports.PlusSolid = SvgPlusSolid;
exports.PlusSquareDuo = SvgPlusSquareDuo;
exports.PlusSquareSolid = SvgPlusSquareSolid;
exports.PositionMarkerDuo = SvgPositionMarkerDuo;
exports.PositionMarkerSolid = SvgPositionMarkerSolid;
exports.Principleshfeatured = SvgPrincipleshfeatured;
exports.Principleshfeaturedcs = SvgPrincipleshfeaturedcs;
exports.PrintDuo = SvgPrintDuo;
exports.PrintSolid = SvgPrintSolid;
exports.PrivacyDuo = SvgPrivacyDuo;
exports.PrivacySolid = SvgPrivacySolid;
exports.ProductDuo = SvgProductDuo;
exports.ProductSolid = SvgProductSolid;
exports.RefreshDataDuo = SvgRefreshDataDuo;
exports.RefreshDataSolid = SvgRefreshDataSolid;
exports.RefreshDuo = SvgRefreshDuo;
exports.RefreshSolid = SvgRefreshSolid;
exports.ReloadDuo = SvgReloadDuo;
exports.ReloadSolid = SvgReloadSolid;
exports.Repeat01Duo = SvgRepeat01Duo;
exports.Repeat01Solid = SvgRepeat01Solid;
exports.ReplyDuo = SvgReplyDuo;
exports.ReplySolid = SvgReplySolid;
exports.ReportDuo = SvgReportDuo;
exports.ReportSolid = SvgReportSolid;
exports.ResistanceBandDuo = SvgResistanceBandDuo;
exports.ResistanceBandSolid = SvgResistanceBandSolid;
exports.ResultsDuo = SvgResultsDuo;
exports.ResultsSolid = SvgResultsSolid;
exports.ReuploadDuo = SvgReuploadDuo;
exports.ReuploadSolid = SvgReuploadSolid;
exports.RouteOpenDuo = SvgRouteOpenDuo;
exports.RouteOpenSolid = SvgRouteOpenSolid;
exports.RowTableDuo = SvgRowTableDuo;
exports.RowTableSolid = SvgRowTableSolid;
exports.SaveLaterDuo = SvgSaveLaterDuo;
exports.SaveLaterSolid = SvgSaveLaterSolid;
exports.ScreenMaximazeDuo = SvgScreenMaximazeDuo;
exports.ScreenMaximazeSolid = SvgScreenMaximazeSolid;
exports.SearchDuo = SvgSearchDuo;
exports.SearchSolid = SvgSearchSolid;
exports.SendDuo = SvgSendDuo;
exports.SendSolid = SvgSendSolid;
exports.SensorDuo = SvgSensorDuo;
exports.SensorSolid = SvgSensorSolid;
exports.Server01Duo = SvgServer01Duo;
exports.Server01Solid = SvgServer01Solid;
exports.SettingsDuo = SvgSettingsDuo;
exports.SettingsSolid = SvgSettingsSolid;
exports.SetupOptionsDuo = SvgSetupOptionsDuo;
exports.SetupOptionsSolid = SvgSetupOptionsSolid;
exports.ShapesDuo = SvgShapesDuo;
exports.ShapesSolid = SvgShapesSolid;
exports.ShareDuo = SvgShareDuo;
exports.ShareSolid = SvgShareSolid;
exports.Signal03Duo = SvgSignal03Duo;
exports.Signal03Solid = SvgSignal03Solid;
exports.SlashOctagonDuo = SvgSlashOctagonDuo;
exports.SlashOctagonSolid = SvgSlashOctagonSolid;
exports.SlideshowDuo = SvgSlideshowDuo;
exports.SlideshowSolid = SvgSlideshowSolid;
exports.SmileyDuo = SvgSmileyDuo;
exports.SmileySolid = SvgSmileySolid;
exports.SquareSetDuo = SvgSquareSetDuo;
exports.SquareSetSolid = SvgSquareSetSolid;
exports.StackDuo = SvgStackDuo;
exports.StackSolid = SvgStackSolid;
exports.StagesDuo = SvgStagesDuo;
exports.StagesSolid = SvgStagesSolid;
exports.Star01Duo = SvgStar01Duo;
exports.Star01Solid = SvgStar01Solid;
exports.Star02Duo = SvgStar02Duo;
exports.Star02Solid = SvgStar02Solid;
exports.StatusPinDuo = SvgStatusPinDuo;
exports.StatusPinSolid = SvgStatusPinSolid;
exports.StatusWorkingDuo = SvgStatusWorkingDuo;
exports.StatusWorkingSolid = SvgStatusWorkingSolid;
exports.StrikethroughDuo = SvgStrikethroughDuo;
exports.StrikethroughSolid = SvgStrikethroughSolid;
exports.SubtitlesDuo = SvgSubtitlesDuo;
exports.SubtitlesSolid = SvgSubtitlesSolid;
exports.SwapVerticalDuo = SvgSwapVerticalDuo;
exports.SwapVerticalSolid = SvgSwapVerticalSolid;
exports.TableFileDuo = SvgTableFileDuo;
exports.TableFileSolid = SvgTableFileSolid;
exports.TableLayoutDuo = SvgTableLayoutDuo;
exports.TableLayoutSolid = SvgTableLayoutSolid;
exports.TagCheckDuo = SvgTagCheckDuo;
exports.TagCheckSolid = SvgTagCheckSolid;
exports.TagDuo = SvgTagDuo;
exports.TagSolid = SvgTagSolid;
exports.TagsStackDuo = SvgTagsStackDuo;
exports.TagsStackSolid = SvgTagsStackSolid;
exports.TargetDuo = SvgTargetDuo;
exports.TargetSolid = SvgTargetSolid;
exports.TextDuo = SvgTextDuo;
exports.TextFieldDuo = SvgTextFieldDuo;
exports.TextFieldSolid = SvgTextFieldSolid;
exports.TextSolid = SvgTextSolid;
exports.TimelineDuo = SvgTimelineDuo;
exports.TimelineSolid = SvgTimelineSolid;
exports.Tokenshfeatured = SvgTokenshfeatured;
exports.TrashDuo = SvgTrashDuo;
exports.TrashFullDuo = SvgTrashFullDuo;
exports.TrashFullSolid = SvgTrashFullSolid;
exports.TrashSolid = SvgTrashSolid;
exports.UnderlineDuo = SvgUnderlineDuo;
exports.UnderlineSolid = SvgUnderlineSolid;
exports.UploadCloudDuo = SvgUploadCloudDuo;
exports.UploadCloudSolid = SvgUploadCloudSolid;
exports.UserSquareDuo = SvgUserSquareDuo;
exports.UserSquareSolid = SvgUserSquareSolid;
exports.UsersDuo = SvgUsersDuo;
exports.UsersSolid = SvgUsersSolid;
exports.VerifiedDuo = SvgVerifiedDuo;
exports.VerifiedSolid = SvgVerifiedSolid;
exports.VersionAddDuo = SvgVersionAddDuo;
exports.VersionAddSolid = SvgVersionAddSolid;
exports.VersionDownloadDuo = SvgVersionDownloadDuo;
exports.VersionDownloadSolid = SvgVersionDownloadSolid;
exports.VersionLockedDuo = SvgVersionLockedDuo;
exports.VersionLockedSolid = SvgVersionLockedSolid;
exports.VersionPendingDuo = SvgVersionPendingDuo;
exports.VersionPendingSolid = SvgVersionPendingSolid;
exports.VersionRejectedDuo = SvgVersionRejectedDuo;
exports.VersionRejectedSolid = SvgVersionRejectedSolid;
exports.VersionSavedDuo = SvgVersionSavedDuo;
exports.VersionSavedSolid = SvgVersionSavedSolid;
exports.VersionSettingsDuo = SvgVersionSettingsDuo;
exports.VersionSettingsSolid = SvgVersionSettingsSolid;
exports.VersionWorkingDuo = SvgVersionWorkingDuo;
exports.VersionWorkingSolid = SvgVersionWorkingSolid;
exports.VersionsDuo = SvgVersionsDuo;
exports.VersionsSolid = SvgVersionsSolid;
exports.XCloseDuo = SvgXCloseDuo;
exports.XCloseSolid = SvgXCloseSolid;
exports.ZoomInDuo = SvgZoomInDuo;
exports.ZoomInSolid = SvgZoomInSolid;
exports.ZoomOutDuo = SvgZoomOutDuo;
exports.ZoomOutSolid = SvgZoomOutSolid;
//# sourceMappingURL=icons.js.map
